(function(){"use strict";try{if(typeof document!="undefined"){var t=document.createElement("style");t.appendChild(document.createTextNode('.notes-ant-btn{line-height:1.499;position:relative;display:inline-block;font-weight:400;white-space:nowrap;text-align:center;background-image:none;border:1px solid transparent;box-shadow:0 2px #00000004;cursor:pointer;transition:all .3s cubic-bezier(.645,.045,.355,1);user-select:none;touch-action:manipulation;height:32px;padding:0 15px;font-size:14px;border-radius:4px;color:#000000a6;background-color:#fff;border-color:#d9d9d9}.notes-ant-btn>.anticon{line-height:1}.notes-ant-btn,.notes-ant-btn:active,.notes-ant-btn:focus{outline:0}.notes-ant-btn:not([disabled]):hover{text-decoration:none}.notes-ant-btn:not([disabled]):active{outline:0;box-shadow:none}.notes-ant-btn.disabled,.notes-ant-btn[disabled]{cursor:not-allowed}.notes-ant-btn.disabled>*,.notes-ant-btn[disabled]>*{pointer-events:none}.notes-ant-btn-lg{height:40px;padding:0 15px;font-size:16px;border-radius:4px}.notes-ant-btn-sm{height:24px;padding:0 7px;font-size:14px;border-radius:4px}.notes-ant-btn>a:only-child{color:currentColor}.notes-ant-btn>a:only-child:after{position:absolute;inset:0;background:transparent;content:""}.notes-ant-btn:hover,.notes-ant-btn:focus{color:#349459;background-color:#fff;border-color:#349459}.notes-ant-btn:hover>a:only-child,.notes-ant-btn:focus>a:only-child{color:currentColor}.notes-ant-btn:hover>a:only-child:after,.notes-ant-btn:focus>a:only-child:after{position:absolute;inset:0;background:transparent;content:""}.notes-ant-btn:active,.notes-ant-btn.active{color:#0e6133;background-color:#fff;border-color:#0e6133}.notes-ant-btn:active>a:only-child,.notes-ant-btn.active>a:only-child{color:currentColor}.notes-ant-btn:active>a:only-child:after,.notes-ant-btn.active>a:only-child:after{position:absolute;inset:0;background:transparent;content:""}.notes-ant-btn-disabled,.notes-ant-btn.disabled,.notes-ant-btn[disabled],.notes-ant-btn-disabled:hover,.notes-ant-btn.disabled:hover,.notes-ant-btn[disabled]:hover,.notes-ant-btn-disabled:focus,.notes-ant-btn.disabled:focus,.notes-ant-btn[disabled]:focus,.notes-ant-btn-disabled:active,.notes-ant-btn.disabled:active,.notes-ant-btn[disabled]:active,.notes-ant-btn-disabled.active,.notes-ant-btn.disabled.active,.notes-ant-btn[disabled].active{color:#c1c5c8;background-color:#f5f5f5;border-color:#d9d9d9;text-shadow:none;box-shadow:none}.notes-ant-btn-disabled>a:only-child,.notes-ant-btn.disabled>a:only-child,.notes-ant-btn[disabled]>a:only-child,.notes-ant-btn-disabled:hover>a:only-child,.notes-ant-btn.disabled:hover>a:only-child,.notes-ant-btn[disabled]:hover>a:only-child,.notes-ant-btn-disabled:focus>a:only-child,.notes-ant-btn.disabled:focus>a:only-child,.notes-ant-btn[disabled]:focus>a:only-child,.notes-ant-btn-disabled:active>a:only-child,.notes-ant-btn.disabled:active>a:only-child,.notes-ant-btn[disabled]:active>a:only-child,.notes-ant-btn-disabled.active>a:only-child,.notes-ant-btn.disabled.active>a:only-child,.notes-ant-btn[disabled].active>a:only-child{color:currentColor}.notes-ant-btn-disabled>a:only-child:after,.notes-ant-btn.disabled>a:only-child:after,.notes-ant-btn[disabled]>a:only-child:after,.notes-ant-btn-disabled:hover>a:only-child:after,.notes-ant-btn.disabled:hover>a:only-child:after,.notes-ant-btn[disabled]:hover>a:only-child:after,.notes-ant-btn-disabled:focus>a:only-child:after,.notes-ant-btn.disabled:focus>a:only-child:after,.notes-ant-btn[disabled]:focus>a:only-child:after,.notes-ant-btn-disabled:active>a:only-child:after,.notes-ant-btn.disabled:active>a:only-child:after,.notes-ant-btn[disabled]:active>a:only-child:after,.notes-ant-btn-disabled.active>a:only-child:after,.notes-ant-btn.disabled.active>a:only-child:after,.notes-ant-btn[disabled].active>a:only-child:after{position:absolute;inset:0;background:transparent;content:""}.notes-ant-btn:hover,.notes-ant-btn:focus,.notes-ant-btn:active,.notes-ant-btn.active{text-decoration:none;background:#fff}.notes-ant-btn>i,.notes-ant-btn>span{display:inline-block;transition:margin-left .3s cubic-bezier(.645,.045,.355,1);pointer-events:none}.notes-ant-btn-primary{color:#fff;background-color:#198746;border-color:#198746;text-shadow:0 -1px 0 rgba(0,0,0,.12);box-shadow:0 2px #0000000b}.notes-ant-btn-primary>a:only-child{color:currentColor}.notes-ant-btn-primary>a:only-child:after{position:absolute;inset:0;background:transparent;content:""}.notes-ant-btn-primary:hover,.notes-ant-btn-primary:focus{color:#fff;background-color:#349459;border-color:#349459}.notes-ant-btn-primary:hover>a:only-child,.notes-ant-btn-primary:focus>a:only-child{color:currentColor}.notes-ant-btn-primary:hover>a:only-child:after,.notes-ant-btn-primary:focus>a:only-child:after{position:absolute;inset:0;background:transparent;content:""}.notes-ant-btn-primary:active,.notes-ant-btn-primary.active{color:#fff;background-color:#0e6133;border-color:#0e6133}.notes-ant-btn-primary:active>a:only-child,.notes-ant-btn-primary.active>a:only-child{color:currentColor}.notes-ant-btn-primary:active>a:only-child:after,.notes-ant-btn-primary.active>a:only-child:after{position:absolute;inset:0;background:transparent;content:""}.notes-ant-btn-primary-disabled,.notes-ant-btn-primary.disabled,.notes-ant-btn-primary[disabled],.notes-ant-btn-primary-disabled:hover,.notes-ant-btn-primary.disabled:hover,.notes-ant-btn-primary[disabled]:hover,.notes-ant-btn-primary-disabled:focus,.notes-ant-btn-primary.disabled:focus,.notes-ant-btn-primary[disabled]:focus,.notes-ant-btn-primary-disabled:active,.notes-ant-btn-primary.disabled:active,.notes-ant-btn-primary[disabled]:active,.notes-ant-btn-primary-disabled.active,.notes-ant-btn-primary.disabled.active,.notes-ant-btn-primary[disabled].active{color:#c1c5c8;background-color:#f5f5f5;border-color:#d9d9d9;text-shadow:none;box-shadow:none}.notes-ant-btn-primary-disabled>a:only-child,.notes-ant-btn-primary.disabled>a:only-child,.notes-ant-btn-primary[disabled]>a:only-child,.notes-ant-btn-primary-disabled:hover>a:only-child,.notes-ant-btn-primary.disabled:hover>a:only-child,.notes-ant-btn-primary[disabled]:hover>a:only-child,.notes-ant-btn-primary-disabled:focus>a:only-child,.notes-ant-btn-primary.disabled:focus>a:only-child,.notes-ant-btn-primary[disabled]:focus>a:only-child,.notes-ant-btn-primary-disabled:active>a:only-child,.notes-ant-btn-primary.disabled:active>a:only-child,.notes-ant-btn-primary[disabled]:active>a:only-child,.notes-ant-btn-primary-disabled.active>a:only-child,.notes-ant-btn-primary.disabled.active>a:only-child,.notes-ant-btn-primary[disabled].active>a:only-child{color:currentColor}.notes-ant-btn-primary-disabled>a:only-child:after,.notes-ant-btn-primary.disabled>a:only-child:after,.notes-ant-btn-primary[disabled]>a:only-child:after,.notes-ant-btn-primary-disabled:hover>a:only-child:after,.notes-ant-btn-primary.disabled:hover>a:only-child:after,.notes-ant-btn-primary[disabled]:hover>a:only-child:after,.notes-ant-btn-primary-disabled:focus>a:only-child:after,.notes-ant-btn-primary.disabled:focus>a:only-child:after,.notes-ant-btn-primary[disabled]:focus>a:only-child:after,.notes-ant-btn-primary-disabled:active>a:only-child:after,.notes-ant-btn-primary.disabled:active>a:only-child:after,.notes-ant-btn-primary[disabled]:active>a:only-child:after,.notes-ant-btn-primary-disabled.active>a:only-child:after,.notes-ant-btn-primary.disabled.active>a:only-child:after,.notes-ant-btn-primary[disabled].active>a:only-child:after{position:absolute;inset:0;background:transparent;content:""}.notes-ant-btn-group .notes-ant-btn-primary:not(:first-child):not(:last-child){border-right-color:#349459;border-left-color:#349459}.notes-ant-btn-group .notes-ant-btn-primary:not(:first-child):not(:last-child):disabled{border-color:#d9d9d9}.notes-ant-btn-group .notes-ant-btn-primary:first-child:not(:last-child){border-right-color:#349459}.notes-ant-btn-group .notes-ant-btn-primary:first-child:not(:last-child)[disabled]{border-right-color:#d9d9d9}.notes-ant-btn-group .notes-ant-btn-primary:last-child:not(:first-child),.notes-ant-btn-group .notes-ant-btn-primary+.notes-ant-btn-primary{border-left-color:#349459}.notes-ant-btn-group .notes-ant-btn-primary:last-child:not(:first-child)[disabled],.notes-ant-btn-group .notes-ant-btn-primary+.notes-ant-btn-primary[disabled]{border-left-color:#d9d9d9}.notes-ant-btn-ghost{color:#000000a6;background-color:transparent;border-color:#d9d9d9}.notes-ant-btn-ghost>a:only-child{color:currentColor}.notes-ant-btn-ghost>a:only-child:after{position:absolute;inset:0;background:transparent;content:""}.notes-ant-btn-ghost:hover,.notes-ant-btn-ghost:focus{color:#349459;background-color:transparent;border-color:#349459}.notes-ant-btn-ghost:hover>a:only-child,.notes-ant-btn-ghost:focus>a:only-child{color:currentColor}.notes-ant-btn-ghost:hover>a:only-child:after,.notes-ant-btn-ghost:focus>a:only-child:after{position:absolute;inset:0;background:transparent;content:""}.notes-ant-btn-ghost:active,.notes-ant-btn-ghost.active{color:#0e6133;background-color:transparent;border-color:#0e6133}.notes-ant-btn-ghost:active>a:only-child,.notes-ant-btn-ghost.active>a:only-child{color:currentColor}.notes-ant-btn-ghost:active>a:only-child:after,.notes-ant-btn-ghost.active>a:only-child:after{position:absolute;inset:0;background:transparent;content:""}.notes-ant-btn-ghost-disabled,.notes-ant-btn-ghost.disabled,.notes-ant-btn-ghost[disabled],.notes-ant-btn-ghost-disabled:hover,.notes-ant-btn-ghost.disabled:hover,.notes-ant-btn-ghost[disabled]:hover,.notes-ant-btn-ghost-disabled:focus,.notes-ant-btn-ghost.disabled:focus,.notes-ant-btn-ghost[disabled]:focus,.notes-ant-btn-ghost-disabled:active,.notes-ant-btn-ghost.disabled:active,.notes-ant-btn-ghost[disabled]:active,.notes-ant-btn-ghost-disabled.active,.notes-ant-btn-ghost.disabled.active,.notes-ant-btn-ghost[disabled].active{color:#c1c5c8;background-color:#f5f5f5;border-color:#d9d9d9;text-shadow:none;box-shadow:none}.notes-ant-btn-ghost-disabled>a:only-child,.notes-ant-btn-ghost.disabled>a:only-child,.notes-ant-btn-ghost[disabled]>a:only-child,.notes-ant-btn-ghost-disabled:hover>a:only-child,.notes-ant-btn-ghost.disabled:hover>a:only-child,.notes-ant-btn-ghost[disabled]:hover>a:only-child,.notes-ant-btn-ghost-disabled:focus>a:only-child,.notes-ant-btn-ghost.disabled:focus>a:only-child,.notes-ant-btn-ghost[disabled]:focus>a:only-child,.notes-ant-btn-ghost-disabled:active>a:only-child,.notes-ant-btn-ghost.disabled:active>a:only-child,.notes-ant-btn-ghost[disabled]:active>a:only-child,.notes-ant-btn-ghost-disabled.active>a:only-child,.notes-ant-btn-ghost.disabled.active>a:only-child,.notes-ant-btn-ghost[disabled].active>a:only-child{color:currentColor}.notes-ant-btn-ghost-disabled>a:only-child:after,.notes-ant-btn-ghost.disabled>a:only-child:after,.notes-ant-btn-ghost[disabled]>a:only-child:after,.notes-ant-btn-ghost-disabled:hover>a:only-child:after,.notes-ant-btn-ghost.disabled:hover>a:only-child:after,.notes-ant-btn-ghost[disabled]:hover>a:only-child:after,.notes-ant-btn-ghost-disabled:focus>a:only-child:after,.notes-ant-btn-ghost.disabled:focus>a:only-child:after,.notes-ant-btn-ghost[disabled]:focus>a:only-child:after,.notes-ant-btn-ghost-disabled:active>a:only-child:after,.notes-ant-btn-ghost.disabled:active>a:only-child:after,.notes-ant-btn-ghost[disabled]:active>a:only-child:after,.notes-ant-btn-ghost-disabled.active>a:only-child:after,.notes-ant-btn-ghost.disabled.active>a:only-child:after,.notes-ant-btn-ghost[disabled].active>a:only-child:after{position:absolute;inset:0;background:transparent;content:""}.notes-ant-btn-dashed{color:#000000a6;background-color:#fff;border-color:#d9d9d9;border-style:dashed}.notes-ant-btn-dashed>a:only-child{color:currentColor}.notes-ant-btn-dashed>a:only-child:after{position:absolute;inset:0;background:transparent;content:""}.notes-ant-btn-dashed:hover,.notes-ant-btn-dashed:focus{color:#349459;background-color:#fff;border-color:#349459}.notes-ant-btn-dashed:hover>a:only-child,.notes-ant-btn-dashed:focus>a:only-child{color:currentColor}.notes-ant-btn-dashed:hover>a:only-child:after,.notes-ant-btn-dashed:focus>a:only-child:after{position:absolute;inset:0;background:transparent;content:""}.notes-ant-btn-dashed:active,.notes-ant-btn-dashed.active{color:#0e6133;background-color:#fff;border-color:#0e6133}.notes-ant-btn-dashed:active>a:only-child,.notes-ant-btn-dashed.active>a:only-child{color:currentColor}.notes-ant-btn-dashed:active>a:only-child:after,.notes-ant-btn-dashed.active>a:only-child:after{position:absolute;inset:0;background:transparent;content:""}.notes-ant-btn-dashed-disabled,.notes-ant-btn-dashed.disabled,.notes-ant-btn-dashed[disabled],.notes-ant-btn-dashed-disabled:hover,.notes-ant-btn-dashed.disabled:hover,.notes-ant-btn-dashed[disabled]:hover,.notes-ant-btn-dashed-disabled:focus,.notes-ant-btn-dashed.disabled:focus,.notes-ant-btn-dashed[disabled]:focus,.notes-ant-btn-dashed-disabled:active,.notes-ant-btn-dashed.disabled:active,.notes-ant-btn-dashed[disabled]:active,.notes-ant-btn-dashed-disabled.active,.notes-ant-btn-dashed.disabled.active,.notes-ant-btn-dashed[disabled].active{color:#c1c5c8;background-color:#f5f5f5;border-color:#d9d9d9;text-shadow:none;box-shadow:none}.notes-ant-btn-dashed-disabled>a:only-child,.notes-ant-btn-dashed.disabled>a:only-child,.notes-ant-btn-dashed[disabled]>a:only-child,.notes-ant-btn-dashed-disabled:hover>a:only-child,.notes-ant-btn-dashed.disabled:hover>a:only-child,.notes-ant-btn-dashed[disabled]:hover>a:only-child,.notes-ant-btn-dashed-disabled:focus>a:only-child,.notes-ant-btn-dashed.disabled:focus>a:only-child,.notes-ant-btn-dashed[disabled]:focus>a:only-child,.notes-ant-btn-dashed-disabled:active>a:only-child,.notes-ant-btn-dashed.disabled:active>a:only-child,.notes-ant-btn-dashed[disabled]:active>a:only-child,.notes-ant-btn-dashed-disabled.active>a:only-child,.notes-ant-btn-dashed.disabled.active>a:only-child,.notes-ant-btn-dashed[disabled].active>a:only-child{color:currentColor}.notes-ant-btn-dashed-disabled>a:only-child:after,.notes-ant-btn-dashed.disabled>a:only-child:after,.notes-ant-btn-dashed[disabled]>a:only-child:after,.notes-ant-btn-dashed-disabled:hover>a:only-child:after,.notes-ant-btn-dashed.disabled:hover>a:only-child:after,.notes-ant-btn-dashed[disabled]:hover>a:only-child:after,.notes-ant-btn-dashed-disabled:focus>a:only-child:after,.notes-ant-btn-dashed.disabled:focus>a:only-child:after,.notes-ant-btn-dashed[disabled]:focus>a:only-child:after,.notes-ant-btn-dashed-disabled:active>a:only-child:after,.notes-ant-btn-dashed.disabled:active>a:only-child:after,.notes-ant-btn-dashed[disabled]:active>a:only-child:after,.notes-ant-btn-dashed-disabled.active>a:only-child:after,.notes-ant-btn-dashed.disabled.active>a:only-child:after,.notes-ant-btn-dashed[disabled].active>a:only-child:after{position:absolute;inset:0;background:transparent;content:""}.notes-ant-btn-danger{color:#fff;background-color:#ff4d4f;border-color:#ff4d4f;text-shadow:0 -1px 0 rgba(0,0,0,.12);box-shadow:0 2px #0000000b}.notes-ant-btn-danger>a:only-child{color:currentColor}.notes-ant-btn-danger>a:only-child:after{position:absolute;inset:0;background:transparent;content:""}.notes-ant-btn-danger:hover,.notes-ant-btn-danger:focus{color:#fff;background-color:#ff7875;border-color:#ff7875}.notes-ant-btn-danger:hover>a:only-child,.notes-ant-btn-danger:focus>a:only-child{color:currentColor}.notes-ant-btn-danger:hover>a:only-child:after,.notes-ant-btn-danger:focus>a:only-child:after{position:absolute;inset:0;background:transparent;content:""}.notes-ant-btn-danger:active,.notes-ant-btn-danger.active{color:#fff;background-color:#d9363e;border-color:#d9363e}.notes-ant-btn-danger:active>a:only-child,.notes-ant-btn-danger.active>a:only-child{color:currentColor}.notes-ant-btn-danger:active>a:only-child:after,.notes-ant-btn-danger.active>a:only-child:after{position:absolute;inset:0;background:transparent;content:""}.notes-ant-btn-danger-disabled,.notes-ant-btn-danger.disabled,.notes-ant-btn-danger[disabled],.notes-ant-btn-danger-disabled:hover,.notes-ant-btn-danger.disabled:hover,.notes-ant-btn-danger[disabled]:hover,.notes-ant-btn-danger-disabled:focus,.notes-ant-btn-danger.disabled:focus,.notes-ant-btn-danger[disabled]:focus,.notes-ant-btn-danger-disabled:active,.notes-ant-btn-danger.disabled:active,.notes-ant-btn-danger[disabled]:active,.notes-ant-btn-danger-disabled.active,.notes-ant-btn-danger.disabled.active,.notes-ant-btn-danger[disabled].active{color:#c1c5c8;background-color:#f5f5f5;border-color:#d9d9d9;text-shadow:none;box-shadow:none}.notes-ant-btn-danger-disabled>a:only-child,.notes-ant-btn-danger.disabled>a:only-child,.notes-ant-btn-danger[disabled]>a:only-child,.notes-ant-btn-danger-disabled:hover>a:only-child,.notes-ant-btn-danger.disabled:hover>a:only-child,.notes-ant-btn-danger[disabled]:hover>a:only-child,.notes-ant-btn-danger-disabled:focus>a:only-child,.notes-ant-btn-danger.disabled:focus>a:only-child,.notes-ant-btn-danger[disabled]:focus>a:only-child,.notes-ant-btn-danger-disabled:active>a:only-child,.notes-ant-btn-danger.disabled:active>a:only-child,.notes-ant-btn-danger[disabled]:active>a:only-child,.notes-ant-btn-danger-disabled.active>a:only-child,.notes-ant-btn-danger.disabled.active>a:only-child,.notes-ant-btn-danger[disabled].active>a:only-child{color:currentColor}.notes-ant-btn-danger-disabled>a:only-child:after,.notes-ant-btn-danger.disabled>a:only-child:after,.notes-ant-btn-danger[disabled]>a:only-child:after,.notes-ant-btn-danger-disabled:hover>a:only-child:after,.notes-ant-btn-danger.disabled:hover>a:only-child:after,.notes-ant-btn-danger[disabled]:hover>a:only-child:after,.notes-ant-btn-danger-disabled:focus>a:only-child:after,.notes-ant-btn-danger.disabled:focus>a:only-child:after,.notes-ant-btn-danger[disabled]:focus>a:only-child:after,.notes-ant-btn-danger-disabled:active>a:only-child:after,.notes-ant-btn-danger.disabled:active>a:only-child:after,.notes-ant-btn-danger[disabled]:active>a:only-child:after,.notes-ant-btn-danger-disabled.active>a:only-child:after,.notes-ant-btn-danger.disabled.active>a:only-child:after,.notes-ant-btn-danger[disabled].active>a:only-child:after{position:absolute;inset:0;background:transparent;content:""}.notes-ant-btn-link{color:#198746;background-color:transparent;border-color:transparent;box-shadow:none}.notes-ant-btn-link>a:only-child{color:currentColor}.notes-ant-btn-link>a:only-child:after{position:absolute;inset:0;background:transparent;content:""}.notes-ant-btn-link:hover,.notes-ant-btn-link:focus{color:#349459;background-color:transparent;border-color:#349459}.notes-ant-btn-link:hover>a:only-child,.notes-ant-btn-link:focus>a:only-child{color:currentColor}.notes-ant-btn-link:hover>a:only-child:after,.notes-ant-btn-link:focus>a:only-child:after{position:absolute;inset:0;background:transparent;content:""}.notes-ant-btn-link:active,.notes-ant-btn-link.active{color:#0e6133;background-color:transparent;border-color:#0e6133}.notes-ant-btn-link:active>a:only-child,.notes-ant-btn-link.active>a:only-child{color:currentColor}.notes-ant-btn-link:active>a:only-child:after,.notes-ant-btn-link.active>a:only-child:after{position:absolute;inset:0;background:transparent;content:""}.notes-ant-btn-link-disabled,.notes-ant-btn-link.disabled,.notes-ant-btn-link[disabled],.notes-ant-btn-link-disabled:hover,.notes-ant-btn-link.disabled:hover,.notes-ant-btn-link[disabled]:hover,.notes-ant-btn-link-disabled:focus,.notes-ant-btn-link.disabled:focus,.notes-ant-btn-link[disabled]:focus,.notes-ant-btn-link-disabled:active,.notes-ant-btn-link.disabled:active,.notes-ant-btn-link[disabled]:active,.notes-ant-btn-link-disabled.active,.notes-ant-btn-link.disabled.active,.notes-ant-btn-link[disabled].active{color:#c1c5c8;background-color:#f5f5f5;border-color:#d9d9d9;text-shadow:none;box-shadow:none}.notes-ant-btn-link:hover,.notes-ant-btn-link:focus,.notes-ant-btn-link:active{border-color:transparent}.notes-ant-btn-link-disabled,.notes-ant-btn-link.disabled,.notes-ant-btn-link[disabled],.notes-ant-btn-link-disabled:hover,.notes-ant-btn-link.disabled:hover,.notes-ant-btn-link[disabled]:hover,.notes-ant-btn-link-disabled:focus,.notes-ant-btn-link.disabled:focus,.notes-ant-btn-link[disabled]:focus,.notes-ant-btn-link-disabled:active,.notes-ant-btn-link.disabled:active,.notes-ant-btn-link[disabled]:active,.notes-ant-btn-link-disabled.active,.notes-ant-btn-link.disabled.active,.notes-ant-btn-link[disabled].active{color:#c1c5c8;background-color:transparent;border-color:transparent;text-shadow:none;box-shadow:none}.notes-ant-btn-link-disabled>a:only-child,.notes-ant-btn-link.disabled>a:only-child,.notes-ant-btn-link[disabled]>a:only-child,.notes-ant-btn-link-disabled:hover>a:only-child,.notes-ant-btn-link.disabled:hover>a:only-child,.notes-ant-btn-link[disabled]:hover>a:only-child,.notes-ant-btn-link-disabled:focus>a:only-child,.notes-ant-btn-link.disabled:focus>a:only-child,.notes-ant-btn-link[disabled]:focus>a:only-child,.notes-ant-btn-link-disabled:active>a:only-child,.notes-ant-btn-link.disabled:active>a:only-child,.notes-ant-btn-link[disabled]:active>a:only-child,.notes-ant-btn-link-disabled.active>a:only-child,.notes-ant-btn-link.disabled.active>a:only-child,.notes-ant-btn-link[disabled].active>a:only-child{color:currentColor}.notes-ant-btn-link-disabled>a:only-child:after,.notes-ant-btn-link.disabled>a:only-child:after,.notes-ant-btn-link[disabled]>a:only-child:after,.notes-ant-btn-link-disabled:hover>a:only-child:after,.notes-ant-btn-link.disabled:hover>a:only-child:after,.notes-ant-btn-link[disabled]:hover>a:only-child:after,.notes-ant-btn-link-disabled:focus>a:only-child:after,.notes-ant-btn-link.disabled:focus>a:only-child:after,.notes-ant-btn-link[disabled]:focus>a:only-child:after,.notes-ant-btn-link-disabled:active>a:only-child:after,.notes-ant-btn-link.disabled:active>a:only-child:after,.notes-ant-btn-link[disabled]:active>a:only-child:after,.notes-ant-btn-link-disabled.active>a:only-child:after,.notes-ant-btn-link.disabled.active>a:only-child:after,.notes-ant-btn-link[disabled].active>a:only-child:after{position:absolute;inset:0;background:transparent;content:""}.notes-ant-btn-icon-only{width:32px;height:32px;padding:0;font-size:16px;border-radius:4px}.notes-ant-btn-icon-only.notes-ant-btn-lg{width:40px;height:40px;padding:0;font-size:18px;border-radius:4px}.notes-ant-btn-icon-only.notes-ant-btn-sm{width:24px;height:24px;padding:0;font-size:14px;border-radius:4px}.notes-ant-btn-icon-only>i{vertical-align:middle}.notes-ant-btn-round{height:32px;padding:0 16px;font-size:14px;border-radius:32px}.notes-ant-btn-round.notes-ant-btn-lg{height:40px;padding:0 20px;font-size:16px;border-radius:40px}.notes-ant-btn-round.notes-ant-btn-sm{height:24px;padding:0 12px;font-size:14px;border-radius:24px}.notes-ant-btn-round.notes-ant-btn-icon-only{width:auto}.notes-ant-btn-circle,.notes-ant-btn-circle-outline{min-width:32px;padding-right:0;padding-left:0;text-align:center;border-radius:50%}.notes-ant-btn-circle.notes-ant-btn-lg,.notes-ant-btn-circle-outline.notes-ant-btn-lg{min-width:40px;border-radius:50%}.notes-ant-btn-circle.notes-ant-btn-sm,.notes-ant-btn-circle-outline.notes-ant-btn-sm{min-width:24px;border-radius:50%}.notes-ant-btn:before{position:absolute;inset:-1px;z-index:1;display:none;background:#fff;border-radius:inherit;opacity:.35;transition:opacity .2s;content:"";pointer-events:none}.notes-ant-btn .anticon{transition:margin-left .3s cubic-bezier(.645,.045,.355,1)}.notes-ant-btn .anticon.anticon-plus>svg,.notes-ant-btn .anticon.anticon-minus>svg{shape-rendering:optimizeSpeed}.notes-ant-btn.notes-ant-btn-loading{position:relative}.notes-ant-btn.notes-ant-btn-loading:not([disabled]){pointer-events:none}.notes-ant-btn.notes-ant-btn-loading:before{display:block}.notes-ant-btn.notes-ant-btn-loading:not(.notes-ant-btn-circle):not(.notes-ant-btn-circle-outline):not(.notes-ant-btn-icon-only){padding-left:29px}.notes-ant-btn.notes-ant-btn-loading:not(.notes-ant-btn-circle):not(.notes-ant-btn-circle-outline):not(.notes-ant-btn-icon-only) .anticon:not(:last-child){margin-left:-14px}.notes-ant-btn-sm.notes-ant-btn-loading:not(.notes-ant-btn-circle):not(.notes-ant-btn-circle-outline):not(.notes-ant-btn-icon-only){padding-left:24px}.notes-ant-btn-sm.notes-ant-btn-loading:not(.notes-ant-btn-circle):not(.notes-ant-btn-circle-outline):not(.notes-ant-btn-icon-only) .anticon{margin-left:-17px}.notes-ant-btn-group{position:relative;display:inline-block}.notes-ant-btn-group>.notes-ant-btn,.notes-ant-btn-group>span>.notes-ant-btn{position:relative}.notes-ant-btn-group>.notes-ant-btn:hover,.notes-ant-btn-group>span>.notes-ant-btn:hover,.notes-ant-btn-group>.notes-ant-btn:focus,.notes-ant-btn-group>span>.notes-ant-btn:focus,.notes-ant-btn-group>.notes-ant-btn:active,.notes-ant-btn-group>span>.notes-ant-btn:active,.notes-ant-btn-group>.notes-ant-btn.active,.notes-ant-btn-group>span>.notes-ant-btn.active{z-index:2}.notes-ant-btn-group>.notes-ant-btn:disabled,.notes-ant-btn-group>span>.notes-ant-btn:disabled{z-index:0}.notes-ant-btn-group>.notes-ant-btn-icon-only{font-size:14px}.notes-ant-btn-group-lg>.notes-ant-btn,.notes-ant-btn-group-lg>span>.notes-ant-btn{height:40px;padding:0 15px;font-size:16px;border-radius:0;line-height:38px}.notes-ant-btn-group-lg>.notes-ant-btn.notes-ant-btn-icon-only{width:40px;height:40px;padding-right:0;padding-left:0}.notes-ant-btn-group-sm>.notes-ant-btn,.notes-ant-btn-group-sm>span>.notes-ant-btn{height:24px;padding:0 7px;font-size:14px;border-radius:0;line-height:22px}.notes-ant-btn-group-sm>.notes-ant-btn>.anticon,.notes-ant-btn-group-sm>span>.notes-ant-btn>.anticon{font-size:14px}.notes-ant-btn-group-sm>.notes-ant-btn.notes-ant-btn-icon-only{width:24px;height:24px;padding-right:0;padding-left:0}.notes-ant-btn-group .notes-ant-btn+.notes-ant-btn,.notes-ant-btn+.notes-ant-btn-group,.notes-ant-btn-group span+.notes-ant-btn,.notes-ant-btn-group .notes-ant-btn+span,.notes-ant-btn-group>span+span,.notes-ant-btn-group+.notes-ant-btn,.notes-ant-btn-group+.notes-ant-btn-group{margin-left:-1px}.notes-ant-btn-group .notes-ant-btn-primary+.notes-ant-btn:not(.notes-ant-btn-primary):not([disabled]){border-left-color:transparent}.notes-ant-btn-group .notes-ant-btn{border-radius:0}.notes-ant-btn-group>.notes-ant-btn:first-child,.notes-ant-btn-group>span:first-child>.notes-ant-btn{margin-left:0}.notes-ant-btn-group>.notes-ant-btn:only-child{border-radius:4px}.notes-ant-btn-group>span:only-child>.notes-ant-btn{border-radius:4px}.notes-ant-btn-group>.notes-ant-btn:first-child:not(:last-child),.notes-ant-btn-group>span:first-child:not(:last-child)>.notes-ant-btn{border-top-left-radius:4px;border-bottom-left-radius:4px}.notes-ant-btn-group>.notes-ant-btn:last-child:not(:first-child),.notes-ant-btn-group>span:last-child:not(:first-child)>.notes-ant-btn{border-top-right-radius:4px;border-bottom-right-radius:4px}.notes-ant-btn-group-sm>.notes-ant-btn:only-child{border-radius:4px}.notes-ant-btn-group-sm>span:only-child>.notes-ant-btn{border-radius:4px}.notes-ant-btn-group-sm>.notes-ant-btn:first-child:not(:last-child),.notes-ant-btn-group-sm>span:first-child:not(:last-child)>.notes-ant-btn{border-top-left-radius:4px;border-bottom-left-radius:4px}.notes-ant-btn-group-sm>.notes-ant-btn:last-child:not(:first-child),.notes-ant-btn-group-sm>span:last-child:not(:first-child)>.notes-ant-btn{border-top-right-radius:4px;border-bottom-right-radius:4px}.notes-ant-btn-group>.notes-ant-btn-group{float:left}.notes-ant-btn-group>.notes-ant-btn-group:not(:first-child):not(:last-child)>.notes-ant-btn{border-radius:0}.notes-ant-btn-group>.notes-ant-btn-group:first-child:not(:last-child)>.notes-ant-btn:last-child{padding-right:8px;border-top-right-radius:0;border-bottom-right-radius:0}.notes-ant-btn-group>.notes-ant-btn-group:last-child:not(:first-child)>.notes-ant-btn:first-child{padding-left:8px;border-top-left-radius:0;border-bottom-left-radius:0}.notes-ant-btn:focus>span,.notes-ant-btn:active>span{position:relative}.notes-ant-btn>.anticon+span,.notes-ant-btn>span+.anticon{margin-left:8px}.notes-ant-btn-background-ghost{color:#fff;background:transparent!important;border-color:#fff}.notes-ant-btn-background-ghost.notes-ant-btn-primary{color:#198746;background-color:transparent;border-color:#198746;text-shadow:none}.notes-ant-btn-background-ghost.notes-ant-btn-primary>a:only-child{color:currentColor}.notes-ant-btn-background-ghost.notes-ant-btn-primary>a:only-child:after{position:absolute;inset:0;background:transparent;content:""}.notes-ant-btn-background-ghost.notes-ant-btn-primary:hover,.notes-ant-btn-background-ghost.notes-ant-btn-primary:focus{color:#349459;background-color:transparent;border-color:#349459}.notes-ant-btn-background-ghost.notes-ant-btn-primary:hover>a:only-child,.notes-ant-btn-background-ghost.notes-ant-btn-primary:focus>a:only-child{color:currentColor}.notes-ant-btn-background-ghost.notes-ant-btn-primary:hover>a:only-child:after,.notes-ant-btn-background-ghost.notes-ant-btn-primary:focus>a:only-child:after{position:absolute;inset:0;background:transparent;content:""}.notes-ant-btn-background-ghost.notes-ant-btn-primary:active,.notes-ant-btn-background-ghost.notes-ant-btn-primary.active{color:#0e6133;background-color:transparent;border-color:#0e6133}.notes-ant-btn-background-ghost.notes-ant-btn-primary:active>a:only-child,.notes-ant-btn-background-ghost.notes-ant-btn-primary.active>a:only-child{color:currentColor}.notes-ant-btn-background-ghost.notes-ant-btn-primary:active>a:only-child:after,.notes-ant-btn-background-ghost.notes-ant-btn-primary.active>a:only-child:after{position:absolute;inset:0;background:transparent;content:""}.notes-ant-btn-background-ghost.notes-ant-btn-primary-disabled,.notes-ant-btn-background-ghost.notes-ant-btn-primary.disabled,.notes-ant-btn-background-ghost.notes-ant-btn-primary[disabled],.notes-ant-btn-background-ghost.notes-ant-btn-primary-disabled:hover,.notes-ant-btn-background-ghost.notes-ant-btn-primary.disabled:hover,.notes-ant-btn-background-ghost.notes-ant-btn-primary[disabled]:hover,.notes-ant-btn-background-ghost.notes-ant-btn-primary-disabled:focus,.notes-ant-btn-background-ghost.notes-ant-btn-primary.disabled:focus,.notes-ant-btn-background-ghost.notes-ant-btn-primary[disabled]:focus,.notes-ant-btn-background-ghost.notes-ant-btn-primary-disabled:active,.notes-ant-btn-background-ghost.notes-ant-btn-primary.disabled:active,.notes-ant-btn-background-ghost.notes-ant-btn-primary[disabled]:active,.notes-ant-btn-background-ghost.notes-ant-btn-primary-disabled.active,.notes-ant-btn-background-ghost.notes-ant-btn-primary.disabled.active,.notes-ant-btn-background-ghost.notes-ant-btn-primary[disabled].active{color:#c1c5c8;background-color:#f5f5f5;border-color:#d9d9d9;text-shadow:none;box-shadow:none}.notes-ant-btn-background-ghost.notes-ant-btn-primary-disabled>a:only-child,.notes-ant-btn-background-ghost.notes-ant-btn-primary.disabled>a:only-child,.notes-ant-btn-background-ghost.notes-ant-btn-primary[disabled]>a:only-child,.notes-ant-btn-background-ghost.notes-ant-btn-primary-disabled:hover>a:only-child,.notes-ant-btn-background-ghost.notes-ant-btn-primary.disabled:hover>a:only-child,.notes-ant-btn-background-ghost.notes-ant-btn-primary[disabled]:hover>a:only-child,.notes-ant-btn-background-ghost.notes-ant-btn-primary-disabled:focus>a:only-child,.notes-ant-btn-background-ghost.notes-ant-btn-primary.disabled:focus>a:only-child,.notes-ant-btn-background-ghost.notes-ant-btn-primary[disabled]:focus>a:only-child,.notes-ant-btn-background-ghost.notes-ant-btn-primary-disabled:active>a:only-child,.notes-ant-btn-background-ghost.notes-ant-btn-primary.disabled:active>a:only-child,.notes-ant-btn-background-ghost.notes-ant-btn-primary[disabled]:active>a:only-child,.notes-ant-btn-background-ghost.notes-ant-btn-primary-disabled.active>a:only-child,.notes-ant-btn-background-ghost.notes-ant-btn-primary.disabled.active>a:only-child,.notes-ant-btn-background-ghost.notes-ant-btn-primary[disabled].active>a:only-child{color:currentColor}.notes-ant-btn-background-ghost.notes-ant-btn-primary-disabled>a:only-child:after,.notes-ant-btn-background-ghost.notes-ant-btn-primary.disabled>a:only-child:after,.notes-ant-btn-background-ghost.notes-ant-btn-primary[disabled]>a:only-child:after,.notes-ant-btn-background-ghost.notes-ant-btn-primary-disabled:hover>a:only-child:after,.notes-ant-btn-background-ghost.notes-ant-btn-primary.disabled:hover>a:only-child:after,.notes-ant-btn-background-ghost.notes-ant-btn-primary[disabled]:hover>a:only-child:after,.notes-ant-btn-background-ghost.notes-ant-btn-primary-disabled:focus>a:only-child:after,.notes-ant-btn-background-ghost.notes-ant-btn-primary.disabled:focus>a:only-child:after,.notes-ant-btn-background-ghost.notes-ant-btn-primary[disabled]:focus>a:only-child:after,.notes-ant-btn-background-ghost.notes-ant-btn-primary-disabled:active>a:only-child:after,.notes-ant-btn-background-ghost.notes-ant-btn-primary.disabled:active>a:only-child:after,.notes-ant-btn-background-ghost.notes-ant-btn-primary[disabled]:active>a:only-child:after,.notes-ant-btn-background-ghost.notes-ant-btn-primary-disabled.active>a:only-child:after,.notes-ant-btn-background-ghost.notes-ant-btn-primary.disabled.active>a:only-child:after,.notes-ant-btn-background-ghost.notes-ant-btn-primary[disabled].active>a:only-child:after{position:absolute;inset:0;background:transparent;content:""}.notes-ant-btn-background-ghost.notes-ant-btn-danger{color:#ff4d4f;background-color:transparent;border-color:#ff4d4f;text-shadow:none}.notes-ant-btn-background-ghost.notes-ant-btn-danger>a:only-child{color:currentColor}.notes-ant-btn-background-ghost.notes-ant-btn-danger>a:only-child:after{position:absolute;inset:0;background:transparent;content:""}.notes-ant-btn-background-ghost.notes-ant-btn-danger:hover,.notes-ant-btn-background-ghost.notes-ant-btn-danger:focus{color:#ff7875;background-color:transparent;border-color:#ff7875}.notes-ant-btn-background-ghost.notes-ant-btn-danger:hover>a:only-child,.notes-ant-btn-background-ghost.notes-ant-btn-danger:focus>a:only-child{color:currentColor}.notes-ant-btn-background-ghost.notes-ant-btn-danger:hover>a:only-child:after,.notes-ant-btn-background-ghost.notes-ant-btn-danger:focus>a:only-child:after{position:absolute;inset:0;background:transparent;content:""}.notes-ant-btn-background-ghost.notes-ant-btn-danger:active,.notes-ant-btn-background-ghost.notes-ant-btn-danger.active{color:#d9363e;background-color:transparent;border-color:#d9363e}.notes-ant-btn-background-ghost.notes-ant-btn-danger:active>a:only-child,.notes-ant-btn-background-ghost.notes-ant-btn-danger.active>a:only-child{color:currentColor}.notes-ant-btn-background-ghost.notes-ant-btn-danger:active>a:only-child:after,.notes-ant-btn-background-ghost.notes-ant-btn-danger.active>a:only-child:after{position:absolute;inset:0;background:transparent;content:""}.notes-ant-btn-background-ghost.notes-ant-btn-danger-disabled,.notes-ant-btn-background-ghost.notes-ant-btn-danger.disabled,.notes-ant-btn-background-ghost.notes-ant-btn-danger[disabled],.notes-ant-btn-background-ghost.notes-ant-btn-danger-disabled:hover,.notes-ant-btn-background-ghost.notes-ant-btn-danger.disabled:hover,.notes-ant-btn-background-ghost.notes-ant-btn-danger[disabled]:hover,.notes-ant-btn-background-ghost.notes-ant-btn-danger-disabled:focus,.notes-ant-btn-background-ghost.notes-ant-btn-danger.disabled:focus,.notes-ant-btn-background-ghost.notes-ant-btn-danger[disabled]:focus,.notes-ant-btn-background-ghost.notes-ant-btn-danger-disabled:active,.notes-ant-btn-background-ghost.notes-ant-btn-danger.disabled:active,.notes-ant-btn-background-ghost.notes-ant-btn-danger[disabled]:active,.notes-ant-btn-background-ghost.notes-ant-btn-danger-disabled.active,.notes-ant-btn-background-ghost.notes-ant-btn-danger.disabled.active,.notes-ant-btn-background-ghost.notes-ant-btn-danger[disabled].active{color:#c1c5c8;background-color:#f5f5f5;border-color:#d9d9d9;text-shadow:none;box-shadow:none}.notes-ant-btn-background-ghost.notes-ant-btn-danger-disabled>a:only-child,.notes-ant-btn-background-ghost.notes-ant-btn-danger.disabled>a:only-child,.notes-ant-btn-background-ghost.notes-ant-btn-danger[disabled]>a:only-child,.notes-ant-btn-background-ghost.notes-ant-btn-danger-disabled:hover>a:only-child,.notes-ant-btn-background-ghost.notes-ant-btn-danger.disabled:hover>a:only-child,.notes-ant-btn-background-ghost.notes-ant-btn-danger[disabled]:hover>a:only-child,.notes-ant-btn-background-ghost.notes-ant-btn-danger-disabled:focus>a:only-child,.notes-ant-btn-background-ghost.notes-ant-btn-danger.disabled:focus>a:only-child,.notes-ant-btn-background-ghost.notes-ant-btn-danger[disabled]:focus>a:only-child,.notes-ant-btn-background-ghost.notes-ant-btn-danger-disabled:active>a:only-child,.notes-ant-btn-background-ghost.notes-ant-btn-danger.disabled:active>a:only-child,.notes-ant-btn-background-ghost.notes-ant-btn-danger[disabled]:active>a:only-child,.notes-ant-btn-background-ghost.notes-ant-btn-danger-disabled.active>a:only-child,.notes-ant-btn-background-ghost.notes-ant-btn-danger.disabled.active>a:only-child,.notes-ant-btn-background-ghost.notes-ant-btn-danger[disabled].active>a:only-child{color:currentColor}.notes-ant-btn-background-ghost.notes-ant-btn-danger-disabled>a:only-child:after,.notes-ant-btn-background-ghost.notes-ant-btn-danger.disabled>a:only-child:after,.notes-ant-btn-background-ghost.notes-ant-btn-danger[disabled]>a:only-child:after,.notes-ant-btn-background-ghost.notes-ant-btn-danger-disabled:hover>a:only-child:after,.notes-ant-btn-background-ghost.notes-ant-btn-danger.disabled:hover>a:only-child:after,.notes-ant-btn-background-ghost.notes-ant-btn-danger[disabled]:hover>a:only-child:after,.notes-ant-btn-background-ghost.notes-ant-btn-danger-disabled:focus>a:only-child:after,.notes-ant-btn-background-ghost.notes-ant-btn-danger.disabled:focus>a:only-child:after,.notes-ant-btn-background-ghost.notes-ant-btn-danger[disabled]:focus>a:only-child:after,.notes-ant-btn-background-ghost.notes-ant-btn-danger-disabled:active>a:only-child:after,.notes-ant-btn-background-ghost.notes-ant-btn-danger.disabled:active>a:only-child:after,.notes-ant-btn-background-ghost.notes-ant-btn-danger[disabled]:active>a:only-child:after,.notes-ant-btn-background-ghost.notes-ant-btn-danger-disabled.active>a:only-child:after,.notes-ant-btn-background-ghost.notes-ant-btn-danger.disabled.active>a:only-child:after,.notes-ant-btn-background-ghost.notes-ant-btn-danger[disabled].active>a:only-child:after{position:absolute;inset:0;background:transparent;content:""}.notes-ant-btn-background-ghost.notes-ant-btn-link{color:#198746;background-color:transparent;border-color:transparent;text-shadow:none;color:#fff}.notes-ant-btn-background-ghost.notes-ant-btn-link>a:only-child{color:currentColor}.notes-ant-btn-background-ghost.notes-ant-btn-link>a:only-child:after{position:absolute;inset:0;background:transparent;content:""}.notes-ant-btn-background-ghost.notes-ant-btn-link:hover,.notes-ant-btn-background-ghost.notes-ant-btn-link:focus{color:#349459;background-color:transparent;border-color:transparent}.notes-ant-btn-background-ghost.notes-ant-btn-link:hover>a:only-child,.notes-ant-btn-background-ghost.notes-ant-btn-link:focus>a:only-child{color:currentColor}.notes-ant-btn-background-ghost.notes-ant-btn-link:hover>a:only-child:after,.notes-ant-btn-background-ghost.notes-ant-btn-link:focus>a:only-child:after{position:absolute;inset:0;background:transparent;content:""}.notes-ant-btn-background-ghost.notes-ant-btn-link:active,.notes-ant-btn-background-ghost.notes-ant-btn-link.active{color:#0e6133;background-color:transparent;border-color:transparent}.notes-ant-btn-background-ghost.notes-ant-btn-link:active>a:only-child,.notes-ant-btn-background-ghost.notes-ant-btn-link.active>a:only-child{color:currentColor}.notes-ant-btn-background-ghost.notes-ant-btn-link:active>a:only-child:after,.notes-ant-btn-background-ghost.notes-ant-btn-link.active>a:only-child:after{position:absolute;inset:0;background:transparent;content:""}.notes-ant-btn-background-ghost.notes-ant-btn-link-disabled,.notes-ant-btn-background-ghost.notes-ant-btn-link.disabled,.notes-ant-btn-background-ghost.notes-ant-btn-link[disabled],.notes-ant-btn-background-ghost.notes-ant-btn-link-disabled:hover,.notes-ant-btn-background-ghost.notes-ant-btn-link.disabled:hover,.notes-ant-btn-background-ghost.notes-ant-btn-link[disabled]:hover,.notes-ant-btn-background-ghost.notes-ant-btn-link-disabled:focus,.notes-ant-btn-background-ghost.notes-ant-btn-link.disabled:focus,.notes-ant-btn-background-ghost.notes-ant-btn-link[disabled]:focus,.notes-ant-btn-background-ghost.notes-ant-btn-link-disabled:active,.notes-ant-btn-background-ghost.notes-ant-btn-link.disabled:active,.notes-ant-btn-background-ghost.notes-ant-btn-link[disabled]:active,.notes-ant-btn-background-ghost.notes-ant-btn-link-disabled.active,.notes-ant-btn-background-ghost.notes-ant-btn-link.disabled.active,.notes-ant-btn-background-ghost.notes-ant-btn-link[disabled].active{color:#c1c5c8;background-color:#f5f5f5;border-color:#d9d9d9;text-shadow:none;box-shadow:none}.notes-ant-btn-background-ghost.notes-ant-btn-link-disabled>a:only-child,.notes-ant-btn-background-ghost.notes-ant-btn-link.disabled>a:only-child,.notes-ant-btn-background-ghost.notes-ant-btn-link[disabled]>a:only-child,.notes-ant-btn-background-ghost.notes-ant-btn-link-disabled:hover>a:only-child,.notes-ant-btn-background-ghost.notes-ant-btn-link.disabled:hover>a:only-child,.notes-ant-btn-background-ghost.notes-ant-btn-link[disabled]:hover>a:only-child,.notes-ant-btn-background-ghost.notes-ant-btn-link-disabled:focus>a:only-child,.notes-ant-btn-background-ghost.notes-ant-btn-link.disabled:focus>a:only-child,.notes-ant-btn-background-ghost.notes-ant-btn-link[disabled]:focus>a:only-child,.notes-ant-btn-background-ghost.notes-ant-btn-link-disabled:active>a:only-child,.notes-ant-btn-background-ghost.notes-ant-btn-link.disabled:active>a:only-child,.notes-ant-btn-background-ghost.notes-ant-btn-link[disabled]:active>a:only-child,.notes-ant-btn-background-ghost.notes-ant-btn-link-disabled.active>a:only-child,.notes-ant-btn-background-ghost.notes-ant-btn-link.disabled.active>a:only-child,.notes-ant-btn-background-ghost.notes-ant-btn-link[disabled].active>a:only-child{color:currentColor}.notes-ant-btn-background-ghost.notes-ant-btn-link-disabled>a:only-child:after,.notes-ant-btn-background-ghost.notes-ant-btn-link.disabled>a:only-child:after,.notes-ant-btn-background-ghost.notes-ant-btn-link[disabled]>a:only-child:after,.notes-ant-btn-background-ghost.notes-ant-btn-link-disabled:hover>a:only-child:after,.notes-ant-btn-background-ghost.notes-ant-btn-link.disabled:hover>a:only-child:after,.notes-ant-btn-background-ghost.notes-ant-btn-link[disabled]:hover>a:only-child:after,.notes-ant-btn-background-ghost.notes-ant-btn-link-disabled:focus>a:only-child:after,.notes-ant-btn-background-ghost.notes-ant-btn-link.disabled:focus>a:only-child:after,.notes-ant-btn-background-ghost.notes-ant-btn-link[disabled]:focus>a:only-child:after,.notes-ant-btn-background-ghost.notes-ant-btn-link-disabled:active>a:only-child:after,.notes-ant-btn-background-ghost.notes-ant-btn-link.disabled:active>a:only-child:after,.notes-ant-btn-background-ghost.notes-ant-btn-link[disabled]:active>a:only-child:after,.notes-ant-btn-background-ghost.notes-ant-btn-link-disabled.active>a:only-child:after,.notes-ant-btn-background-ghost.notes-ant-btn-link.disabled.active>a:only-child:after,.notes-ant-btn-background-ghost.notes-ant-btn-link[disabled].active>a:only-child:after{position:absolute;inset:0;background:transparent;content:""}.notes-ant-btn-two-chinese-chars:first-letter{letter-spacing:.34em}.notes-ant-btn-two-chinese-chars>*:not(.anticon){margin-right:-.34em;letter-spacing:.34em}.notes-ant-btn-block{width:100%}.notes-ant-btn:empty{vertical-align:top}a.notes-ant-btn{padding-top:.1px;line-height:30px}a.notes-ant-btn-lg{line-height:38px}a.notes-ant-btn-sm{line-height:22px}.notes-ant-calendar-picker-container{box-sizing:border-box;margin:0;padding:0;color:#000000a6;font-size:14px;font-variant:tabular-nums;line-height:1.5;list-style:none;font-feature-settings:"tnum";position:absolute;z-index:1050;font-family:Noto Sans,sans-serif}.notes-ant-calendar-picker-container.slide-up-enter.slide-up-enter-active.notes-ant-calendar-picker-container-placement-topLeft,.notes-ant-calendar-picker-container.slide-up-enter.slide-up-enter-active.notes-ant-calendar-picker-container-placement-topRight,.notes-ant-calendar-picker-container.slide-up-appear.slide-up-appear-active.notes-ant-calendar-picker-container-placement-topLeft,.notes-ant-calendar-picker-container.slide-up-appear.slide-up-appear-active.notes-ant-calendar-picker-container-placement-topRight{animation-name:antSlideDownIn}.notes-ant-calendar-picker-container.slide-up-enter.slide-up-enter-active.notes-ant-calendar-picker-container-placement-bottomLeft,.notes-ant-calendar-picker-container.slide-up-enter.slide-up-enter-active.notes-ant-calendar-picker-container-placement-bottomRight,.notes-ant-calendar-picker-container.slide-up-appear.slide-up-appear-active.notes-ant-calendar-picker-container-placement-bottomLeft,.notes-ant-calendar-picker-container.slide-up-appear.slide-up-appear-active.notes-ant-calendar-picker-container-placement-bottomRight{animation-name:antSlideUpIn}.notes-ant-calendar-picker-container.slide-up-leave.slide-up-leave-active.notes-ant-calendar-picker-container-placement-topLeft,.notes-ant-calendar-picker-container.slide-up-leave.slide-up-leave-active.notes-ant-calendar-picker-container-placement-topRight{animation-name:antSlideDownOut}.notes-ant-calendar-picker-container.slide-up-leave.slide-up-leave-active.notes-ant-calendar-picker-container-placement-bottomLeft,.notes-ant-calendar-picker-container.slide-up-leave.slide-up-leave-active.notes-ant-calendar-picker-container-placement-bottomRight{animation-name:antSlideUpOut}.notes-ant-calendar-picker{box-sizing:border-box;margin:0;padding:0;color:#000000a6;font-size:14px;font-variant:tabular-nums;line-height:1.5;list-style:none;font-feature-settings:"tnum";position:relative;display:inline-block;outline:none;cursor:text;transition:opacity .3s}.notes-ant-calendar-picker-input{outline:none}.notes-ant-calendar-picker-input.notes-ant-input{line-height:1.5}.notes-ant-calendar-picker-input.notes-ant-input-sm{padding-top:0;padding-bottom:0}.notes-ant-calendar-picker:hover .notes-ant-calendar-picker-input:not(.notes-ant-input-disabled){border-color:#349459}.notes-ant-calendar-picker:focus .notes-ant-calendar-picker-input:not(.notes-ant-input-disabled){border-color:#349459;border-right-width:1px!important;outline:0;box-shadow:0 0 0 2px #19874633}.notes-ant-calendar-picker-clear,.notes-ant-calendar-picker-icon{position:absolute;top:50%;right:12px;z-index:1;width:14px;height:14px;margin-top:-7px;font-size:12px;line-height:14px;transition:all .3s;user-select:none}.notes-ant-calendar-picker-clear{z-index:2;color:#c1c5c8;font-size:14px;background:#fff;cursor:pointer;opacity:0;pointer-events:none}.notes-ant-calendar-picker-clear:hover{color:#00000073}.notes-ant-calendar-picker:hover .notes-ant-calendar-picker-clear{opacity:1;pointer-events:auto}.notes-ant-calendar-picker-icon{display:inline-block;color:#c1c5c8;font-size:14px;line-height:1}.notes-ant-input-disabled+.notes-ant-calendar-picker-icon{cursor:not-allowed}.notes-ant-calendar-picker-small .notes-ant-calendar-picker-clear,.notes-ant-calendar-picker-small .notes-ant-calendar-picker-icon{right:8px}.notes-ant-calendar{position:relative;width:280px;font-size:14px;line-height:1.5;text-align:left;list-style:none;background-color:#fff;background-clip:padding-box;border:1px solid #fff;border-radius:4px;outline:none;box-shadow:0 2px 8px #00000026}.notes-ant-calendar-input-wrap{height:34px;padding:6px 10px;border-bottom:1px solid #e8e8e8}.notes-ant-calendar-input{width:100%;height:22px;color:#000000a6;background:#fff;border:0;outline:0;cursor:auto}.notes-ant-calendar-input::-moz-placeholder{color:#bfbfbf;opacity:1}.notes-ant-calendar-input:-ms-input-placeholder{color:#bfbfbf}.notes-ant-calendar-input::-webkit-input-placeholder{color:#bfbfbf}.notes-ant-calendar-input:placeholder-shown{text-overflow:ellipsis}.notes-ant-calendar-week-number{width:286px}.notes-ant-calendar-week-number-cell{text-align:center}.notes-ant-calendar-header{height:40px;line-height:40px;text-align:center;border-bottom:1px solid #e8e8e8;user-select:none}.notes-ant-calendar-header a:hover{color:#349459}.notes-ant-calendar-header .notes-ant-calendar-century-select,.notes-ant-calendar-header .notes-ant-calendar-decade-select,.notes-ant-calendar-header .notes-ant-calendar-year-select,.notes-ant-calendar-header .notes-ant-calendar-month-select{display:inline-block;padding:0 2px;color:#000000d9;font-weight:500;line-height:40px}.notes-ant-calendar-header .notes-ant-calendar-century-select-arrow,.notes-ant-calendar-header .notes-ant-calendar-decade-select-arrow,.notes-ant-calendar-header .notes-ant-calendar-year-select-arrow,.notes-ant-calendar-header .notes-ant-calendar-month-select-arrow{display:none}.notes-ant-calendar-header .notes-ant-calendar-prev-century-btn,.notes-ant-calendar-header .notes-ant-calendar-next-century-btn,.notes-ant-calendar-header .notes-ant-calendar-prev-decade-btn,.notes-ant-calendar-header .notes-ant-calendar-next-decade-btn,.notes-ant-calendar-header .notes-ant-calendar-prev-month-btn,.notes-ant-calendar-header .notes-ant-calendar-next-month-btn,.notes-ant-calendar-header .notes-ant-calendar-prev-year-btn,.notes-ant-calendar-header .notes-ant-calendar-next-year-btn{position:absolute;top:0;display:inline-block;padding:0 5px;color:#00000073;font-size:16px;font-family:Arial,Hiragino Sans GB,Microsoft Yahei,"Microsoft Sans Serif",sans-serif;line-height:40px}.notes-ant-calendar-header .notes-ant-calendar-prev-century-btn,.notes-ant-calendar-header .notes-ant-calendar-prev-decade-btn,.notes-ant-calendar-header .notes-ant-calendar-prev-year-btn{left:7px;height:100%}.notes-ant-calendar-header .notes-ant-calendar-prev-century-btn:before,.notes-ant-calendar-header .notes-ant-calendar-prev-decade-btn:before,.notes-ant-calendar-header .notes-ant-calendar-prev-year-btn:before,.notes-ant-calendar-header .notes-ant-calendar-prev-century-btn:after,.notes-ant-calendar-header .notes-ant-calendar-prev-decade-btn:after,.notes-ant-calendar-header .notes-ant-calendar-prev-year-btn:after{position:relative;top:-1px;display:inline-block;width:8px;height:8px;vertical-align:middle;border:0 solid #aaa;border-width:1.5px 0 0 1.5px;border-radius:1px;transform:rotate(-45deg) scale(.8);transition:all .3s;content:""}.notes-ant-calendar-header .notes-ant-calendar-prev-century-btn:hover:before,.notes-ant-calendar-header .notes-ant-calendar-prev-decade-btn:hover:before,.notes-ant-calendar-header .notes-ant-calendar-prev-year-btn:hover:before,.notes-ant-calendar-header .notes-ant-calendar-prev-century-btn:hover:after,.notes-ant-calendar-header .notes-ant-calendar-prev-decade-btn:hover:after,.notes-ant-calendar-header .notes-ant-calendar-prev-year-btn:hover:after{border-color:#000000a6}.notes-ant-calendar-header .notes-ant-calendar-prev-century-btn:after,.notes-ant-calendar-header .notes-ant-calendar-prev-decade-btn:after,.notes-ant-calendar-header .notes-ant-calendar-prev-year-btn:after{display:none}.notes-ant-calendar-header .notes-ant-calendar-prev-century-btn:after,.notes-ant-calendar-header .notes-ant-calendar-prev-decade-btn:after,.notes-ant-calendar-header .notes-ant-calendar-prev-year-btn:after{position:relative;left:-3px;display:inline-block}.notes-ant-calendar-header .notes-ant-calendar-next-century-btn,.notes-ant-calendar-header .notes-ant-calendar-next-decade-btn,.notes-ant-calendar-header .notes-ant-calendar-next-year-btn{right:7px;height:100%}.notes-ant-calendar-header .notes-ant-calendar-next-century-btn:before,.notes-ant-calendar-header .notes-ant-calendar-next-decade-btn:before,.notes-ant-calendar-header .notes-ant-calendar-next-year-btn:before,.notes-ant-calendar-header .notes-ant-calendar-next-century-btn:after,.notes-ant-calendar-header .notes-ant-calendar-next-decade-btn:after,.notes-ant-calendar-header .notes-ant-calendar-next-year-btn:after{position:relative;top:-1px;display:inline-block;width:8px;height:8px;vertical-align:middle;border:0 solid #aaa;border-width:1.5px 0 0 1.5px;border-radius:1px;transform:rotate(-45deg) scale(.8);transition:all .3s;content:""}.notes-ant-calendar-header .notes-ant-calendar-next-century-btn:hover:before,.notes-ant-calendar-header .notes-ant-calendar-next-decade-btn:hover:before,.notes-ant-calendar-header .notes-ant-calendar-next-year-btn:hover:before,.notes-ant-calendar-header .notes-ant-calendar-next-century-btn:hover:after,.notes-ant-calendar-header .notes-ant-calendar-next-decade-btn:hover:after,.notes-ant-calendar-header .notes-ant-calendar-next-year-btn:hover:after{border-color:#000000a6}.notes-ant-calendar-header .notes-ant-calendar-next-century-btn:after,.notes-ant-calendar-header .notes-ant-calendar-next-decade-btn:after,.notes-ant-calendar-header .notes-ant-calendar-next-year-btn:after{display:none}.notes-ant-calendar-header .notes-ant-calendar-next-century-btn:before,.notes-ant-calendar-header .notes-ant-calendar-next-decade-btn:before,.notes-ant-calendar-header .notes-ant-calendar-next-year-btn:before,.notes-ant-calendar-header .notes-ant-calendar-next-century-btn:after,.notes-ant-calendar-header .notes-ant-calendar-next-decade-btn:after,.notes-ant-calendar-header .notes-ant-calendar-next-year-btn:after{transform:rotate(135deg) scale(.8)}.notes-ant-calendar-header .notes-ant-calendar-next-century-btn:before,.notes-ant-calendar-header .notes-ant-calendar-next-decade-btn:before,.notes-ant-calendar-header .notes-ant-calendar-next-year-btn:before{position:relative;left:3px}.notes-ant-calendar-header .notes-ant-calendar-next-century-btn:after,.notes-ant-calendar-header .notes-ant-calendar-next-decade-btn:after,.notes-ant-calendar-header .notes-ant-calendar-next-year-btn:after{display:inline-block}.notes-ant-calendar-header .notes-ant-calendar-prev-month-btn{left:29px;height:100%}.notes-ant-calendar-header .notes-ant-calendar-prev-month-btn:before,.notes-ant-calendar-header .notes-ant-calendar-prev-month-btn:after{position:relative;top:-1px;display:inline-block;width:8px;height:8px;vertical-align:middle;border:0 solid #aaa;border-width:1.5px 0 0 1.5px;border-radius:1px;transform:rotate(-45deg) scale(.8);transition:all .3s;content:""}.notes-ant-calendar-header .notes-ant-calendar-prev-month-btn:hover:before,.notes-ant-calendar-header .notes-ant-calendar-prev-month-btn:hover:after{border-color:#000000a6}.notes-ant-calendar-header .notes-ant-calendar-prev-month-btn:after{display:none}.notes-ant-calendar-header .notes-ant-calendar-next-month-btn{right:29px;height:100%}.notes-ant-calendar-header .notes-ant-calendar-next-month-btn:before,.notes-ant-calendar-header .notes-ant-calendar-next-month-btn:after{position:relative;top:-1px;display:inline-block;width:8px;height:8px;vertical-align:middle;border:0 solid #aaa;border-width:1.5px 0 0 1.5px;border-radius:1px;transform:rotate(-45deg) scale(.8);transition:all .3s;content:""}.notes-ant-calendar-header .notes-ant-calendar-next-month-btn:hover:before,.notes-ant-calendar-header .notes-ant-calendar-next-month-btn:hover:after{border-color:#000000a6}.notes-ant-calendar-header .notes-ant-calendar-next-month-btn:after{display:none}.notes-ant-calendar-header .notes-ant-calendar-next-month-btn:before,.notes-ant-calendar-header .notes-ant-calendar-next-month-btn:after{transform:rotate(135deg) scale(.8)}.notes-ant-calendar-body{padding:8px 12px}.notes-ant-calendar table{width:100%;max-width:100%;background-color:transparent;border-collapse:collapse}.notes-ant-calendar table,.notes-ant-calendar th,.notes-ant-calendar td{text-align:center;border:0}.notes-ant-calendar-calendar-table{margin-bottom:0;border-spacing:0}.notes-ant-calendar-column-header{width:33px;padding:6px 0;line-height:18px;text-align:center}.notes-ant-calendar-column-header .notes-ant-calendar-column-header-inner{display:block;font-weight:400}.notes-ant-calendar-week-number-header .notes-ant-calendar-column-header-inner{display:none}.notes-ant-calendar-cell{height:30px;padding:3px 0}.notes-ant-calendar-date{display:block;width:24px;height:24px;margin:0 auto;padding:0;color:#000000a6;line-height:22px;text-align:center;background:transparent;border:1px solid transparent;border-radius:2px;transition:background .3s ease}.notes-ant-calendar-date-panel{position:relative;outline:none}.notes-ant-calendar-date:hover{background:#bbc7be;cursor:pointer}.notes-ant-calendar-date:active{color:#fff;background:#349459}.notes-ant-calendar-today .notes-ant-calendar-date{color:#198746;font-weight:700;border-color:#198746}.notes-ant-calendar-selected-day .notes-ant-calendar-date{background:#9bbaa3}.notes-ant-calendar-last-month-cell .notes-ant-calendar-date,.notes-ant-calendar-next-month-btn-day .notes-ant-calendar-date,.notes-ant-calendar-last-month-cell .notes-ant-calendar-date:hover,.notes-ant-calendar-next-month-btn-day .notes-ant-calendar-date:hover{color:#c1c5c8;background:transparent;border-color:transparent}.notes-ant-calendar-disabled-cell .notes-ant-calendar-date{position:relative;width:auto;color:#c1c5c8;background:#f5f5f5;border:1px solid transparent;border-radius:0;cursor:not-allowed}.notes-ant-calendar-disabled-cell .notes-ant-calendar-date:hover{background:#f5f5f5}.notes-ant-calendar-disabled-cell.notes-ant-calendar-selected-day .notes-ant-calendar-date:before{position:absolute;top:-1px;left:5px;width:24px;height:24px;background:rgba(0,0,0,.1);border-radius:2px;content:""}.notes-ant-calendar-disabled-cell.notes-ant-calendar-today .notes-ant-calendar-date{position:relative;padding-right:5px;padding-left:5px}.notes-ant-calendar-disabled-cell.notes-ant-calendar-today .notes-ant-calendar-date:before{position:absolute;top:-1px;left:5px;width:24px;height:24px;border:1px solid #c1c5c8;border-radius:2px;content:" "}.notes-ant-calendar-disabled-cell-first-of-row .notes-ant-calendar-date{border-top-left-radius:4px;border-bottom-left-radius:4px}.notes-ant-calendar-disabled-cell-last-of-row .notes-ant-calendar-date{border-top-right-radius:4px;border-bottom-right-radius:4px}.notes-ant-calendar-footer{padding:0 12px;line-height:38px;border-top:1px solid #e8e8e8}.notes-ant-calendar-footer:empty{border-top:0}.notes-ant-calendar-footer-btn{display:block;text-align:center}.notes-ant-calendar-footer-extra{text-align:left}.notes-ant-calendar .notes-ant-calendar-today-btn,.notes-ant-calendar .notes-ant-calendar-clear-btn{display:inline-block;margin:0 0 0 8px;text-align:center}.notes-ant-calendar .notes-ant-calendar-today-btn-disabled,.notes-ant-calendar .notes-ant-calendar-clear-btn-disabled{color:#c1c5c8;cursor:not-allowed}.notes-ant-calendar .notes-ant-calendar-today-btn:only-child,.notes-ant-calendar .notes-ant-calendar-clear-btn:only-child{margin:0}.notes-ant-calendar .notes-ant-calendar-clear-btn{position:absolute;top:7px;right:5px;display:none;width:20px;height:20px;margin:0;overflow:hidden;line-height:20px;text-align:center;text-indent:-76px}.notes-ant-calendar .notes-ant-calendar-clear-btn:after{display:inline-block;width:20px;color:#c1c5c8;font-size:14px;line-height:1;text-indent:43px;transition:color .3s ease}.notes-ant-calendar .notes-ant-calendar-clear-btn:hover:after{color:#00000073}.notes-ant-calendar .notes-ant-calendar-ok-btn{position:relative;display:inline-block;font-weight:400;white-space:nowrap;text-align:center;background-image:none;border:1px solid transparent;box-shadow:0 2px #00000004;cursor:pointer;transition:all .3s cubic-bezier(.645,.045,.355,1);user-select:none;touch-action:manipulation;height:32px;color:#fff;background-color:#198746;border-color:#198746;text-shadow:0 -1px 0 rgba(0,0,0,.12);box-shadow:0 2px #0000000b;height:24px;padding:0 7px;font-size:14px;border-radius:4px;line-height:22px}.notes-ant-calendar .notes-ant-calendar-ok-btn>.anticon{line-height:1}.notes-ant-calendar .notes-ant-calendar-ok-btn,.notes-ant-calendar .notes-ant-calendar-ok-btn:active,.notes-ant-calendar .notes-ant-calendar-ok-btn:focus{outline:0}.notes-ant-calendar .notes-ant-calendar-ok-btn:not([disabled]):hover{text-decoration:none}.notes-ant-calendar .notes-ant-calendar-ok-btn:not([disabled]):active{outline:0;box-shadow:none}.notes-ant-calendar .notes-ant-calendar-ok-btn.disabled,.notes-ant-calendar .notes-ant-calendar-ok-btn[disabled]{cursor:not-allowed}.notes-ant-calendar .notes-ant-calendar-ok-btn.disabled>*,.notes-ant-calendar .notes-ant-calendar-ok-btn[disabled]>*{pointer-events:none}.notes-ant-calendar .notes-ant-calendar-ok-btn-lg{height:40px;padding:0 15px;font-size:16px;border-radius:4px}.notes-ant-calendar .notes-ant-calendar-ok-btn-sm{height:24px;padding:0 7px;font-size:14px;border-radius:4px}.notes-ant-calendar .notes-ant-calendar-ok-btn>a:only-child{color:currentColor}.notes-ant-calendar .notes-ant-calendar-ok-btn>a:only-child:after{position:absolute;inset:0;background:transparent;content:""}.notes-ant-calendar .notes-ant-calendar-ok-btn:hover,.notes-ant-calendar .notes-ant-calendar-ok-btn:focus{color:#fff;background-color:#349459;border-color:#349459}.notes-ant-calendar .notes-ant-calendar-ok-btn:hover>a:only-child,.notes-ant-calendar .notes-ant-calendar-ok-btn:focus>a:only-child{color:currentColor}.notes-ant-calendar .notes-ant-calendar-ok-btn:hover>a:only-child:after,.notes-ant-calendar .notes-ant-calendar-ok-btn:focus>a:only-child:after{position:absolute;inset:0;background:transparent;content:""}.notes-ant-calendar .notes-ant-calendar-ok-btn:active,.notes-ant-calendar .notes-ant-calendar-ok-btn.active{color:#fff;background-color:#0e6133;border-color:#0e6133}.notes-ant-calendar .notes-ant-calendar-ok-btn:active>a:only-child,.notes-ant-calendar .notes-ant-calendar-ok-btn.active>a:only-child{color:currentColor}.notes-ant-calendar .notes-ant-calendar-ok-btn:active>a:only-child:after,.notes-ant-calendar .notes-ant-calendar-ok-btn.active>a:only-child:after{position:absolute;inset:0;background:transparent;content:""}.notes-ant-calendar .notes-ant-calendar-ok-btn-disabled,.notes-ant-calendar .notes-ant-calendar-ok-btn.disabled,.notes-ant-calendar .notes-ant-calendar-ok-btn[disabled],.notes-ant-calendar .notes-ant-calendar-ok-btn-disabled:hover,.notes-ant-calendar .notes-ant-calendar-ok-btn.disabled:hover,.notes-ant-calendar .notes-ant-calendar-ok-btn[disabled]:hover,.notes-ant-calendar .notes-ant-calendar-ok-btn-disabled:focus,.notes-ant-calendar .notes-ant-calendar-ok-btn.disabled:focus,.notes-ant-calendar .notes-ant-calendar-ok-btn[disabled]:focus,.notes-ant-calendar .notes-ant-calendar-ok-btn-disabled:active,.notes-ant-calendar .notes-ant-calendar-ok-btn.disabled:active,.notes-ant-calendar .notes-ant-calendar-ok-btn[disabled]:active,.notes-ant-calendar .notes-ant-calendar-ok-btn-disabled.active,.notes-ant-calendar .notes-ant-calendar-ok-btn.disabled.active,.notes-ant-calendar .notes-ant-calendar-ok-btn[disabled].active{color:#c1c5c8;background-color:#f5f5f5;border-color:#d9d9d9;text-shadow:none;box-shadow:none}.notes-ant-calendar .notes-ant-calendar-ok-btn-disabled>a:only-child,.notes-ant-calendar .notes-ant-calendar-ok-btn.disabled>a:only-child,.notes-ant-calendar .notes-ant-calendar-ok-btn[disabled]>a:only-child,.notes-ant-calendar .notes-ant-calendar-ok-btn-disabled:hover>a:only-child,.notes-ant-calendar .notes-ant-calendar-ok-btn.disabled:hover>a:only-child,.notes-ant-calendar .notes-ant-calendar-ok-btn[disabled]:hover>a:only-child,.notes-ant-calendar .notes-ant-calendar-ok-btn-disabled:focus>a:only-child,.notes-ant-calendar .notes-ant-calendar-ok-btn.disabled:focus>a:only-child,.notes-ant-calendar .notes-ant-calendar-ok-btn[disabled]:focus>a:only-child,.notes-ant-calendar .notes-ant-calendar-ok-btn-disabled:active>a:only-child,.notes-ant-calendar .notes-ant-calendar-ok-btn.disabled:active>a:only-child,.notes-ant-calendar .notes-ant-calendar-ok-btn[disabled]:active>a:only-child,.notes-ant-calendar .notes-ant-calendar-ok-btn-disabled.active>a:only-child,.notes-ant-calendar .notes-ant-calendar-ok-btn.disabled.active>a:only-child,.notes-ant-calendar .notes-ant-calendar-ok-btn[disabled].active>a:only-child{color:currentColor}.notes-ant-calendar .notes-ant-calendar-ok-btn-disabled>a:only-child:after,.notes-ant-calendar .notes-ant-calendar-ok-btn.disabled>a:only-child:after,.notes-ant-calendar .notes-ant-calendar-ok-btn[disabled]>a:only-child:after,.notes-ant-calendar .notes-ant-calendar-ok-btn-disabled:hover>a:only-child:after,.notes-ant-calendar .notes-ant-calendar-ok-btn.disabled:hover>a:only-child:after,.notes-ant-calendar .notes-ant-calendar-ok-btn[disabled]:hover>a:only-child:after,.notes-ant-calendar .notes-ant-calendar-ok-btn-disabled:focus>a:only-child:after,.notes-ant-calendar .notes-ant-calendar-ok-btn.disabled:focus>a:only-child:after,.notes-ant-calendar .notes-ant-calendar-ok-btn[disabled]:focus>a:only-child:after,.notes-ant-calendar .notes-ant-calendar-ok-btn-disabled:active>a:only-child:after,.notes-ant-calendar .notes-ant-calendar-ok-btn.disabled:active>a:only-child:after,.notes-ant-calendar .notes-ant-calendar-ok-btn[disabled]:active>a:only-child:after,.notes-ant-calendar .notes-ant-calendar-ok-btn-disabled.active>a:only-child:after,.notes-ant-calendar .notes-ant-calendar-ok-btn.disabled.active>a:only-child:after,.notes-ant-calendar .notes-ant-calendar-ok-btn[disabled].active>a:only-child:after{position:absolute;inset:0;background:transparent;content:""}.notes-ant-calendar-range-picker-input{width:44%;height:99%;text-align:center;background-color:transparent;border:0;outline:0}.notes-ant-calendar-range-picker-input::-moz-placeholder{color:#bfbfbf;opacity:1}.notes-ant-calendar-range-picker-input:-ms-input-placeholder{color:#bfbfbf}.notes-ant-calendar-range-picker-input::-webkit-input-placeholder{color:#bfbfbf}.notes-ant-calendar-range-picker-input:placeholder-shown{text-overflow:ellipsis}.notes-ant-calendar-range-picker-input[disabled]{cursor:not-allowed}.notes-ant-calendar-range-picker-separator{display:inline-block;min-width:10px;height:100%;color:#00000073;white-space:nowrap;text-align:center;vertical-align:top;pointer-events:none}.notes-ant-calendar-range{width:552px;overflow:hidden}.notes-ant-calendar-range .notes-ant-calendar-date-panel:after{display:block;clear:both;height:0;visibility:hidden;content:"."}.notes-ant-calendar-range-part{position:relative;width:50%}.notes-ant-calendar-range-left{float:left}.notes-ant-calendar-range-left .notes-ant-calendar-time-picker-inner{border-right:1px solid #e8e8e8}.notes-ant-calendar-range-right{float:right}.notes-ant-calendar-range-right .notes-ant-calendar-time-picker-inner{border-left:1px solid #e8e8e8}.notes-ant-calendar-range-middle{position:absolute;left:50%;z-index:1;height:34px;margin:1px 0 0;padding:0 200px 0 0;color:#00000073;line-height:34px;text-align:center;transform:translate(-50%);pointer-events:none}.notes-ant-calendar-range-right .notes-ant-calendar-date-input-wrap{margin-left:-90px}.notes-ant-calendar-range.notes-ant-calendar-time .notes-ant-calendar-range-middle{padding:0 10px 0 0;transform:translate(-50%)}.notes-ant-calendar-range .notes-ant-calendar-today :not(.notes-ant-calendar-disabled-cell) :not(.notes-ant-calendar-last-month-cell) :not(.notes-ant-calendar-next-month-btn-day) .notes-ant-calendar-date{color:#198746;background:#9bbaa3;border-color:#198746}.notes-ant-calendar-range .notes-ant-calendar-selected-start-date .notes-ant-calendar-date,.notes-ant-calendar-range .notes-ant-calendar-selected-end-date .notes-ant-calendar-date{color:#fff;background:#198746;border:1px solid transparent}.notes-ant-calendar-range .notes-ant-calendar-selected-start-date .notes-ant-calendar-date:hover,.notes-ant-calendar-range .notes-ant-calendar-selected-end-date .notes-ant-calendar-date:hover{background:#198746}.notes-ant-calendar-range.notes-ant-calendar-time .notes-ant-calendar-range-right .notes-ant-calendar-date-input-wrap{margin-left:0}.notes-ant-calendar-range .notes-ant-calendar-input-wrap{position:relative;height:34px}.notes-ant-calendar-range .notes-ant-calendar-input,.notes-ant-calendar-range .notes-ant-calendar-time-picker-input{position:relative;display:inline-block;width:100%;height:32px;color:#000000a6;font-size:14px;line-height:1.5;background-color:#fff;background-image:none;border:1px solid #d9d9d9;border-radius:4px;transition:all .3s;height:24px;padding:4px 0;line-height:24px;border:0;box-shadow:none}.notes-ant-calendar-range .notes-ant-calendar-input::-moz-placeholder,.notes-ant-calendar-range .notes-ant-calendar-time-picker-input::-moz-placeholder{color:#bfbfbf;opacity:1}.notes-ant-calendar-range .notes-ant-calendar-input:-ms-input-placeholder,.notes-ant-calendar-range .notes-ant-calendar-time-picker-input:-ms-input-placeholder{color:#bfbfbf}.notes-ant-calendar-range .notes-ant-calendar-input::-webkit-input-placeholder,.notes-ant-calendar-range .notes-ant-calendar-time-picker-input::-webkit-input-placeholder{color:#bfbfbf}.notes-ant-calendar-range .notes-ant-calendar-input:placeholder-shown,.notes-ant-calendar-range .notes-ant-calendar-time-picker-input:placeholder-shown{text-overflow:ellipsis}.notes-ant-calendar-range .notes-ant-calendar-input:hover,.notes-ant-calendar-range .notes-ant-calendar-time-picker-input:hover{border-color:#349459;border-right-width:1px!important}.notes-ant-calendar-range .notes-ant-calendar-input:focus,.notes-ant-calendar-range .notes-ant-calendar-time-picker-input:focus{border-color:#349459;border-right-width:1px!important;outline:0;box-shadow:0 0 0 2px #19874633}.notes-ant-calendar-range .notes-ant-calendar-input-disabled,.notes-ant-calendar-range .notes-ant-calendar-time-picker-input-disabled{color:#c1c5c8;background-color:#f5f5f5;cursor:not-allowed;opacity:1}.notes-ant-calendar-range .notes-ant-calendar-input-disabled:hover,.notes-ant-calendar-range .notes-ant-calendar-time-picker-input-disabled:hover{border-color:#d9d9d9;border-right-width:1px!important}.notes-ant-calendar-range .notes-ant-calendar-input[disabled],.notes-ant-calendar-range .notes-ant-calendar-time-picker-input[disabled]{color:#c1c5c8;background-color:#f5f5f5;cursor:not-allowed;opacity:1}.notes-ant-calendar-range .notes-ant-calendar-input[disabled]:hover,.notes-ant-calendar-range .notes-ant-calendar-time-picker-input[disabled]:hover{border-color:#d9d9d9;border-right-width:1px!important}textarea.notes-ant-calendar-range .notes-ant-calendar-input,textarea.notes-ant-calendar-range .notes-ant-calendar-time-picker-input{max-width:100%;height:auto;min-height:32px;line-height:1.5;vertical-align:bottom;transition:all .3s,height 0s}.notes-ant-calendar-range .notes-ant-calendar-input-lg,.notes-ant-calendar-range .notes-ant-calendar-time-picker-input-lg{height:40px;padding:6px 11px;font-size:16px}.notes-ant-calendar-range .notes-ant-calendar-input-sm,.notes-ant-calendar-range .notes-ant-calendar-time-picker-input-sm{height:24px;padding:1px 7px}.notes-ant-calendar-range .notes-ant-calendar-input:focus,.notes-ant-calendar-range .notes-ant-calendar-time-picker-input:focus{box-shadow:none}.notes-ant-calendar-range .notes-ant-calendar-time-picker-icon{display:none}.notes-ant-calendar-range.notes-ant-calendar-week-number{width:574px}.notes-ant-calendar-range.notes-ant-calendar-week-number .notes-ant-calendar-range-part{width:286px}.notes-ant-calendar-range .notes-ant-calendar-year-panel,.notes-ant-calendar-range .notes-ant-calendar-month-panel,.notes-ant-calendar-range .notes-ant-calendar-decade-panel{top:34px}.notes-ant-calendar-range .notes-ant-calendar-month-panel .notes-ant-calendar-year-panel{top:0}.notes-ant-calendar-range .notes-ant-calendar-decade-panel-table,.notes-ant-calendar-range .notes-ant-calendar-year-panel-table,.notes-ant-calendar-range .notes-ant-calendar-month-panel-table{height:208px}.notes-ant-calendar-range .notes-ant-calendar-in-range-cell{position:relative;border-radius:0}.notes-ant-calendar-range .notes-ant-calendar-in-range-cell>div{position:relative;z-index:1}.notes-ant-calendar-range .notes-ant-calendar-in-range-cell:before{position:absolute;inset:4px 0;display:block;background:#bbc7be;border:0;border-radius:0;content:""}.notes-ant-calendar-range .notes-ant-calendar-footer-extra{float:left}div.notes-ant-calendar-range-quick-selector{text-align:left}div.notes-ant-calendar-range-quick-selector>a{margin-right:8px}.notes-ant-calendar-range .notes-ant-calendar-header,.notes-ant-calendar-range .notes-ant-calendar-month-panel-header,.notes-ant-calendar-range .notes-ant-calendar-year-panel-header,.notes-ant-calendar-range .notes-ant-calendar-decade-panel-header{border-bottom:0}.notes-ant-calendar-range .notes-ant-calendar-body,.notes-ant-calendar-range .notes-ant-calendar-month-panel-body,.notes-ant-calendar-range .notes-ant-calendar-year-panel-body,.notes-ant-calendar-range .notes-ant-calendar-decade-panel-body{border-top:1px solid #e8e8e8}.notes-ant-calendar-range.notes-ant-calendar-time .notes-ant-calendar-time-picker{top:68px;z-index:2;width:100%;height:207px}.notes-ant-calendar-range.notes-ant-calendar-time .notes-ant-calendar-time-picker-panel{height:267px;margin-top:-34px}.notes-ant-calendar-range.notes-ant-calendar-time .notes-ant-calendar-time-picker-inner{height:100%;padding-top:40px;background:none}.notes-ant-calendar-range.notes-ant-calendar-time .notes-ant-calendar-time-picker-combobox{display:inline-block;height:100%;background-color:#fff;border-top:1px solid #e8e8e8}.notes-ant-calendar-range.notes-ant-calendar-time .notes-ant-calendar-time-picker-select{height:100%}.notes-ant-calendar-range.notes-ant-calendar-time .notes-ant-calendar-time-picker-select ul{max-height:100%}.notes-ant-calendar-range.notes-ant-calendar-time .notes-ant-calendar-footer .notes-ant-calendar-time-picker-btn{margin-right:8px}.notes-ant-calendar-range.notes-ant-calendar-time .notes-ant-calendar-today-btn{height:22px;margin:8px 12px;line-height:22px}.notes-ant-calendar-range-with-ranges.notes-ant-calendar-time .notes-ant-calendar-time-picker{height:233px}.notes-ant-calendar-range.notes-ant-calendar-show-time-picker .notes-ant-calendar-body{border-top-color:transparent}.notes-ant-calendar-time-picker{position:absolute;top:40px;width:100%;background-color:#fff}.notes-ant-calendar-time-picker-panel{position:absolute;z-index:1050;width:100%}.notes-ant-calendar-time-picker-inner{position:relative;display:inline-block;width:100%;overflow:hidden;font-size:14px;line-height:1.5;text-align:left;list-style:none;background-color:#fff;background-clip:padding-box;outline:none}.notes-ant-calendar-time-picker-combobox,.notes-ant-calendar-time-picker-column-1,.notes-ant-calendar-time-picker-column-1 .notes-ant-calendar-time-picker-select{width:100%}.notes-ant-calendar-time-picker-column-2 .notes-ant-calendar-time-picker-select{width:50%}.notes-ant-calendar-time-picker-column-3 .notes-ant-calendar-time-picker-select{width:33.33%}.notes-ant-calendar-time-picker-column-4 .notes-ant-calendar-time-picker-select{width:25%}.notes-ant-calendar-time-picker-input-wrap{display:none}.notes-ant-calendar-time-picker-select{position:relative;float:left;height:226px;overflow:hidden;font-size:14px;border-right:1px solid #e8e8e8}.notes-ant-calendar-time-picker-select:hover{overflow-y:auto}.notes-ant-calendar-time-picker-select:first-child{margin-left:0;border-left:0}.notes-ant-calendar-time-picker-select:last-child{border-right:0}.notes-ant-calendar-time-picker-select ul{width:100%;max-height:206px;margin:0;padding:0;list-style:none}.notes-ant-calendar-time-picker-select li{width:100%;height:24px;margin:0;line-height:24px;text-align:center;list-style:none;cursor:pointer;transition:all .3s;user-select:none}.notes-ant-calendar-time-picker-select li:last-child:after{display:block;height:202px;content:""}.notes-ant-calendar-time-picker-select li:hover{background:#bbc7be}.notes-ant-calendar-time-picker-select li:focus{color:#198746;font-weight:600;outline:none}li.notes-ant-calendar-time-picker-select-option-selected{font-weight:600;background:#f5f5f5}li.notes-ant-calendar-time-picker-select-option-disabled{color:#c1c5c8}li.notes-ant-calendar-time-picker-select-option-disabled:hover{background:transparent;cursor:not-allowed}.notes-ant-calendar-time .notes-ant-calendar-day-select{display:inline-block;padding:0 2px;color:#000000d9;font-weight:500;line-height:34px}.notes-ant-calendar-time .notes-ant-calendar-footer{position:relative;height:auto}.notes-ant-calendar-time .notes-ant-calendar-footer-btn{text-align:right}.notes-ant-calendar-time .notes-ant-calendar-footer .notes-ant-calendar-today-btn{float:left;margin:0}.notes-ant-calendar-time .notes-ant-calendar-footer .notes-ant-calendar-time-picker-btn{display:inline-block;margin-right:8px}.notes-ant-calendar-time .notes-ant-calendar-footer .notes-ant-calendar-time-picker-btn-disabled{color:#c1c5c8}.notes-ant-calendar-month-panel{position:absolute;inset:0;z-index:10;background:#fff;border-radius:4px;outline:none}.notes-ant-calendar-month-panel>div{display:flex;flex-direction:column;height:100%}.notes-ant-calendar-month-panel-hidden{display:none}.notes-ant-calendar-month-panel-header{height:40px;line-height:40px;text-align:center;border-bottom:1px solid #e8e8e8;user-select:none;position:relative}.notes-ant-calendar-month-panel-header a:hover{color:#349459}.notes-ant-calendar-month-panel-header .notes-ant-calendar-month-panel-century-select,.notes-ant-calendar-month-panel-header .notes-ant-calendar-month-panel-decade-select,.notes-ant-calendar-month-panel-header .notes-ant-calendar-month-panel-year-select,.notes-ant-calendar-month-panel-header .notes-ant-calendar-month-panel-month-select{display:inline-block;padding:0 2px;color:#000000d9;font-weight:500;line-height:40px}.notes-ant-calendar-month-panel-header .notes-ant-calendar-month-panel-century-select-arrow,.notes-ant-calendar-month-panel-header .notes-ant-calendar-month-panel-decade-select-arrow,.notes-ant-calendar-month-panel-header .notes-ant-calendar-month-panel-year-select-arrow,.notes-ant-calendar-month-panel-header .notes-ant-calendar-month-panel-month-select-arrow{display:none}.notes-ant-calendar-month-panel-header .notes-ant-calendar-month-panel-prev-century-btn,.notes-ant-calendar-month-panel-header .notes-ant-calendar-month-panel-next-century-btn,.notes-ant-calendar-month-panel-header .notes-ant-calendar-month-panel-prev-decade-btn,.notes-ant-calendar-month-panel-header .notes-ant-calendar-month-panel-next-decade-btn,.notes-ant-calendar-month-panel-header .notes-ant-calendar-month-panel-prev-month-btn,.notes-ant-calendar-month-panel-header .notes-ant-calendar-month-panel-next-month-btn,.notes-ant-calendar-month-panel-header .notes-ant-calendar-month-panel-prev-year-btn,.notes-ant-calendar-month-panel-header .notes-ant-calendar-month-panel-next-year-btn{position:absolute;top:0;display:inline-block;padding:0 5px;color:#00000073;font-size:16px;font-family:Arial,Hiragino Sans GB,Microsoft Yahei,"Microsoft Sans Serif",sans-serif;line-height:40px}.notes-ant-calendar-month-panel-header .notes-ant-calendar-month-panel-prev-century-btn,.notes-ant-calendar-month-panel-header .notes-ant-calendar-month-panel-prev-decade-btn,.notes-ant-calendar-month-panel-header .notes-ant-calendar-month-panel-prev-year-btn{left:7px;height:100%}.notes-ant-calendar-month-panel-header .notes-ant-calendar-month-panel-prev-century-btn:before,.notes-ant-calendar-month-panel-header .notes-ant-calendar-month-panel-prev-decade-btn:before,.notes-ant-calendar-month-panel-header .notes-ant-calendar-month-panel-prev-year-btn:before,.notes-ant-calendar-month-panel-header .notes-ant-calendar-month-panel-prev-century-btn:after,.notes-ant-calendar-month-panel-header .notes-ant-calendar-month-panel-prev-decade-btn:after,.notes-ant-calendar-month-panel-header .notes-ant-calendar-month-panel-prev-year-btn:after{position:relative;top:-1px;display:inline-block;width:8px;height:8px;vertical-align:middle;border:0 solid #aaa;border-width:1.5px 0 0 1.5px;border-radius:1px;transform:rotate(-45deg) scale(.8);transition:all .3s;content:""}.notes-ant-calendar-month-panel-header .notes-ant-calendar-month-panel-prev-century-btn:hover:before,.notes-ant-calendar-month-panel-header .notes-ant-calendar-month-panel-prev-decade-btn:hover:before,.notes-ant-calendar-month-panel-header .notes-ant-calendar-month-panel-prev-year-btn:hover:before,.notes-ant-calendar-month-panel-header .notes-ant-calendar-month-panel-prev-century-btn:hover:after,.notes-ant-calendar-month-panel-header .notes-ant-calendar-month-panel-prev-decade-btn:hover:after,.notes-ant-calendar-month-panel-header .notes-ant-calendar-month-panel-prev-year-btn:hover:after{border-color:#000000a6}.notes-ant-calendar-month-panel-header .notes-ant-calendar-month-panel-prev-century-btn:after,.notes-ant-calendar-month-panel-header .notes-ant-calendar-month-panel-prev-decade-btn:after,.notes-ant-calendar-month-panel-header .notes-ant-calendar-month-panel-prev-year-btn:after{display:none}.notes-ant-calendar-month-panel-header .notes-ant-calendar-month-panel-prev-century-btn:after,.notes-ant-calendar-month-panel-header .notes-ant-calendar-month-panel-prev-decade-btn:after,.notes-ant-calendar-month-panel-header .notes-ant-calendar-month-panel-prev-year-btn:after{position:relative;left:-3px;display:inline-block}.notes-ant-calendar-month-panel-header .notes-ant-calendar-month-panel-next-century-btn,.notes-ant-calendar-month-panel-header .notes-ant-calendar-month-panel-next-decade-btn,.notes-ant-calendar-month-panel-header .notes-ant-calendar-month-panel-next-year-btn{right:7px;height:100%}.notes-ant-calendar-month-panel-header .notes-ant-calendar-month-panel-next-century-btn:before,.notes-ant-calendar-month-panel-header .notes-ant-calendar-month-panel-next-decade-btn:before,.notes-ant-calendar-month-panel-header .notes-ant-calendar-month-panel-next-year-btn:before,.notes-ant-calendar-month-panel-header .notes-ant-calendar-month-panel-next-century-btn:after,.notes-ant-calendar-month-panel-header .notes-ant-calendar-month-panel-next-decade-btn:after,.notes-ant-calendar-month-panel-header .notes-ant-calendar-month-panel-next-year-btn:after{position:relative;top:-1px;display:inline-block;width:8px;height:8px;vertical-align:middle;border:0 solid #aaa;border-width:1.5px 0 0 1.5px;border-radius:1px;transform:rotate(-45deg) scale(.8);transition:all .3s;content:""}.notes-ant-calendar-month-panel-header .notes-ant-calendar-month-panel-next-century-btn:hover:before,.notes-ant-calendar-month-panel-header .notes-ant-calendar-month-panel-next-decade-btn:hover:before,.notes-ant-calendar-month-panel-header .notes-ant-calendar-month-panel-next-year-btn:hover:before,.notes-ant-calendar-month-panel-header .notes-ant-calendar-month-panel-next-century-btn:hover:after,.notes-ant-calendar-month-panel-header .notes-ant-calendar-month-panel-next-decade-btn:hover:after,.notes-ant-calendar-month-panel-header .notes-ant-calendar-month-panel-next-year-btn:hover:after{border-color:#000000a6}.notes-ant-calendar-month-panel-header .notes-ant-calendar-month-panel-next-century-btn:after,.notes-ant-calendar-month-panel-header .notes-ant-calendar-month-panel-next-decade-btn:after,.notes-ant-calendar-month-panel-header .notes-ant-calendar-month-panel-next-year-btn:after{display:none}.notes-ant-calendar-month-panel-header .notes-ant-calendar-month-panel-next-century-btn:before,.notes-ant-calendar-month-panel-header .notes-ant-calendar-month-panel-next-decade-btn:before,.notes-ant-calendar-month-panel-header .notes-ant-calendar-month-panel-next-year-btn:before,.notes-ant-calendar-month-panel-header .notes-ant-calendar-month-panel-next-century-btn:after,.notes-ant-calendar-month-panel-header .notes-ant-calendar-month-panel-next-decade-btn:after,.notes-ant-calendar-month-panel-header .notes-ant-calendar-month-panel-next-year-btn:after{transform:rotate(135deg) scale(.8)}.notes-ant-calendar-month-panel-header .notes-ant-calendar-month-panel-next-century-btn:before,.notes-ant-calendar-month-panel-header .notes-ant-calendar-month-panel-next-decade-btn:before,.notes-ant-calendar-month-panel-header .notes-ant-calendar-month-panel-next-year-btn:before{position:relative;left:3px}.notes-ant-calendar-month-panel-header .notes-ant-calendar-month-panel-next-century-btn:after,.notes-ant-calendar-month-panel-header .notes-ant-calendar-month-panel-next-decade-btn:after,.notes-ant-calendar-month-panel-header .notes-ant-calendar-month-panel-next-year-btn:after{display:inline-block}.notes-ant-calendar-month-panel-header .notes-ant-calendar-month-panel-prev-month-btn{left:29px;height:100%}.notes-ant-calendar-month-panel-header .notes-ant-calendar-month-panel-prev-month-btn:before,.notes-ant-calendar-month-panel-header .notes-ant-calendar-month-panel-prev-month-btn:after{position:relative;top:-1px;display:inline-block;width:8px;height:8px;vertical-align:middle;border:0 solid #aaa;border-width:1.5px 0 0 1.5px;border-radius:1px;transform:rotate(-45deg) scale(.8);transition:all .3s;content:""}.notes-ant-calendar-month-panel-header .notes-ant-calendar-month-panel-prev-month-btn:hover:before,.notes-ant-calendar-month-panel-header .notes-ant-calendar-month-panel-prev-month-btn:hover:after{border-color:#000000a6}.notes-ant-calendar-month-panel-header .notes-ant-calendar-month-panel-prev-month-btn:after{display:none}.notes-ant-calendar-month-panel-header .notes-ant-calendar-month-panel-next-month-btn{right:29px;height:100%}.notes-ant-calendar-month-panel-header .notes-ant-calendar-month-panel-next-month-btn:before,.notes-ant-calendar-month-panel-header .notes-ant-calendar-month-panel-next-month-btn:after{position:relative;top:-1px;display:inline-block;width:8px;height:8px;vertical-align:middle;border:0 solid #aaa;border-width:1.5px 0 0 1.5px;border-radius:1px;transform:rotate(-45deg) scale(.8);transition:all .3s;content:""}.notes-ant-calendar-month-panel-header .notes-ant-calendar-month-panel-next-month-btn:hover:before,.notes-ant-calendar-month-panel-header .notes-ant-calendar-month-panel-next-month-btn:hover:after{border-color:#000000a6}.notes-ant-calendar-month-panel-header .notes-ant-calendar-month-panel-next-month-btn:after{display:none}.notes-ant-calendar-month-panel-header .notes-ant-calendar-month-panel-next-month-btn:before,.notes-ant-calendar-month-panel-header .notes-ant-calendar-month-panel-next-month-btn:after{transform:rotate(135deg) scale(.8)}.notes-ant-calendar-month-panel-body{flex:1}.notes-ant-calendar-month-panel-footer{border-top:1px solid #e8e8e8}.notes-ant-calendar-month-panel-footer .notes-ant-calendar-footer-extra{padding:0 12px}.notes-ant-calendar-month-panel-table{width:100%;height:100%;table-layout:fixed;border-collapse:separate}.notes-ant-calendar-month-panel-selected-cell .notes-ant-calendar-month-panel-month,.notes-ant-calendar-month-panel-selected-cell .notes-ant-calendar-month-panel-month:hover{color:#fff;background:#198746}.notes-ant-calendar-month-panel-cell{text-align:center}.notes-ant-calendar-month-panel-cell-disabled .notes-ant-calendar-month-panel-month,.notes-ant-calendar-month-panel-cell-disabled .notes-ant-calendar-month-panel-month:hover{color:#c1c5c8;background:#f5f5f5;cursor:not-allowed}.notes-ant-calendar-month-panel-month{display:inline-block;height:24px;margin:0 auto;padding:0 8px;color:#000000a6;line-height:24px;text-align:center;background:transparent;border-radius:2px;transition:background .3s ease}.notes-ant-calendar-month-panel-month:hover{background:#bbc7be;cursor:pointer}.notes-ant-calendar-year-panel{position:absolute;inset:0;z-index:10;background:#fff;border-radius:4px;outline:none}.notes-ant-calendar-year-panel>div{display:flex;flex-direction:column;height:100%}.notes-ant-calendar-year-panel-hidden{display:none}.notes-ant-calendar-year-panel-header{height:40px;line-height:40px;text-align:center;border-bottom:1px solid #e8e8e8;user-select:none;position:relative}.notes-ant-calendar-year-panel-header a:hover{color:#349459}.notes-ant-calendar-year-panel-header .notes-ant-calendar-year-panel-century-select,.notes-ant-calendar-year-panel-header .notes-ant-calendar-year-panel-decade-select,.notes-ant-calendar-year-panel-header .notes-ant-calendar-year-panel-year-select,.notes-ant-calendar-year-panel-header .notes-ant-calendar-year-panel-month-select{display:inline-block;padding:0 2px;color:#000000d9;font-weight:500;line-height:40px}.notes-ant-calendar-year-panel-header .notes-ant-calendar-year-panel-century-select-arrow,.notes-ant-calendar-year-panel-header .notes-ant-calendar-year-panel-decade-select-arrow,.notes-ant-calendar-year-panel-header .notes-ant-calendar-year-panel-year-select-arrow,.notes-ant-calendar-year-panel-header .notes-ant-calendar-year-panel-month-select-arrow{display:none}.notes-ant-calendar-year-panel-header .notes-ant-calendar-year-panel-prev-century-btn,.notes-ant-calendar-year-panel-header .notes-ant-calendar-year-panel-next-century-btn,.notes-ant-calendar-year-panel-header .notes-ant-calendar-year-panel-prev-decade-btn,.notes-ant-calendar-year-panel-header .notes-ant-calendar-year-panel-next-decade-btn,.notes-ant-calendar-year-panel-header .notes-ant-calendar-year-panel-prev-month-btn,.notes-ant-calendar-year-panel-header .notes-ant-calendar-year-panel-next-month-btn,.notes-ant-calendar-year-panel-header .notes-ant-calendar-year-panel-prev-year-btn,.notes-ant-calendar-year-panel-header .notes-ant-calendar-year-panel-next-year-btn{position:absolute;top:0;display:inline-block;padding:0 5px;color:#00000073;font-size:16px;font-family:Arial,Hiragino Sans GB,Microsoft Yahei,"Microsoft Sans Serif",sans-serif;line-height:40px}.notes-ant-calendar-year-panel-header .notes-ant-calendar-year-panel-prev-century-btn,.notes-ant-calendar-year-panel-header .notes-ant-calendar-year-panel-prev-decade-btn,.notes-ant-calendar-year-panel-header .notes-ant-calendar-year-panel-prev-year-btn{left:7px;height:100%}.notes-ant-calendar-year-panel-header .notes-ant-calendar-year-panel-prev-century-btn:before,.notes-ant-calendar-year-panel-header .notes-ant-calendar-year-panel-prev-decade-btn:before,.notes-ant-calendar-year-panel-header .notes-ant-calendar-year-panel-prev-year-btn:before,.notes-ant-calendar-year-panel-header .notes-ant-calendar-year-panel-prev-century-btn:after,.notes-ant-calendar-year-panel-header .notes-ant-calendar-year-panel-prev-decade-btn:after,.notes-ant-calendar-year-panel-header .notes-ant-calendar-year-panel-prev-year-btn:after{position:relative;top:-1px;display:inline-block;width:8px;height:8px;vertical-align:middle;border:0 solid #aaa;border-width:1.5px 0 0 1.5px;border-radius:1px;transform:rotate(-45deg) scale(.8);transition:all .3s;content:""}.notes-ant-calendar-year-panel-header .notes-ant-calendar-year-panel-prev-century-btn:hover:before,.notes-ant-calendar-year-panel-header .notes-ant-calendar-year-panel-prev-decade-btn:hover:before,.notes-ant-calendar-year-panel-header .notes-ant-calendar-year-panel-prev-year-btn:hover:before,.notes-ant-calendar-year-panel-header .notes-ant-calendar-year-panel-prev-century-btn:hover:after,.notes-ant-calendar-year-panel-header .notes-ant-calendar-year-panel-prev-decade-btn:hover:after,.notes-ant-calendar-year-panel-header .notes-ant-calendar-year-panel-prev-year-btn:hover:after{border-color:#000000a6}.notes-ant-calendar-year-panel-header .notes-ant-calendar-year-panel-prev-century-btn:after,.notes-ant-calendar-year-panel-header .notes-ant-calendar-year-panel-prev-decade-btn:after,.notes-ant-calendar-year-panel-header .notes-ant-calendar-year-panel-prev-year-btn:after{display:none}.notes-ant-calendar-year-panel-header .notes-ant-calendar-year-panel-prev-century-btn:after,.notes-ant-calendar-year-panel-header .notes-ant-calendar-year-panel-prev-decade-btn:after,.notes-ant-calendar-year-panel-header .notes-ant-calendar-year-panel-prev-year-btn:after{position:relative;left:-3px;display:inline-block}.notes-ant-calendar-year-panel-header .notes-ant-calendar-year-panel-next-century-btn,.notes-ant-calendar-year-panel-header .notes-ant-calendar-year-panel-next-decade-btn,.notes-ant-calendar-year-panel-header .notes-ant-calendar-year-panel-next-year-btn{right:7px;height:100%}.notes-ant-calendar-year-panel-header .notes-ant-calendar-year-panel-next-century-btn:before,.notes-ant-calendar-year-panel-header .notes-ant-calendar-year-panel-next-decade-btn:before,.notes-ant-calendar-year-panel-header .notes-ant-calendar-year-panel-next-year-btn:before,.notes-ant-calendar-year-panel-header .notes-ant-calendar-year-panel-next-century-btn:after,.notes-ant-calendar-year-panel-header .notes-ant-calendar-year-panel-next-decade-btn:after,.notes-ant-calendar-year-panel-header .notes-ant-calendar-year-panel-next-year-btn:after{position:relative;top:-1px;display:inline-block;width:8px;height:8px;vertical-align:middle;border:0 solid #aaa;border-width:1.5px 0 0 1.5px;border-radius:1px;transform:rotate(-45deg) scale(.8);transition:all .3s;content:""}.notes-ant-calendar-year-panel-header .notes-ant-calendar-year-panel-next-century-btn:hover:before,.notes-ant-calendar-year-panel-header .notes-ant-calendar-year-panel-next-decade-btn:hover:before,.notes-ant-calendar-year-panel-header .notes-ant-calendar-year-panel-next-year-btn:hover:before,.notes-ant-calendar-year-panel-header .notes-ant-calendar-year-panel-next-century-btn:hover:after,.notes-ant-calendar-year-panel-header .notes-ant-calendar-year-panel-next-decade-btn:hover:after,.notes-ant-calendar-year-panel-header .notes-ant-calendar-year-panel-next-year-btn:hover:after{border-color:#000000a6}.notes-ant-calendar-year-panel-header .notes-ant-calendar-year-panel-next-century-btn:after,.notes-ant-calendar-year-panel-header .notes-ant-calendar-year-panel-next-decade-btn:after,.notes-ant-calendar-year-panel-header .notes-ant-calendar-year-panel-next-year-btn:after{display:none}.notes-ant-calendar-year-panel-header .notes-ant-calendar-year-panel-next-century-btn:before,.notes-ant-calendar-year-panel-header .notes-ant-calendar-year-panel-next-decade-btn:before,.notes-ant-calendar-year-panel-header .notes-ant-calendar-year-panel-next-year-btn:before,.notes-ant-calendar-year-panel-header .notes-ant-calendar-year-panel-next-century-btn:after,.notes-ant-calendar-year-panel-header .notes-ant-calendar-year-panel-next-decade-btn:after,.notes-ant-calendar-year-panel-header .notes-ant-calendar-year-panel-next-year-btn:after{transform:rotate(135deg) scale(.8)}.notes-ant-calendar-year-panel-header .notes-ant-calendar-year-panel-next-century-btn:before,.notes-ant-calendar-year-panel-header .notes-ant-calendar-year-panel-next-decade-btn:before,.notes-ant-calendar-year-panel-header .notes-ant-calendar-year-panel-next-year-btn:before{position:relative;left:3px}.notes-ant-calendar-year-panel-header .notes-ant-calendar-year-panel-next-century-btn:after,.notes-ant-calendar-year-panel-header .notes-ant-calendar-year-panel-next-decade-btn:after,.notes-ant-calendar-year-panel-header .notes-ant-calendar-year-panel-next-year-btn:after{display:inline-block}.notes-ant-calendar-year-panel-header .notes-ant-calendar-year-panel-prev-month-btn{left:29px;height:100%}.notes-ant-calendar-year-panel-header .notes-ant-calendar-year-panel-prev-month-btn:before,.notes-ant-calendar-year-panel-header .notes-ant-calendar-year-panel-prev-month-btn:after{position:relative;top:-1px;display:inline-block;width:8px;height:8px;vertical-align:middle;border:0 solid #aaa;border-width:1.5px 0 0 1.5px;border-radius:1px;transform:rotate(-45deg) scale(.8);transition:all .3s;content:""}.notes-ant-calendar-year-panel-header .notes-ant-calendar-year-panel-prev-month-btn:hover:before,.notes-ant-calendar-year-panel-header .notes-ant-calendar-year-panel-prev-month-btn:hover:after{border-color:#000000a6}.notes-ant-calendar-year-panel-header .notes-ant-calendar-year-panel-prev-month-btn:after{display:none}.notes-ant-calendar-year-panel-header .notes-ant-calendar-year-panel-next-month-btn{right:29px;height:100%}.notes-ant-calendar-year-panel-header .notes-ant-calendar-year-panel-next-month-btn:before,.notes-ant-calendar-year-panel-header .notes-ant-calendar-year-panel-next-month-btn:after{position:relative;top:-1px;display:inline-block;width:8px;height:8px;vertical-align:middle;border:0 solid #aaa;border-width:1.5px 0 0 1.5px;border-radius:1px;transform:rotate(-45deg) scale(.8);transition:all .3s;content:""}.notes-ant-calendar-year-panel-header .notes-ant-calendar-year-panel-next-month-btn:hover:before,.notes-ant-calendar-year-panel-header .notes-ant-calendar-year-panel-next-month-btn:hover:after{border-color:#000000a6}.notes-ant-calendar-year-panel-header .notes-ant-calendar-year-panel-next-month-btn:after{display:none}.notes-ant-calendar-year-panel-header .notes-ant-calendar-year-panel-next-month-btn:before,.notes-ant-calendar-year-panel-header .notes-ant-calendar-year-panel-next-month-btn:after{transform:rotate(135deg) scale(.8)}.notes-ant-calendar-year-panel-body{flex:1}.notes-ant-calendar-year-panel-footer{border-top:1px solid #e8e8e8}.notes-ant-calendar-year-panel-footer .notes-ant-calendar-footer-extra{padding:0 12px}.notes-ant-calendar-year-panel-table{width:100%;height:100%;table-layout:fixed;border-collapse:separate}.notes-ant-calendar-year-panel-cell{text-align:center}.notes-ant-calendar-year-panel-year{display:inline-block;height:24px;margin:0 auto;padding:0 8px;color:#000000a6;line-height:24px;text-align:center;background:transparent;border-radius:2px;transition:background .3s ease}.notes-ant-calendar-year-panel-year:hover{background:#bbc7be;cursor:pointer}.notes-ant-calendar-year-panel-selected-cell .notes-ant-calendar-year-panel-year,.notes-ant-calendar-year-panel-selected-cell .notes-ant-calendar-year-panel-year:hover{color:#fff;background:#198746}.notes-ant-calendar-year-panel-last-decade-cell .notes-ant-calendar-year-panel-year,.notes-ant-calendar-year-panel-next-decade-cell .notes-ant-calendar-year-panel-year{color:#c1c5c8;user-select:none}.notes-ant-calendar-decade-panel{position:absolute;inset:0;z-index:10;display:flex;flex-direction:column;background:#fff;border-radius:4px;outline:none}.notes-ant-calendar-decade-panel-hidden{display:none}.notes-ant-calendar-decade-panel-header{height:40px;line-height:40px;text-align:center;border-bottom:1px solid #e8e8e8;user-select:none;position:relative}.notes-ant-calendar-decade-panel-header a:hover{color:#349459}.notes-ant-calendar-decade-panel-header .notes-ant-calendar-decade-panel-century-select,.notes-ant-calendar-decade-panel-header .notes-ant-calendar-decade-panel-decade-select,.notes-ant-calendar-decade-panel-header .notes-ant-calendar-decade-panel-year-select,.notes-ant-calendar-decade-panel-header .notes-ant-calendar-decade-panel-month-select{display:inline-block;padding:0 2px;color:#000000d9;font-weight:500;line-height:40px}.notes-ant-calendar-decade-panel-header .notes-ant-calendar-decade-panel-century-select-arrow,.notes-ant-calendar-decade-panel-header .notes-ant-calendar-decade-panel-decade-select-arrow,.notes-ant-calendar-decade-panel-header .notes-ant-calendar-decade-panel-year-select-arrow,.notes-ant-calendar-decade-panel-header .notes-ant-calendar-decade-panel-month-select-arrow{display:none}.notes-ant-calendar-decade-panel-header .notes-ant-calendar-decade-panel-prev-century-btn,.notes-ant-calendar-decade-panel-header .notes-ant-calendar-decade-panel-next-century-btn,.notes-ant-calendar-decade-panel-header .notes-ant-calendar-decade-panel-prev-decade-btn,.notes-ant-calendar-decade-panel-header .notes-ant-calendar-decade-panel-next-decade-btn,.notes-ant-calendar-decade-panel-header .notes-ant-calendar-decade-panel-prev-month-btn,.notes-ant-calendar-decade-panel-header .notes-ant-calendar-decade-panel-next-month-btn,.notes-ant-calendar-decade-panel-header .notes-ant-calendar-decade-panel-prev-year-btn,.notes-ant-calendar-decade-panel-header .notes-ant-calendar-decade-panel-next-year-btn{position:absolute;top:0;display:inline-block;padding:0 5px;color:#00000073;font-size:16px;font-family:Arial,Hiragino Sans GB,Microsoft Yahei,"Microsoft Sans Serif",sans-serif;line-height:40px}.notes-ant-calendar-decade-panel-header .notes-ant-calendar-decade-panel-prev-century-btn,.notes-ant-calendar-decade-panel-header .notes-ant-calendar-decade-panel-prev-decade-btn,.notes-ant-calendar-decade-panel-header .notes-ant-calendar-decade-panel-prev-year-btn{left:7px;height:100%}.notes-ant-calendar-decade-panel-header .notes-ant-calendar-decade-panel-prev-century-btn:before,.notes-ant-calendar-decade-panel-header .notes-ant-calendar-decade-panel-prev-decade-btn:before,.notes-ant-calendar-decade-panel-header .notes-ant-calendar-decade-panel-prev-year-btn:before,.notes-ant-calendar-decade-panel-header .notes-ant-calendar-decade-panel-prev-century-btn:after,.notes-ant-calendar-decade-panel-header .notes-ant-calendar-decade-panel-prev-decade-btn:after,.notes-ant-calendar-decade-panel-header .notes-ant-calendar-decade-panel-prev-year-btn:after{position:relative;top:-1px;display:inline-block;width:8px;height:8px;vertical-align:middle;border:0 solid #aaa;border-width:1.5px 0 0 1.5px;border-radius:1px;transform:rotate(-45deg) scale(.8);transition:all .3s;content:""}.notes-ant-calendar-decade-panel-header .notes-ant-calendar-decade-panel-prev-century-btn:hover:before,.notes-ant-calendar-decade-panel-header .notes-ant-calendar-decade-panel-prev-decade-btn:hover:before,.notes-ant-calendar-decade-panel-header .notes-ant-calendar-decade-panel-prev-year-btn:hover:before,.notes-ant-calendar-decade-panel-header .notes-ant-calendar-decade-panel-prev-century-btn:hover:after,.notes-ant-calendar-decade-panel-header .notes-ant-calendar-decade-panel-prev-decade-btn:hover:after,.notes-ant-calendar-decade-panel-header .notes-ant-calendar-decade-panel-prev-year-btn:hover:after{border-color:#000000a6}.notes-ant-calendar-decade-panel-header .notes-ant-calendar-decade-panel-prev-century-btn:after,.notes-ant-calendar-decade-panel-header .notes-ant-calendar-decade-panel-prev-decade-btn:after,.notes-ant-calendar-decade-panel-header .notes-ant-calendar-decade-panel-prev-year-btn:after{display:none}.notes-ant-calendar-decade-panel-header .notes-ant-calendar-decade-panel-prev-century-btn:after,.notes-ant-calendar-decade-panel-header .notes-ant-calendar-decade-panel-prev-decade-btn:after,.notes-ant-calendar-decade-panel-header .notes-ant-calendar-decade-panel-prev-year-btn:after{position:relative;left:-3px;display:inline-block}.notes-ant-calendar-decade-panel-header .notes-ant-calendar-decade-panel-next-century-btn,.notes-ant-calendar-decade-panel-header .notes-ant-calendar-decade-panel-next-decade-btn,.notes-ant-calendar-decade-panel-header .notes-ant-calendar-decade-panel-next-year-btn{right:7px;height:100%}.notes-ant-calendar-decade-panel-header .notes-ant-calendar-decade-panel-next-century-btn:before,.notes-ant-calendar-decade-panel-header .notes-ant-calendar-decade-panel-next-decade-btn:before,.notes-ant-calendar-decade-panel-header .notes-ant-calendar-decade-panel-next-year-btn:before,.notes-ant-calendar-decade-panel-header .notes-ant-calendar-decade-panel-next-century-btn:after,.notes-ant-calendar-decade-panel-header .notes-ant-calendar-decade-panel-next-decade-btn:after,.notes-ant-calendar-decade-panel-header .notes-ant-calendar-decade-panel-next-year-btn:after{position:relative;top:-1px;display:inline-block;width:8px;height:8px;vertical-align:middle;border:0 solid #aaa;border-width:1.5px 0 0 1.5px;border-radius:1px;transform:rotate(-45deg) scale(.8);transition:all .3s;content:""}.notes-ant-calendar-decade-panel-header .notes-ant-calendar-decade-panel-next-century-btn:hover:before,.notes-ant-calendar-decade-panel-header .notes-ant-calendar-decade-panel-next-decade-btn:hover:before,.notes-ant-calendar-decade-panel-header .notes-ant-calendar-decade-panel-next-year-btn:hover:before,.notes-ant-calendar-decade-panel-header .notes-ant-calendar-decade-panel-next-century-btn:hover:after,.notes-ant-calendar-decade-panel-header .notes-ant-calendar-decade-panel-next-decade-btn:hover:after,.notes-ant-calendar-decade-panel-header .notes-ant-calendar-decade-panel-next-year-btn:hover:after{border-color:#000000a6}.notes-ant-calendar-decade-panel-header .notes-ant-calendar-decade-panel-next-century-btn:after,.notes-ant-calendar-decade-panel-header .notes-ant-calendar-decade-panel-next-decade-btn:after,.notes-ant-calendar-decade-panel-header .notes-ant-calendar-decade-panel-next-year-btn:after{display:none}.notes-ant-calendar-decade-panel-header .notes-ant-calendar-decade-panel-next-century-btn:before,.notes-ant-calendar-decade-panel-header .notes-ant-calendar-decade-panel-next-decade-btn:before,.notes-ant-calendar-decade-panel-header .notes-ant-calendar-decade-panel-next-year-btn:before,.notes-ant-calendar-decade-panel-header .notes-ant-calendar-decade-panel-next-century-btn:after,.notes-ant-calendar-decade-panel-header .notes-ant-calendar-decade-panel-next-decade-btn:after,.notes-ant-calendar-decade-panel-header .notes-ant-calendar-decade-panel-next-year-btn:after{transform:rotate(135deg) scale(.8)}.notes-ant-calendar-decade-panel-header .notes-ant-calendar-decade-panel-next-century-btn:before,.notes-ant-calendar-decade-panel-header .notes-ant-calendar-decade-panel-next-decade-btn:before,.notes-ant-calendar-decade-panel-header .notes-ant-calendar-decade-panel-next-year-btn:before{position:relative;left:3px}.notes-ant-calendar-decade-panel-header .notes-ant-calendar-decade-panel-next-century-btn:after,.notes-ant-calendar-decade-panel-header .notes-ant-calendar-decade-panel-next-decade-btn:after,.notes-ant-calendar-decade-panel-header .notes-ant-calendar-decade-panel-next-year-btn:after{display:inline-block}.notes-ant-calendar-decade-panel-header .notes-ant-calendar-decade-panel-prev-month-btn{left:29px;height:100%}.notes-ant-calendar-decade-panel-header .notes-ant-calendar-decade-panel-prev-month-btn:before,.notes-ant-calendar-decade-panel-header .notes-ant-calendar-decade-panel-prev-month-btn:after{position:relative;top:-1px;display:inline-block;width:8px;height:8px;vertical-align:middle;border:0 solid #aaa;border-width:1.5px 0 0 1.5px;border-radius:1px;transform:rotate(-45deg) scale(.8);transition:all .3s;content:""}.notes-ant-calendar-decade-panel-header .notes-ant-calendar-decade-panel-prev-month-btn:hover:before,.notes-ant-calendar-decade-panel-header .notes-ant-calendar-decade-panel-prev-month-btn:hover:after{border-color:#000000a6}.notes-ant-calendar-decade-panel-header .notes-ant-calendar-decade-panel-prev-month-btn:after{display:none}.notes-ant-calendar-decade-panel-header .notes-ant-calendar-decade-panel-next-month-btn{right:29px;height:100%}.notes-ant-calendar-decade-panel-header .notes-ant-calendar-decade-panel-next-month-btn:before,.notes-ant-calendar-decade-panel-header .notes-ant-calendar-decade-panel-next-month-btn:after{position:relative;top:-1px;display:inline-block;width:8px;height:8px;vertical-align:middle;border:0 solid #aaa;border-width:1.5px 0 0 1.5px;border-radius:1px;transform:rotate(-45deg) scale(.8);transition:all .3s;content:""}.notes-ant-calendar-decade-panel-header .notes-ant-calendar-decade-panel-next-month-btn:hover:before,.notes-ant-calendar-decade-panel-header .notes-ant-calendar-decade-panel-next-month-btn:hover:after{border-color:#000000a6}.notes-ant-calendar-decade-panel-header .notes-ant-calendar-decade-panel-next-month-btn:after{display:none}.notes-ant-calendar-decade-panel-header .notes-ant-calendar-decade-panel-next-month-btn:before,.notes-ant-calendar-decade-panel-header .notes-ant-calendar-decade-panel-next-month-btn:after{transform:rotate(135deg) scale(.8)}.notes-ant-calendar-decade-panel-body{flex:1}.notes-ant-calendar-decade-panel-footer{border-top:1px solid #e8e8e8}.notes-ant-calendar-decade-panel-footer .notes-ant-calendar-footer-extra{padding:0 12px}.notes-ant-calendar-decade-panel-table{width:100%;height:100%;table-layout:fixed;border-collapse:separate}.notes-ant-calendar-decade-panel-cell{white-space:nowrap;text-align:center}.notes-ant-calendar-decade-panel-decade{display:inline-block;height:24px;margin:0 auto;padding:0 6px;color:#000000a6;line-height:24px;text-align:center;background:transparent;border-radius:2px;transition:background .3s ease}.notes-ant-calendar-decade-panel-decade:hover{background:#bbc7be;cursor:pointer}.notes-ant-calendar-decade-panel-selected-cell .notes-ant-calendar-decade-panel-decade,.notes-ant-calendar-decade-panel-selected-cell .notes-ant-calendar-decade-panel-decade:hover{color:#fff;background:#198746}.notes-ant-calendar-decade-panel-last-century-cell .notes-ant-calendar-decade-panel-decade,.notes-ant-calendar-decade-panel-next-century-cell .notes-ant-calendar-decade-panel-decade{color:#c1c5c8;user-select:none}.notes-ant-calendar-month .notes-ant-calendar-month-header-wrap{position:relative;height:288px}.notes-ant-calendar-month .notes-ant-calendar-month-panel,.notes-ant-calendar-month .notes-ant-calendar-year-panel{top:0;height:100%}.notes-ant-calendar-week-number-cell{opacity:.5}.notes-ant-calendar-week-number .notes-ant-calendar-body tr{cursor:pointer;transition:all .3s}.notes-ant-calendar-week-number .notes-ant-calendar-body tr:hover{background:#bbc7be}.notes-ant-calendar-week-number .notes-ant-calendar-body tr.notes-ant-calendar-active-week{font-weight:700;background:#9bbaa3}.notes-ant-calendar-week-number .notes-ant-calendar-body tr .notes-ant-calendar-selected-day .notes-ant-calendar-date,.notes-ant-calendar-week-number .notes-ant-calendar-body tr .notes-ant-calendar-selected-day:hover .notes-ant-calendar-date{color:#000000a6;background:transparent}.notes-ant-collapse{box-sizing:border-box;margin:0;padding:0;color:#000000a6;font-size:14px;font-variant:tabular-nums;line-height:1.5;list-style:none;font-feature-settings:"tnum";background-color:#fafafa;border:1px solid #d9d9d9;border-bottom:0;border-radius:4px}.notes-ant-collapse>.notes-ant-collapse-item{border-bottom:1px solid #d9d9d9}.notes-ant-collapse>.notes-ant-collapse-item:last-child,.notes-ant-collapse>.notes-ant-collapse-item:last-child>.notes-ant-collapse-header{border-radius:0 0 4px 4px}.notes-ant-collapse>.notes-ant-collapse-item>.notes-ant-collapse-header{position:relative;padding:12px 16px 12px 40px;color:#000000d9;line-height:22px;cursor:pointer;transition:all .3s}.notes-ant-collapse>.notes-ant-collapse-item>.notes-ant-collapse-header .notes-ant-collapse-arrow{color:inherit;font-style:normal;line-height:0;text-align:center;text-transform:none;vertical-align:-.125em;text-rendering:optimizeLegibility;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;position:absolute;top:50%;left:16px;display:inline-block;font-size:12px;transform:translateY(-50%)}.notes-ant-collapse>.notes-ant-collapse-item>.notes-ant-collapse-header .notes-ant-collapse-arrow>*{line-height:1}.notes-ant-collapse>.notes-ant-collapse-item>.notes-ant-collapse-header .notes-ant-collapse-arrow svg{display:inline-block}.notes-ant-collapse>.notes-ant-collapse-item>.notes-ant-collapse-header .notes-ant-collapse-arrow:before{display:none}.notes-ant-collapse>.notes-ant-collapse-item>.notes-ant-collapse-header .notes-ant-collapse-arrow .notes-ant-collapse>.notes-ant-collapse-item>.notes-ant-collapse-header .notes-ant-collapse-arrow-icon{display:block}.notes-ant-collapse>.notes-ant-collapse-item>.notes-ant-collapse-header .notes-ant-collapse-arrow svg{transition:transform .24s}.notes-ant-collapse>.notes-ant-collapse-item>.notes-ant-collapse-header .notes-ant-collapse-extra{float:right}.notes-ant-collapse>.notes-ant-collapse-item>.notes-ant-collapse-header:focus{outline:none}.notes-ant-collapse>.notes-ant-collapse-item.notes-ant-collapse-no-arrow>.notes-ant-collapse-header{padding-left:12px}.notes-ant-collapse-icon-position-right>.notes-ant-collapse-item>.notes-ant-collapse-header{padding:12px 40px 12px 16px}.notes-ant-collapse-icon-position-right>.notes-ant-collapse-item>.notes-ant-collapse-header .notes-ant-collapse-arrow{right:16px;left:auto}.notes-ant-collapse-anim-active{transition:height .2s cubic-bezier(.215,.61,.355,1)}.notes-ant-collapse-content{overflow:hidden;color:#000000a6;background-color:#fff;border-top:1px solid #d9d9d9}.notes-ant-collapse-content>.notes-ant-collapse-content-box{padding:16px}.notes-ant-collapse-content-inactive{display:none}.notes-ant-collapse-item:last-child>.notes-ant-collapse-content{border-radius:0 0 4px 4px}.notes-ant-collapse-borderless{background-color:#fafafa;border:0}.notes-ant-collapse-borderless>.notes-ant-collapse-item{border-bottom:1px solid #d9d9d9}.notes-ant-collapse-borderless>.notes-ant-collapse-item:last-child,.notes-ant-collapse-borderless>.notes-ant-collapse-item:last-child .notes-ant-collapse-header{border-radius:0}.notes-ant-collapse-borderless>.notes-ant-collapse-item>.notes-ant-collapse-content{background-color:transparent;border-top:0}.notes-ant-collapse-borderless>.notes-ant-collapse-item>.notes-ant-collapse-content>.notes-ant-collapse-content-box{padding-top:4px}.notes-ant-collapse .notes-ant-collapse-item-disabled>.notes-ant-collapse-header,.notes-ant-collapse .notes-ant-collapse-item-disabled>.notes-ant-collapse-header>.arrow{color:#c1c5c8;cursor:not-allowed}.notes-ant-form{box-sizing:border-box;margin:0;padding:0;color:#000000a6;font-size:14px;font-variant:tabular-nums;line-height:1.5;list-style:none;font-feature-settings:"tnum"}.notes-ant-form legend{display:block;width:100%;margin-bottom:20px;padding:0;color:#00000073;font-size:16px;line-height:inherit;border:0;border-bottom:1px solid #d9d9d9}.notes-ant-form label{font-size:14px}.notes-ant-form input[type=search]{box-sizing:border-box}.notes-ant-form input[type=radio],.notes-ant-form input[type=checkbox]{line-height:normal}.notes-ant-form input[type=file]{display:block}.notes-ant-form input[type=range]{display:block;width:100%}.notes-ant-form select[multiple],.notes-ant-form select[size]{height:auto}.notes-ant-form input[type=file]:focus,.notes-ant-form input[type=radio]:focus,.notes-ant-form input[type=checkbox]:focus{outline:thin dotted;outline:5px auto -webkit-focus-ring-color;outline-offset:-2px}.notes-ant-form output{display:block;padding-top:15px;color:#000000a6;font-size:14px;line-height:1.5}.notes-ant-form-item-required:before{display:inline-block;margin-right:4px;color:#f5222d;font-size:14px;font-family:SimSun,sans-serif;line-height:1;content:"*"}.notes-ant-form-hide-required-mark .notes-ant-form-item-required:before{display:none}.notes-ant-form-item-label>label{color:#000000d9}.notes-ant-form-item-label>label:after{content:":";position:relative;top:-.5px;margin:0 8px 0 2px}.notes-ant-form-item-label>label.notes-ant-form-item-no-colon:after{content:" "}.notes-ant-form-item{box-sizing:border-box;margin:0 0 24px;padding:0;color:#000000a6;font-size:14px;font-variant:tabular-nums;line-height:1.5;list-style:none;font-feature-settings:"tnum";vertical-align:top}.notes-ant-form-item label{position:relative}.notes-ant-form-item label>.anticon{font-size:14px;vertical-align:top}.notes-ant-form-item-control{position:relative;line-height:40px;zoom:1}.notes-ant-form-item-control:before,.notes-ant-form-item-control:after{display:table;content:""}.notes-ant-form-item-control:after{clear:both}.notes-ant-form-item-children{position:relative}.notes-ant-form-item-with-help{margin-bottom:5px}.notes-ant-form-item-label{display:inline-block;overflow:hidden;line-height:39.9999px;white-space:nowrap;text-align:right;vertical-align:middle}.notes-ant-form-item-label-left{text-align:left}.notes-ant-form-item .notes-ant-switch{margin:2px 0 4px}.notes-ant-form-explain,.notes-ant-form-extra{clear:both;min-height:22px;margin-top:-2px;color:#00000073;font-size:14px;line-height:1.5;transition:color .3s cubic-bezier(.215,.61,.355,1)}.notes-ant-form-explain{margin-bottom:-1px}.notes-ant-form-extra{padding-top:4px}.notes-ant-form-text{display:inline-block;padding-right:8px}.notes-ant-form-split{display:block;text-align:center}form .has-feedback .notes-ant-input{padding-right:30px}form .has-feedback .notes-ant-input-affix-wrapper .notes-ant-input-suffix{padding-right:18px}form .has-feedback .notes-ant-input-affix-wrapper .notes-ant-input{padding-right:49px}form .has-feedback .notes-ant-input-affix-wrapper.notes-ant-input-affix-wrapper-input-with-clear-btn .notes-ant-input{padding-right:68px}form .has-feedback>.notes-ant-select .notes-ant-select-arrow,form .has-feedback>.notes-ant-select .notes-ant-select-selection__clear,form .has-feedback :not(.notes-ant-input-group-addon)>.notes-ant-select .notes-ant-select-arrow,form .has-feedback :not(.notes-ant-input-group-addon)>.notes-ant-select .notes-ant-select-selection__clear{right:28px}form .has-feedback>.notes-ant-select .notes-ant-select-selection-selected-value,form .has-feedback :not(.notes-ant-input-group-addon)>.notes-ant-select .notes-ant-select-selection-selected-value{padding-right:42px}form .has-feedback .notes-ant-cascader-picker-arrow{margin-right:17px}form .has-feedback .notes-ant-cascader-picker-clear{right:28px}form .has-feedback .notes-ant-input-search:not(.notes-ant-input-search-enter-button) .notes-ant-input-suffix{right:28px}form .has-feedback .notes-ant-calendar-picker-icon,form .has-feedback .notes-ant-time-picker-icon,form .has-feedback .notes-ant-calendar-picker-clear,form .has-feedback .notes-ant-time-picker-clear{right:28px}form .notes-ant-mentions,form textarea.notes-ant-input{height:auto;margin-bottom:4px}form .notes-ant-upload{background:transparent}form input[type=radio],form input[type=checkbox]{width:14px;height:14px}form .notes-ant-radio-inline,form .notes-ant-checkbox-inline{display:inline-block;margin-left:8px;font-weight:400;vertical-align:middle;cursor:pointer}form .notes-ant-radio-inline:first-child,form .notes-ant-checkbox-inline:first-child{margin-left:0}form .notes-ant-checkbox-vertical,form .notes-ant-radio-vertical{display:block}form .notes-ant-checkbox-vertical+.notes-ant-checkbox-vertical,form .notes-ant-radio-vertical+.notes-ant-radio-vertical{margin-left:0}form .notes-ant-input-number+.notes-ant-form-text{margin-left:8px}form .notes-ant-input-number-handler-wrap{z-index:2}form .notes-ant-select,form .notes-ant-cascader-picker{width:100%}form .notes-ant-input-group .notes-ant-select,form .notes-ant-input-group .notes-ant-cascader-picker{width:auto}form :not(.notes-ant-input-group-wrapper)>.notes-ant-input-group,form .notes-ant-input-group-wrapper{display:inline-block;vertical-align:middle}form:not(.notes-ant-form-vertical) :not(.notes-ant-input-group-wrapper)>.notes-ant-input-group,form:not(.notes-ant-form-vertical) .notes-ant-input-group-wrapper{position:relative;top:-1px}.notes-ant-form-vertical .notes-ant-form-item-label,.notes-ant-col-24.notes-ant-form-item-label,.notes-ant-col-xl-24.notes-ant-form-item-label{display:block;margin:0;padding:0 0 8px;line-height:1.5;white-space:initial;text-align:left}.notes-ant-form-vertical .notes-ant-form-item-label label:after,.notes-ant-col-24.notes-ant-form-item-label label:after,.notes-ant-col-xl-24.notes-ant-form-item-label label:after{display:none}.notes-ant-form-vertical .notes-ant-form-item{padding-bottom:8px}.notes-ant-form-vertical .notes-ant-form-item-control{line-height:1.5}.notes-ant-form-vertical .notes-ant-form-explain{margin-top:2px;margin-bottom:-5px}.notes-ant-form-vertical .notes-ant-form-extra{margin-top:2px;margin-bottom:-4px}@media (max-width: 575px){.notes-ant-form-item-label,.notes-ant-form-item-control-wrapper{display:block;width:100%}.notes-ant-form-item-label{display:block;margin:0;padding:0 0 8px;line-height:1.5;white-space:initial;text-align:left}.notes-ant-form-item-label label:after{display:none}.notes-ant-col-xs-24.notes-ant-form-item-label{display:block;margin:0;padding:0 0 8px;line-height:1.5;white-space:initial;text-align:left}.notes-ant-col-xs-24.notes-ant-form-item-label label:after{display:none}}@media (max-width: 767px){.notes-ant-col-sm-24.notes-ant-form-item-label{display:block;margin:0;padding:0 0 8px;line-height:1.5;white-space:initial;text-align:left}.notes-ant-col-sm-24.notes-ant-form-item-label label:after{display:none}}@media (max-width: 991px){.notes-ant-col-md-24.notes-ant-form-item-label{display:block;margin:0;padding:0 0 8px;line-height:1.5;white-space:initial;text-align:left}.notes-ant-col-md-24.notes-ant-form-item-label label:after{display:none}}@media (max-width: 1199px){.notes-ant-col-lg-24.notes-ant-form-item-label{display:block;margin:0;padding:0 0 8px;line-height:1.5;white-space:initial;text-align:left}.notes-ant-col-lg-24.notes-ant-form-item-label label:after{display:none}}@media (max-width: 1599px){.notes-ant-col-xl-24.notes-ant-form-item-label{display:block;margin:0;padding:0 0 8px;line-height:1.5;white-space:initial;text-align:left}.notes-ant-col-xl-24.notes-ant-form-item-label label:after{display:none}}.notes-ant-form-inline .notes-ant-form-item{display:inline-block;margin-right:16px;margin-bottom:0}.notes-ant-form-inline .notes-ant-form-item-with-help{margin-bottom:24px}.notes-ant-form-inline .notes-ant-form-item>.notes-ant-form-item-control-wrapper,.notes-ant-form-inline .notes-ant-form-item>.notes-ant-form-item-label{display:inline-block;vertical-align:top}.notes-ant-form-inline .notes-ant-form-text,.notes-ant-form-inline .has-feedback{display:inline-block}.has-success.has-feedback .notes-ant-form-item-children-icon,.has-warning.has-feedback .notes-ant-form-item-children-icon,.has-error.has-feedback .notes-ant-form-item-children-icon,.is-validating.has-feedback .notes-ant-form-item-children-icon{position:absolute;top:50%;right:0;z-index:1;width:32px;height:20px;margin-top:-10px;font-size:14px;line-height:20px;text-align:center;visibility:visible;animation:zoomIn .3s cubic-bezier(.12,.4,.29,1.46);pointer-events:none}.has-success.has-feedback .notes-ant-form-item-children-icon svg,.has-warning.has-feedback .notes-ant-form-item-children-icon svg,.has-error.has-feedback .notes-ant-form-item-children-icon svg,.is-validating.has-feedback .notes-ant-form-item-children-icon svg{position:absolute;inset:0;margin:auto}.has-success.has-feedback .notes-ant-form-item-children-icon{color:#52c41a;animation-name:diffZoomIn1!important}.has-warning .notes-ant-form-explain,.has-warning .notes-ant-form-split{color:#faad14}.has-warning .notes-ant-input,.has-warning .notes-ant-input:hover{background-color:#fff;border-color:#faad14}.has-warning .notes-ant-input:focus{border-color:#ffc53d;border-right-width:1px!important;outline:0;box-shadow:0 0 0 2px #faad1433}.has-warning .notes-ant-input:not([disabled]):hover{border-color:#faad14}.has-warning .notes-ant-calendar-picker-open .notes-ant-calendar-picker-input{border-color:#ffc53d;border-right-width:1px!important;outline:0;box-shadow:0 0 0 2px #faad1433}.has-warning .notes-ant-input-affix-wrapper .notes-ant-input,.has-warning .notes-ant-input-affix-wrapper .notes-ant-input:hover{background-color:#fff;border-color:#faad14}.has-warning .notes-ant-input-affix-wrapper .notes-ant-input:focus{border-color:#ffc53d;border-right-width:1px!important;outline:0;box-shadow:0 0 0 2px #faad1433}.has-warning .notes-ant-input-affix-wrapper:hover .notes-ant-input:not(.notes-ant-input-disabled){border-color:#faad14}.has-warning .notes-ant-input-prefix{color:#faad14}.has-warning .notes-ant-input-group-addon{color:#faad14;background-color:#fff;border-color:#faad14}.has-warning .has-feedback{color:#faad14}.has-warning.has-feedback .notes-ant-form-item-children-icon{color:#faad14;animation-name:diffZoomIn3!important}.has-warning .notes-ant-select-selection,.has-warning .notes-ant-select-selection:hover{border-color:#faad14}.has-warning .notes-ant-select-open .notes-ant-select-selection,.has-warning .notes-ant-select-focused .notes-ant-select-selection{border-color:#ffc53d;border-right-width:1px!important;outline:0;box-shadow:0 0 0 2px #faad1433}.has-warning .notes-ant-calendar-picker-icon:after,.has-warning .notes-ant-time-picker-icon:after,.has-warning .notes-ant-picker-icon:after,.has-warning .notes-ant-select-arrow,.has-warning .notes-ant-cascader-picker-arrow{color:#faad14}.has-warning .notes-ant-input-number,.has-warning .notes-ant-time-picker-input{border-color:#faad14}.has-warning .notes-ant-input-number-focused,.has-warning .notes-ant-time-picker-input-focused,.has-warning .notes-ant-input-number:focus,.has-warning .notes-ant-time-picker-input:focus{border-color:#ffc53d;border-right-width:1px!important;outline:0;box-shadow:0 0 0 2px #faad1433}.has-warning .notes-ant-input-number:not([disabled]):hover,.has-warning .notes-ant-time-picker-input:not([disabled]):hover{border-color:#faad14}.has-warning .notes-ant-cascader-picker:focus .notes-ant-cascader-input{border-color:#ffc53d;border-right-width:1px!important;outline:0;box-shadow:0 0 0 2px #faad1433}.has-warning .notes-ant-cascader-picker:hover .notes-ant-cascader-input{border-color:#faad14}.has-error .notes-ant-form-explain,.has-error .notes-ant-form-split{color:#f5222d}.has-error .notes-ant-input,.has-error .notes-ant-input:hover{background-color:#fff;border-color:#f5222d}.has-error .notes-ant-input:focus{border-color:#ff4d4f;border-right-width:1px!important;outline:0;box-shadow:0 0 0 2px #f5222d33}.has-error .notes-ant-input:not([disabled]):hover{border-color:#f5222d}.has-error .notes-ant-calendar-picker-open .notes-ant-calendar-picker-input{border-color:#ff4d4f;border-right-width:1px!important;outline:0;box-shadow:0 0 0 2px #f5222d33}.has-error .notes-ant-input-affix-wrapper .notes-ant-input,.has-error .notes-ant-input-affix-wrapper .notes-ant-input:hover{background-color:#fff;border-color:#f5222d}.has-error .notes-ant-input-affix-wrapper .notes-ant-input:focus{border-color:#ff4d4f;border-right-width:1px!important;outline:0;box-shadow:0 0 0 2px #f5222d33}.has-error .notes-ant-input-affix-wrapper:hover .notes-ant-input:not(.notes-ant-input-disabled){border-color:#f5222d}.has-error .notes-ant-input-prefix{color:#f5222d}.has-error .notes-ant-input-group-addon{color:#f5222d;background-color:#fff;border-color:#f5222d}.has-error .has-feedback{color:#f5222d}.has-error.has-feedback .notes-ant-form-item-children-icon{color:#f5222d;animation-name:diffZoomIn2!important}.has-error .notes-ant-select-selection,.has-error .notes-ant-select-selection:hover{border-color:#f5222d}.has-error .notes-ant-select-open .notes-ant-select-selection,.has-error .notes-ant-select-focused .notes-ant-select-selection{border-color:#ff4d4f;border-right-width:1px!important;outline:0;box-shadow:0 0 0 2px #f5222d33}.has-error .notes-ant-select.notes-ant-select-auto-complete .notes-ant-input:focus{border-color:#f5222d}.has-error .notes-ant-input-group-addon .notes-ant-select-selection{border-color:transparent;box-shadow:none}.has-error .notes-ant-calendar-picker-icon:after,.has-error .notes-ant-time-picker-icon:after,.has-error .notes-ant-picker-icon:after,.has-error .notes-ant-select-arrow,.has-error .notes-ant-cascader-picker-arrow{color:#f5222d}.has-error .notes-ant-input-number,.has-error .notes-ant-time-picker-input{border-color:#f5222d}.has-error .notes-ant-input-number-focused,.has-error .notes-ant-time-picker-input-focused,.has-error .notes-ant-input-number:focus,.has-error .notes-ant-time-picker-input:focus{border-color:#ff4d4f;border-right-width:1px!important;outline:0;box-shadow:0 0 0 2px #f5222d33}.has-error .notes-ant-input-number:not([disabled]):hover,.has-error .notes-ant-time-picker-input:not([disabled]):hover{border-color:#f5222d}.has-error .notes-ant-mention-wrapper .notes-ant-mention-editor,.has-error .notes-ant-mention-wrapper .notes-ant-mention-editor:not([disabled]):hover{border-color:#f5222d}.has-error .notes-ant-mention-wrapper.notes-ant-mention-active:not([disabled]) .notes-ant-mention-editor,.has-error .notes-ant-mention-wrapper .notes-ant-mention-editor:not([disabled]):focus{border-color:#ff4d4f;border-right-width:1px!important;outline:0;box-shadow:0 0 0 2px #f5222d33}.has-error .notes-ant-cascader-picker:focus .notes-ant-cascader-input{border-color:#ff4d4f;border-right-width:1px!important;outline:0;box-shadow:0 0 0 2px #f5222d33}.has-error .notes-ant-cascader-picker:hover .notes-ant-cascader-input,.has-error .notes-ant-transfer-list{border-color:#f5222d}.has-error .notes-ant-transfer-list-search:not([disabled]){border-color:#d9d9d9}.has-error .notes-ant-transfer-list-search:not([disabled]):hover{border-color:#349459;border-right-width:1px!important}.has-error .notes-ant-transfer-list-search:not([disabled]):focus{border-color:#349459;border-right-width:1px!important;outline:0;box-shadow:0 0 0 2px #19874633}.is-validating.has-feedback .notes-ant-form-item-children-icon{display:inline-block;color:#198746}.notes-ant-advanced-search-form .notes-ant-form-item{margin-bottom:24px}.notes-ant-advanced-search-form .notes-ant-form-item-with-help{margin-bottom:5px}.show-help-enter,.show-help-appear,.show-help-leave{animation-duration:.3s;animation-fill-mode:both;animation-play-state:paused}.show-help-enter.show-help-enter-active,.show-help-appear.show-help-appear-active{animation-name:antShowHelpIn;animation-play-state:running}.show-help-leave.show-help-leave-active{animation-name:antShowHelpOut;animation-play-state:running;pointer-events:none}.show-help-enter,.show-help-appear{opacity:0;animation-timing-function:cubic-bezier(.645,.045,.355,1)}.show-help-leave{animation-timing-function:cubic-bezier(.645,.045,.355,1)}@keyframes antShowHelpIn{0%{transform:translateY(-5px);opacity:0}to{transform:translateY(0);opacity:1}}@keyframes antShowHelpOut{to{transform:translateY(-5px);opacity:0}}@keyframes diffZoomIn1{0%{transform:scale(0)}to{transform:scale(1)}}@keyframes diffZoomIn2{0%{transform:scale(0)}to{transform:scale(1)}}@keyframes diffZoomIn3{0%{transform:scale(0)}to{transform:scale(1)}}.notes-ant-row{position:relative;height:auto;margin-right:0;margin-left:0;zoom:1;display:block;box-sizing:border-box}.notes-ant-row:before,.notes-ant-row:after{display:table;content:""}.notes-ant-row:after{clear:both}.notes-ant-row+.notes-ant-row:before{clear:both}.notes-ant-row-flex{display:flex;flex-flow:row wrap}.notes-ant-row-flex:before,.notes-ant-row-flex:after{display:flex}.notes-ant-row-flex-start{justify-content:flex-start}.notes-ant-row-flex-center{justify-content:center}.notes-ant-row-flex-end{justify-content:flex-end}.notes-ant-row-flex-space-between{justify-content:space-between}.notes-ant-row-flex-space-around{justify-content:space-around}.notes-ant-row-flex-top{align-items:flex-start}.notes-ant-row-flex-middle{align-items:center}.notes-ant-row-flex-bottom{align-items:flex-end}.notes-ant-col{position:relative;min-height:1px}.notes-ant-col-1,.notes-ant-col-xs-1,.notes-ant-col-sm-1,.notes-ant-col-md-1,.notes-ant-col-lg-1,.notes-ant-col-2,.notes-ant-col-xs-2,.notes-ant-col-sm-2,.notes-ant-col-md-2,.notes-ant-col-lg-2,.notes-ant-col-3,.notes-ant-col-xs-3,.notes-ant-col-sm-3,.notes-ant-col-md-3,.notes-ant-col-lg-3,.notes-ant-col-4,.notes-ant-col-xs-4,.notes-ant-col-sm-4,.notes-ant-col-md-4,.notes-ant-col-lg-4,.notes-ant-col-5,.notes-ant-col-xs-5,.notes-ant-col-sm-5,.notes-ant-col-md-5,.notes-ant-col-lg-5,.notes-ant-col-6,.notes-ant-col-xs-6,.notes-ant-col-sm-6,.notes-ant-col-md-6,.notes-ant-col-lg-6,.notes-ant-col-7,.notes-ant-col-xs-7,.notes-ant-col-sm-7,.notes-ant-col-md-7,.notes-ant-col-lg-7,.notes-ant-col-8,.notes-ant-col-xs-8,.notes-ant-col-sm-8,.notes-ant-col-md-8,.notes-ant-col-lg-8,.notes-ant-col-9,.notes-ant-col-xs-9,.notes-ant-col-sm-9,.notes-ant-col-md-9,.notes-ant-col-lg-9,.notes-ant-col-10,.notes-ant-col-xs-10,.notes-ant-col-sm-10,.notes-ant-col-md-10,.notes-ant-col-lg-10,.notes-ant-col-11,.notes-ant-col-xs-11,.notes-ant-col-sm-11,.notes-ant-col-md-11,.notes-ant-col-lg-11,.notes-ant-col-12,.notes-ant-col-xs-12,.notes-ant-col-sm-12,.notes-ant-col-md-12,.notes-ant-col-lg-12,.notes-ant-col-13,.notes-ant-col-xs-13,.notes-ant-col-sm-13,.notes-ant-col-md-13,.notes-ant-col-lg-13,.notes-ant-col-14,.notes-ant-col-xs-14,.notes-ant-col-sm-14,.notes-ant-col-md-14,.notes-ant-col-lg-14,.notes-ant-col-15,.notes-ant-col-xs-15,.notes-ant-col-sm-15,.notes-ant-col-md-15,.notes-ant-col-lg-15,.notes-ant-col-16,.notes-ant-col-xs-16,.notes-ant-col-sm-16,.notes-ant-col-md-16,.notes-ant-col-lg-16,.notes-ant-col-17,.notes-ant-col-xs-17,.notes-ant-col-sm-17,.notes-ant-col-md-17,.notes-ant-col-lg-17,.notes-ant-col-18,.notes-ant-col-xs-18,.notes-ant-col-sm-18,.notes-ant-col-md-18,.notes-ant-col-lg-18,.notes-ant-col-19,.notes-ant-col-xs-19,.notes-ant-col-sm-19,.notes-ant-col-md-19,.notes-ant-col-lg-19,.notes-ant-col-20,.notes-ant-col-xs-20,.notes-ant-col-sm-20,.notes-ant-col-md-20,.notes-ant-col-lg-20,.notes-ant-col-21,.notes-ant-col-xs-21,.notes-ant-col-sm-21,.notes-ant-col-md-21,.notes-ant-col-lg-21,.notes-ant-col-22,.notes-ant-col-xs-22,.notes-ant-col-sm-22,.notes-ant-col-md-22,.notes-ant-col-lg-22,.notes-ant-col-23,.notes-ant-col-xs-23,.notes-ant-col-sm-23,.notes-ant-col-md-23,.notes-ant-col-lg-23,.notes-ant-col-24,.notes-ant-col-xs-24,.notes-ant-col-sm-24,.notes-ant-col-md-24,.notes-ant-col-lg-24{position:relative;padding-right:0;padding-left:0}.notes-ant-col-1,.notes-ant-col-2,.notes-ant-col-3,.notes-ant-col-4,.notes-ant-col-5,.notes-ant-col-6,.notes-ant-col-7,.notes-ant-col-8,.notes-ant-col-9,.notes-ant-col-10,.notes-ant-col-11,.notes-ant-col-12,.notes-ant-col-13,.notes-ant-col-14,.notes-ant-col-15,.notes-ant-col-16,.notes-ant-col-17,.notes-ant-col-18,.notes-ant-col-19,.notes-ant-col-20,.notes-ant-col-21,.notes-ant-col-22,.notes-ant-col-23,.notes-ant-col-24{flex:0 0 auto;float:left}.notes-ant-col-24{display:block;box-sizing:border-box;width:100%}.notes-ant-col-push-24{left:100%}.notes-ant-col-pull-24{right:100%}.notes-ant-col-offset-24{margin-left:100%}.notes-ant-col-order-24{order:24}.notes-ant-col-23{display:block;box-sizing:border-box;width:95.83333333%}.notes-ant-col-push-23{left:95.83333333%}.notes-ant-col-pull-23{right:95.83333333%}.notes-ant-col-offset-23{margin-left:95.83333333%}.notes-ant-col-order-23{order:23}.notes-ant-col-22{display:block;box-sizing:border-box;width:91.66666667%}.notes-ant-col-push-22{left:91.66666667%}.notes-ant-col-pull-22{right:91.66666667%}.notes-ant-col-offset-22{margin-left:91.66666667%}.notes-ant-col-order-22{order:22}.notes-ant-col-21{display:block;box-sizing:border-box;width:87.5%}.notes-ant-col-push-21{left:87.5%}.notes-ant-col-pull-21{right:87.5%}.notes-ant-col-offset-21{margin-left:87.5%}.notes-ant-col-order-21{order:21}.notes-ant-col-20{display:block;box-sizing:border-box;width:83.33333333%}.notes-ant-col-push-20{left:83.33333333%}.notes-ant-col-pull-20{right:83.33333333%}.notes-ant-col-offset-20{margin-left:83.33333333%}.notes-ant-col-order-20{order:20}.notes-ant-col-19{display:block;box-sizing:border-box;width:79.16666667%}.notes-ant-col-push-19{left:79.16666667%}.notes-ant-col-pull-19{right:79.16666667%}.notes-ant-col-offset-19{margin-left:79.16666667%}.notes-ant-col-order-19{order:19}.notes-ant-col-18{display:block;box-sizing:border-box;width:75%}.notes-ant-col-push-18{left:75%}.notes-ant-col-pull-18{right:75%}.notes-ant-col-offset-18{margin-left:75%}.notes-ant-col-order-18{order:18}.notes-ant-col-17{display:block;box-sizing:border-box;width:70.83333333%}.notes-ant-col-push-17{left:70.83333333%}.notes-ant-col-pull-17{right:70.83333333%}.notes-ant-col-offset-17{margin-left:70.83333333%}.notes-ant-col-order-17{order:17}.notes-ant-col-16{display:block;box-sizing:border-box;width:66.66666667%}.notes-ant-col-push-16{left:66.66666667%}.notes-ant-col-pull-16{right:66.66666667%}.notes-ant-col-offset-16{margin-left:66.66666667%}.notes-ant-col-order-16{order:16}.notes-ant-col-15{display:block;box-sizing:border-box;width:62.5%}.notes-ant-col-push-15{left:62.5%}.notes-ant-col-pull-15{right:62.5%}.notes-ant-col-offset-15{margin-left:62.5%}.notes-ant-col-order-15{order:15}.notes-ant-col-14{display:block;box-sizing:border-box;width:58.33333333%}.notes-ant-col-push-14{left:58.33333333%}.notes-ant-col-pull-14{right:58.33333333%}.notes-ant-col-offset-14{margin-left:58.33333333%}.notes-ant-col-order-14{order:14}.notes-ant-col-13{display:block;box-sizing:border-box;width:54.16666667%}.notes-ant-col-push-13{left:54.16666667%}.notes-ant-col-pull-13{right:54.16666667%}.notes-ant-col-offset-13{margin-left:54.16666667%}.notes-ant-col-order-13{order:13}.notes-ant-col-12{display:block;box-sizing:border-box;width:50%}.notes-ant-col-push-12{left:50%}.notes-ant-col-pull-12{right:50%}.notes-ant-col-offset-12{margin-left:50%}.notes-ant-col-order-12{order:12}.notes-ant-col-11{display:block;box-sizing:border-box;width:45.83333333%}.notes-ant-col-push-11{left:45.83333333%}.notes-ant-col-pull-11{right:45.83333333%}.notes-ant-col-offset-11{margin-left:45.83333333%}.notes-ant-col-order-11{order:11}.notes-ant-col-10{display:block;box-sizing:border-box;width:41.66666667%}.notes-ant-col-push-10{left:41.66666667%}.notes-ant-col-pull-10{right:41.66666667%}.notes-ant-col-offset-10{margin-left:41.66666667%}.notes-ant-col-order-10{order:10}.notes-ant-col-9{display:block;box-sizing:border-box;width:37.5%}.notes-ant-col-push-9{left:37.5%}.notes-ant-col-pull-9{right:37.5%}.notes-ant-col-offset-9{margin-left:37.5%}.notes-ant-col-order-9{order:9}.notes-ant-col-8{display:block;box-sizing:border-box;width:33.33333333%}.notes-ant-col-push-8{left:33.33333333%}.notes-ant-col-pull-8{right:33.33333333%}.notes-ant-col-offset-8{margin-left:33.33333333%}.notes-ant-col-order-8{order:8}.notes-ant-col-7{display:block;box-sizing:border-box;width:29.16666667%}.notes-ant-col-push-7{left:29.16666667%}.notes-ant-col-pull-7{right:29.16666667%}.notes-ant-col-offset-7{margin-left:29.16666667%}.notes-ant-col-order-7{order:7}.notes-ant-col-6{display:block;box-sizing:border-box;width:25%}.notes-ant-col-push-6{left:25%}.notes-ant-col-pull-6{right:25%}.notes-ant-col-offset-6{margin-left:25%}.notes-ant-col-order-6{order:6}.notes-ant-col-5{display:block;box-sizing:border-box;width:20.83333333%}.notes-ant-col-push-5{left:20.83333333%}.notes-ant-col-pull-5{right:20.83333333%}.notes-ant-col-offset-5{margin-left:20.83333333%}.notes-ant-col-order-5{order:5}.notes-ant-col-4{display:block;box-sizing:border-box;width:16.66666667%}.notes-ant-col-push-4{left:16.66666667%}.notes-ant-col-pull-4{right:16.66666667%}.notes-ant-col-offset-4{margin-left:16.66666667%}.notes-ant-col-order-4{order:4}.notes-ant-col-3{display:block;box-sizing:border-box;width:12.5%}.notes-ant-col-push-3{left:12.5%}.notes-ant-col-pull-3{right:12.5%}.notes-ant-col-offset-3{margin-left:12.5%}.notes-ant-col-order-3{order:3}.notes-ant-col-2{display:block;box-sizing:border-box;width:8.33333333%}.notes-ant-col-push-2{left:8.33333333%}.notes-ant-col-pull-2{right:8.33333333%}.notes-ant-col-offset-2{margin-left:8.33333333%}.notes-ant-col-order-2{order:2}.notes-ant-col-1{display:block;box-sizing:border-box;width:4.16666667%}.notes-ant-col-push-1{left:4.16666667%}.notes-ant-col-pull-1{right:4.16666667%}.notes-ant-col-offset-1{margin-left:4.16666667%}.notes-ant-col-order-1{order:1}.notes-ant-col-0{display:none}.notes-ant-col-offset-0{margin-left:0}.notes-ant-col-order-0{order:0}.notes-ant-col-xs-1,.notes-ant-col-xs-2,.notes-ant-col-xs-3,.notes-ant-col-xs-4,.notes-ant-col-xs-5,.notes-ant-col-xs-6,.notes-ant-col-xs-7,.notes-ant-col-xs-8,.notes-ant-col-xs-9,.notes-ant-col-xs-10,.notes-ant-col-xs-11,.notes-ant-col-xs-12,.notes-ant-col-xs-13,.notes-ant-col-xs-14,.notes-ant-col-xs-15,.notes-ant-col-xs-16,.notes-ant-col-xs-17,.notes-ant-col-xs-18,.notes-ant-col-xs-19,.notes-ant-col-xs-20,.notes-ant-col-xs-21,.notes-ant-col-xs-22,.notes-ant-col-xs-23,.notes-ant-col-xs-24{flex:0 0 auto;float:left}.notes-ant-col-xs-24{display:block;box-sizing:border-box;width:100%}.notes-ant-col-xs-push-24{left:100%}.notes-ant-col-xs-pull-24{right:100%}.notes-ant-col-xs-offset-24{margin-left:100%}.notes-ant-col-xs-order-24{order:24}.notes-ant-col-xs-23{display:block;box-sizing:border-box;width:95.83333333%}.notes-ant-col-xs-push-23{left:95.83333333%}.notes-ant-col-xs-pull-23{right:95.83333333%}.notes-ant-col-xs-offset-23{margin-left:95.83333333%}.notes-ant-col-xs-order-23{order:23}.notes-ant-col-xs-22{display:block;box-sizing:border-box;width:91.66666667%}.notes-ant-col-xs-push-22{left:91.66666667%}.notes-ant-col-xs-pull-22{right:91.66666667%}.notes-ant-col-xs-offset-22{margin-left:91.66666667%}.notes-ant-col-xs-order-22{order:22}.notes-ant-col-xs-21{display:block;box-sizing:border-box;width:87.5%}.notes-ant-col-xs-push-21{left:87.5%}.notes-ant-col-xs-pull-21{right:87.5%}.notes-ant-col-xs-offset-21{margin-left:87.5%}.notes-ant-col-xs-order-21{order:21}.notes-ant-col-xs-20{display:block;box-sizing:border-box;width:83.33333333%}.notes-ant-col-xs-push-20{left:83.33333333%}.notes-ant-col-xs-pull-20{right:83.33333333%}.notes-ant-col-xs-offset-20{margin-left:83.33333333%}.notes-ant-col-xs-order-20{order:20}.notes-ant-col-xs-19{display:block;box-sizing:border-box;width:79.16666667%}.notes-ant-col-xs-push-19{left:79.16666667%}.notes-ant-col-xs-pull-19{right:79.16666667%}.notes-ant-col-xs-offset-19{margin-left:79.16666667%}.notes-ant-col-xs-order-19{order:19}.notes-ant-col-xs-18{display:block;box-sizing:border-box;width:75%}.notes-ant-col-xs-push-18{left:75%}.notes-ant-col-xs-pull-18{right:75%}.notes-ant-col-xs-offset-18{margin-left:75%}.notes-ant-col-xs-order-18{order:18}.notes-ant-col-xs-17{display:block;box-sizing:border-box;width:70.83333333%}.notes-ant-col-xs-push-17{left:70.83333333%}.notes-ant-col-xs-pull-17{right:70.83333333%}.notes-ant-col-xs-offset-17{margin-left:70.83333333%}.notes-ant-col-xs-order-17{order:17}.notes-ant-col-xs-16{display:block;box-sizing:border-box;width:66.66666667%}.notes-ant-col-xs-push-16{left:66.66666667%}.notes-ant-col-xs-pull-16{right:66.66666667%}.notes-ant-col-xs-offset-16{margin-left:66.66666667%}.notes-ant-col-xs-order-16{order:16}.notes-ant-col-xs-15{display:block;box-sizing:border-box;width:62.5%}.notes-ant-col-xs-push-15{left:62.5%}.notes-ant-col-xs-pull-15{right:62.5%}.notes-ant-col-xs-offset-15{margin-left:62.5%}.notes-ant-col-xs-order-15{order:15}.notes-ant-col-xs-14{display:block;box-sizing:border-box;width:58.33333333%}.notes-ant-col-xs-push-14{left:58.33333333%}.notes-ant-col-xs-pull-14{right:58.33333333%}.notes-ant-col-xs-offset-14{margin-left:58.33333333%}.notes-ant-col-xs-order-14{order:14}.notes-ant-col-xs-13{display:block;box-sizing:border-box;width:54.16666667%}.notes-ant-col-xs-push-13{left:54.16666667%}.notes-ant-col-xs-pull-13{right:54.16666667%}.notes-ant-col-xs-offset-13{margin-left:54.16666667%}.notes-ant-col-xs-order-13{order:13}.notes-ant-col-xs-12{display:block;box-sizing:border-box;width:50%}.notes-ant-col-xs-push-12{left:50%}.notes-ant-col-xs-pull-12{right:50%}.notes-ant-col-xs-offset-12{margin-left:50%}.notes-ant-col-xs-order-12{order:12}.notes-ant-col-xs-11{display:block;box-sizing:border-box;width:45.83333333%}.notes-ant-col-xs-push-11{left:45.83333333%}.notes-ant-col-xs-pull-11{right:45.83333333%}.notes-ant-col-xs-offset-11{margin-left:45.83333333%}.notes-ant-col-xs-order-11{order:11}.notes-ant-col-xs-10{display:block;box-sizing:border-box;width:41.66666667%}.notes-ant-col-xs-push-10{left:41.66666667%}.notes-ant-col-xs-pull-10{right:41.66666667%}.notes-ant-col-xs-offset-10{margin-left:41.66666667%}.notes-ant-col-xs-order-10{order:10}.notes-ant-col-xs-9{display:block;box-sizing:border-box;width:37.5%}.notes-ant-col-xs-push-9{left:37.5%}.notes-ant-col-xs-pull-9{right:37.5%}.notes-ant-col-xs-offset-9{margin-left:37.5%}.notes-ant-col-xs-order-9{order:9}.notes-ant-col-xs-8{display:block;box-sizing:border-box;width:33.33333333%}.notes-ant-col-xs-push-8{left:33.33333333%}.notes-ant-col-xs-pull-8{right:33.33333333%}.notes-ant-col-xs-offset-8{margin-left:33.33333333%}.notes-ant-col-xs-order-8{order:8}.notes-ant-col-xs-7{display:block;box-sizing:border-box;width:29.16666667%}.notes-ant-col-xs-push-7{left:29.16666667%}.notes-ant-col-xs-pull-7{right:29.16666667%}.notes-ant-col-xs-offset-7{margin-left:29.16666667%}.notes-ant-col-xs-order-7{order:7}.notes-ant-col-xs-6{display:block;box-sizing:border-box;width:25%}.notes-ant-col-xs-push-6{left:25%}.notes-ant-col-xs-pull-6{right:25%}.notes-ant-col-xs-offset-6{margin-left:25%}.notes-ant-col-xs-order-6{order:6}.notes-ant-col-xs-5{display:block;box-sizing:border-box;width:20.83333333%}.notes-ant-col-xs-push-5{left:20.83333333%}.notes-ant-col-xs-pull-5{right:20.83333333%}.notes-ant-col-xs-offset-5{margin-left:20.83333333%}.notes-ant-col-xs-order-5{order:5}.notes-ant-col-xs-4{display:block;box-sizing:border-box;width:16.66666667%}.notes-ant-col-xs-push-4{left:16.66666667%}.notes-ant-col-xs-pull-4{right:16.66666667%}.notes-ant-col-xs-offset-4{margin-left:16.66666667%}.notes-ant-col-xs-order-4{order:4}.notes-ant-col-xs-3{display:block;box-sizing:border-box;width:12.5%}.notes-ant-col-xs-push-3{left:12.5%}.notes-ant-col-xs-pull-3{right:12.5%}.notes-ant-col-xs-offset-3{margin-left:12.5%}.notes-ant-col-xs-order-3{order:3}.notes-ant-col-xs-2{display:block;box-sizing:border-box;width:8.33333333%}.notes-ant-col-xs-push-2{left:8.33333333%}.notes-ant-col-xs-pull-2{right:8.33333333%}.notes-ant-col-xs-offset-2{margin-left:8.33333333%}.notes-ant-col-xs-order-2{order:2}.notes-ant-col-xs-1{display:block;box-sizing:border-box;width:4.16666667%}.notes-ant-col-xs-push-1{left:4.16666667%}.notes-ant-col-xs-pull-1{right:4.16666667%}.notes-ant-col-xs-offset-1{margin-left:4.16666667%}.notes-ant-col-xs-order-1{order:1}.notes-ant-col-xs-0{display:none}.notes-ant-col-push-0{left:auto}.notes-ant-col-pull-0{right:auto}.notes-ant-col-xs-push-0{left:auto}.notes-ant-col-xs-pull-0{right:auto}.notes-ant-col-xs-offset-0{margin-left:0}.notes-ant-col-xs-order-0{order:0}@media (min-width: 576px){.notes-ant-col-sm-1,.notes-ant-col-sm-2,.notes-ant-col-sm-3,.notes-ant-col-sm-4,.notes-ant-col-sm-5,.notes-ant-col-sm-6,.notes-ant-col-sm-7,.notes-ant-col-sm-8,.notes-ant-col-sm-9,.notes-ant-col-sm-10,.notes-ant-col-sm-11,.notes-ant-col-sm-12,.notes-ant-col-sm-13,.notes-ant-col-sm-14,.notes-ant-col-sm-15,.notes-ant-col-sm-16,.notes-ant-col-sm-17,.notes-ant-col-sm-18,.notes-ant-col-sm-19,.notes-ant-col-sm-20,.notes-ant-col-sm-21,.notes-ant-col-sm-22,.notes-ant-col-sm-23,.notes-ant-col-sm-24{flex:0 0 auto;float:left}.notes-ant-col-sm-24{display:block;box-sizing:border-box;width:100%}.notes-ant-col-sm-push-24{left:100%}.notes-ant-col-sm-pull-24{right:100%}.notes-ant-col-sm-offset-24{margin-left:100%}.notes-ant-col-sm-order-24{order:24}.notes-ant-col-sm-23{display:block;box-sizing:border-box;width:95.83333333%}.notes-ant-col-sm-push-23{left:95.83333333%}.notes-ant-col-sm-pull-23{right:95.83333333%}.notes-ant-col-sm-offset-23{margin-left:95.83333333%}.notes-ant-col-sm-order-23{order:23}.notes-ant-col-sm-22{display:block;box-sizing:border-box;width:91.66666667%}.notes-ant-col-sm-push-22{left:91.66666667%}.notes-ant-col-sm-pull-22{right:91.66666667%}.notes-ant-col-sm-offset-22{margin-left:91.66666667%}.notes-ant-col-sm-order-22{order:22}.notes-ant-col-sm-21{display:block;box-sizing:border-box;width:87.5%}.notes-ant-col-sm-push-21{left:87.5%}.notes-ant-col-sm-pull-21{right:87.5%}.notes-ant-col-sm-offset-21{margin-left:87.5%}.notes-ant-col-sm-order-21{order:21}.notes-ant-col-sm-20{display:block;box-sizing:border-box;width:83.33333333%}.notes-ant-col-sm-push-20{left:83.33333333%}.notes-ant-col-sm-pull-20{right:83.33333333%}.notes-ant-col-sm-offset-20{margin-left:83.33333333%}.notes-ant-col-sm-order-20{order:20}.notes-ant-col-sm-19{display:block;box-sizing:border-box;width:79.16666667%}.notes-ant-col-sm-push-19{left:79.16666667%}.notes-ant-col-sm-pull-19{right:79.16666667%}.notes-ant-col-sm-offset-19{margin-left:79.16666667%}.notes-ant-col-sm-order-19{order:19}.notes-ant-col-sm-18{display:block;box-sizing:border-box;width:75%}.notes-ant-col-sm-push-18{left:75%}.notes-ant-col-sm-pull-18{right:75%}.notes-ant-col-sm-offset-18{margin-left:75%}.notes-ant-col-sm-order-18{order:18}.notes-ant-col-sm-17{display:block;box-sizing:border-box;width:70.83333333%}.notes-ant-col-sm-push-17{left:70.83333333%}.notes-ant-col-sm-pull-17{right:70.83333333%}.notes-ant-col-sm-offset-17{margin-left:70.83333333%}.notes-ant-col-sm-order-17{order:17}.notes-ant-col-sm-16{display:block;box-sizing:border-box;width:66.66666667%}.notes-ant-col-sm-push-16{left:66.66666667%}.notes-ant-col-sm-pull-16{right:66.66666667%}.notes-ant-col-sm-offset-16{margin-left:66.66666667%}.notes-ant-col-sm-order-16{order:16}.notes-ant-col-sm-15{display:block;box-sizing:border-box;width:62.5%}.notes-ant-col-sm-push-15{left:62.5%}.notes-ant-col-sm-pull-15{right:62.5%}.notes-ant-col-sm-offset-15{margin-left:62.5%}.notes-ant-col-sm-order-15{order:15}.notes-ant-col-sm-14{display:block;box-sizing:border-box;width:58.33333333%}.notes-ant-col-sm-push-14{left:58.33333333%}.notes-ant-col-sm-pull-14{right:58.33333333%}.notes-ant-col-sm-offset-14{margin-left:58.33333333%}.notes-ant-col-sm-order-14{order:14}.notes-ant-col-sm-13{display:block;box-sizing:border-box;width:54.16666667%}.notes-ant-col-sm-push-13{left:54.16666667%}.notes-ant-col-sm-pull-13{right:54.16666667%}.notes-ant-col-sm-offset-13{margin-left:54.16666667%}.notes-ant-col-sm-order-13{order:13}.notes-ant-col-sm-12{display:block;box-sizing:border-box;width:50%}.notes-ant-col-sm-push-12{left:50%}.notes-ant-col-sm-pull-12{right:50%}.notes-ant-col-sm-offset-12{margin-left:50%}.notes-ant-col-sm-order-12{order:12}.notes-ant-col-sm-11{display:block;box-sizing:border-box;width:45.83333333%}.notes-ant-col-sm-push-11{left:45.83333333%}.notes-ant-col-sm-pull-11{right:45.83333333%}.notes-ant-col-sm-offset-11{margin-left:45.83333333%}.notes-ant-col-sm-order-11{order:11}.notes-ant-col-sm-10{display:block;box-sizing:border-box;width:41.66666667%}.notes-ant-col-sm-push-10{left:41.66666667%}.notes-ant-col-sm-pull-10{right:41.66666667%}.notes-ant-col-sm-offset-10{margin-left:41.66666667%}.notes-ant-col-sm-order-10{order:10}.notes-ant-col-sm-9{display:block;box-sizing:border-box;width:37.5%}.notes-ant-col-sm-push-9{left:37.5%}.notes-ant-col-sm-pull-9{right:37.5%}.notes-ant-col-sm-offset-9{margin-left:37.5%}.notes-ant-col-sm-order-9{order:9}.notes-ant-col-sm-8{display:block;box-sizing:border-box;width:33.33333333%}.notes-ant-col-sm-push-8{left:33.33333333%}.notes-ant-col-sm-pull-8{right:33.33333333%}.notes-ant-col-sm-offset-8{margin-left:33.33333333%}.notes-ant-col-sm-order-8{order:8}.notes-ant-col-sm-7{display:block;box-sizing:border-box;width:29.16666667%}.notes-ant-col-sm-push-7{left:29.16666667%}.notes-ant-col-sm-pull-7{right:29.16666667%}.notes-ant-col-sm-offset-7{margin-left:29.16666667%}.notes-ant-col-sm-order-7{order:7}.notes-ant-col-sm-6{display:block;box-sizing:border-box;width:25%}.notes-ant-col-sm-push-6{left:25%}.notes-ant-col-sm-pull-6{right:25%}.notes-ant-col-sm-offset-6{margin-left:25%}.notes-ant-col-sm-order-6{order:6}.notes-ant-col-sm-5{display:block;box-sizing:border-box;width:20.83333333%}.notes-ant-col-sm-push-5{left:20.83333333%}.notes-ant-col-sm-pull-5{right:20.83333333%}.notes-ant-col-sm-offset-5{margin-left:20.83333333%}.notes-ant-col-sm-order-5{order:5}.notes-ant-col-sm-4{display:block;box-sizing:border-box;width:16.66666667%}.notes-ant-col-sm-push-4{left:16.66666667%}.notes-ant-col-sm-pull-4{right:16.66666667%}.notes-ant-col-sm-offset-4{margin-left:16.66666667%}.notes-ant-col-sm-order-4{order:4}.notes-ant-col-sm-3{display:block;box-sizing:border-box;width:12.5%}.notes-ant-col-sm-push-3{left:12.5%}.notes-ant-col-sm-pull-3{right:12.5%}.notes-ant-col-sm-offset-3{margin-left:12.5%}.notes-ant-col-sm-order-3{order:3}.notes-ant-col-sm-2{display:block;box-sizing:border-box;width:8.33333333%}.notes-ant-col-sm-push-2{left:8.33333333%}.notes-ant-col-sm-pull-2{right:8.33333333%}.notes-ant-col-sm-offset-2{margin-left:8.33333333%}.notes-ant-col-sm-order-2{order:2}.notes-ant-col-sm-1{display:block;box-sizing:border-box;width:4.16666667%}.notes-ant-col-sm-push-1{left:4.16666667%}.notes-ant-col-sm-pull-1{right:4.16666667%}.notes-ant-col-sm-offset-1{margin-left:4.16666667%}.notes-ant-col-sm-order-1{order:1}.notes-ant-col-sm-0{display:none}.notes-ant-col-push-0{left:auto}.notes-ant-col-pull-0{right:auto}.notes-ant-col-sm-push-0{left:auto}.notes-ant-col-sm-pull-0{right:auto}.notes-ant-col-sm-offset-0{margin-left:0}.notes-ant-col-sm-order-0{order:0}}@media (min-width: 768px){.notes-ant-col-md-1,.notes-ant-col-md-2,.notes-ant-col-md-3,.notes-ant-col-md-4,.notes-ant-col-md-5,.notes-ant-col-md-6,.notes-ant-col-md-7,.notes-ant-col-md-8,.notes-ant-col-md-9,.notes-ant-col-md-10,.notes-ant-col-md-11,.notes-ant-col-md-12,.notes-ant-col-md-13,.notes-ant-col-md-14,.notes-ant-col-md-15,.notes-ant-col-md-16,.notes-ant-col-md-17,.notes-ant-col-md-18,.notes-ant-col-md-19,.notes-ant-col-md-20,.notes-ant-col-md-21,.notes-ant-col-md-22,.notes-ant-col-md-23,.notes-ant-col-md-24{flex:0 0 auto;float:left}.notes-ant-col-md-24{display:block;box-sizing:border-box;width:100%}.notes-ant-col-md-push-24{left:100%}.notes-ant-col-md-pull-24{right:100%}.notes-ant-col-md-offset-24{margin-left:100%}.notes-ant-col-md-order-24{order:24}.notes-ant-col-md-23{display:block;box-sizing:border-box;width:95.83333333%}.notes-ant-col-md-push-23{left:95.83333333%}.notes-ant-col-md-pull-23{right:95.83333333%}.notes-ant-col-md-offset-23{margin-left:95.83333333%}.notes-ant-col-md-order-23{order:23}.notes-ant-col-md-22{display:block;box-sizing:border-box;width:91.66666667%}.notes-ant-col-md-push-22{left:91.66666667%}.notes-ant-col-md-pull-22{right:91.66666667%}.notes-ant-col-md-offset-22{margin-left:91.66666667%}.notes-ant-col-md-order-22{order:22}.notes-ant-col-md-21{display:block;box-sizing:border-box;width:87.5%}.notes-ant-col-md-push-21{left:87.5%}.notes-ant-col-md-pull-21{right:87.5%}.notes-ant-col-md-offset-21{margin-left:87.5%}.notes-ant-col-md-order-21{order:21}.notes-ant-col-md-20{display:block;box-sizing:border-box;width:83.33333333%}.notes-ant-col-md-push-20{left:83.33333333%}.notes-ant-col-md-pull-20{right:83.33333333%}.notes-ant-col-md-offset-20{margin-left:83.33333333%}.notes-ant-col-md-order-20{order:20}.notes-ant-col-md-19{display:block;box-sizing:border-box;width:79.16666667%}.notes-ant-col-md-push-19{left:79.16666667%}.notes-ant-col-md-pull-19{right:79.16666667%}.notes-ant-col-md-offset-19{margin-left:79.16666667%}.notes-ant-col-md-order-19{order:19}.notes-ant-col-md-18{display:block;box-sizing:border-box;width:75%}.notes-ant-col-md-push-18{left:75%}.notes-ant-col-md-pull-18{right:75%}.notes-ant-col-md-offset-18{margin-left:75%}.notes-ant-col-md-order-18{order:18}.notes-ant-col-md-17{display:block;box-sizing:border-box;width:70.83333333%}.notes-ant-col-md-push-17{left:70.83333333%}.notes-ant-col-md-pull-17{right:70.83333333%}.notes-ant-col-md-offset-17{margin-left:70.83333333%}.notes-ant-col-md-order-17{order:17}.notes-ant-col-md-16{display:block;box-sizing:border-box;width:66.66666667%}.notes-ant-col-md-push-16{left:66.66666667%}.notes-ant-col-md-pull-16{right:66.66666667%}.notes-ant-col-md-offset-16{margin-left:66.66666667%}.notes-ant-col-md-order-16{order:16}.notes-ant-col-md-15{display:block;box-sizing:border-box;width:62.5%}.notes-ant-col-md-push-15{left:62.5%}.notes-ant-col-md-pull-15{right:62.5%}.notes-ant-col-md-offset-15{margin-left:62.5%}.notes-ant-col-md-order-15{order:15}.notes-ant-col-md-14{display:block;box-sizing:border-box;width:58.33333333%}.notes-ant-col-md-push-14{left:58.33333333%}.notes-ant-col-md-pull-14{right:58.33333333%}.notes-ant-col-md-offset-14{margin-left:58.33333333%}.notes-ant-col-md-order-14{order:14}.notes-ant-col-md-13{display:block;box-sizing:border-box;width:54.16666667%}.notes-ant-col-md-push-13{left:54.16666667%}.notes-ant-col-md-pull-13{right:54.16666667%}.notes-ant-col-md-offset-13{margin-left:54.16666667%}.notes-ant-col-md-order-13{order:13}.notes-ant-col-md-12{display:block;box-sizing:border-box;width:50%}.notes-ant-col-md-push-12{left:50%}.notes-ant-col-md-pull-12{right:50%}.notes-ant-col-md-offset-12{margin-left:50%}.notes-ant-col-md-order-12{order:12}.notes-ant-col-md-11{display:block;box-sizing:border-box;width:45.83333333%}.notes-ant-col-md-push-11{left:45.83333333%}.notes-ant-col-md-pull-11{right:45.83333333%}.notes-ant-col-md-offset-11{margin-left:45.83333333%}.notes-ant-col-md-order-11{order:11}.notes-ant-col-md-10{display:block;box-sizing:border-box;width:41.66666667%}.notes-ant-col-md-push-10{left:41.66666667%}.notes-ant-col-md-pull-10{right:41.66666667%}.notes-ant-col-md-offset-10{margin-left:41.66666667%}.notes-ant-col-md-order-10{order:10}.notes-ant-col-md-9{display:block;box-sizing:border-box;width:37.5%}.notes-ant-col-md-push-9{left:37.5%}.notes-ant-col-md-pull-9{right:37.5%}.notes-ant-col-md-offset-9{margin-left:37.5%}.notes-ant-col-md-order-9{order:9}.notes-ant-col-md-8{display:block;box-sizing:border-box;width:33.33333333%}.notes-ant-col-md-push-8{left:33.33333333%}.notes-ant-col-md-pull-8{right:33.33333333%}.notes-ant-col-md-offset-8{margin-left:33.33333333%}.notes-ant-col-md-order-8{order:8}.notes-ant-col-md-7{display:block;box-sizing:border-box;width:29.16666667%}.notes-ant-col-md-push-7{left:29.16666667%}.notes-ant-col-md-pull-7{right:29.16666667%}.notes-ant-col-md-offset-7{margin-left:29.16666667%}.notes-ant-col-md-order-7{order:7}.notes-ant-col-md-6{display:block;box-sizing:border-box;width:25%}.notes-ant-col-md-push-6{left:25%}.notes-ant-col-md-pull-6{right:25%}.notes-ant-col-md-offset-6{margin-left:25%}.notes-ant-col-md-order-6{order:6}.notes-ant-col-md-5{display:block;box-sizing:border-box;width:20.83333333%}.notes-ant-col-md-push-5{left:20.83333333%}.notes-ant-col-md-pull-5{right:20.83333333%}.notes-ant-col-md-offset-5{margin-left:20.83333333%}.notes-ant-col-md-order-5{order:5}.notes-ant-col-md-4{display:block;box-sizing:border-box;width:16.66666667%}.notes-ant-col-md-push-4{left:16.66666667%}.notes-ant-col-md-pull-4{right:16.66666667%}.notes-ant-col-md-offset-4{margin-left:16.66666667%}.notes-ant-col-md-order-4{order:4}.notes-ant-col-md-3{display:block;box-sizing:border-box;width:12.5%}.notes-ant-col-md-push-3{left:12.5%}.notes-ant-col-md-pull-3{right:12.5%}.notes-ant-col-md-offset-3{margin-left:12.5%}.notes-ant-col-md-order-3{order:3}.notes-ant-col-md-2{display:block;box-sizing:border-box;width:8.33333333%}.notes-ant-col-md-push-2{left:8.33333333%}.notes-ant-col-md-pull-2{right:8.33333333%}.notes-ant-col-md-offset-2{margin-left:8.33333333%}.notes-ant-col-md-order-2{order:2}.notes-ant-col-md-1{display:block;box-sizing:border-box;width:4.16666667%}.notes-ant-col-md-push-1{left:4.16666667%}.notes-ant-col-md-pull-1{right:4.16666667%}.notes-ant-col-md-offset-1{margin-left:4.16666667%}.notes-ant-col-md-order-1{order:1}.notes-ant-col-md-0{display:none}.notes-ant-col-push-0{left:auto}.notes-ant-col-pull-0{right:auto}.notes-ant-col-md-push-0{left:auto}.notes-ant-col-md-pull-0{right:auto}.notes-ant-col-md-offset-0{margin-left:0}.notes-ant-col-md-order-0{order:0}}@media (min-width: 992px){.notes-ant-col-lg-1,.notes-ant-col-lg-2,.notes-ant-col-lg-3,.notes-ant-col-lg-4,.notes-ant-col-lg-5,.notes-ant-col-lg-6,.notes-ant-col-lg-7,.notes-ant-col-lg-8,.notes-ant-col-lg-9,.notes-ant-col-lg-10,.notes-ant-col-lg-11,.notes-ant-col-lg-12,.notes-ant-col-lg-13,.notes-ant-col-lg-14,.notes-ant-col-lg-15,.notes-ant-col-lg-16,.notes-ant-col-lg-17,.notes-ant-col-lg-18,.notes-ant-col-lg-19,.notes-ant-col-lg-20,.notes-ant-col-lg-21,.notes-ant-col-lg-22,.notes-ant-col-lg-23,.notes-ant-col-lg-24{flex:0 0 auto;float:left}.notes-ant-col-lg-24{display:block;box-sizing:border-box;width:100%}.notes-ant-col-lg-push-24{left:100%}.notes-ant-col-lg-pull-24{right:100%}.notes-ant-col-lg-offset-24{margin-left:100%}.notes-ant-col-lg-order-24{order:24}.notes-ant-col-lg-23{display:block;box-sizing:border-box;width:95.83333333%}.notes-ant-col-lg-push-23{left:95.83333333%}.notes-ant-col-lg-pull-23{right:95.83333333%}.notes-ant-col-lg-offset-23{margin-left:95.83333333%}.notes-ant-col-lg-order-23{order:23}.notes-ant-col-lg-22{display:block;box-sizing:border-box;width:91.66666667%}.notes-ant-col-lg-push-22{left:91.66666667%}.notes-ant-col-lg-pull-22{right:91.66666667%}.notes-ant-col-lg-offset-22{margin-left:91.66666667%}.notes-ant-col-lg-order-22{order:22}.notes-ant-col-lg-21{display:block;box-sizing:border-box;width:87.5%}.notes-ant-col-lg-push-21{left:87.5%}.notes-ant-col-lg-pull-21{right:87.5%}.notes-ant-col-lg-offset-21{margin-left:87.5%}.notes-ant-col-lg-order-21{order:21}.notes-ant-col-lg-20{display:block;box-sizing:border-box;width:83.33333333%}.notes-ant-col-lg-push-20{left:83.33333333%}.notes-ant-col-lg-pull-20{right:83.33333333%}.notes-ant-col-lg-offset-20{margin-left:83.33333333%}.notes-ant-col-lg-order-20{order:20}.notes-ant-col-lg-19{display:block;box-sizing:border-box;width:79.16666667%}.notes-ant-col-lg-push-19{left:79.16666667%}.notes-ant-col-lg-pull-19{right:79.16666667%}.notes-ant-col-lg-offset-19{margin-left:79.16666667%}.notes-ant-col-lg-order-19{order:19}.notes-ant-col-lg-18{display:block;box-sizing:border-box;width:75%}.notes-ant-col-lg-push-18{left:75%}.notes-ant-col-lg-pull-18{right:75%}.notes-ant-col-lg-offset-18{margin-left:75%}.notes-ant-col-lg-order-18{order:18}.notes-ant-col-lg-17{display:block;box-sizing:border-box;width:70.83333333%}.notes-ant-col-lg-push-17{left:70.83333333%}.notes-ant-col-lg-pull-17{right:70.83333333%}.notes-ant-col-lg-offset-17{margin-left:70.83333333%}.notes-ant-col-lg-order-17{order:17}.notes-ant-col-lg-16{display:block;box-sizing:border-box;width:66.66666667%}.notes-ant-col-lg-push-16{left:66.66666667%}.notes-ant-col-lg-pull-16{right:66.66666667%}.notes-ant-col-lg-offset-16{margin-left:66.66666667%}.notes-ant-col-lg-order-16{order:16}.notes-ant-col-lg-15{display:block;box-sizing:border-box;width:62.5%}.notes-ant-col-lg-push-15{left:62.5%}.notes-ant-col-lg-pull-15{right:62.5%}.notes-ant-col-lg-offset-15{margin-left:62.5%}.notes-ant-col-lg-order-15{order:15}.notes-ant-col-lg-14{display:block;box-sizing:border-box;width:58.33333333%}.notes-ant-col-lg-push-14{left:58.33333333%}.notes-ant-col-lg-pull-14{right:58.33333333%}.notes-ant-col-lg-offset-14{margin-left:58.33333333%}.notes-ant-col-lg-order-14{order:14}.notes-ant-col-lg-13{display:block;box-sizing:border-box;width:54.16666667%}.notes-ant-col-lg-push-13{left:54.16666667%}.notes-ant-col-lg-pull-13{right:54.16666667%}.notes-ant-col-lg-offset-13{margin-left:54.16666667%}.notes-ant-col-lg-order-13{order:13}.notes-ant-col-lg-12{display:block;box-sizing:border-box;width:50%}.notes-ant-col-lg-push-12{left:50%}.notes-ant-col-lg-pull-12{right:50%}.notes-ant-col-lg-offset-12{margin-left:50%}.notes-ant-col-lg-order-12{order:12}.notes-ant-col-lg-11{display:block;box-sizing:border-box;width:45.83333333%}.notes-ant-col-lg-push-11{left:45.83333333%}.notes-ant-col-lg-pull-11{right:45.83333333%}.notes-ant-col-lg-offset-11{margin-left:45.83333333%}.notes-ant-col-lg-order-11{order:11}.notes-ant-col-lg-10{display:block;box-sizing:border-box;width:41.66666667%}.notes-ant-col-lg-push-10{left:41.66666667%}.notes-ant-col-lg-pull-10{right:41.66666667%}.notes-ant-col-lg-offset-10{margin-left:41.66666667%}.notes-ant-col-lg-order-10{order:10}.notes-ant-col-lg-9{display:block;box-sizing:border-box;width:37.5%}.notes-ant-col-lg-push-9{left:37.5%}.notes-ant-col-lg-pull-9{right:37.5%}.notes-ant-col-lg-offset-9{margin-left:37.5%}.notes-ant-col-lg-order-9{order:9}.notes-ant-col-lg-8{display:block;box-sizing:border-box;width:33.33333333%}.notes-ant-col-lg-push-8{left:33.33333333%}.notes-ant-col-lg-pull-8{right:33.33333333%}.notes-ant-col-lg-offset-8{margin-left:33.33333333%}.notes-ant-col-lg-order-8{order:8}.notes-ant-col-lg-7{display:block;box-sizing:border-box;width:29.16666667%}.notes-ant-col-lg-push-7{left:29.16666667%}.notes-ant-col-lg-pull-7{right:29.16666667%}.notes-ant-col-lg-offset-7{margin-left:29.16666667%}.notes-ant-col-lg-order-7{order:7}.notes-ant-col-lg-6{display:block;box-sizing:border-box;width:25%}.notes-ant-col-lg-push-6{left:25%}.notes-ant-col-lg-pull-6{right:25%}.notes-ant-col-lg-offset-6{margin-left:25%}.notes-ant-col-lg-order-6{order:6}.notes-ant-col-lg-5{display:block;box-sizing:border-box;width:20.83333333%}.notes-ant-col-lg-push-5{left:20.83333333%}.notes-ant-col-lg-pull-5{right:20.83333333%}.notes-ant-col-lg-offset-5{margin-left:20.83333333%}.notes-ant-col-lg-order-5{order:5}.notes-ant-col-lg-4{display:block;box-sizing:border-box;width:16.66666667%}.notes-ant-col-lg-push-4{left:16.66666667%}.notes-ant-col-lg-pull-4{right:16.66666667%}.notes-ant-col-lg-offset-4{margin-left:16.66666667%}.notes-ant-col-lg-order-4{order:4}.notes-ant-col-lg-3{display:block;box-sizing:border-box;width:12.5%}.notes-ant-col-lg-push-3{left:12.5%}.notes-ant-col-lg-pull-3{right:12.5%}.notes-ant-col-lg-offset-3{margin-left:12.5%}.notes-ant-col-lg-order-3{order:3}.notes-ant-col-lg-2{display:block;box-sizing:border-box;width:8.33333333%}.notes-ant-col-lg-push-2{left:8.33333333%}.notes-ant-col-lg-pull-2{right:8.33333333%}.notes-ant-col-lg-offset-2{margin-left:8.33333333%}.notes-ant-col-lg-order-2{order:2}.notes-ant-col-lg-1{display:block;box-sizing:border-box;width:4.16666667%}.notes-ant-col-lg-push-1{left:4.16666667%}.notes-ant-col-lg-pull-1{right:4.16666667%}.notes-ant-col-lg-offset-1{margin-left:4.16666667%}.notes-ant-col-lg-order-1{order:1}.notes-ant-col-lg-0{display:none}.notes-ant-col-push-0{left:auto}.notes-ant-col-pull-0{right:auto}.notes-ant-col-lg-push-0{left:auto}.notes-ant-col-lg-pull-0{right:auto}.notes-ant-col-lg-offset-0{margin-left:0}.notes-ant-col-lg-order-0{order:0}}@media (min-width: 1200px){.notes-ant-col-xl-1,.notes-ant-col-xl-2,.notes-ant-col-xl-3,.notes-ant-col-xl-4,.notes-ant-col-xl-5,.notes-ant-col-xl-6,.notes-ant-col-xl-7,.notes-ant-col-xl-8,.notes-ant-col-xl-9,.notes-ant-col-xl-10,.notes-ant-col-xl-11,.notes-ant-col-xl-12,.notes-ant-col-xl-13,.notes-ant-col-xl-14,.notes-ant-col-xl-15,.notes-ant-col-xl-16,.notes-ant-col-xl-17,.notes-ant-col-xl-18,.notes-ant-col-xl-19,.notes-ant-col-xl-20,.notes-ant-col-xl-21,.notes-ant-col-xl-22,.notes-ant-col-xl-23,.notes-ant-col-xl-24{flex:0 0 auto;float:left}.notes-ant-col-xl-24{display:block;box-sizing:border-box;width:100%}.notes-ant-col-xl-push-24{left:100%}.notes-ant-col-xl-pull-24{right:100%}.notes-ant-col-xl-offset-24{margin-left:100%}.notes-ant-col-xl-order-24{order:24}.notes-ant-col-xl-23{display:block;box-sizing:border-box;width:95.83333333%}.notes-ant-col-xl-push-23{left:95.83333333%}.notes-ant-col-xl-pull-23{right:95.83333333%}.notes-ant-col-xl-offset-23{margin-left:95.83333333%}.notes-ant-col-xl-order-23{order:23}.notes-ant-col-xl-22{display:block;box-sizing:border-box;width:91.66666667%}.notes-ant-col-xl-push-22{left:91.66666667%}.notes-ant-col-xl-pull-22{right:91.66666667%}.notes-ant-col-xl-offset-22{margin-left:91.66666667%}.notes-ant-col-xl-order-22{order:22}.notes-ant-col-xl-21{display:block;box-sizing:border-box;width:87.5%}.notes-ant-col-xl-push-21{left:87.5%}.notes-ant-col-xl-pull-21{right:87.5%}.notes-ant-col-xl-offset-21{margin-left:87.5%}.notes-ant-col-xl-order-21{order:21}.notes-ant-col-xl-20{display:block;box-sizing:border-box;width:83.33333333%}.notes-ant-col-xl-push-20{left:83.33333333%}.notes-ant-col-xl-pull-20{right:83.33333333%}.notes-ant-col-xl-offset-20{margin-left:83.33333333%}.notes-ant-col-xl-order-20{order:20}.notes-ant-col-xl-19{display:block;box-sizing:border-box;width:79.16666667%}.notes-ant-col-xl-push-19{left:79.16666667%}.notes-ant-col-xl-pull-19{right:79.16666667%}.notes-ant-col-xl-offset-19{margin-left:79.16666667%}.notes-ant-col-xl-order-19{order:19}.notes-ant-col-xl-18{display:block;box-sizing:border-box;width:75%}.notes-ant-col-xl-push-18{left:75%}.notes-ant-col-xl-pull-18{right:75%}.notes-ant-col-xl-offset-18{margin-left:75%}.notes-ant-col-xl-order-18{order:18}.notes-ant-col-xl-17{display:block;box-sizing:border-box;width:70.83333333%}.notes-ant-col-xl-push-17{left:70.83333333%}.notes-ant-col-xl-pull-17{right:70.83333333%}.notes-ant-col-xl-offset-17{margin-left:70.83333333%}.notes-ant-col-xl-order-17{order:17}.notes-ant-col-xl-16{display:block;box-sizing:border-box;width:66.66666667%}.notes-ant-col-xl-push-16{left:66.66666667%}.notes-ant-col-xl-pull-16{right:66.66666667%}.notes-ant-col-xl-offset-16{margin-left:66.66666667%}.notes-ant-col-xl-order-16{order:16}.notes-ant-col-xl-15{display:block;box-sizing:border-box;width:62.5%}.notes-ant-col-xl-push-15{left:62.5%}.notes-ant-col-xl-pull-15{right:62.5%}.notes-ant-col-xl-offset-15{margin-left:62.5%}.notes-ant-col-xl-order-15{order:15}.notes-ant-col-xl-14{display:block;box-sizing:border-box;width:58.33333333%}.notes-ant-col-xl-push-14{left:58.33333333%}.notes-ant-col-xl-pull-14{right:58.33333333%}.notes-ant-col-xl-offset-14{margin-left:58.33333333%}.notes-ant-col-xl-order-14{order:14}.notes-ant-col-xl-13{display:block;box-sizing:border-box;width:54.16666667%}.notes-ant-col-xl-push-13{left:54.16666667%}.notes-ant-col-xl-pull-13{right:54.16666667%}.notes-ant-col-xl-offset-13{margin-left:54.16666667%}.notes-ant-col-xl-order-13{order:13}.notes-ant-col-xl-12{display:block;box-sizing:border-box;width:50%}.notes-ant-col-xl-push-12{left:50%}.notes-ant-col-xl-pull-12{right:50%}.notes-ant-col-xl-offset-12{margin-left:50%}.notes-ant-col-xl-order-12{order:12}.notes-ant-col-xl-11{display:block;box-sizing:border-box;width:45.83333333%}.notes-ant-col-xl-push-11{left:45.83333333%}.notes-ant-col-xl-pull-11{right:45.83333333%}.notes-ant-col-xl-offset-11{margin-left:45.83333333%}.notes-ant-col-xl-order-11{order:11}.notes-ant-col-xl-10{display:block;box-sizing:border-box;width:41.66666667%}.notes-ant-col-xl-push-10{left:41.66666667%}.notes-ant-col-xl-pull-10{right:41.66666667%}.notes-ant-col-xl-offset-10{margin-left:41.66666667%}.notes-ant-col-xl-order-10{order:10}.notes-ant-col-xl-9{display:block;box-sizing:border-box;width:37.5%}.notes-ant-col-xl-push-9{left:37.5%}.notes-ant-col-xl-pull-9{right:37.5%}.notes-ant-col-xl-offset-9{margin-left:37.5%}.notes-ant-col-xl-order-9{order:9}.notes-ant-col-xl-8{display:block;box-sizing:border-box;width:33.33333333%}.notes-ant-col-xl-push-8{left:33.33333333%}.notes-ant-col-xl-pull-8{right:33.33333333%}.notes-ant-col-xl-offset-8{margin-left:33.33333333%}.notes-ant-col-xl-order-8{order:8}.notes-ant-col-xl-7{display:block;box-sizing:border-box;width:29.16666667%}.notes-ant-col-xl-push-7{left:29.16666667%}.notes-ant-col-xl-pull-7{right:29.16666667%}.notes-ant-col-xl-offset-7{margin-left:29.16666667%}.notes-ant-col-xl-order-7{order:7}.notes-ant-col-xl-6{display:block;box-sizing:border-box;width:25%}.notes-ant-col-xl-push-6{left:25%}.notes-ant-col-xl-pull-6{right:25%}.notes-ant-col-xl-offset-6{margin-left:25%}.notes-ant-col-xl-order-6{order:6}.notes-ant-col-xl-5{display:block;box-sizing:border-box;width:20.83333333%}.notes-ant-col-xl-push-5{left:20.83333333%}.notes-ant-col-xl-pull-5{right:20.83333333%}.notes-ant-col-xl-offset-5{margin-left:20.83333333%}.notes-ant-col-xl-order-5{order:5}.notes-ant-col-xl-4{display:block;box-sizing:border-box;width:16.66666667%}.notes-ant-col-xl-push-4{left:16.66666667%}.notes-ant-col-xl-pull-4{right:16.66666667%}.notes-ant-col-xl-offset-4{margin-left:16.66666667%}.notes-ant-col-xl-order-4{order:4}.notes-ant-col-xl-3{display:block;box-sizing:border-box;width:12.5%}.notes-ant-col-xl-push-3{left:12.5%}.notes-ant-col-xl-pull-3{right:12.5%}.notes-ant-col-xl-offset-3{margin-left:12.5%}.notes-ant-col-xl-order-3{order:3}.notes-ant-col-xl-2{display:block;box-sizing:border-box;width:8.33333333%}.notes-ant-col-xl-push-2{left:8.33333333%}.notes-ant-col-xl-pull-2{right:8.33333333%}.notes-ant-col-xl-offset-2{margin-left:8.33333333%}.notes-ant-col-xl-order-2{order:2}.notes-ant-col-xl-1{display:block;box-sizing:border-box;width:4.16666667%}.notes-ant-col-xl-push-1{left:4.16666667%}.notes-ant-col-xl-pull-1{right:4.16666667%}.notes-ant-col-xl-offset-1{margin-left:4.16666667%}.notes-ant-col-xl-order-1{order:1}.notes-ant-col-xl-0{display:none}.notes-ant-col-push-0{left:auto}.notes-ant-col-pull-0{right:auto}.notes-ant-col-xl-push-0{left:auto}.notes-ant-col-xl-pull-0{right:auto}.notes-ant-col-xl-offset-0{margin-left:0}.notes-ant-col-xl-order-0{order:0}}@media (min-width: 1600px){.notes-ant-col-xxl-1,.notes-ant-col-xxl-2,.notes-ant-col-xxl-3,.notes-ant-col-xxl-4,.notes-ant-col-xxl-5,.notes-ant-col-xxl-6,.notes-ant-col-xxl-7,.notes-ant-col-xxl-8,.notes-ant-col-xxl-9,.notes-ant-col-xxl-10,.notes-ant-col-xxl-11,.notes-ant-col-xxl-12,.notes-ant-col-xxl-13,.notes-ant-col-xxl-14,.notes-ant-col-xxl-15,.notes-ant-col-xxl-16,.notes-ant-col-xxl-17,.notes-ant-col-xxl-18,.notes-ant-col-xxl-19,.notes-ant-col-xxl-20,.notes-ant-col-xxl-21,.notes-ant-col-xxl-22,.notes-ant-col-xxl-23,.notes-ant-col-xxl-24{flex:0 0 auto;float:left}.notes-ant-col-xxl-24{display:block;box-sizing:border-box;width:100%}.notes-ant-col-xxl-push-24{left:100%}.notes-ant-col-xxl-pull-24{right:100%}.notes-ant-col-xxl-offset-24{margin-left:100%}.notes-ant-col-xxl-order-24{order:24}.notes-ant-col-xxl-23{display:block;box-sizing:border-box;width:95.83333333%}.notes-ant-col-xxl-push-23{left:95.83333333%}.notes-ant-col-xxl-pull-23{right:95.83333333%}.notes-ant-col-xxl-offset-23{margin-left:95.83333333%}.notes-ant-col-xxl-order-23{order:23}.notes-ant-col-xxl-22{display:block;box-sizing:border-box;width:91.66666667%}.notes-ant-col-xxl-push-22{left:91.66666667%}.notes-ant-col-xxl-pull-22{right:91.66666667%}.notes-ant-col-xxl-offset-22{margin-left:91.66666667%}.notes-ant-col-xxl-order-22{order:22}.notes-ant-col-xxl-21{display:block;box-sizing:border-box;width:87.5%}.notes-ant-col-xxl-push-21{left:87.5%}.notes-ant-col-xxl-pull-21{right:87.5%}.notes-ant-col-xxl-offset-21{margin-left:87.5%}.notes-ant-col-xxl-order-21{order:21}.notes-ant-col-xxl-20{display:block;box-sizing:border-box;width:83.33333333%}.notes-ant-col-xxl-push-20{left:83.33333333%}.notes-ant-col-xxl-pull-20{right:83.33333333%}.notes-ant-col-xxl-offset-20{margin-left:83.33333333%}.notes-ant-col-xxl-order-20{order:20}.notes-ant-col-xxl-19{display:block;box-sizing:border-box;width:79.16666667%}.notes-ant-col-xxl-push-19{left:79.16666667%}.notes-ant-col-xxl-pull-19{right:79.16666667%}.notes-ant-col-xxl-offset-19{margin-left:79.16666667%}.notes-ant-col-xxl-order-19{order:19}.notes-ant-col-xxl-18{display:block;box-sizing:border-box;width:75%}.notes-ant-col-xxl-push-18{left:75%}.notes-ant-col-xxl-pull-18{right:75%}.notes-ant-col-xxl-offset-18{margin-left:75%}.notes-ant-col-xxl-order-18{order:18}.notes-ant-col-xxl-17{display:block;box-sizing:border-box;width:70.83333333%}.notes-ant-col-xxl-push-17{left:70.83333333%}.notes-ant-col-xxl-pull-17{right:70.83333333%}.notes-ant-col-xxl-offset-17{margin-left:70.83333333%}.notes-ant-col-xxl-order-17{order:17}.notes-ant-col-xxl-16{display:block;box-sizing:border-box;width:66.66666667%}.notes-ant-col-xxl-push-16{left:66.66666667%}.notes-ant-col-xxl-pull-16{right:66.66666667%}.notes-ant-col-xxl-offset-16{margin-left:66.66666667%}.notes-ant-col-xxl-order-16{order:16}.notes-ant-col-xxl-15{display:block;box-sizing:border-box;width:62.5%}.notes-ant-col-xxl-push-15{left:62.5%}.notes-ant-col-xxl-pull-15{right:62.5%}.notes-ant-col-xxl-offset-15{margin-left:62.5%}.notes-ant-col-xxl-order-15{order:15}.notes-ant-col-xxl-14{display:block;box-sizing:border-box;width:58.33333333%}.notes-ant-col-xxl-push-14{left:58.33333333%}.notes-ant-col-xxl-pull-14{right:58.33333333%}.notes-ant-col-xxl-offset-14{margin-left:58.33333333%}.notes-ant-col-xxl-order-14{order:14}.notes-ant-col-xxl-13{display:block;box-sizing:border-box;width:54.16666667%}.notes-ant-col-xxl-push-13{left:54.16666667%}.notes-ant-col-xxl-pull-13{right:54.16666667%}.notes-ant-col-xxl-offset-13{margin-left:54.16666667%}.notes-ant-col-xxl-order-13{order:13}.notes-ant-col-xxl-12{display:block;box-sizing:border-box;width:50%}.notes-ant-col-xxl-push-12{left:50%}.notes-ant-col-xxl-pull-12{right:50%}.notes-ant-col-xxl-offset-12{margin-left:50%}.notes-ant-col-xxl-order-12{order:12}.notes-ant-col-xxl-11{display:block;box-sizing:border-box;width:45.83333333%}.notes-ant-col-xxl-push-11{left:45.83333333%}.notes-ant-col-xxl-pull-11{right:45.83333333%}.notes-ant-col-xxl-offset-11{margin-left:45.83333333%}.notes-ant-col-xxl-order-11{order:11}.notes-ant-col-xxl-10{display:block;box-sizing:border-box;width:41.66666667%}.notes-ant-col-xxl-push-10{left:41.66666667%}.notes-ant-col-xxl-pull-10{right:41.66666667%}.notes-ant-col-xxl-offset-10{margin-left:41.66666667%}.notes-ant-col-xxl-order-10{order:10}.notes-ant-col-xxl-9{display:block;box-sizing:border-box;width:37.5%}.notes-ant-col-xxl-push-9{left:37.5%}.notes-ant-col-xxl-pull-9{right:37.5%}.notes-ant-col-xxl-offset-9{margin-left:37.5%}.notes-ant-col-xxl-order-9{order:9}.notes-ant-col-xxl-8{display:block;box-sizing:border-box;width:33.33333333%}.notes-ant-col-xxl-push-8{left:33.33333333%}.notes-ant-col-xxl-pull-8{right:33.33333333%}.notes-ant-col-xxl-offset-8{margin-left:33.33333333%}.notes-ant-col-xxl-order-8{order:8}.notes-ant-col-xxl-7{display:block;box-sizing:border-box;width:29.16666667%}.notes-ant-col-xxl-push-7{left:29.16666667%}.notes-ant-col-xxl-pull-7{right:29.16666667%}.notes-ant-col-xxl-offset-7{margin-left:29.16666667%}.notes-ant-col-xxl-order-7{order:7}.notes-ant-col-xxl-6{display:block;box-sizing:border-box;width:25%}.notes-ant-col-xxl-push-6{left:25%}.notes-ant-col-xxl-pull-6{right:25%}.notes-ant-col-xxl-offset-6{margin-left:25%}.notes-ant-col-xxl-order-6{order:6}.notes-ant-col-xxl-5{display:block;box-sizing:border-box;width:20.83333333%}.notes-ant-col-xxl-push-5{left:20.83333333%}.notes-ant-col-xxl-pull-5{right:20.83333333%}.notes-ant-col-xxl-offset-5{margin-left:20.83333333%}.notes-ant-col-xxl-order-5{order:5}.notes-ant-col-xxl-4{display:block;box-sizing:border-box;width:16.66666667%}.notes-ant-col-xxl-push-4{left:16.66666667%}.notes-ant-col-xxl-pull-4{right:16.66666667%}.notes-ant-col-xxl-offset-4{margin-left:16.66666667%}.notes-ant-col-xxl-order-4{order:4}.notes-ant-col-xxl-3{display:block;box-sizing:border-box;width:12.5%}.notes-ant-col-xxl-push-3{left:12.5%}.notes-ant-col-xxl-pull-3{right:12.5%}.notes-ant-col-xxl-offset-3{margin-left:12.5%}.notes-ant-col-xxl-order-3{order:3}.notes-ant-col-xxl-2{display:block;box-sizing:border-box;width:8.33333333%}.notes-ant-col-xxl-push-2{left:8.33333333%}.notes-ant-col-xxl-pull-2{right:8.33333333%}.notes-ant-col-xxl-offset-2{margin-left:8.33333333%}.notes-ant-col-xxl-order-2{order:2}.notes-ant-col-xxl-1{display:block;box-sizing:border-box;width:4.16666667%}.notes-ant-col-xxl-push-1{left:4.16666667%}.notes-ant-col-xxl-pull-1{right:4.16666667%}.notes-ant-col-xxl-offset-1{margin-left:4.16666667%}.notes-ant-col-xxl-order-1{order:1}.notes-ant-col-xxl-0{display:none}.notes-ant-col-push-0{left:auto}.notes-ant-col-pull-0{right:auto}.notes-ant-col-xxl-push-0{left:auto}.notes-ant-col-xxl-pull-0{right:auto}.notes-ant-col-xxl-offset-0{margin-left:0}.notes-ant-col-xxl-order-0{order:0}}.notes-ant-input{box-sizing:border-box;margin:0;font-variant:tabular-nums;list-style:none;font-feature-settings:"tnum";position:relative;display:inline-block;width:100%;height:32px;padding:4px 11px;color:#000000a6;font-size:14px;line-height:1.5;background-color:#fff;background-image:none;border:1px solid #d9d9d9;border-radius:4px;transition:all .3s}.notes-ant-input::-moz-placeholder{color:#bfbfbf;opacity:1}.notes-ant-input:-ms-input-placeholder{color:#bfbfbf}.notes-ant-input::-webkit-input-placeholder{color:#bfbfbf}.notes-ant-input:placeholder-shown{text-overflow:ellipsis}.notes-ant-input:hover{border-color:#349459;border-right-width:1px!important}.notes-ant-input:focus{border-color:#349459;border-right-width:1px!important;outline:0;box-shadow:0 0 0 2px #19874633}.notes-ant-input-disabled{color:#c1c5c8;background-color:#f5f5f5;cursor:not-allowed;opacity:1}.notes-ant-input-disabled:hover{border-color:#d9d9d9;border-right-width:1px!important}.notes-ant-input[disabled]{color:#c1c5c8;background-color:#f5f5f5;cursor:not-allowed;opacity:1}.notes-ant-input[disabled]:hover{border-color:#d9d9d9;border-right-width:1px!important}textarea.notes-ant-input{max-width:100%;height:auto;min-height:32px;line-height:1.5;vertical-align:bottom;transition:all .3s,height 0s}.notes-ant-input-lg{height:40px;padding:6px 11px;font-size:16px}.notes-ant-input-sm{height:24px;padding:1px 7px}.notes-ant-input-group{box-sizing:border-box;margin:0;padding:0;color:#000000a6;font-size:14px;font-variant:tabular-nums;line-height:1.5;list-style:none;font-feature-settings:"tnum";position:relative;display:table;width:100%;border-collapse:separate;border-spacing:0}.notes-ant-input-group[class*=col-]{float:none;padding-right:0;padding-left:0}.notes-ant-input-group>[class*=col-]{padding-right:8px}.notes-ant-input-group>[class*=col-]:last-child{padding-right:0}.notes-ant-input-group-addon,.notes-ant-input-group-wrap,.notes-ant-input-group>.notes-ant-input{display:table-cell}.notes-ant-input-group-addon:not(:first-child):not(:last-child),.notes-ant-input-group-wrap:not(:first-child):not(:last-child),.notes-ant-input-group>.notes-ant-input:not(:first-child):not(:last-child){border-radius:0}.notes-ant-input-group-addon,.notes-ant-input-group-wrap{width:1px;white-space:nowrap;vertical-align:middle}.notes-ant-input-group-wrap>*{display:block!important}.notes-ant-input-group .notes-ant-input{float:left;width:100%;margin-bottom:0;text-align:inherit}.notes-ant-input-group .notes-ant-input:focus{z-index:1;border-right-width:1px}.notes-ant-input-group .notes-ant-input:hover{z-index:1;border-right-width:1px}.notes-ant-input-group-addon{position:relative;padding:0 11px;color:#000000a6;font-weight:400;font-size:14px;text-align:center;background-color:#fafafa;border:1px solid #d9d9d9;border-radius:4px;transition:all .3s}.notes-ant-input-group-addon .notes-ant-select{margin:-5px -11px}.notes-ant-input-group-addon .notes-ant-select .notes-ant-select-selection{margin:-1px;background-color:inherit;border:1px solid transparent;box-shadow:none}.notes-ant-input-group-addon .notes-ant-select-open .notes-ant-select-selection,.notes-ant-input-group-addon .notes-ant-select-focused .notes-ant-select-selection{color:#198746}.notes-ant-input-group-addon>i:only-child:after{position:absolute;inset:0;content:""}.notes-ant-input-group>.notes-ant-input:first-child,.notes-ant-input-group-addon:first-child{border-top-right-radius:0;border-bottom-right-radius:0}.notes-ant-input-group>.notes-ant-input:first-child .notes-ant-select .notes-ant-select-selection,.notes-ant-input-group-addon:first-child .notes-ant-select .notes-ant-select-selection{border-top-right-radius:0;border-bottom-right-radius:0}.notes-ant-input-group>.notes-ant-input-affix-wrapper:not(:first-child) .notes-ant-input{border-top-left-radius:0;border-bottom-left-radius:0}.notes-ant-input-group>.notes-ant-input-affix-wrapper:not(:last-child) .notes-ant-input{border-top-right-radius:0;border-bottom-right-radius:0}.notes-ant-input-group-addon:first-child{border-right:0}.notes-ant-input-group-addon:last-child{border-left:0}.notes-ant-input-group>.notes-ant-input:last-child,.notes-ant-input-group-addon:last-child{border-top-left-radius:0;border-bottom-left-radius:0}.notes-ant-input-group>.notes-ant-input:last-child .notes-ant-select .notes-ant-select-selection,.notes-ant-input-group-addon:last-child .notes-ant-select .notes-ant-select-selection{border-top-left-radius:0;border-bottom-left-radius:0}.notes-ant-input-group-lg .notes-ant-input,.notes-ant-input-group-lg>.notes-ant-input-group-addon{height:40px;padding:6px 11px;font-size:16px}.notes-ant-input-group-sm .notes-ant-input,.notes-ant-input-group-sm>.notes-ant-input-group-addon{height:24px;padding:1px 7px}.notes-ant-input-group-lg .notes-ant-select-selection--single{height:40px}.notes-ant-input-group-sm .notes-ant-select-selection--single{height:24px}.notes-ant-input-group .notes-ant-input-affix-wrapper{display:table-cell;float:left;width:100%}.notes-ant-input-group.notes-ant-input-group-compact{display:block;zoom:1}.notes-ant-input-group.notes-ant-input-group-compact:before,.notes-ant-input-group.notes-ant-input-group-compact:after{display:table;content:""}.notes-ant-input-group.notes-ant-input-group-compact:after{clear:both}.notes-ant-input-group.notes-ant-input-group-compact-addon:not(:first-child):not(:last-child),.notes-ant-input-group.notes-ant-input-group-compact-wrap:not(:first-child):not(:last-child),.notes-ant-input-group.notes-ant-input-group-compact>.notes-ant-input:not(:first-child):not(:last-child){border-right-width:1px}.notes-ant-input-group.notes-ant-input-group-compact-addon:not(:first-child):not(:last-child):hover,.notes-ant-input-group.notes-ant-input-group-compact-wrap:not(:first-child):not(:last-child):hover,.notes-ant-input-group.notes-ant-input-group-compact>.notes-ant-input:not(:first-child):not(:last-child):hover{z-index:1}.notes-ant-input-group.notes-ant-input-group-compact-addon:not(:first-child):not(:last-child):focus,.notes-ant-input-group.notes-ant-input-group-compact-wrap:not(:first-child):not(:last-child):focus,.notes-ant-input-group.notes-ant-input-group-compact>.notes-ant-input:not(:first-child):not(:last-child):focus{z-index:1}.notes-ant-input-group.notes-ant-input-group-compact>*{display:inline-block;float:none;vertical-align:top;border-radius:0}.notes-ant-input-group.notes-ant-input-group-compact>*:not(:last-child){margin-right:-1px;border-right-width:1px}.notes-ant-input-group.notes-ant-input-group-compact .notes-ant-input{float:none}.notes-ant-input-group.notes-ant-input-group-compact>.notes-ant-select>.notes-ant-select-selection,.notes-ant-input-group.notes-ant-input-group-compact>.notes-ant-calendar-picker .notes-ant-input,.notes-ant-input-group.notes-ant-input-group-compact>.notes-ant-select-auto-complete .notes-ant-input,.notes-ant-input-group.notes-ant-input-group-compact>.notes-ant-cascader-picker .notes-ant-input,.notes-ant-input-group.notes-ant-input-group-compact>.notes-ant-mention-wrapper .notes-ant-mention-editor,.notes-ant-input-group.notes-ant-input-group-compact>.notes-ant-time-picker .notes-ant-time-picker-input,.notes-ant-input-group.notes-ant-input-group-compact>.notes-ant-input-group-wrapper .notes-ant-input{border-right-width:1px;border-radius:0}.notes-ant-input-group.notes-ant-input-group-compact>.notes-ant-select>.notes-ant-select-selection:hover,.notes-ant-input-group.notes-ant-input-group-compact>.notes-ant-calendar-picker .notes-ant-input:hover,.notes-ant-input-group.notes-ant-input-group-compact>.notes-ant-select-auto-complete .notes-ant-input:hover,.notes-ant-input-group.notes-ant-input-group-compact>.notes-ant-cascader-picker .notes-ant-input:hover,.notes-ant-input-group.notes-ant-input-group-compact>.notes-ant-mention-wrapper .notes-ant-mention-editor:hover,.notes-ant-input-group.notes-ant-input-group-compact>.notes-ant-time-picker .notes-ant-time-picker-input:hover,.notes-ant-input-group.notes-ant-input-group-compact>.notes-ant-input-group-wrapper .notes-ant-input:hover{z-index:1}.notes-ant-input-group.notes-ant-input-group-compact>.notes-ant-select>.notes-ant-select-selection:focus,.notes-ant-input-group.notes-ant-input-group-compact>.notes-ant-calendar-picker .notes-ant-input:focus,.notes-ant-input-group.notes-ant-input-group-compact>.notes-ant-select-auto-complete .notes-ant-input:focus,.notes-ant-input-group.notes-ant-input-group-compact>.notes-ant-cascader-picker .notes-ant-input:focus,.notes-ant-input-group.notes-ant-input-group-compact>.notes-ant-mention-wrapper .notes-ant-mention-editor:focus,.notes-ant-input-group.notes-ant-input-group-compact>.notes-ant-time-picker .notes-ant-time-picker-input:focus,.notes-ant-input-group.notes-ant-input-group-compact>.notes-ant-input-group-wrapper .notes-ant-input:focus{z-index:1}.notes-ant-input-group.notes-ant-input-group-compact>*:first-child,.notes-ant-input-group.notes-ant-input-group-compact>.notes-ant-select:first-child>.notes-ant-select-selection,.notes-ant-input-group.notes-ant-input-group-compact>.notes-ant-calendar-picker:first-child .notes-ant-input,.notes-ant-input-group.notes-ant-input-group-compact>.notes-ant-select-auto-complete:first-child .notes-ant-input,.notes-ant-input-group.notes-ant-input-group-compact>.notes-ant-cascader-picker:first-child .notes-ant-input,.notes-ant-input-group.notes-ant-input-group-compact>.notes-ant-mention-wrapper:first-child .notes-ant-mention-editor,.notes-ant-input-group.notes-ant-input-group-compact>.notes-ant-time-picker:first-child .notes-ant-time-picker-input{border-top-left-radius:4px;border-bottom-left-radius:4px}.notes-ant-input-group.notes-ant-input-group-compact>*:last-child,.notes-ant-input-group.notes-ant-input-group-compact>.notes-ant-select:last-child>.notes-ant-select-selection,.notes-ant-input-group.notes-ant-input-group-compact>.notes-ant-calendar-picker:last-child .notes-ant-input,.notes-ant-input-group.notes-ant-input-group-compact>.notes-ant-select-auto-complete:last-child .notes-ant-input,.notes-ant-input-group.notes-ant-input-group-compact>.notes-ant-cascader-picker:last-child .notes-ant-input,.notes-ant-input-group.notes-ant-input-group-compact>.notes-ant-cascader-picker-focused:last-child .notes-ant-input,.notes-ant-input-group.notes-ant-input-group-compact>.notes-ant-mention-wrapper:last-child .notes-ant-mention-editor,.notes-ant-input-group.notes-ant-input-group-compact>.notes-ant-time-picker:last-child .notes-ant-time-picker-input{border-right-width:1px;border-top-right-radius:4px;border-bottom-right-radius:4px}.notes-ant-input-group.notes-ant-input-group-compact>.notes-ant-select-auto-complete .notes-ant-input{vertical-align:top}.notes-ant-input-group-wrapper{display:inline-block;width:100%;text-align:start;vertical-align:top}.notes-ant-input-affix-wrapper{box-sizing:border-box;margin:0;padding:0;color:#000000a6;font-size:14px;font-variant:tabular-nums;line-height:1.5;list-style:none;font-feature-settings:"tnum";position:relative;display:inline-block;width:100%;text-align:start}.notes-ant-input-affix-wrapper:hover .notes-ant-input:not(.notes-ant-input-disabled){border-color:#349459;border-right-width:1px!important}.notes-ant-input-affix-wrapper .notes-ant-input{position:relative;text-align:inherit}.notes-ant-input-affix-wrapper .notes-ant-input-prefix,.notes-ant-input-affix-wrapper .notes-ant-input-suffix{position:absolute;top:50%;z-index:2;display:flex;align-items:center;color:#000000a6;line-height:0;transform:translateY(-50%)}.notes-ant-input-affix-wrapper .notes-ant-input-prefix :not(.anticon),.notes-ant-input-affix-wrapper .notes-ant-input-suffix :not(.anticon){line-height:1.5}.notes-ant-input-affix-wrapper .notes-ant-input-disabled~.notes-ant-input-suffix .anticon{color:#c1c5c8;cursor:not-allowed}.notes-ant-input-affix-wrapper .notes-ant-input-prefix{left:12px}.notes-ant-input-affix-wrapper .notes-ant-input-suffix{right:12px}.notes-ant-input-affix-wrapper .notes-ant-input:not(:first-child){padding-left:30px}.notes-ant-input-affix-wrapper .notes-ant-input:not(:last-child){padding-right:30px}.notes-ant-input-affix-wrapper.notes-ant-input-affix-wrapper-input-with-clear-btn .notes-ant-input:not(:last-child){padding-right:49px}.notes-ant-input-affix-wrapper.notes-ant-input-affix-wrapper-textarea-with-clear-btn .notes-ant-input{padding-right:22px}.notes-ant-input-affix-wrapper .notes-ant-input{min-height:100%}.notes-ant-input-password-icon{color:#00000073;cursor:pointer;transition:all .3s}.notes-ant-input-password-icon:hover{color:#333}.notes-ant-input-clear-icon{color:#c1c5c8;font-size:12px;cursor:pointer;transition:color .3s;vertical-align:0}.notes-ant-input-clear-icon:hover{color:#00000073}.notes-ant-input-clear-icon:active{color:#000000a6}.notes-ant-input-clear-icon+i{margin-left:6px}.notes-ant-input-textarea-clear-icon{color:#c1c5c8;font-size:12px;cursor:pointer;transition:color .3s;position:absolute;top:0;right:0;margin:8px 8px 0 0}.notes-ant-input-textarea-clear-icon:hover{color:#00000073}.notes-ant-input-textarea-clear-icon:active{color:#000000a6}.notes-ant-input-textarea-clear-icon+i{margin-left:6px}.notes-ant-input-search-icon{color:#00000073;cursor:pointer;transition:all .3s}.notes-ant-input-search-icon:hover{color:#000c}.notes-ant-input-search-enter-button input{border-right:0}.notes-ant-input-search-enter-button+.notes-ant-input-group-addon,.notes-ant-input-search-enter-button input+.notes-ant-input-group-addon{padding:0;border:0}.notes-ant-input-search-enter-button+.notes-ant-input-group-addon .notes-ant-input-search-button,.notes-ant-input-search-enter-button input+.notes-ant-input-group-addon .notes-ant-input-search-button{border-top-left-radius:0;border-bottom-left-radius:0}.notes-ant-popover{box-sizing:border-box;margin:0;padding:0;color:#000000a6;font-size:14px;font-variant:tabular-nums;line-height:1.5;list-style:none;font-feature-settings:"tnum";position:absolute;top:0;left:0;z-index:1030;font-weight:400;white-space:normal;text-align:left;cursor:auto;user-select:text}.notes-ant-popover:after{position:absolute;background:rgba(255,255,255,.01);content:""}.notes-ant-popover-hidden{display:none}.notes-ant-popover-placement-top,.notes-ant-popover-placement-topLeft,.notes-ant-popover-placement-topRight{padding-bottom:10px}.notes-ant-popover-placement-right,.notes-ant-popover-placement-rightTop,.notes-ant-popover-placement-rightBottom{padding-left:10px}.notes-ant-popover-placement-bottom,.notes-ant-popover-placement-bottomLeft,.notes-ant-popover-placement-bottomRight{padding-top:10px}.notes-ant-popover-placement-left,.notes-ant-popover-placement-leftTop,.notes-ant-popover-placement-leftBottom{padding-right:10px}.notes-ant-popover-inner{background-color:#fff;background-clip:padding-box;border-radius:4px;box-shadow:0 2px 8px #00000026;box-shadow:0 0 8px #00000026 \\	}@media screen and (-ms-high-contrast: active),(-ms-high-contrast: none){.notes-ant-popover-inner{box-shadow:0 2px 8px #00000026}}.notes-ant-popover-title{min-width:177px;min-height:32px;margin:0;padding:5px 16px 4px;color:#000000d9;font-weight:500;border-bottom:1px solid #e8e8e8}.notes-ant-popover-inner-content{padding:12px 16px;color:#000000a6}.notes-ant-popover-message{position:relative;padding:4px 0 12px;color:#000000a6;font-size:14px}.notes-ant-popover-message>.anticon{position:absolute;top:8px;color:#faad14;font-size:14px}.notes-ant-popover-message-title{padding-left:22px}.notes-ant-popover-buttons{margin-bottom:4px;text-align:right}.notes-ant-popover-buttons button{margin-left:8px}.notes-ant-popover-arrow{position:absolute;display:block;width:8.48528137px;height:8.48528137px;background:transparent;border-style:solid;border-width:4.24264069px;transform:rotate(45deg)}.notes-ant-popover-placement-top>.notes-ant-popover-content>.notes-ant-popover-arrow,.notes-ant-popover-placement-topLeft>.notes-ant-popover-content>.notes-ant-popover-arrow,.notes-ant-popover-placement-topRight>.notes-ant-popover-content>.notes-ant-popover-arrow{bottom:6.2px;border-top-color:transparent;border-right-color:#fff;border-bottom-color:#fff;border-left-color:transparent;box-shadow:3px 3px 7px #00000012}.notes-ant-popover-placement-top>.notes-ant-popover-content>.notes-ant-popover-arrow{left:50%;transform:translate(-50%) rotate(45deg)}.notes-ant-popover-placement-topLeft>.notes-ant-popover-content>.notes-ant-popover-arrow{left:16px}.notes-ant-popover-placement-topRight>.notes-ant-popover-content>.notes-ant-popover-arrow{right:16px}.notes-ant-popover-placement-right>.notes-ant-popover-content>.notes-ant-popover-arrow,.notes-ant-popover-placement-rightTop>.notes-ant-popover-content>.notes-ant-popover-arrow,.notes-ant-popover-placement-rightBottom>.notes-ant-popover-content>.notes-ant-popover-arrow{left:6px;border-top-color:transparent;border-right-color:transparent;border-bottom-color:#fff;border-left-color:#fff;box-shadow:-3px 3px 7px #00000012}.notes-ant-popover-placement-right>.notes-ant-popover-content>.notes-ant-popover-arrow{top:50%;transform:translateY(-50%) rotate(45deg)}.notes-ant-popover-placement-rightTop>.notes-ant-popover-content>.notes-ant-popover-arrow{top:12px}.notes-ant-popover-placement-rightBottom>.notes-ant-popover-content>.notes-ant-popover-arrow{bottom:12px}.notes-ant-popover-placement-bottom>.notes-ant-popover-content>.notes-ant-popover-arrow,.notes-ant-popover-placement-bottomLeft>.notes-ant-popover-content>.notes-ant-popover-arrow,.notes-ant-popover-placement-bottomRight>.notes-ant-popover-content>.notes-ant-popover-arrow{top:6px;border-top-color:#fff;border-right-color:transparent;border-bottom-color:transparent;border-left-color:#fff;box-shadow:-2px -2px 5px #0000000f}.notes-ant-popover-placement-bottom>.notes-ant-popover-content>.notes-ant-popover-arrow{left:50%;transform:translate(-50%) rotate(45deg)}.notes-ant-popover-placement-bottomLeft>.notes-ant-popover-content>.notes-ant-popover-arrow{left:16px}.notes-ant-popover-placement-bottomRight>.notes-ant-popover-content>.notes-ant-popover-arrow{right:16px}.notes-ant-popover-placement-left>.notes-ant-popover-content>.notes-ant-popover-arrow,.notes-ant-popover-placement-leftTop>.notes-ant-popover-content>.notes-ant-popover-arrow,.notes-ant-popover-placement-leftBottom>.notes-ant-popover-content>.notes-ant-popover-arrow{right:6px;border-top-color:#fff;border-right-color:#fff;border-bottom-color:transparent;border-left-color:transparent;box-shadow:3px -3px 7px #00000012}.notes-ant-popover-placement-left>.notes-ant-popover-content>.notes-ant-popover-arrow{top:50%;transform:translateY(-50%) rotate(45deg)}.notes-ant-popover-placement-leftTop>.notes-ant-popover-content>.notes-ant-popover-arrow{top:12px}.notes-ant-popover-placement-leftBottom>.notes-ant-popover-content>.notes-ant-popover-arrow{bottom:12px}.notes-ant-select{box-sizing:border-box;margin:0;padding:0;color:#000000a6;font-size:14px;font-variant:tabular-nums;line-height:1.5;list-style:none;font-feature-settings:"tnum";position:relative;display:inline-block;outline:0}.notes-ant-select ul,.notes-ant-select ol{margin:0;padding:0;list-style:none}.notes-ant-select>ul>li>a{padding:0;background-color:#fff}.notes-ant-select-arrow{display:inline-block;color:inherit;font-style:normal;line-height:0;text-align:center;text-transform:none;vertical-align:-.125em;text-rendering:optimizeLegibility;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;position:absolute;top:50%;right:11px;margin-top:-6px;color:#c1c5c8;font-size:12px;line-height:1;transform-origin:50% 50%}.notes-ant-select-arrow>*{line-height:1}.notes-ant-select-arrow svg{display:inline-block}.notes-ant-select-arrow:before{display:none}.notes-ant-select-arrow .notes-ant-select-arrow-icon{display:block}.notes-ant-select-arrow .notes-ant-select-arrow-icon svg{transition:transform .3s}.notes-ant-select-selection{display:block;box-sizing:border-box;background-color:#fff;border:1px solid #d9d9d9;border-top-width:1.02px;border-radius:4px;outline:none;transition:all .3s cubic-bezier(.645,.045,.355,1);user-select:none}.notes-ant-select-selection:hover{border-color:#349459;border-right-width:1px!important}.notes-ant-select-focused .notes-ant-select-selection,.notes-ant-select-selection:focus,.notes-ant-select-selection:active{border-color:#349459;border-right-width:1px!important;outline:0;box-shadow:0 0 0 2px #19874633}.notes-ant-select-selection__clear{position:absolute;top:50%;right:11px;z-index:1;display:inline-block;width:12px;height:12px;margin-top:-6px;color:#c1c5c8;font-size:12px;font-style:normal;line-height:12px;text-align:center;text-transform:none;background:#fff;cursor:pointer;opacity:0;transition:color .3s ease,opacity .15s ease;text-rendering:auto}.notes-ant-select-selection__clear:before{display:block}.notes-ant-select-selection__clear:hover{color:#00000073}.notes-ant-select-selection:hover .notes-ant-select-selection__clear{opacity:1}.notes-ant-select-selection-selected-value{float:left;max-width:100%;overflow:hidden;white-space:nowrap;text-overflow:ellipsis}.notes-ant-select-no-arrow .notes-ant-select-selection-selected-value{padding-right:0}.notes-ant-select-disabled{color:#c1c5c8}.notes-ant-select-disabled .notes-ant-select-selection{background:#f5f5f5;cursor:not-allowed}.notes-ant-select-disabled .notes-ant-select-selection:hover,.notes-ant-select-disabled .notes-ant-select-selection:focus,.notes-ant-select-disabled .notes-ant-select-selection:active{border-color:#d9d9d9;box-shadow:none}.notes-ant-select-disabled .notes-ant-select-selection__clear{display:none;visibility:hidden;pointer-events:none}.notes-ant-select-disabled .notes-ant-select-selection--multiple .notes-ant-select-selection__choice{padding-right:10px;color:#00000054;background:#f5f5f5}.notes-ant-select-disabled .notes-ant-select-selection--multiple .notes-ant-select-selection__choice__remove{display:none}.notes-ant-select-selection--single{position:relative;height:32px;cursor:pointer}.notes-ant-select-selection--single .notes-ant-select-selection__rendered{margin-right:24px}.notes-ant-select-no-arrow .notes-ant-select-selection__rendered{margin-right:11px}.notes-ant-select-selection__rendered{position:relative;display:block;margin-right:11px;margin-left:11px;line-height:30px}.notes-ant-select-selection__rendered:after{display:inline-block;width:0;visibility:hidden;content:".";pointer-events:none}.notes-ant-select-lg{font-size:16px}.notes-ant-select-lg .notes-ant-select-selection--single{height:40px}.notes-ant-select-lg .notes-ant-select-selection__rendered{line-height:38px}.notes-ant-select-lg .notes-ant-select-selection--multiple{min-height:40px}.notes-ant-select-lg .notes-ant-select-selection--multiple .notes-ant-select-selection__rendered li{height:32px;line-height:32px}.notes-ant-select-lg .notes-ant-select-selection--multiple .notes-ant-select-selection__clear,.notes-ant-select-lg .notes-ant-select-selection--multiple .notes-ant-select-arrow{top:20px}.notes-ant-select-sm .notes-ant-select-selection--single{height:24px}.notes-ant-select-sm .notes-ant-select-selection__rendered{margin-left:7px;line-height:22px}.notes-ant-select-sm .notes-ant-select-selection--multiple{min-height:24px}.notes-ant-select-sm .notes-ant-select-selection--multiple .notes-ant-select-selection__rendered li{height:16px;line-height:14px}.notes-ant-select-sm .notes-ant-select-selection--multiple .notes-ant-select-selection__clear,.notes-ant-select-sm .notes-ant-select-selection--multiple .notes-ant-select-arrow{top:12px}.notes-ant-select-sm .notes-ant-select-selection__clear,.notes-ant-select-sm .notes-ant-select-arrow{right:8px}.notes-ant-select-disabled .notes-ant-select-selection__choice__remove{color:#c1c5c8;cursor:default}.notes-ant-select-disabled .notes-ant-select-selection__choice__remove:hover{color:#c1c5c8}.notes-ant-select-search__field__wrap{position:relative;display:inline-block}.notes-ant-select-selection__placeholder,.notes-ant-select-search__field__placeholder{position:absolute;top:50%;right:9px;left:0;max-width:100%;height:20px;margin-top:-10px;overflow:hidden;color:#bfbfbf;line-height:20px;white-space:nowrap;text-align:left;text-overflow:ellipsis}.notes-ant-select-search__field__placeholder{left:12px}.notes-ant-select-search__field__mirror{position:absolute;top:0;left:0;white-space:pre;opacity:0;pointer-events:none}.notes-ant-select-search--inline{position:absolute;width:100%;height:100%}.notes-ant-select-search--inline .notes-ant-select-search__field__wrap{width:100%;height:100%}.notes-ant-select-search--inline .notes-ant-select-search__field{width:100%;height:100%;font-size:100%;line-height:1;background:transparent;border-width:0;border-radius:4px;outline:0}.notes-ant-select-search--inline>i{float:right}.notes-ant-select-selection--multiple{min-height:32px;padding-bottom:3px;cursor:text;zoom:1}.notes-ant-select-selection--multiple:before,.notes-ant-select-selection--multiple:after{display:table;content:""}.notes-ant-select-selection--multiple:after{clear:both}.notes-ant-select-selection--multiple .notes-ant-select-search--inline{position:static;float:left;width:auto;max-width:100%;padding:0}.notes-ant-select-selection--multiple .notes-ant-select-search--inline .notes-ant-select-search__field{width:.75em;max-width:100%;padding:1px}.notes-ant-select-selection--multiple .notes-ant-select-selection__rendered{height:auto;margin-bottom:-3px;margin-left:5px}.notes-ant-select-selection--multiple .notes-ant-select-selection__placeholder{margin-left:6px}.notes-ant-select-selection--multiple>ul>li,.notes-ant-select-selection--multiple .notes-ant-select-selection__rendered>ul>li{height:24px;margin-top:3px;line-height:22px}.notes-ant-select-selection--multiple .notes-ant-select-selection__choice{position:relative;float:left;max-width:99%;margin-right:4px;padding:0 20px 0 10px;overflow:hidden;color:#000000a6;background-color:#fafafa;border:1px solid #e8e8e8;border-radius:2px;cursor:default;transition:padding .3s cubic-bezier(.645,.045,.355,1)}.notes-ant-select-selection--multiple .notes-ant-select-selection__choice__disabled{padding:0 10px}.notes-ant-select-selection--multiple .notes-ant-select-selection__choice__content{display:inline-block;max-width:100%;overflow:hidden;white-space:nowrap;text-overflow:ellipsis;transition:margin .3s cubic-bezier(.645,.045,.355,1)}.notes-ant-select-selection--multiple .notes-ant-select-selection__choice__remove{color:inherit;font-style:normal;line-height:0;text-align:center;text-transform:none;vertical-align:-.125em;text-rendering:optimizeLegibility;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;position:absolute;right:4px;color:#00000073;font-weight:700;line-height:inherit;cursor:pointer;transition:all .3s;display:inline-block;font-size:12px;font-size:10px \\	;transform:scale(.83333333) rotate(0)}.notes-ant-select-selection--multiple .notes-ant-select-selection__choice__remove>*{line-height:1}.notes-ant-select-selection--multiple .notes-ant-select-selection__choice__remove svg{display:inline-block}.notes-ant-select-selection--multiple .notes-ant-select-selection__choice__remove:before{display:none}.notes-ant-select-selection--multiple .notes-ant-select-selection__choice__remove .notes-ant-select-selection--multiple .notes-ant-select-selection__choice__remove-icon{display:block}:root .notes-ant-select-selection--multiple .notes-ant-select-selection__choice__remove{font-size:12px}.notes-ant-select-selection--multiple .notes-ant-select-selection__choice__remove:hover{color:#000000bf}.notes-ant-select-selection--multiple .notes-ant-select-selection__clear,.notes-ant-select-selection--multiple .notes-ant-select-arrow{top:16px}.notes-ant-select-allow-clear .notes-ant-select-selection--multiple .notes-ant-select-selection__rendered,.notes-ant-select-show-arrow .notes-ant-select-selection--multiple .notes-ant-select-selection__rendered{margin-right:20px}.notes-ant-select-open .notes-ant-select-arrow-icon svg{transform:rotate(180deg)}.notes-ant-select-open .notes-ant-select-selection{border-color:#349459;border-right-width:1px!important;outline:0;box-shadow:0 0 0 2px #19874633}.notes-ant-select-combobox .notes-ant-select-arrow{display:none}.notes-ant-select-combobox .notes-ant-select-search--inline{float:none;width:100%;height:100%}.notes-ant-select-combobox .notes-ant-select-search__field__wrap{width:100%;height:100%}.notes-ant-select-combobox .notes-ant-select-search__field{position:relative;z-index:1;width:100%;height:100%;box-shadow:none;transition:all .3s cubic-bezier(.645,.045,.355,1),height 0s}.notes-ant-select-combobox.notes-ant-select-allow-clear .notes-ant-select-selection:hover .notes-ant-select-selection__rendered,.notes-ant-select-combobox.notes-ant-select-show-arrow .notes-ant-select-selection:hover .notes-ant-select-selection__rendered{margin-right:20px}.notes-ant-select-dropdown{margin:0;padding:0;color:#000000a6;font-variant:tabular-nums;line-height:1.5;list-style:none;font-feature-settings:"tnum";position:absolute;top:-9999px;left:-9999px;z-index:1050;box-sizing:border-box;font-size:14px;font-variant:initial;background-color:#fff;border-radius:4px;outline:none;box-shadow:0 2px 8px #00000026}.notes-ant-select-dropdown.slide-up-enter.slide-up-enter-active.notes-ant-select-dropdown-placement-bottomLeft,.notes-ant-select-dropdown.slide-up-appear.slide-up-appear-active.notes-ant-select-dropdown-placement-bottomLeft{animation-name:antSlideUpIn}.notes-ant-select-dropdown.slide-up-enter.slide-up-enter-active.notes-ant-select-dropdown-placement-topLeft,.notes-ant-select-dropdown.slide-up-appear.slide-up-appear-active.notes-ant-select-dropdown-placement-topLeft{animation-name:antSlideDownIn}.notes-ant-select-dropdown.slide-up-leave.slide-up-leave-active.notes-ant-select-dropdown-placement-bottomLeft{animation-name:antSlideUpOut}.notes-ant-select-dropdown.slide-up-leave.slide-up-leave-active.notes-ant-select-dropdown-placement-topLeft{animation-name:antSlideDownOut}.notes-ant-select-dropdown-hidden{display:none}.notes-ant-select-dropdown-menu{max-height:250px;margin-bottom:0;padding:4px 0;overflow:auto;list-style:none;outline:none}.notes-ant-select-dropdown-menu-item-group-list{margin:0;padding:0}.notes-ant-select-dropdown-menu-item-group-list>.notes-ant-select-dropdown-menu-item{padding-left:20px}.notes-ant-select-dropdown-menu-item-group-title{height:32px;padding:0 12px;color:#00000073;font-size:12px;line-height:32px}.notes-ant-select-dropdown-menu-item-group-list .notes-ant-select-dropdown-menu-item:first-child:not(:last-child),.notes-ant-select-dropdown-menu-item-group:not(:last-child) .notes-ant-select-dropdown-menu-item-group-list .notes-ant-select-dropdown-menu-item:last-child{border-radius:0}.notes-ant-select-dropdown-menu-item{position:relative;display:block;padding:5px 12px;overflow:hidden;color:#000000a6;font-weight:400;font-size:14px;line-height:22px;white-space:nowrap;text-overflow:ellipsis;cursor:pointer;transition:background .3s ease}.notes-ant-select-dropdown-menu-item:hover:not(.notes-ant-select-dropdown-menu-item-disabled){background-color:#bbc7be}.notes-ant-select-dropdown-menu-item-selected{color:#000000a6;font-weight:600;background-color:#fafafa}.notes-ant-select-dropdown-menu-item-disabled,.notes-ant-select-dropdown-menu-item-disabled:hover{color:#c1c5c8;cursor:not-allowed}.notes-ant-select-dropdown-menu-item-active:not(.notes-ant-select-dropdown-menu-item-disabled){background-color:#bbc7be}.notes-ant-select-dropdown-menu-item-divider{height:1px;margin:1px 0;overflow:hidden;line-height:0;background-color:#e8e8e8}.notes-ant-select-dropdown.notes-ant-select-dropdown--multiple .notes-ant-select-dropdown-menu-item{padding-right:32px}.notes-ant-select-dropdown.notes-ant-select-dropdown--multiple .notes-ant-select-dropdown-menu-item .notes-ant-select-selected-icon{position:absolute;top:50%;right:12px;color:transparent;font-weight:700;font-size:12px;text-shadow:0 .1px 0,.1px 0 0,0 -.1px 0,-.1px 0;transform:translateY(-50%);transition:all .2s}.notes-ant-select-dropdown.notes-ant-select-dropdown--multiple .notes-ant-select-dropdown-menu-item:hover .notes-ant-select-selected-icon{color:#000000de}.notes-ant-select-dropdown.notes-ant-select-dropdown--multiple .notes-ant-select-dropdown-menu-item-disabled .notes-ant-select-selected-icon{display:none}.notes-ant-select-dropdown.notes-ant-select-dropdown--multiple .notes-ant-select-dropdown-menu-item-selected .notes-ant-select-selected-icon,.notes-ant-select-dropdown.notes-ant-select-dropdown--multiple .notes-ant-select-dropdown-menu-item-selected:hover .notes-ant-select-selected-icon{display:inline-block;color:#198746}.notes-ant-select-dropdown--empty.notes-ant-select-dropdown--multiple .notes-ant-select-dropdown-menu-item{padding-right:12px}.notes-ant-select-dropdown-container-open .notes-ant-select-dropdown,.notes-ant-select-dropdown-open .notes-ant-select-dropdown{display:block}.notes-ant-spin{box-sizing:border-box;margin:0;padding:0;color:#000000a6;font-size:14px;font-variant:tabular-nums;line-height:1.5;list-style:none;font-feature-settings:"tnum";position:absolute;display:none;color:#198746;text-align:center;vertical-align:middle;opacity:0;transition:transform .3s cubic-bezier(.78,.14,.15,.86)}.notes-ant-spin-spinning{position:static;display:inline-block;opacity:1}.notes-ant-spin-nested-loading{position:relative}.notes-ant-spin-nested-loading>div>.notes-ant-spin{position:absolute;top:0;left:0;z-index:4;display:block;width:100%;height:100%;max-height:400px}.notes-ant-spin-nested-loading>div>.notes-ant-spin .notes-ant-spin-dot{position:absolute;top:50%;left:50%;margin:-10px}.notes-ant-spin-nested-loading>div>.notes-ant-spin .notes-ant-spin-text{position:absolute;top:50%;width:100%;padding-top:5px;text-shadow:0 1px 2px #fff}.notes-ant-spin-nested-loading>div>.notes-ant-spin.notes-ant-spin-show-text .notes-ant-spin-dot{margin-top:-20px}.notes-ant-spin-nested-loading>div>.notes-ant-spin-sm .notes-ant-spin-dot{margin:-7px}.notes-ant-spin-nested-loading>div>.notes-ant-spin-sm .notes-ant-spin-text{padding-top:2px}.notes-ant-spin-nested-loading>div>.notes-ant-spin-sm.notes-ant-spin-show-text .notes-ant-spin-dot{margin-top:-17px}.notes-ant-spin-nested-loading>div>.notes-ant-spin-lg .notes-ant-spin-dot{margin:-16px}.notes-ant-spin-nested-loading>div>.notes-ant-spin-lg .notes-ant-spin-text{padding-top:11px}.notes-ant-spin-nested-loading>div>.notes-ant-spin-lg.notes-ant-spin-show-text .notes-ant-spin-dot{margin-top:-26px}.notes-ant-spin-container{position:relative;transition:opacity .3s}.notes-ant-spin-container:after{position:absolute;inset:0;z-index:10;display:none \\	;width:100%;height:100%;background:#fff;opacity:0;transition:all .3s;content:"";pointer-events:none}.notes-ant-spin-blur{clear:both;overflow:hidden;opacity:.5;user-select:none;pointer-events:none}.notes-ant-spin-blur:after{opacity:.4;pointer-events:auto}.notes-ant-spin-tip{color:#00000073}.notes-ant-spin-dot{position:relative;display:inline-block;font-size:20px;width:1em;height:1em}.notes-ant-spin-dot-item{position:absolute;display:block;width:9px;height:9px;background-color:#198746;border-radius:100%;transform:scale(.75);transform-origin:50% 50%;opacity:.3;animation:antSpinMove 1s infinite linear alternate}.notes-ant-spin-dot-item:nth-child(1){top:0;left:0}.notes-ant-spin-dot-item:nth-child(2){top:0;right:0;animation-delay:.4s}.notes-ant-spin-dot-item:nth-child(3){right:0;bottom:0;animation-delay:.8s}.notes-ant-spin-dot-item:nth-child(4){bottom:0;left:0;animation-delay:1.2s}.notes-ant-spin-dot-spin{transform:rotate(45deg);animation:antRotate 1.2s infinite linear}.notes-ant-spin-sm .notes-ant-spin-dot{font-size:14px}.notes-ant-spin-sm .notes-ant-spin-dot i{width:6px;height:6px}.notes-ant-spin-lg .notes-ant-spin-dot{font-size:32px}.notes-ant-spin-lg .notes-ant-spin-dot i{width:14px;height:14px}.notes-ant-spin.notes-ant-spin-show-text .notes-ant-spin-text{display:block}@media all and (-ms-high-contrast: none),(-ms-high-contrast: active){.notes-ant-spin-blur{background:#fff;opacity:.5}}@keyframes antSpinMove{to{opacity:1}}@keyframes antRotate{to{transform:rotate(405deg)}}.notes-ant-tag{box-sizing:border-box;margin:0 8px 0 0;color:#000000a6;font-size:14px;font-variant:tabular-nums;line-height:1.5;list-style:none;font-feature-settings:"tnum";display:inline-block;height:auto;padding:0 7px;font-size:12px;line-height:20px;white-space:nowrap;background:#fafafa;border:1px solid #d9d9d9;border-radius:4px;cursor:default;opacity:1;transition:all .3s cubic-bezier(.78,.14,.15,.86)}.notes-ant-tag:hover{opacity:.85}.notes-ant-tag,.notes-ant-tag a,.notes-ant-tag a:hover{color:#000000a6}.notes-ant-tag>a:first-child:last-child{display:inline-block;margin:0 -8px;padding:0 8px}.notes-ant-tag .anticon-close{display:inline-block;font-size:12px;font-size:10px \\	;transform:scale(.83333333) rotate(0);margin-left:3px;color:#00000073;font-weight:700;cursor:pointer;transition:all .3s cubic-bezier(.78,.14,.15,.86)}:root .notes-ant-tag .anticon-close{font-size:12px}.notes-ant-tag .anticon-close:hover{color:#000000d9}.notes-ant-tag-has-color{border-color:transparent}.notes-ant-tag-has-color,.notes-ant-tag-has-color a,.notes-ant-tag-has-color a:hover,.notes-ant-tag-has-color .anticon-close,.notes-ant-tag-has-color .anticon-close:hover{color:#fff}.notes-ant-tag-checkable{background-color:transparent;border-color:transparent}.notes-ant-tag-checkable:not(.notes-ant-tag-checkable-checked):hover{color:#198746}.notes-ant-tag-checkable:active,.notes-ant-tag-checkable-checked{color:#fff}.notes-ant-tag-checkable-checked{background-color:#198746}.notes-ant-tag-checkable:active{background-color:#0e6133}.notes-ant-tag-hidden{display:none}.notes-ant-tag-pink{color:#eb2f96;background:#fff0f6;border-color:#ffadd2}.notes-ant-tag-pink-inverse{color:#fff;background:#eb2f96;border-color:#eb2f96}.notes-ant-tag-magenta{color:#eb2f96;background:#fff0f6;border-color:#ffadd2}.notes-ant-tag-magenta-inverse{color:#fff;background:#eb2f96;border-color:#eb2f96}.notes-ant-tag-red{color:#f5222d;background:#fff1f0;border-color:#ffa39e}.notes-ant-tag-red-inverse{color:#fff;background:#f5222d;border-color:#f5222d}.notes-ant-tag-volcano{color:#fa541c;background:#fff2e8;border-color:#ffbb96}.notes-ant-tag-volcano-inverse{color:#fff;background:#fa541c;border-color:#fa541c}.notes-ant-tag-orange{color:#fa8c16;background:#fff7e6;border-color:#ffd591}.notes-ant-tag-orange-inverse{color:#fff;background:#fa8c16;border-color:#fa8c16}.notes-ant-tag-yellow{color:#fadb14;background:#feffe6;border-color:#fffb8f}.notes-ant-tag-yellow-inverse{color:#fff;background:#fadb14;border-color:#fadb14}.notes-ant-tag-gold{color:#faad14;background:#fffbe6;border-color:#ffe58f}.notes-ant-tag-gold-inverse{color:#fff;background:#faad14;border-color:#faad14}.notes-ant-tag-cyan{color:#13c2c2;background:#e6fffb;border-color:#87e8de}.notes-ant-tag-cyan-inverse{color:#fff;background:#13c2c2;border-color:#13c2c2}.notes-ant-tag-lime{color:#a0d911;background:#fcffe6;border-color:#eaff8f}.notes-ant-tag-lime-inverse{color:#fff;background:#a0d911;border-color:#a0d911}.notes-ant-tag-green{color:#52c41a;background:#f6ffed;border-color:#b7eb8f}.notes-ant-tag-green-inverse{color:#fff;background:#52c41a;border-color:#52c41a}.notes-ant-tag-blue{color:#1890ff;background:#e6f7ff;border-color:#91d5ff}.notes-ant-tag-blue-inverse{color:#fff;background:#1890ff;border-color:#1890ff}.notes-ant-tag-geekblue{color:#2f54eb;background:#f0f5ff;border-color:#adc6ff}.notes-ant-tag-geekblue-inverse{color:#fff;background:#2f54eb;border-color:#2f54eb}.notes-ant-tag-purple{color:#722ed1;background:#f9f0ff;border-color:#d3adf7}.notes-ant-tag-purple-inverse{color:#fff;background:#722ed1;border-color:#722ed1}.notes-ant-tooltip{box-sizing:border-box;margin:0;padding:0;color:#000000a6;font-size:14px;font-variant:tabular-nums;line-height:1.5;list-style:none;font-feature-settings:"tnum";position:absolute;z-index:1060;display:block;max-width:250px;visibility:visible}.notes-ant-tooltip-hidden{display:none}.notes-ant-tooltip-placement-top,.notes-ant-tooltip-placement-topLeft,.notes-ant-tooltip-placement-topRight{padding-bottom:8px}.notes-ant-tooltip-placement-right,.notes-ant-tooltip-placement-rightTop,.notes-ant-tooltip-placement-rightBottom{padding-left:8px}.notes-ant-tooltip-placement-bottom,.notes-ant-tooltip-placement-bottomLeft,.notes-ant-tooltip-placement-bottomRight{padding-top:8px}.notes-ant-tooltip-placement-left,.notes-ant-tooltip-placement-leftTop,.notes-ant-tooltip-placement-leftBottom{padding-right:8px}.notes-ant-tooltip-inner{min-width:30px;min-height:32px;padding:6px 8px;color:#fff;text-align:left;text-decoration:none;word-wrap:break-word;background-color:#000000bf;border-radius:4px;box-shadow:0 2px 8px #00000026}.notes-ant-tooltip-arrow{position:absolute;display:block;width:13.07106781px;height:13.07106781px;overflow:hidden;background:transparent;pointer-events:none}.notes-ant-tooltip-arrow:before{position:absolute;inset:0;display:block;width:5px;height:5px;margin:auto;background-color:#000000bf;content:"";pointer-events:auto}.notes-ant-tooltip-placement-top .notes-ant-tooltip-arrow,.notes-ant-tooltip-placement-topLeft .notes-ant-tooltip-arrow,.notes-ant-tooltip-placement-topRight .notes-ant-tooltip-arrow{bottom:-5.07106781px}.notes-ant-tooltip-placement-top .notes-ant-tooltip-arrow:before,.notes-ant-tooltip-placement-topLeft .notes-ant-tooltip-arrow:before,.notes-ant-tooltip-placement-topRight .notes-ant-tooltip-arrow:before{box-shadow:3px 3px 7px #00000012;transform:translateY(-6.53553391px) rotate(45deg)}.notes-ant-tooltip-placement-top .notes-ant-tooltip-arrow{left:50%;transform:translate(-50%)}.notes-ant-tooltip-placement-topLeft .notes-ant-tooltip-arrow{left:13px}.notes-ant-tooltip-placement-topRight .notes-ant-tooltip-arrow{right:13px}.notes-ant-tooltip-placement-right .notes-ant-tooltip-arrow,.notes-ant-tooltip-placement-rightTop .notes-ant-tooltip-arrow,.notes-ant-tooltip-placement-rightBottom .notes-ant-tooltip-arrow{left:-5.07106781px}.notes-ant-tooltip-placement-right .notes-ant-tooltip-arrow:before,.notes-ant-tooltip-placement-rightTop .notes-ant-tooltip-arrow:before,.notes-ant-tooltip-placement-rightBottom .notes-ant-tooltip-arrow:before{box-shadow:-3px 3px 7px #00000012;transform:translate(6.53553391px) rotate(45deg)}.notes-ant-tooltip-placement-right .notes-ant-tooltip-arrow{top:50%;transform:translateY(-50%)}.notes-ant-tooltip-placement-rightTop .notes-ant-tooltip-arrow{top:5px}.notes-ant-tooltip-placement-rightBottom .notes-ant-tooltip-arrow{bottom:5px}.notes-ant-tooltip-placement-left .notes-ant-tooltip-arrow,.notes-ant-tooltip-placement-leftTop .notes-ant-tooltip-arrow,.notes-ant-tooltip-placement-leftBottom .notes-ant-tooltip-arrow{right:-5.07106781px}.notes-ant-tooltip-placement-left .notes-ant-tooltip-arrow:before,.notes-ant-tooltip-placement-leftTop .notes-ant-tooltip-arrow:before,.notes-ant-tooltip-placement-leftBottom .notes-ant-tooltip-arrow:before{box-shadow:3px -3px 7px #00000012;transform:translate(-6.53553391px) rotate(45deg)}.notes-ant-tooltip-placement-left .notes-ant-tooltip-arrow{top:50%;transform:translateY(-50%)}.notes-ant-tooltip-placement-leftTop .notes-ant-tooltip-arrow{top:5px}.notes-ant-tooltip-placement-leftBottom .notes-ant-tooltip-arrow{bottom:5px}.notes-ant-tooltip-placement-bottom .notes-ant-tooltip-arrow,.notes-ant-tooltip-placement-bottomLeft .notes-ant-tooltip-arrow,.notes-ant-tooltip-placement-bottomRight .notes-ant-tooltip-arrow{top:-5.07106781px}.notes-ant-tooltip-placement-bottom .notes-ant-tooltip-arrow:before,.notes-ant-tooltip-placement-bottomLeft .notes-ant-tooltip-arrow:before,.notes-ant-tooltip-placement-bottomRight .notes-ant-tooltip-arrow:before{box-shadow:-3px -3px 7px #00000012;transform:translateY(6.53553391px) rotate(45deg)}.notes-ant-tooltip-placement-bottom .notes-ant-tooltip-arrow{left:50%;transform:translate(-50%)}.notes-ant-tooltip-placement-bottomLeft .notes-ant-tooltip-arrow{left:13px}.notes-ant-tooltip-placement-bottomRight .notes-ant-tooltip-arrow{right:13px}@keyframes antCheckboxEffect{0%{transform:scale(1);opacity:.5}to{transform:scale(1.6);opacity:0}}.notes-ant-select-tree-checkbox{box-sizing:border-box;margin:0;padding:0;color:#000000a6;font-size:14px;font-variant:tabular-nums;line-height:1.5;list-style:none;font-feature-settings:"tnum";position:relative;top:-.09em;display:inline-block;line-height:1;white-space:nowrap;vertical-align:middle;outline:none;cursor:pointer}.notes-ant-select-tree-checkbox-wrapper:hover .notes-ant-select-tree-checkbox-inner,.notes-ant-select-tree-checkbox:hover .notes-ant-select-tree-checkbox-inner,.notes-ant-select-tree-checkbox-input:focus+.notes-ant-select-tree-checkbox-inner{border-color:#198746}.notes-ant-select-tree-checkbox-checked:after{position:absolute;top:0;left:0;width:100%;height:100%;border:1px solid #198746;border-radius:2px;visibility:hidden;animation:antCheckboxEffect .36s ease-in-out;animation-fill-mode:backwards;content:""}.notes-ant-select-tree-checkbox:hover:after,.notes-ant-select-tree-checkbox-wrapper:hover .notes-ant-select-tree-checkbox:after{visibility:visible}.notes-ant-select-tree-checkbox-inner{position:relative;top:0;left:0;display:block;width:16px;height:16px;background-color:#fff;border:1px solid #d9d9d9;border-radius:2px;border-collapse:separate;transition:all .3s}.notes-ant-select-tree-checkbox-inner:after{position:absolute;top:50%;left:22%;display:table;width:5.71428571px;height:9.14285714px;border:2px solid #fff;border-top:0;border-left:0;transform:rotate(45deg) scale(0) translate(-50%,-50%);opacity:0;transition:all .1s cubic-bezier(.71,-.46,.88,.6),opacity .1s;content:" "}.notes-ant-select-tree-checkbox-input{position:absolute;inset:0;z-index:1;width:100%;height:100%;cursor:pointer;opacity:0}.notes-ant-select-tree-checkbox-checked .notes-ant-select-tree-checkbox-inner:after{position:absolute;display:table;border:2px solid #fff;border-top:0;border-left:0;transform:rotate(45deg) scale(1) translate(-50%,-50%);opacity:1;transition:all .2s cubic-bezier(.12,.4,.29,1.46) .1s;content:" "}.notes-ant-select-tree-checkbox-checked .notes-ant-select-tree-checkbox-inner{background-color:#198746;border-color:#198746}.notes-ant-select-tree-checkbox-disabled{cursor:not-allowed}.notes-ant-select-tree-checkbox-disabled.notes-ant-select-tree-checkbox-checked .notes-ant-select-tree-checkbox-inner:after{border-color:#c1c5c8;animation-name:none}.notes-ant-select-tree-checkbox-disabled .notes-ant-select-tree-checkbox-input{cursor:not-allowed}.notes-ant-select-tree-checkbox-disabled .notes-ant-select-tree-checkbox-inner{background-color:#f5f5f5;border-color:#d9d9d9!important}.notes-ant-select-tree-checkbox-disabled .notes-ant-select-tree-checkbox-inner:after{border-color:#f5f5f5;border-collapse:separate;animation-name:none}.notes-ant-select-tree-checkbox-disabled+span{color:#c1c5c8;cursor:not-allowed}.notes-ant-select-tree-checkbox-disabled:hover:after,.notes-ant-select-tree-checkbox-wrapper:hover .notes-ant-select-tree-checkbox-disabled:after{visibility:hidden}.notes-ant-select-tree-checkbox-wrapper{box-sizing:border-box;margin:0;padding:0;color:#000000a6;font-size:14px;font-variant:tabular-nums;line-height:1.5;list-style:none;font-feature-settings:"tnum";display:inline-block;line-height:unset;cursor:pointer}.notes-ant-select-tree-checkbox-wrapper.notes-ant-select-tree-checkbox-wrapper-disabled{cursor:not-allowed}.notes-ant-select-tree-checkbox-wrapper+.notes-ant-select-tree-checkbox-wrapper{margin-left:8px}.notes-ant-select-tree-checkbox+span{padding-right:8px;padding-left:8px}.notes-ant-select-tree-checkbox-group{box-sizing:border-box;margin:0;padding:0;color:#000000a6;font-size:14px;font-variant:tabular-nums;line-height:1.5;list-style:none;font-feature-settings:"tnum";display:inline-block}.notes-ant-select-tree-checkbox-group-item{display:inline-block;margin-right:8px}.notes-ant-select-tree-checkbox-group-item:last-child{margin-right:0}.notes-ant-select-tree-checkbox-group-item+.notes-ant-select-tree-checkbox-group-item{margin-left:0}.notes-ant-select-tree-checkbox-indeterminate .notes-ant-select-tree-checkbox-inner{background-color:#fff;border-color:#d9d9d9}.notes-ant-select-tree-checkbox-indeterminate .notes-ant-select-tree-checkbox-inner:after{top:50%;left:50%;width:8px;height:8px;background-color:#198746;border:0;transform:translate(-50%,-50%) scale(1);opacity:1;content:" "}.notes-ant-select-tree-checkbox-indeterminate.notes-ant-select-tree-checkbox-disabled .notes-ant-select-tree-checkbox-inner:after{background-color:#c1c5c8;border-color:#c1c5c8}.notes-ant-select-tree{box-sizing:border-box;color:#000000a6;font-size:14px;font-variant:tabular-nums;line-height:1.5;list-style:none;font-feature-settings:"tnum";margin:-4px 0 0;padding:0 4px}.notes-ant-select-tree li{margin:8px 0;padding:0;white-space:nowrap;list-style:none;outline:0}.notes-ant-select-tree li.filter-node>span{font-weight:500}.notes-ant-select-tree li ul{margin:0;padding:0 0 0 18px}.notes-ant-select-tree li .notes-ant-select-tree-node-content-wrapper{display:inline-block;width:calc(100% - 24px);margin:0;padding:3px 5px;color:#000000a6;text-decoration:none;border-radius:2px;cursor:pointer;transition:all .3s}.notes-ant-select-tree li .notes-ant-select-tree-node-content-wrapper:hover{background-color:#bbc7be}.notes-ant-select-tree li .notes-ant-select-tree-node-content-wrapper.notes-ant-select-tree-node-selected{background-color:#9bbaa3}.notes-ant-select-tree li span.notes-ant-select-tree-checkbox{margin:0 4px 0 0}.notes-ant-select-tree li span.notes-ant-select-tree-checkbox+.notes-ant-select-tree-node-content-wrapper{width:calc(100% - 46px)}.notes-ant-select-tree li span.notes-ant-select-tree-switcher,.notes-ant-select-tree li span.notes-ant-select-tree-iconEle{display:inline-block;width:24px;height:24px;margin:0;line-height:22px;text-align:center;vertical-align:middle;border:0 none;outline:none;cursor:pointer}.notes-ant-select-tree li span.notes-ant-select-icon_loading .notes-ant-select-switcher-loading-icon{position:absolute;left:0;display:inline-block;color:#198746;font-size:14px;transform:none}.notes-ant-select-tree li span.notes-ant-select-icon_loading .notes-ant-select-switcher-loading-icon svg{position:absolute;inset:0;margin:auto}.notes-ant-select-tree li span.notes-ant-select-tree-switcher{position:relative}.notes-ant-select-tree li span.notes-ant-select-tree-switcher.notes-ant-select-tree-switcher-noop{cursor:auto}.notes-ant-select-tree li span.notes-ant-select-tree-switcher.notes-ant-select-tree-switcher_open .notes-ant-tree-switcher-icon,.notes-ant-select-tree li span.notes-ant-select-tree-switcher.notes-ant-select-tree-switcher_open .notes-ant-select-switcher-icon{font-size:12px;font-size:10px \\	;transform:scale(.83333333) rotate(0);display:inline-block;font-weight:700}:root .notes-ant-select-tree li span.notes-ant-select-tree-switcher.notes-ant-select-tree-switcher_open .notes-ant-tree-switcher-icon,:root .notes-ant-select-tree li span.notes-ant-select-tree-switcher.notes-ant-select-tree-switcher_open .notes-ant-select-switcher-icon{font-size:12px}.notes-ant-select-tree li span.notes-ant-select-tree-switcher.notes-ant-select-tree-switcher_open .notes-ant-tree-switcher-icon svg,.notes-ant-select-tree li span.notes-ant-select-tree-switcher.notes-ant-select-tree-switcher_open .notes-ant-select-switcher-icon svg{transition:transform .3s}.notes-ant-select-tree li span.notes-ant-select-tree-switcher.notes-ant-select-tree-switcher_close .notes-ant-tree-switcher-icon,.notes-ant-select-tree li span.notes-ant-select-tree-switcher.notes-ant-select-tree-switcher_close .notes-ant-select-switcher-icon{font-size:12px;font-size:10px \\	;transform:scale(.83333333) rotate(0);display:inline-block;font-weight:700}:root .notes-ant-select-tree li span.notes-ant-select-tree-switcher.notes-ant-select-tree-switcher_close .notes-ant-tree-switcher-icon,:root .notes-ant-select-tree li span.notes-ant-select-tree-switcher.notes-ant-select-tree-switcher_close .notes-ant-select-switcher-icon{font-size:12px}.notes-ant-select-tree li span.notes-ant-select-tree-switcher.notes-ant-select-tree-switcher_close .notes-ant-tree-switcher-icon svg,.notes-ant-select-tree li span.notes-ant-select-tree-switcher.notes-ant-select-tree-switcher_close .notes-ant-select-switcher-icon svg{transition:transform .3s}.notes-ant-select-tree li span.notes-ant-select-tree-switcher.notes-ant-select-tree-switcher_close .notes-ant-select-switcher-icon svg{transform:rotate(-90deg)}.notes-ant-select-tree li span.notes-ant-select-tree-switcher.notes-ant-select-tree-switcher_open .notes-ant-select-switcher-loading-icon,.notes-ant-select-tree li span.notes-ant-select-tree-switcher.notes-ant-select-tree-switcher_close .notes-ant-select-switcher-loading-icon{position:absolute;left:0;display:inline-block;width:24px;height:24px;color:#198746;font-size:14px;transform:none}.notes-ant-select-tree li span.notes-ant-select-tree-switcher.notes-ant-select-tree-switcher_open .notes-ant-select-switcher-loading-icon svg,.notes-ant-select-tree li span.notes-ant-select-tree-switcher.notes-ant-select-tree-switcher_close .notes-ant-select-switcher-loading-icon svg{position:absolute;inset:0;margin:auto}.notes-ant-select-tree .notes-ant-select-tree-treenode-loading .notes-ant-select-tree-iconEle,.notes-ant-select-tree-child-tree{display:none}.notes-ant-select-tree-child-tree-open{display:block}li.notes-ant-select-tree-treenode-disabled>span:not(.notes-ant-select-tree-switcher),li.notes-ant-select-tree-treenode-disabled>.notes-ant-select-tree-node-content-wrapper,li.notes-ant-select-tree-treenode-disabled>.notes-ant-select-tree-node-content-wrapper span{color:#c1c5c8;cursor:not-allowed}li.notes-ant-select-tree-treenode-disabled>.notes-ant-select-tree-node-content-wrapper:hover{background:transparent}.notes-ant-select-tree-icon__open,.notes-ant-select-tree-icon__close{margin-right:2px;vertical-align:top}.notes-ant-select-tree-dropdown{box-sizing:border-box;margin:0;padding:0;color:#000000a6;font-size:14px;font-variant:tabular-nums;line-height:1.5;list-style:none;font-feature-settings:"tnum"}.notes-ant-select-tree-dropdown .notes-ant-select-dropdown-search{position:sticky;top:0;z-index:1;display:block;padding:4px;background:#fff}.notes-ant-select-tree-dropdown .notes-ant-select-dropdown-search .notes-ant-select-search__field__wrap{width:100%}.notes-ant-select-tree-dropdown .notes-ant-select-dropdown-search .notes-ant-select-search__field{box-sizing:border-box;width:100%;padding:4px 7px;border:1px solid #d9d9d9;border-radius:4px;outline:none}.notes-ant-select-tree-dropdown .notes-ant-select-dropdown-search.notes-ant-select-search--hide{display:none}.notes-ant-select-tree-dropdown .notes-ant-select-not-found{display:block;padding:7px 16px;color:#c1c5c8;cursor:not-allowed}*{box-sizing:border-box}.sidebar-header__container{align-items:center;background:#f3f4f6;display:flex;height:60px;padding:16px 15px 16px 20px;justify-content:space-between}.sidebar-header__container-dark{background:#232630}.sidebar-header__title{color:#14151c;font:600 20px/1.4 Noto Sans,sans-serif;margin:0}.sidebar-header__title-dark{color:#fff}.sidebar-subheader__container{align-items:center;display:flex;height:41px;justify-content:space-between;padding:14px 21px 7px 20px}.sidebar-subheader__container-dark{background:linear-gradient(0deg,rgba(77,81,101,.2),rgba(77,81,101,.2)),rgba(55,56,64,.85);backdrop-filter:blur(5px)}.sidebar-subheader__title{color:#14151c;font:400 14px/1.43 Noto Sans,sans-serif;margin:0}.sidebar-subheader__title-dark{color:#fff}.sidebar-content__container{gap:8px;height:100%;display:flex;overflow:auto;flex-direction:column}.sidebar-content__container::-webkit-scrollbar{width:10px;height:12px}.sidebar-content__container::-webkit-scrollbar-track{box-shadow:inset 0 0 10px 10px #e7e7e7bb;border:solid 2px transparent}.sidebar-content__container::-webkit-scrollbar-thumb{box-shadow:inset 0 0 10px 10px #60606186;border:solid 2px transparent;border-radius:10px}.sidebar-content__container-dark{background:linear-gradient(0deg,rgba(77,81,101,.2),rgba(77,81,101,.2)),rgba(55,56,64,.85);backdrop-filter:blur(5px)}.notes-sidebar-create-wrapper{display:grid;grid-template-rows:max-content 1fr}.notes-sidebar-create{--leftPadding: 8px;--labelColor: #a3a9b9;--textColor: white;display:grid;height:100%;grid-template-rows:1fr max-content;background:linear-gradient(0deg,rgba(77,81,101,.2),rgba(77,81,101,.2)),rgba(55,56,64,.85);backdrop-filter:blur(5px);padding:12px;overflow:hidden}.notes-sidebar-create__inner{height:100%;overflow-y:auto;background:#232630;border-radius:4px}.notes-sidebar-create__inner_wrapper{display:grid;grid-auto-rows:auto;row-gap:12px;padding:14px 12px 14px 24px}.notes-sidebar-create__footer{display:flex;align-items:center;justify-content:flex-end;gap:12px;padding:16px 0}.notes-sidebar-create__footer__delete{flex:1}.notes-sidebar-create__split{display:grid;grid-template-columns:repeat(2,1fr);column-gap:16px}.notes-sidebar-create__tags{margin-top:8px;padding-left:var(--leftPadding)}.notes-sidebar-create__input label{display:grid;grid-template-columns:max-content 1fr;column-gap:8px;color:var(--labelColor);text-transform:uppercase;margin-bottom:8px}.notes-sidebar-create__input label:after{content:"";height:1px;background-color:#696f88;margin:auto 0}.notes-sidebar-create__input input,.notes-sidebar-create__input .notes-ant-input[disabled]{color:#fff;background-color:#14151c;border:0}.notes-sidebar-create__input .notes-ant-form-item{margin-bottom:0}.notes-sidebar-create__input .has-error .notes-ant-input{background-color:#14151c;border:0}.notes-sidebar-create__input .notes-ant-input[disabled]{opacity:.3}.notes-sidebar-create__input textarea{color:var(--textColor);background-color:transparent;border:none;outline:none;resize:none}.notes-sidebar-create__input textarea:focus{border:none!important;box-shadow:none}.notes-sidebar-create__input__upload{display:flex;flex-wrap:wrap;gap:7px}.notes-sidebar-create__input__upload img{height:100%;width:100%;border-radius:inherit}.notes-sidebar-create__input__uploadBtn{width:72px;aspect-ratio:1;background-color:#14151c;border:none;padding:0;border-radius:8px;outline:none}.notes-sidebar-create__input__uploadBtn:active,.notes-sidebar-create__input__uploadBtn:focus-visible{background-color:#000}.notes-sidebar-create__input__uploadBtn svg{margin:0 auto}.notes-sidebar-create__input__uploadedImage{position:relative;width:72px;aspect-ratio:1;background-color:#14151c;border-radius:8px;user-select:none}.notes-sidebar-create__input__uploadedImage:hover>.notes-sidebar-create__input__uploadedImage-close{opacity:1}.notes-sidebar-create__input__uploadedImage-close{position:absolute;display:grid;place-items:center;width:20px;aspect-ratio:1;top:2px;right:2px;background-color:#2f3031;border-radius:50%;transition:opacity .15s,background-color .15s;opacity:0}.notes-sidebar-create__input__uploadedImage-close svg{transform:scale(.8)}.notes-sidebar-create__input__uploadedImage-close:hover{cursor:pointer;background-color:#000}.notes-sidebar-create__antd-datepicker .notes-ant-calendar{color:#fff;background-color:#232630}.notes-sidebar-create__antd-datepicker .notes-ant-calendar .notes-ant-calendar-selected-day .notes-ant-calendar-date{background-color:#0071cd;border:0}.notes-sidebar-create__antd-datepicker .notes-ant-calendar td .notes-ant-calendar-date{color:#fff}.notes-sidebar-create__antd-datepicker .notes-ant-calendar td .notes-ant-calendar-date:hover,.notes-sidebar-create__antd-datepicker .notes-ant-calendar td .notes-ant-calendar-date:active{background-color:#0071cd}.notes-sidebar-create__antd-datepicker .notes-ant-calendar{border-color:#363948}.notes-sidebar-create__antd-datepicker .notes-ant-calendar .notes-ant-calendar-panel .notes-ant-calendar-input-wrap{border-bottom-color:#363948}.notes-sidebar-create__antd-datepicker .notes-ant-calendar .notes-ant-calendar-panel .notes-ant-calendar-input-wrap .notes-ant-calendar-input{background-color:#14151c;color:#fff;border-bottom-color:#363948;border-radius:4px}.notes-sidebar-create__antd-datepicker .notes-ant-calendar .notes-ant-calendar-panel .notes-ant-calendar-header{border-bottom-color:#363948}.notes-sidebar-create__antd-datepicker .notes-ant-calendar .notes-ant-calendar-panel .notes-ant-calendar-header div span a{color:#fff}.notes-sidebar-create__antd-datepicker .notes-ant-calendar .notes-ant-calendar-panel .notes-ant-calendar-header div a:before,.notes-sidebar-create__antd-datepicker .notes-ant-calendar .notes-ant-calendar-panel .notes-ant-calendar-header div a:after{border-color:#a3a9b9}.notes-sidebar-create__antd-datepicker .notes-ant-calendar .notes-ant-calendar-panel .notes-ant-calendar-header .notes-ant-calendar-next-month-btn:hover:before,.notes-sidebar-create__antd-datepicker .notes-ant-calendar .notes-ant-calendar-panel .notes-ant-calendar-header .notes-ant-calendar-prev-month-btn:hover:before,.notes-sidebar-create__antd-datepicker .notes-ant-calendar .notes-ant-calendar-panel .notes-ant-calendar-header .notes-ant-calendar-prev-year-btn:hover:before,.notes-sidebar-create__antd-datepicker .notes-ant-calendar .notes-ant-calendar-panel .notes-ant-calendar-header .notes-ant-calendar-next-year-btn:hover:before,.notes-sidebar-create__antd-datepicker .notes-ant-calendar .notes-ant-calendar-panel .notes-ant-calendar-header .notes-ant-calendar-next-month-btn:hover:after,.notes-sidebar-create__antd-datepicker .notes-ant-calendar .notes-ant-calendar-panel .notes-ant-calendar-header .notes-ant-calendar-prev-month-btn:hover:after,.notes-sidebar-create__antd-datepicker .notes-ant-calendar .notes-ant-calendar-panel .notes-ant-calendar-header .notes-ant-calendar-prev-year-btn:hover:after,.notes-sidebar-create__antd-datepicker .notes-ant-calendar .notes-ant-calendar-panel .notes-ant-calendar-header .notes-ant-calendar-next-year-btn:hover:after{border-color:#fff}.notes-sidebar-create__antd-datepicker .notes-ant-calendar .notes-ant-calendar-panel .notes-ant-calendar-disabled-cell .notes-ant-calendar-date{background:black}.notes-sidebar-create__antd-datepicker .notes-ant-calendar .notes-ant-calendar-panel .notes-ant-calendar-last-month-cell .notes-ant-calendar-date,.notes-sidebar-create__antd-datepicker .notes-ant-calendar .notes-ant-calendar-panel .notes-ant-calendar-next-month-btn-day .notes-ant-calendar-date,.notes-sidebar-create__antd-datepicker .notes-ant-calendar .notes-ant-calendar-panel .notes-ant-calendar-last-month-cell .notes-ant-calendar-date:hover,.notes-sidebar-create__antd-datepicker .notes-ant-calendar .notes-ant-calendar-panel .notes-ant-calendar-next-month-btn-day .notes-ant-calendar-date:hover{color:#a9a9a9}.submitBtn{background-color:#14803c;border:0;color:#fff}.submitBtn:hover,.submitBtn:focus{background-color:#198746;color:#fff}.deleteBtn{display:flex;align-items:center;gap:4px;color:var(--labelColor);transition:color .2s ease;background:none;border:none}.deleteBtn svg>path{transition:fill .2s ease;fill:var(--labelColor)}.deleteBtn:hover,.deleteBtn:active,.deleteBtn:focus{color:#eb4b4b;background:none;border:none}.deleteBtn:hover svg>path,.deleteBtn:active svg>path,.deleteBtn:focus svg>path{fill:#eb4b4b}.dark-header{position:relative;background-color:#232630}.dark-header .sidebar-header__title{color:#fff}.dark-header__closeBtn{display:grid;place-items:center;width:32px;aspect-ratio:1;appearance:none;border:0;border-radius:50%;background-color:#363948;transition:background-color .15s}.dark-header__closeBtn:hover{background-color:#0071cd}.dark-header__closeBtn svg{transform:scale(.7)}.audio-player{background:#f3f4f6;border-radius:8px;max-height:35px;display:flex;padding:10px 12px}.audio-player-dark{background:#363948}.audio-icon{width:90%;height:90%}.controls{display:flex;flex-direction:row;align-items:center;width:100%}.speed-control{background:#dfe2e7;color:#696f88;border-radius:20px;padding:3px 6px;border:none}.controls-dl-speed{display:flex;align-items:center;width:70px;justify-content:space-around;margin-left:5px}.controls-dark>span{color:#fff}.player-button{background-color:transparent;border:0;height:16px;cursor:pointer;padding:0}.player-button-dark svg>path{fill:#fff}.timeline{--timelinePrimary: #696f88;--timelineHover: #7d7e82;-webkit-appearance:none;width:100%;height:2px;background-color:#a3a9b9;border-radius:5px;background-size:0% 100%;background-image:linear-gradient(#7d7e82,#7d7e82);background-repeat:no-repeat;margin:0 16px 0 8px}.timeline-dark{--timelinePrimary: white;--timelineHover: lightgray;background-color:gray;background-image:linear-gradient(white,white)}.timeline::-webkit-slider-thumb{-webkit-appearance:none;width:8px;height:8px;border-radius:50%;cursor:pointer;opacity:1;transition:all .1s;background-color:var(--timelinePrimary)}.timeline::-moz-range-thumb{-webkit-appearance:none;width:1em;height:1em;border-radius:50%;cursor:pointer;opacity:0;transition:all .1s;background-color:var(--timelinePrimary)}.timeline::-ms-thumb{-webkit-appearance:none;width:1em;height:1em;border-radius:50%;cursor:pointer;opacity:0;transition:all .1s;background-color:var(--timelinePrimary)}.timeline::-webkit-slider-thumb:hover{background-color:var(--timelineHover)}.timeline:hover::-webkit-slider-thumb{opacity:1}.timeline::-moz-range-thumb:hover{background-color:var(--timelineHover)}.timeline:hover::-moz-range-thumb{opacity:1}.timeline::-ms-thumb:hover{background-color:var(--timelineHover)}.timeline:hover::-ms-thumb{opacity:1}.timeline::-webkit-slider-runnable-track{-webkit-appearance:none;box-shadow:none;border:none;background:transparent}.timeline::-moz-range-track{-webkit-appearance:none;box-shadow:none;border:none;background:transparent}.timeline::-ms-track{-webkit-appearance:none;box-shadow:none;border:none;background:transparent}/*! PhotoSwipe main CSS by Dmytro Semenov | photoswipe.com */.pswp{--pswp-bg: #000;--pswp-placeholder-bg: #222;--pswp-root-z-index: 100000;--pswp-preloader-color: rgba(79, 79, 79, .4);--pswp-preloader-color-secondary: rgba(255, 255, 255, .9);--pswp-icon-color: #fff;--pswp-icon-color-secondary: #4f4f4f;--pswp-icon-stroke-color: #4f4f4f;--pswp-icon-stroke-width: 2px;--pswp-error-text-color: var(--pswp-icon-color)}.pswp{position:fixed;top:0;left:0;width:100%;height:100%;z-index:var(--pswp-root-z-index);display:none;touch-action:none;outline:0;opacity:.003;contain:layout style size;-webkit-tap-highlight-color:rgba(0,0,0,0)}.pswp:focus{outline:0}.pswp *{box-sizing:border-box}.pswp img{max-width:none}.pswp--open{display:block}.pswp,.pswp__bg{transform:translateZ(0);will-change:opacity}.pswp__bg{opacity:.005;background:var(--pswp-bg)}.pswp,.pswp__scroll-wrap{overflow:hidden}.pswp__scroll-wrap,.pswp__bg,.pswp__container,.pswp__item,.pswp__content,.pswp__img,.pswp__zoom-wrap{position:absolute;top:0;left:0;width:100%;height:100%}.pswp__img,.pswp__zoom-wrap{width:auto;height:auto}.pswp--click-to-zoom.pswp--zoom-allowed .pswp__img{cursor:-webkit-zoom-in;cursor:-moz-zoom-in;cursor:zoom-in}.pswp--click-to-zoom.pswp--zoomed-in .pswp__img{cursor:move;cursor:-webkit-grab;cursor:-moz-grab;cursor:grab}.pswp--click-to-zoom.pswp--zoomed-in .pswp__img:active{cursor:-webkit-grabbing;cursor:-moz-grabbing;cursor:grabbing}.pswp--no-mouse-drag.pswp--zoomed-in .pswp__img,.pswp--no-mouse-drag.pswp--zoomed-in .pswp__img:active,.pswp__img{cursor:-webkit-zoom-out;cursor:-moz-zoom-out;cursor:zoom-out}.pswp__container,.pswp__img,.pswp__button,.pswp__counter{-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.pswp__item{z-index:1;overflow:hidden}.pswp__hidden{display:none!important}.pswp__content{pointer-events:none}.pswp__content>*{pointer-events:auto}.pswp__error-msg-container{display:grid}.pswp__error-msg{margin:auto;font-size:1em;line-height:1;color:var(--pswp-error-text-color)}.pswp .pswp__hide-on-close{opacity:.005;will-change:opacity;transition:opacity var(--pswp-transition-duration) cubic-bezier(.4,0,.22,1);z-index:10;pointer-events:none}.pswp--ui-visible .pswp__hide-on-close{opacity:1;pointer-events:auto}.pswp__button{position:relative;display:block;width:50px;height:60px;padding:0;margin:0;overflow:hidden;cursor:pointer;background:none;border:0;box-shadow:none;opacity:.85;-webkit-appearance:none;-webkit-touch-callout:none}.pswp__button:hover,.pswp__button:active,.pswp__button:focus{transition:none;padding:0;background:none;border:0;box-shadow:none;opacity:1}.pswp__button:disabled{opacity:.3;cursor:auto}.pswp__icn{fill:var(--pswp-icon-color);color:var(--pswp-icon-color-secondary)}.pswp__icn{position:absolute;top:14px;left:9px;width:32px;height:32px;overflow:hidden;pointer-events:none}.pswp__icn-shadow{stroke:var(--pswp-icon-stroke-color);stroke-width:var(--pswp-icon-stroke-width);fill:none}.pswp__icn:focus{outline:0}div.pswp__img--placeholder,.pswp__img--with-bg{background:var(--pswp-placeholder-bg)}.pswp__top-bar{position:absolute;left:0;top:0;width:100%;height:60px;display:flex;flex-direction:row;justify-content:flex-end;z-index:10;pointer-events:none!important}.pswp__top-bar>*{pointer-events:auto;will-change:opacity}.pswp__button--close{margin-right:6px}.pswp__button--arrow{position:absolute;width:75px;height:100px;top:50%;margin-top:-50px}.pswp__button--arrow:disabled{display:none;cursor:default}.pswp__button--arrow .pswp__icn{top:50%;margin-top:-30px;width:60px;height:60px;background:none;border-radius:0}.pswp--one-slide .pswp__button--arrow{display:none}.pswp--touch .pswp__button--arrow{visibility:hidden}.pswp--has_mouse .pswp__button--arrow{visibility:visible}.pswp__button--arrow--prev{right:auto;left:0}.pswp__button--arrow--next{right:0}.pswp__button--arrow--next .pswp__icn{left:auto;right:14px;transform:scaleX(-1)}.pswp__button--zoom{display:none}.pswp--zoom-allowed .pswp__button--zoom{display:block}.pswp--zoomed-in .pswp__zoom-icn-bar-v{display:none}.pswp__preloader{position:relative;overflow:hidden;width:50px;height:60px;margin-right:auto}.pswp__preloader .pswp__icn{opacity:0;transition:opacity .2s linear;animation:pswp-clockwise .6s linear infinite}.pswp__preloader--active .pswp__icn{opacity:.85}@keyframes pswp-clockwise{0%{transform:rotate(0)}to{transform:rotate(360deg)}}.pswp__counter{height:30px;margin-top:15px;margin-inline-start:20px;font-size:14px;line-height:30px;color:var(--pswp-icon-color);text-shadow:1px 1px 3px var(--pswp-icon-color-secondary);opacity:.85}.pswp--one-slide .pswp__counter{display:none}.pswp{font-family:Noto Sans,sans-serif}.pswp__bullets-indicator{bottom:20px;width:50vw;position:absolute;transform:translate(50%);padding:10px 0;overflow:hidden}.pswp__bullets-indicator>.pswp__bullet-wrapper{gap:16px;display:flex;transition:transform .3s ease-in-out;transform:translate(calc(50vw - 40px))}.pswp__bullet{width:80px;height:80px;opacity:.6;cursor:pointer;min-width:80px;max-width:80px;max-height:80px;min-height:80px;object-fit:cover;transform:scale(1);transition:all .1s ease-in}.pswp__bullet--active{opacity:1;width:80px;height:80px;cursor:not-allowed;transform:scale(1.2)}.gallery-image{position:absolute;z-index:-99999;width:0;height:0;left:-100vw;top:-100vh;overflow:hidden}.gallery-image-link{visibility:hidden;width:100%;height:100%;position:absolute;top:0;left:0}.gallery-image-link-image{width:100%;height:100%;object-fit:cover}.container__gallery{display:flex;align-items:center;justify-content:center;background:none;flex-direction:column}.container__photoswipe{position:relative;display:flex;align-items:center}.container__photoswipe__header{position:absolute;display:flex;justify-content:space-between;padding:16px 24px 0;margin:0 auto;top:0;color:#fff;background:linear-gradient(360deg,rgba(0,0,0,.0001) 0%,#00000050 100%);width:100%;height:140px;z-index:1;border-radius:12px}.container__photoswipe__header__container{display:flex;flex-direction:column}.container__photoswipe__header____title{font-weight:600;font-size:14px}.container__photoswipe__header__content{font-weight:400;font-size:12px}.container__photoswipe__header__download{display:flex;align-items:center;justify-content:center;width:40px;height:40px;border:0;background:rgba(20,21,28,.5);border-radius:50%;cursor:pointer}.container__photoswipe__header__download svg{width:18px;height:18px}.container__photoswipe__header__download:hover{background:rgba(20,21,28)}.container__photoswipe__image{position:relative;display:flex;align-items:center;justify-content:center;max-width:502px;width:502px;max-height:502px;height:502px;background-color:#14151c;border-radius:8px;box-shadow:0 4px 12px #00000026;margin:0 16px}.container__photoswipe__image img,.container__photoswipe__image video{max-height:100%;max-width:100%;border-radius:8px;filter:drop-shadow(0px 4px 12px rgba(0,0,0,.15))}.container__photoswipe__button{border:0;background:#00000070;border-radius:50%;display:flex;align-items:center;justify-content:center;width:40px;height:40px;cursor:pointer}.container__photoswipe__button:hover{background:#000}.container__preview{margin-top:20px;display:flex}.container__preview__item{width:48px;height:48px;box-shadow:0 4px 12px #00000026;border-radius:4px;cursor:pointer;background-size:cover;background-position:center;border:0}.container__preview__item:not(:first-child){margin-left:12px}.note-content{width:304px;max-width:304px;margin-left:42px;margin-bottom:68px}.note-content svg{fill:#fff}.note-content svg path{fill:#fff}.note-content svg line{stroke:#fff}.note-content span{color:#fff}.note-content .timeline{background-color:#5a5c60;background-image:linear-gradient(#fff,#fff)}.note-content .timeline::-webkit-slider-thumb{background-color:#fff}.note-content__infos{background:rgba(20,21,28);border-radius:4px;padding:12px}.note-content__infos .notes-card__container__info-note__text{max-height:250px;overflow:auto;color:#fff}.note-content__infos .notes-card__container__info-note__svg{background:transparent;color:#fff}.note-content__user{font-size:12px;width:100%;padding:4px 8px;color:#fff;background:rgba(20,21,28,.5);backdrop-filter:blur(5px);border-radius:4px;margin-top:8px}.note-content__user b{font-weight:600}.note-content .notes-card__container__info-note__svg-dark{background-color:transparent}.gallery{display:flex;flex-direction:row;align-items:center;justify-content:center;width:100%;height:100%}.gallery__content{display:flex;align-items:center;position:relative}.gallery__close-button{border:0;width:40px;height:40px;border-radius:50%;display:flex;align-items:center;justify-content:center;position:absolute;top:0;right:0;background:rgba(0,0,0,.5);cursor:pointer}.gallery__close-button:hover{background:rgba(0,0,0)}.modal{position:fixed;overflow:hidden;inset:0;background-color:#000000a6;width:100%;height:100%;display:flex;align-items:center;justify-content:center;padding:1.5em 1em;z-index:999999;box-sizing:border-box}.modal.modal-fade{animation:fade-in 1s 1 linear;animation-fill-mode:forwards;opacity:0}.modal>.modal-overlay{width:100%;height:100%;position:absolute;top:0;left:0}.modal>.modal-close{position:absolute;right:15px;top:10px;color:#5e5e5e;cursor:pointer;font-size:1.25em;padding:7px;background:rgba(255,255,255,.749);border:1px solid #c3c0c0;border-radius:50%;width:42px;height:42px;display:flex;align-items:center;justify-content:center;z-index:999999;box-sizing:border-box;text-align:center}.modal>.modal-close:hover{background:rgba(255,255,255,.989)}.modal>.modal-body{z-index:2;position:relative;margin:0 auto;border-radius:3px;overflow-x:hidden;overflow-y:auto;max-height:100%;padding:15px 20px;color:#c3c0c0}@keyframes fade-in{0%{animation-timing-function:cubic-bezier(.2242,.7499,.3142,.8148);opacity:0}to{opacity:1}}.notes-ant-tooltip{z-index:1000000}.notes-ant-collapse-icon-position-right>.notes-ant-collapse-item>.notes-ant-collapse-header{position:relative;padding:0!important;width:100%}.notes-ant-collapse-borderless{background-color:#fff;margin:0 12px}.note-card-action-menu-popover .notes-ant-popover-arrow{display:none}.note-card-action-menu-popover .notes-ant-popover-inner{background-color:transparent}.note-card-action-menu-popover .notes-ant-popover-inner-content{padding:0;margin:0}.notes-ant-collapse-icon-position-right>.notes-ant-collapse-item>.notes-ant-collapse-header .notes-ant-collapse-arrow{position:absolute;top:16px!important;right:14px!important}.notes-ant-collapse-borderless>.notes-ant-collapse-item>.notes-ant-collapse-content>.notes-ant-collapse-content-box{padding:0 12px}.notes-ant-collapse-borderless>.notes-ant-collapse-item{border:1px solid #f3f4f6;border-radius:8px!important}.notes-ant-collapse-borderless>.notes-ant-collapse-item.notes-card__container__expanded{border:1px solid #9664f0}.notes-ant-collapse-borderless>.notes-ant-collapse-item.notes-card__container-dark__expanded{border:1px solid #8354d6;background-color:#232630}.notes-ant-collapse-borderless-dark{background-color:transparent}.notes-ant-collapse-borderless-dark>.notes-ant-collapse-item{border:0}.st-avatar-2{margin-right:20px}.notes-card__container{row-gap:8px;display:grid;grid-template-rows:auto;margin:0 0 8px;background-color:#fff;border-radius:8px;max-width:530px}.notes-card__container__actions-menu__unstyled-button{padding:0;border:none;background:none;border-radius:100%}.notes-card__container__actions-menu__button{display:flex;align-self:center;border-radius:4px;border:none;background-color:transparent;padding:2px;cursor:pointer}.notes-card__container__actions-menu__button.active,.notes-card__container__actions-menu__button:hover{background-color:#dfe2e7}.notes-card__container__actions-menu__button-dark.active{background-color:#0071cd}.notes-card__container__actions-menu__button-dark.active svg>path{fill:#fff}.notes-card__container__actions-menu__button-dark:hover{background-color:#0071cd}.notes-card__container__actions-menu__button-dark:hover svg path{fill:#fff}.notes-card__container__icon-container{display:flex;opacity:1;transition:all .1s ease-in;align-items:center}.notes-card__container__icon-container__expanded{display:flex;transition:all .1s ease-in-out;opacity:0}.notes-card__container__icon{display:flex;align-items:center;justify-content:center;width:24px;height:24px;background:#f3f4f6;border-radius:4px;margin:2px}.notes-card__container__icon-dark{background:#232630}.notes-card__container__icon-dark svg>path{fill:#fff}.notes-card__container__audio-duration-dark{color:#fff}.notes-card__container__title{font-weight:900;font-size:16px;color:#2f3031}.notes-card__container__title-container{display:flex;justify-content:space-between;background:#f3f4f6;align-items:flex-start;padding:8px 12px;border-radius:8px 8px 0 0;min-height:36px}.notes-card__container__title-container-dark{background:#232630}.notes-card__container__thumbnails-container{gap:8px;display:flex;align-items:center;justify-content:flex-start}.notes-card__container__thumbnails-container__thumbnail{display:flex;position:relative;align-items:center;background-size:cover;justify-content:center;background-position:center;background-repeat:no-repeat;transition:all .2s ease-in;width:32px!important;height:32px!important;border-radius:50%}.notes-card__container__thumbnails-container__thumbnail__expanded{transition:all .2s ease-in-out;width:117px!important;height:85px!important;border-radius:8px}.notes-card__container__thumbnails-container__thumbnail:hover{cursor:pointer}.notes-card__container__thumbnails-container__thumbnail__text{font-size:20px;color:#fff}.notes-card__container__thumbnails-container__thumbnail__text-dark{background-color:#232630;padding:.35rem;aspect-ratio:1;border-radius:50%;font-size:20px;color:#fff}.notes-card__container__resume-note{position:relative;display:flex;justify-content:space-between;align-items:end;padding:12px}.notes-card__container__info-note{gap:8px;display:flex;align-items:center;justify-content:flex-start;margin:4px 0}.notes-card__container__info-note__svg{background:#f3f4f6;border-radius:4px;height:24px;min-width:24px;display:flex;align-items:center;justify-content:center}.notes-card__container__info-note__svg-dark{background:#14151c}.notes-card__container__info-note__svg-dark svg>path{fill:#fff}.notes-card__container__info-note__text{max-height:250px;overflow:auto;font-size:14px;line-height:24px;font-family:Rubik,sans-serif;color:#2f3031}.notes-card__container__info-note__text-dark{color:#fff}.notes-card__container__info-note__fieldName-container{max-width:120px;white-space:nowrap;overflow:hidden;text-overflow:ellipsis}.notes-card__container__info-note__fieldName-container span{font-size:14px;line-height:20px;font-weight:600}.notes-card__container__info-note__tags-container{width:100%;gap:4px;display:flex;flex-direction:row;max-width:362px;margin-right:18px;justify-content:end}.notes-card__container__info-note__tags-container__tag-item{display:flex;border-radius:4px;width:max-content;align-items:center;justify-items:center;padding:4px 8px;background-color:#8354d6;max-width:362px}.notes-card__container__info-note__tags-container__tag-item:not(:first-child){margin-left:4px}.notes-card__container__info-note__tags-container__tag-item__text{color:#fff;font-size:12px;line-height:12px;font-weight:600;white-space:nowrap;overflow:hidden;text-overflow:ellipsis}.notes-card__container__info-note__comment{gap:8px;display:flex;align-items:flex-start;justify-content:flex-start}.notes-card__container__info-note__comment svg{min-width:16px;margin-top:4px}.notes-card__container__info-note__comment span{line-height:1.5}.notes-card__container__info-note__comment__isHeader{top:12px;left:44px;max-width:calc(100% - 48px);position:absolute;overflow:hidden;text-overflow:ellipsis;word-wrap:break-word;display:-webkit-box;-webkit-line-clamp:1;line-clamp:1;-webkit-box-orient:vertical}.notes-card__container__info-note__scouter-container{display:flex;align-items:center;flex-direction:row;justify-content:flex-start;margin-right:12px}.notes-card__container__info-note__scouter-container__name{font-size:14px;color:#2f3031;max-width:92px;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;margin-right:10px}.notes-card__container__info-note__scouter-container__name-dark{color:#fff}.notes-card__container__info-note__scouter-container__scouter-initials{width:24px;height:24px;display:flex;border-radius:50%;align-items:center;justify-content:center;border:1px solid #dfe2e7;margin-right:8px}.notes-card__container__info-note__scouter-container__scouter-initials__text{color:#707374;font-size:10px}.notes-card__container__info-note__scouter-container__scouter-initials-dark{background-color:#fff}.notes-card__container-dark{background-color:#23263080;backdrop-filter:blur(5px)}.notes-ant-collapse>.notes-ant-collapse-item>.notes-ant-collapse-header .notes-sidebar__collapse-icon{transition:all .2s ease-in-out;transform:rotate(180deg)}.notes-ant-collapse>.notes-ant-collapse-item>.notes-ant-collapse-header .notes-sidebar__collapse-icon__expanded{transition:all .2s ease-in-out;transform:rotate(0)}.notes-sidebar__container{z-index:1001;background-color:#fff;display:flex;flex-direction:column;height:100%;max-width:550px;width:42.15%}.notes-sidebar__container__virtualList{height:1000px;max-width:550px;overflow-y:auto;contain:strict}.notes-sidebar__container-dark{background-color:transparent}.notes-sidebar__collapse-icon{transition:all .2s ease-in-out;transform:rotate(180deg)}.notes-sidebar__collapse-icon__expanded{transition:all .2s ease-in-out;transform:rotate(0)}.notes-sidebar__content{flex:1 1;flex-basis:0}.range-picker__container{width:100%}.container{min-height:334px;display:flex;background:#ffffff;flex-direction:column;align-items:flex-start;justify-content:space-between;width:min-content}.container>header,.container section,.container footer{width:100%;height:auto}.filter-title{font-size:16px;font-weight:600;color:#000;line-height:24px;font-style:normal;letter-spacing:-.0075em}.range-picker{width:100%;height:40px}.range-picker>.notes-ant-calendar-picker-input,.range-picker .notes-ant-input,.range-picker .notes-ant-input-lg{max-width:100%;margin:0}.note-inputs-footer{width:100%;height:auto;display:flex;align-items:center;justify-content:space-between}.note-inputs-footer>button{cursor:pointer;color:#14803c}.note-inputs-footer>div{display:flex;width:100%;justify-content:flex-end}.note-inputs-footer>div>button{margin-left:8px}.content{margin-top:16px}.content .label-component{color:#14151c;font-size:14px;font-weight:400;font-style:normal}.quick-filters{width:auto;height:auto;display:grid;margin:0 0 12px;grid-row-gap:8px;grid-column-gap:8px;grid-template-columns:1fr 1fr}.quick-filters>button{padding:20px;display:flex;align-items:center;justify-content:center}.quick-filters>.selected-range{background:#14803c;color:#fff}.filter-button{width:32px;height:32px;display:flex;cursor:pointer;border-radius:50%;align-items:center;justify-content:center;background-color:#dfe2e7}.sd-multilayer-1{height:60px;cursor:pointer}.sd-map__container{position:absolute;inset:0}.sd-map .mapboxgl-popup{z-index:1000}.notes-map__container{flex:1 1;flex-basis:0;position:relative}.notes-map__container,.notes-map__container .sd-map,.notes-map__container .sd-map__container,.notes-map__container .mapboxgl-canvas-container{height:100%}.notes-map__container .sd-map__container{position:static}.notes-map__container .mapboxgl-canvas-container{display:flex}.notes-map__container .mapboxgl-canvas-container .mapboxgl-canvas{height:100%!important;width:100%!important}.notes-map__container .mapboxgl-control-container{bottom:120px;position:absolute;right:20px}.notes-map__container .mapboxgl-ctrl-group{backdrop-filter:blur(5px);background:rgba(20,21,28,.5);border-radius:8px;display:flex;flex-direction:column;margin:0}.notes-map__container .mapboxgl-ctrl-group button{align-items:center;border:none;color:#dfe2e7;cursor:pointer;display:flex;justify-content:center;height:40px;padding:0;width:40px;background:none;font-family:Noto Sans,sans-serif}.notes-map__container .mapboxgl-ctrl-group button span{position:relative;background-image:none!important}.notes-map__container .mapboxgl-ctrl-group button span:before{position:absolute;top:50%;left:50%;transform:translate(-50%,-50%)}.notes-map__container .mapboxgl-ctrl-group .mapboxgl-ctrl-zoom-in span:before{content:"+";font-size:24.6px}.notes-map__container .mapboxgl-ctrl-group .mapboxgl-ctrl-zoom-out span:before{content:"-";font-size:37.2px;top:40%}.notes-map__container .notes-map__fullscreen,.notes-map__container .notes-map__centralizer{backdrop-filter:blur(5px);background:rgba(20,21,28,.5);border-radius:8px;align-items:center;border:none;color:#dfe2e7;cursor:pointer;display:flex;justify-content:center;height:40px;padding:0;width:40px;position:absolute;right:20px}.notes-map__container .notes-map__fullscreen svg,.notes-map__container .notes-map__centralizer svg,.notes-map__container .notes-map__fullscreen path,.notes-map__container .notes-map__centralizer path{fill:#dfe2e7}.notes-map__container .notes-map__fullscreen{bottom:72px}.notes-map__container .notes-map__centralizer{bottom:24px}.notes-map__container .notes-map__centralizer svg{height:22px;width:22px}.notes-map__container__buttons{backdrop-filter:blur(5px);background:rgba(20,21,28,.5);border-radius:8px}.notes-map__container__button{align-items:center;border:none;color:#dfe2e7;cursor:pointer;display:flex;justify-content:center;height:40px;padding:0;width:40px}.notes-map__container .mapboxgl-popup{position:absolute;top:0;left:0;display:-webkit-flex;display:flex;will-change:transform;pointer-events:none;z-index:1000;background:#fff}.notes-map__container .mapboxgl-popup-content{position:inherit;padding:inherit;box-shadow:0 4px 12px #7073744d;border-radius:8px;background:#fff;pointer-events:auto}.popup__header{display:flex;align-items:center;justify-content:space-between;padding:8px 8px 0}.popup__header__text{font-size:16px;font-weight:600;line-height:24px}.popup__header__close-button{width:24px;height:24px}.popup__container{width:215px;height:auto;max-height:250px;overflow-y:auto}.popup__container__list{display:flex;align-items:center;cursor:pointer;padding:5px 0 5px 8px}.popup__container__list::-webkit-scrollbar{width:12px}.popup__container__list::-webkit-scrollbar-track{border:solid 4px transparent}.popup__container__list::-webkit-scrollbar-thumb{box-shadow:inset 0 0 2px 2px #c1c5c8;border:solid 4px transparent;border-radius:10px}.popup__container__list:hover{background-color:#f3f4f6}.popup__container__img{margin-right:10px}.popup__container__img img{width:50px}.popup__container__text span{font-weight:600}.loading__container{width:100%;height:100%}.loading__wrapper{width:100%;height:80px;display:grid;border-radius:8px;margin-bottom:8px;align-content:center;justify-items:center;background-color:#fff;grid-template-columns:1fr 1fr}.loading__wrapper>.right-hand-side{gap:8px;width:100%;height:100%;display:flex;padding:0 8px;align-items:flex-end;flex-direction:column;justify-content:space-between}.loading__wrapper>.right-hand-side>:nth-child(2){gap:4px;display:flex}.loading__wrapper>.left-hand-side{gap:8px;width:100%;height:100%;display:flex;padding:0 8px;flex-direction:column;justify-content:center}.loading__wrapper>.left-hand-side>div{gap:4px;display:flex}.loading__wrapper-dark{background-color:#23263080}.info-first-line-left{top:10px;left:149px;width:64px;height:16px;border-radius:8px}.info-second-line-left{top:36px;left:13px;height:32px;width:167px;border-radius:8px}.info-first-line-right{top:8px;left:374px;height:16px;width:131px;border-radius:8px}.info-second-line-right-circle{top:40px;width:26px;left:446px;height:26px;border-radius:40px}.info-second-line-right-square{height:26px;width:26px;left:479px;top:40px;border-radius:4px}.loading-item{background-color:transparent}.loading-item-dark{background-color:#23263080}.skeleton{animation:skeleton-animation 1s linear infinite alternate}.skeleton-dark{animation:skeleton-animation-dark 1s linear infinite alternate}@keyframes skeleton-animation{0%{background-color:#f2f2f2}to{background-color:#e6e6e6}}@keyframes skeleton-animation-dark{0%{background-color:#232630}to{background-color:#4d5165}}.error__container{width:100%;height:100%;display:flex;align-items:center;flex-direction:column;justify-content:center}.error__container .title{font-size:24px;color:#00004b;font-weight:600;line-height:32px;text-align:center;font-family:Noto Sans,sans-serif}.error__container .error,.error__container .subtitle{font-family:Noto Sans,sans-serif;font-size:14px;font-weight:400;line-height:20px;text-align:center}.loading-map__container{inset:0;z-index:1;display:flex;position:absolute;align-items:center;background:#f5f8fc;justify-content:center;text-align:center;font:400 14px/1.43 Noto Sans,sans-serif}.notes-component__container{display:flex;height:100%;width:100%}')),document.head.appendChild(t)}}catch(n){console.error("vite-plugin-css-injected-by-js",n)}})();
var $a = Object.defineProperty, Xa = Object.defineProperties;
var Ka = Object.getOwnPropertyDescriptors;
var Nn = Object.getOwnPropertySymbols;
var Rr = Object.prototype.hasOwnProperty, zr = Object.prototype.propertyIsEnumerable;
var pi = Math.pow, Lr = (n, e, t) => e in n ? $a(n, e, { enumerable: !0, configurable: !0, writable: !0, value: t }) : n[e] = t, Y = (n, e) => {
  for (var t in e || (e = {}))
    Rr.call(e, t) && Lr(n, t, e[t]);
  if (Nn)
    for (var t of Nn(e))
      zr.call(e, t) && Lr(n, t, e[t]);
  return n;
}, Te = (n, e) => Xa(n, Ka(e));
var xt = (n, e) => {
  var t = {};
  for (var i in n)
    Rr.call(n, i) && e.indexOf(i) < 0 && (t[i] = n[i]);
  if (n != null && Nn)
    for (var i of Nn(n))
      e.indexOf(i) < 0 && zr.call(n, i) && (t[i] = n[i]);
  return t;
};
import * as hn from "react";
import c, { createContext as Ts, useContext as Os, useMemo as Ue, forwardRef as Is, useCallback as Oe, useState as le, useRef as We, useEffect as he, useImperativeHandle as Ja } from "react";
import { Tag as Qa, Form as tt, Input as mi, DatePicker as ks, Button as jt, Tooltip as Ds, Popover as Ms, Collapse as Ls, TreeSelect as el, Spin as tl, Icon as nl, ConfigProvider as il } from "antd";
import Re from "moment";
import rl, { createPortal as sl } from "react-dom";
import Rs, { NavigationControl as ol } from "mapbox-gl";
import { bbox as zs, point as al, ellipse as ll } from "@turf/turf";
var Ti = {}, cl = {
  get exports() {
    return Ti;
  },
  set exports(n) {
    Ti = n;
  }
};
/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/
(function(n) {
  (function() {
    var e = {}.hasOwnProperty;
    function t() {
      for (var i = [], r = 0; r < arguments.length; r++) {
        var s = arguments[r];
        if (s) {
          var o = typeof s;
          if (o === "string" || o === "number")
            i.push(s);
          else if (Array.isArray(s)) {
            if (s.length) {
              var l = t.apply(null, s);
              l && i.push(l);
            }
          } else if (o === "object") {
            if (s.toString !== Object.prototype.toString && !s.toString.toString().includes("[native code]")) {
              i.push(s.toString());
              continue;
            }
            for (var h in s)
              e.call(s, h) && s[h] && i.push(h);
          }
        }
      }
      return i.join(" ");
    }
    n.exports ? (t.default = t, n.exports = t) : window.classNames = t;
  })();
})(cl);
const G = Ti, Ns = Ts(null), ze = () => Os(Ns), ul = ({ theme: n, children: e }) => {
  const t = Ue(() => ({ theme: n }), [n]);
  return /* @__PURE__ */ c.createElement(Ns.Provider, { value: t }, e);
}, Fs = ({ title: n, prefixContent: e, suffixContent: t, className: i }) => {
  const { theme: r } = ze();
  return /* @__PURE__ */ c.createElement(
    "div",
    {
      className: G(i, "sidebar-header__container", {
        "sidebar-header__container-dark": r === "dark"
      })
    },
    e,
    n && /* @__PURE__ */ c.createElement("h1", { className: G("sidebar-header__title", { "sidebar-header__title-dark": r === "dark" }) }, n),
    t
  );
};
const hl = ({ title: n, content: e, className: t }) => {
  const { theme: i } = ze();
  return /* @__PURE__ */ c.createElement(
    "div",
    {
      className: G(t, "sidebar-subheader__container", {
        "sidebar-subheader__container-dark": i === "dark"
      })
    },
    n && /* @__PURE__ */ c.createElement("h2", { className: G("sidebar-subheader__title", { "sidebar-subheader__title-dark": i === "dark" }) }, n),
    e
  );
};
const dl = Is(({ customStyle: n, children: e, className: t }, i) => {
  const { theme: r } = ze();
  return /* @__PURE__ */ c.createElement(
    "div",
    {
      style: n,
      className: G(t, "sidebar-content__container", {
        "sidebar-content__container-dark": r === "dark"
      }),
      ref: i
    },
    e
  );
}), fl = ({
  checked: n,
  onChange: e,
  value: t,
  disabled: i = !1,
  checkedColor: r = "#8354D6",
  color: s = "#363948",
  children: o,
  style: l = {}
}) => {
  const h = Oe(() => {
    i || e(t);
  }, [e, t, i]);
  return /* @__PURE__ */ c.createElement(
    Qa.CheckableTag,
    {
      style: Y({
        backgroundColor: n ? r : s,
        color: n ? "white" : "#868CA2",
        fontWeight: 600,
        userSelect: "none"
      }, l),
      checked: n,
      onChange: h
    },
    o
  );
}, pl = (n) => /* @__PURE__ */ c.createElement("svg", Y({ width: "18", height: "18", viewBox: "0 0 20 18", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, n), /* @__PURE__ */ c.createElement(
  "path",
  {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7 0H13L14.83 2H18C19.1 2 20 2.9 20 4V16C20 17.1 19.1 18 18 18H2C0.9 18 0 17.1 0 16V4C0 2.9 0.9 2 2 2H5.17L7 0ZM13.95 4L12.12 2H7.88L6.05 4H2V16H18V4H13.95ZM10 7C11.65 7 13 8.35 13 10C13 11.65 11.65 13 10 13C8.35 13 7 11.65 7 10C7 8.35 8.35 7 10 7ZM5 10C5 7.24 7.24 5 10 5C12.76 5 15 7.24 15 10C15 12.76 12.76 15 10 15C7.24 15 5 12.76 5 10Z",
    fill: "#19A04B"
  }
)), ml = (n) => /* @__PURE__ */ c.createElement("svg", Y({ width: "16", height: "18", viewBox: "0 0 16 18", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, n), /* @__PURE__ */ c.createElement(
  "path",
  {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14 2.25H13.25V0.75H11.75V2.25H4.25V0.75H2.75V2.25H2C1.175 2.25 0.5 2.925 0.5 3.75V15.75C0.5 16.575 1.175 17.25 2 17.25H14C14.825 17.25 15.5 16.575 15.5 15.75V3.75C15.5 2.925 14.825 2.25 14 2.25ZM14 15.75H2V7.5H14V15.75ZM2 6H14V3.75H2V6Z",
    fill: "#696F88"
  }
)), Oi = (n) => /* @__PURE__ */ c.createElement("svg", Y({ width: "14", height: "14", viewBox: "0 0 14 14", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, n), /* @__PURE__ */ c.createElement(
  "path",
  {
    d: "M14 1.41L12.59 0L7 5.59L1.41 0L0 1.41L5.59 7L0 12.59L1.41 14L7 8.41L12.59 14L14 12.59L8.41 7L14 1.41Z",
    fill: "white"
  }
)), vl = (n) => /* @__PURE__ */ c.createElement("svg", Y({ width: "19", height: "18", viewBox: "0 0 19 18", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, n), /* @__PURE__ */ c.createElement(
  "path",
  {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.375 2.25H7.625L6.875 3H4.25V4.5H14.75V3H12.125L11.375 2.25ZM12.5 6.75V14.25H6.5V6.75H12.5ZM5 5.25H14V14.25C14 15.075 13.325 15.75 12.5 15.75H6.5C5.675 15.75 5 15.075 5 14.25V5.25Z",
    fill: "#A3A9B9"
  }
)), Nr = /^[-+]?(180(\.0+)?|((1[0-7]\d)|([1-9]?\d))(\.\d+)?),\s*[-+]?([1-8]?\d(\.\d+)?|90(\.0+)?)$/, gl = {
  text: !1,
  files: !1,
  tags: !1,
  location: !1,
  date: !1
};
const yl = ({
  translations: n,
  tags: e = [],
  initialValues: t = {},
  fieldName: i,
  location: r,
  loading: s = !1,
  onCancel: o,
  onSubmit: l,
  onDelete: h,
  showDeleteButton: d = !1,
  onLocationChange: m,
  dateFormat: p,
  className: _ = "",
  form: g,
  style: S = {},
  maxNoteInputLength: A = 1e3,
  disabledInputs: I = gl
}) => {
  const [L, x] = le((t == null ? void 0 : t.mediaFiles) || []), [Z, R] = le((t == null ? void 0 : t.noteTags) || []), P = We(), W = (F) => {
    Z.findIndex((j) => j === F) >= 0 ? R((j) => j.filter((X) => X !== F)) : R((j) => [...j, F]);
  }, K = (F) => {
    F.preventDefault(), g.validateFields((V, j) => {
      if (!V) {
        const X = Te(Y({}, j), {
          noteDate: j.noteDate.toDate(),
          mediaFiles: L,
          noteTags: Z
        });
        l && l(X);
      }
    });
  }, J = (F) => {
    if (F.stopPropagation(), F.preventDefault(), s)
      return;
    const V = Object.values(F.target.files).filter((j) => j.type.match(/image-*/));
    V.length && x((j) => [
      ...j,
      ...V.filter((X) => !j.find((_e) => _e.name === X.name))
    ]), P.current.value = null;
  }, q = (F) => {
    const V = L.findIndex((X) => X.name === F.name), j = L.slice();
    !s && V >= 0 && (j.splice(V, 1), x(j));
  };
  return he(() => {
    r && g.getFieldValue("noteLocation") !== r && g.setFieldsValue({
      noteLocation: r
    });
  }, [r]), he(() => {
    i && (g == null ? void 0 : g.getFieldValue("noteField")) !== i && g.setFieldsValue({
      noteField: i
    });
  }, [i]), /* @__PURE__ */ c.createElement("div", { className: G("notes-sidebar-create-wrapper", _), style: S }, /* @__PURE__ */ c.createElement(
    Fs,
    {
      title: n.title,
      className: "dark-header",
      suffixContent: /* @__PURE__ */ c.createElement("button", { className: "dark-header__closeBtn", onClick: () => o == null ? void 0 : o() }, /* @__PURE__ */ c.createElement(Oi, null))
    }
  ), /* @__PURE__ */ c.createElement(tt, { onSubmit: K, className: "notes-sidebar-create" }, /* @__PURE__ */ c.createElement("div", { className: "notes-sidebar-create__inner" }, /* @__PURE__ */ c.createElement("div", { className: "notes-sidebar-create__inner_wrapper" }, /* @__PURE__ */ c.createElement("div", { className: "notes-sidebar-create__input" }, /* @__PURE__ */ c.createElement("label", { htmlFor: "note-text" }, n.noteTextLabel), /* @__PURE__ */ c.createElement(tt.Item, null, g.getFieldDecorator("noteText", {
    rules: [
      { required: !0, message: n.noteTextPlaceholder },
      { max: A, message: n.noteTextMaxLengthError }
    ],
    initialValue: (t == null ? void 0 : t.noteText) || ""
  })(
    /* @__PURE__ */ c.createElement(
      mi.TextArea,
      {
        rows: 4,
        id: "note-text",
        placeholder: n.noteTextPlaceholder,
        disabled: I.text || s
      }
    )
  ))), /* @__PURE__ */ c.createElement("div", { className: "notes-sidebar-create__input" }, /* @__PURE__ */ c.createElement("label", null, n.mediaLabel), /* @__PURE__ */ c.createElement("div", { className: "notes-sidebar-create__input__upload" }, /* @__PURE__ */ c.createElement(
    "button",
    {
      onClick: (F) => {
        var V;
        (V = P.current) == null || V.click(), F.preventDefault();
      },
      className: "notes-sidebar-create__input__uploadBtn"
    },
    /* @__PURE__ */ c.createElement(pl, null)
  ), /* @__PURE__ */ c.createElement(
    "input",
    {
      "data-testid": "uploadImage",
      style: { display: "none" },
      ref: P,
      type: "file",
      accept: "image/x-png,image/jpeg",
      multiple: !0,
      onChange: J,
      disabled: I.files || s
    }
  ), L.map((F) => /* @__PURE__ */ c.createElement("div", { key: F.name, className: "notes-sidebar-create__input__uploadedImage" }, /* @__PURE__ */ c.createElement("img", { src: URL.createObjectURL(F) }), /* @__PURE__ */ c.createElement(
    "div",
    {
      onClick: () => q(F),
      className: "notes-sidebar-create__input__uploadedImage-close",
      role: "button",
      tabIndex: 0
    },
    /* @__PURE__ */ c.createElement(Oi, null)
  ))))), /* @__PURE__ */ c.createElement("div", { className: "notes-sidebar-create__input" }, /* @__PURE__ */ c.createElement("label", null, n.tagLabel), /* @__PURE__ */ c.createElement("div", { className: "notes-sidebar-create__tags" }, e.map(({ label: F, value: V }) => /* @__PURE__ */ c.createElement(
    fl,
    {
      key: V,
      value: V,
      checked: Z.findIndex((j) => j === V) >= 0,
      onChange: () => W(V),
      style: { marginBottom: 8 },
      disabled: I.tags || s
    },
    F.toUpperCase()
  )))), /* @__PURE__ */ c.createElement("div", { className: "notes-sidebar-create__input" }, /* @__PURE__ */ c.createElement("label", null, n.locationLabel), /* @__PURE__ */ c.createElement("div", { className: "notes-sidebar-create__split" }, /* @__PURE__ */ c.createElement(tt.Item, null, g.getFieldDecorator("noteLocation", {
    rules: [{ required: !0, message: n.locationError, pattern: Nr }],
    initialValue: (t == null ? void 0 : t.noteLocation) || ""
  })(
    /* @__PURE__ */ c.createElement(
      mi,
      {
        disabled: I.location || s,
        onChange: (F) => {
          const V = F.target.value;
          m && Nr.test(V) && m(F.target.value);
        }
      }
    )
  )), /* @__PURE__ */ c.createElement(tt.Item, null, g.getFieldDecorator("noteField", {
    initialValue: (t == null ? void 0 : t.noteField) || "",
    rules: [{ required: !1 }]
  })(/* @__PURE__ */ c.createElement(mi, { disabled: !0 }))))), /* @__PURE__ */ c.createElement("div", { className: "notes-sidebar-create__input" }, /* @__PURE__ */ c.createElement("label", null, n.dateLabel), /* @__PURE__ */ c.createElement("div", { className: "notes-sidebar-create__split" }, /* @__PURE__ */ c.createElement(tt.Item, null, g.getFieldDecorator("noteDate", {
    initialValue: Re(t == null ? void 0 : t.noteDate) || Re(),
    rules: [{ required: !0 }]
  })(
    /* @__PURE__ */ c.createElement(
      ks,
      {
        style: { width: "100%" },
        format: p,
        dropdownClassName: "notes-sidebar-create__antd-datepicker",
        suffixIcon: /* @__PURE__ */ c.createElement(ml, null),
        allowClear: !1,
        disabledDate: (F) => F && F > Re(),
        showToday: !1,
        disabled: I.date || s
      }
    )
  )))))), /* @__PURE__ */ c.createElement("div", { className: "notes-sidebar-create__footer" }, d && /* @__PURE__ */ c.createElement("div", { className: "notes-sidebar-create__footer__delete" }, /* @__PURE__ */ c.createElement(jt, { onClick: () => h == null ? void 0 : h(), className: "deleteBtn", "data-testid": "sidebar-create-delete-btn" }, /* @__PURE__ */ c.createElement(vl, null), n.delete)), /* @__PURE__ */ c.createElement(jt, { onClick: () => o == null ? void 0 : o() }, n.cancel), /* @__PURE__ */ c.createElement(jt, { htmlType: "submit", className: "submitBtn", loading: s, "data-testid": "sidebar-create-submit-btn" }, n.submit))));
}, Kp = tt.create({ name: "note-create" })(yl), _l = (n) => /* @__PURE__ */ c.createElement("svg", Y({ xmlns: "http://www.w3.org/2000/svg", width: "16", height: "18", fill: "none" }, n), /* @__PURE__ */ c.createElement(
  "path",
  {
    fill: "#696F88",
    fillRule: "evenodd",
    d: "M14 2.25h-.75V.75h-1.5v1.5h-7.5V.75h-1.5v1.5H2c-.825 0-1.5.675-1.5 1.5v12c0 .825.675 1.5 1.5 1.5h12c.825 0 1.5-.675 1.5-1.5v-12c0-.825-.675-1.5-1.5-1.5Zm0 13.5H2V7.5h12v8.25ZM2 6h12V3.75H2V6Z",
    clipRule: "evenodd"
  }
)), Zs = (n) => /* @__PURE__ */ c.createElement("svg", Y({ xmlns: "http://www.w3.org/2000/svg", width: "16", height: "16", fill: "none" }, n), /* @__PURE__ */ c.createElement(
  "path",
  {
    fill: "#696F88",
    fillRule: "evenodd",
    d: "M2 .5h12c.825 0 1.5.675 1.5 1.5v13.5l-3-3H2c-.825 0-1.5-.675-1.5-1.5V2C.5 1.175 1.175.5 2 .5ZM13.123 11l.877.877V2H2v9h11.123Z",
    clipRule: "evenodd"
  }
)), bl = (n) => /* @__PURE__ */ c.createElement("svg", Y({ xmlns: "http://www.w3.org/2000/svg", width: "12", height: "16", fill: "none" }, n), /* @__PURE__ */ c.createElement(
  "path",
  {
    fill: "#696F88",
    fillRule: "evenodd",
    d: "M6 .5A5.246 5.246 0 0 0 .75 5.75C.75 9.688 6 15.5 6 15.5s5.25-5.813 5.25-9.75A5.246 5.246 0 0 0 6 .5ZM2.25 5.75C2.25 3.68 3.93 2 6 2c2.07 0 3.75 1.68 3.75 3.75 0 2.16-2.16 5.393-3.75 7.41-1.56-2.002-3.75-5.272-3.75-7.41Zm1.875 0a1.875 1.875 0 1 1 3.75 0 1.875 1.875 0 0 1-3.75 0Z",
    clipRule: "evenodd"
  }
));
var wl = typeof global == "object" && global && global.Object === Object && global;
const Bs = wl;
var El = typeof self == "object" && self && self.Object === Object && self, Sl = Bs || El || Function("return this")();
const ot = Sl;
var Al = ot.Symbol;
const yt = Al;
var Hs = Object.prototype, xl = Hs.hasOwnProperty, Cl = Hs.toString, on = yt ? yt.toStringTag : void 0;
function Pl(n) {
  var e = xl.call(n, on), t = n[on];
  try {
    n[on] = void 0;
    var i = !0;
  } catch (s) {
  }
  var r = Cl.call(n);
  return i && (e ? n[on] = t : delete n[on]), r;
}
var Tl = Object.prototype, Ol = Tl.toString;
function Il(n) {
  return Ol.call(n);
}
var kl = "[object Null]", Dl = "[object Undefined]", Fr = yt ? yt.toStringTag : void 0;
function Gt(n) {
  return n == null ? n === void 0 ? Dl : kl : Fr && Fr in Object(n) ? Pl(n) : Il(n);
}
function Ut(n) {
  return n != null && typeof n == "object";
}
var Ml = "[object Symbol]";
function Ll(n) {
  return typeof n == "symbol" || Ut(n) && Gt(n) == Ml;
}
function Rl(n, e) {
  for (var t = -1, i = n == null ? 0 : n.length, r = Array(i); ++t < i; )
    r[t] = e(n[t], t, n);
  return r;
}
var zl = Array.isArray;
const Wt = zl;
var Nl = 1 / 0, Zr = yt ? yt.prototype : void 0, Br = Zr ? Zr.toString : void 0;
function Vs(n) {
  if (typeof n == "string")
    return n;
  if (Wt(n))
    return Rl(n, Vs) + "";
  if (Ll(n))
    return Br ? Br.call(n) : "";
  var e = n + "";
  return e == "0" && 1 / n == -Nl ? "-0" : e;
}
function js(n) {
  var e = typeof n;
  return n != null && (e == "object" || e == "function");
}
var Fl = "[object AsyncFunction]", Zl = "[object Function]", Bl = "[object GeneratorFunction]", Hl = "[object Proxy]";
function Us(n) {
  if (!js(n))
    return !1;
  var e = Gt(n);
  return e == Zl || e == Bl || e == Fl || e == Hl;
}
var Vl = ot["__core-js_shared__"];
const vi = Vl;
var Hr = function() {
  var n = /[^.]+$/.exec(vi && vi.keys && vi.keys.IE_PROTO || "");
  return n ? "Symbol(src)_1." + n : "";
}();
function jl(n) {
  return !!Hr && Hr in n;
}
var Ul = Function.prototype, Wl = Ul.toString;
function kt(n) {
  if (n != null) {
    try {
      return Wl.call(n);
    } catch (e) {
    }
    try {
      return n + "";
    } catch (e) {
    }
  }
  return "";
}
var ql = /[\\^$.*+?()[\]{}|]/g, Gl = /^\[object .+?Constructor\]$/, Yl = Function.prototype, $l = Object.prototype, Xl = Yl.toString, Kl = $l.hasOwnProperty, Jl = RegExp(
  "^" + Xl.call(Kl).replace(ql, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
);
function Ql(n) {
  if (!js(n) || jl(n))
    return !1;
  var e = Us(n) ? Jl : Gl;
  return e.test(kt(n));
}
function ec(n, e) {
  return n == null ? void 0 : n[e];
}
function Yt(n, e) {
  var t = ec(n, e);
  return Ql(t) ? t : void 0;
}
var tc = Yt(ot, "WeakMap");
const Ii = tc;
var nc = 9007199254740991, ic = /^(?:0|[1-9]\d*)$/;
function rc(n, e) {
  var t = typeof n;
  return e = e == null ? nc : e, !!e && (t == "number" || t != "symbol" && ic.test(n)) && n > -1 && n % 1 == 0 && n < e;
}
function Ws(n, e) {
  return n === e || n !== n && e !== e;
}
var sc = 9007199254740991;
function qs(n) {
  return typeof n == "number" && n > -1 && n % 1 == 0 && n <= sc;
}
function Gs(n) {
  return n != null && qs(n.length) && !Us(n);
}
var oc = Object.prototype;
function Ys(n) {
  var e = n && n.constructor, t = typeof e == "function" && e.prototype || oc;
  return n === t;
}
function ac(n, e) {
  for (var t = -1, i = Array(n); ++t < n; )
    i[t] = e(t);
  return i;
}
var lc = "[object Arguments]";
function Vr(n) {
  return Ut(n) && Gt(n) == lc;
}
var $s = Object.prototype, cc = $s.hasOwnProperty, uc = $s.propertyIsEnumerable, hc = Vr(function() {
  return arguments;
}()) ? Vr : function(n) {
  return Ut(n) && cc.call(n, "callee") && !uc.call(n, "callee");
};
const Xs = hc;
function dc() {
  return !1;
}
var Ks = typeof exports == "object" && exports && !exports.nodeType && exports, jr = Ks && typeof module == "object" && module && !module.nodeType && module, fc = jr && jr.exports === Ks, Ur = fc ? ot.Buffer : void 0, pc = Ur ? Ur.isBuffer : void 0, mc = pc || dc;
const Vn = mc;
var vc = "[object Arguments]", gc = "[object Array]", yc = "[object Boolean]", _c = "[object Date]", bc = "[object Error]", wc = "[object Function]", Ec = "[object Map]", Sc = "[object Number]", Ac = "[object Object]", xc = "[object RegExp]", Cc = "[object Set]", Pc = "[object String]", Tc = "[object WeakMap]", Oc = "[object ArrayBuffer]", Ic = "[object DataView]", kc = "[object Float32Array]", Dc = "[object Float64Array]", Mc = "[object Int8Array]", Lc = "[object Int16Array]", Rc = "[object Int32Array]", zc = "[object Uint8Array]", Nc = "[object Uint8ClampedArray]", Fc = "[object Uint16Array]", Zc = "[object Uint32Array]", ue = {};
ue[kc] = ue[Dc] = ue[Mc] = ue[Lc] = ue[Rc] = ue[zc] = ue[Nc] = ue[Fc] = ue[Zc] = !0;
ue[vc] = ue[gc] = ue[Oc] = ue[yc] = ue[Ic] = ue[_c] = ue[bc] = ue[wc] = ue[Ec] = ue[Sc] = ue[Ac] = ue[xc] = ue[Cc] = ue[Pc] = ue[Tc] = !1;
function Bc(n) {
  return Ut(n) && qs(n.length) && !!ue[Gt(n)];
}
function Hc(n) {
  return function(e) {
    return n(e);
  };
}
var Js = typeof exports == "object" && exports && !exports.nodeType && exports, dn = Js && typeof module == "object" && module && !module.nodeType && module, Vc = dn && dn.exports === Js, gi = Vc && Bs.process, jc = function() {
  try {
    var n = dn && dn.require && dn.require("util").types;
    return n || gi && gi.binding && gi.binding("util");
  } catch (e) {
  }
}();
const Wr = jc;
var qr = Wr && Wr.isTypedArray, Uc = qr ? Hc(qr) : Bc;
const Vi = Uc;
var Wc = Object.prototype, qc = Wc.hasOwnProperty;
function Gc(n, e) {
  var t = Wt(n), i = !t && Xs(n), r = !t && !i && Vn(n), s = !t && !i && !r && Vi(n), o = t || i || r || s, l = o ? ac(n.length, String) : [], h = l.length;
  for (var d in n)
    (e || qc.call(n, d)) && !(o && // Safari 9 has enumerable `arguments.length` in strict mode.
    (d == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
    r && (d == "offset" || d == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
    s && (d == "buffer" || d == "byteLength" || d == "byteOffset") || // Skip index properties.
    rc(d, h))) && l.push(d);
  return l;
}
function Yc(n, e) {
  return function(t) {
    return n(e(t));
  };
}
var $c = Yc(Object.keys, Object);
const Xc = $c;
var Kc = Object.prototype, Jc = Kc.hasOwnProperty;
function Qs(n) {
  if (!Ys(n))
    return Xc(n);
  var e = [];
  for (var t in Object(n))
    Jc.call(n, t) && t != "constructor" && e.push(t);
  return e;
}
function Qc(n) {
  return Gs(n) ? Gc(n) : Qs(n);
}
var eu = Yt(Object, "create");
const pn = eu;
function tu() {
  this.__data__ = pn ? pn(null) : {}, this.size = 0;
}
function nu(n) {
  var e = this.has(n) && delete this.__data__[n];
  return this.size -= e ? 1 : 0, e;
}
var iu = "__lodash_hash_undefined__", ru = Object.prototype, su = ru.hasOwnProperty;
function ou(n) {
  var e = this.__data__;
  if (pn) {
    var t = e[n];
    return t === iu ? void 0 : t;
  }
  return su.call(e, n) ? e[n] : void 0;
}
var au = Object.prototype, lu = au.hasOwnProperty;
function cu(n) {
  var e = this.__data__;
  return pn ? e[n] !== void 0 : lu.call(e, n);
}
var uu = "__lodash_hash_undefined__";
function hu(n, e) {
  var t = this.__data__;
  return this.size += this.has(n) ? 0 : 1, t[n] = pn && e === void 0 ? uu : e, this;
}
function It(n) {
  var e = -1, t = n == null ? 0 : n.length;
  for (this.clear(); ++e < t; ) {
    var i = n[e];
    this.set(i[0], i[1]);
  }
}
It.prototype.clear = tu;
It.prototype.delete = nu;
It.prototype.get = ou;
It.prototype.has = cu;
It.prototype.set = hu;
function du() {
  this.__data__ = [], this.size = 0;
}
function $n(n, e) {
  for (var t = n.length; t--; )
    if (Ws(n[t][0], e))
      return t;
  return -1;
}
var fu = Array.prototype, pu = fu.splice;
function mu(n) {
  var e = this.__data__, t = $n(e, n);
  if (t < 0)
    return !1;
  var i = e.length - 1;
  return t == i ? e.pop() : pu.call(e, t, 1), --this.size, !0;
}
function vu(n) {
  var e = this.__data__, t = $n(e, n);
  return t < 0 ? void 0 : e[t][1];
}
function gu(n) {
  return $n(this.__data__, n) > -1;
}
function yu(n, e) {
  var t = this.__data__, i = $n(t, n);
  return i < 0 ? (++this.size, t.push([n, e])) : t[i][1] = e, this;
}
function at(n) {
  var e = -1, t = n == null ? 0 : n.length;
  for (this.clear(); ++e < t; ) {
    var i = n[e];
    this.set(i[0], i[1]);
  }
}
at.prototype.clear = du;
at.prototype.delete = mu;
at.prototype.get = vu;
at.prototype.has = gu;
at.prototype.set = yu;
var _u = Yt(ot, "Map");
const mn = _u;
function bu() {
  this.size = 0, this.__data__ = {
    hash: new It(),
    map: new (mn || at)(),
    string: new It()
  };
}
function wu(n) {
  var e = typeof n;
  return e == "string" || e == "number" || e == "symbol" || e == "boolean" ? n !== "__proto__" : n === null;
}
function Xn(n, e) {
  var t = n.__data__;
  return wu(e) ? t[typeof e == "string" ? "string" : "hash"] : t.map;
}
function Eu(n) {
  var e = Xn(this, n).delete(n);
  return this.size -= e ? 1 : 0, e;
}
function Su(n) {
  return Xn(this, n).get(n);
}
function Au(n) {
  return Xn(this, n).has(n);
}
function xu(n, e) {
  var t = Xn(this, n), i = t.size;
  return t.set(n, e), this.size += t.size == i ? 0 : 1, this;
}
function Dt(n) {
  var e = -1, t = n == null ? 0 : n.length;
  for (this.clear(); ++e < t; ) {
    var i = n[e];
    this.set(i[0], i[1]);
  }
}
Dt.prototype.clear = bu;
Dt.prototype.delete = Eu;
Dt.prototype.get = Su;
Dt.prototype.has = Au;
Dt.prototype.set = xu;
function Cu(n) {
  return n == null ? "" : Vs(n);
}
function Pu(n, e) {
  for (var t = -1, i = e.length, r = n.length; ++t < i; )
    n[r + t] = e[t];
  return n;
}
function Tu() {
  this.__data__ = new at(), this.size = 0;
}
function Ou(n) {
  var e = this.__data__, t = e.delete(n);
  return this.size = e.size, t;
}
function Iu(n) {
  return this.__data__.get(n);
}
function ku(n) {
  return this.__data__.has(n);
}
var Du = 200;
function Mu(n, e) {
  var t = this.__data__;
  if (t instanceof at) {
    var i = t.__data__;
    if (!mn || i.length < Du - 1)
      return i.push([n, e]), this.size = ++t.size, this;
    t = this.__data__ = new Dt(i);
  }
  return t.set(n, e), this.size = t.size, this;
}
function gt(n) {
  var e = this.__data__ = new at(n);
  this.size = e.size;
}
gt.prototype.clear = Tu;
gt.prototype.delete = Ou;
gt.prototype.get = Iu;
gt.prototype.has = ku;
gt.prototype.set = Mu;
function Lu(n, e) {
  for (var t = -1, i = n == null ? 0 : n.length, r = 0, s = []; ++t < i; ) {
    var o = n[t];
    e(o, t, n) && (s[r++] = o);
  }
  return s;
}
function Ru() {
  return [];
}
var zu = Object.prototype, Nu = zu.propertyIsEnumerable, Gr = Object.getOwnPropertySymbols, Fu = Gr ? function(n) {
  return n == null ? [] : (n = Object(n), Lu(Gr(n), function(e) {
    return Nu.call(n, e);
  }));
} : Ru;
const Zu = Fu;
function Bu(n, e, t) {
  var i = e(n);
  return Wt(n) ? i : Pu(i, t(n));
}
function Yr(n) {
  return Bu(n, Qc, Zu);
}
var Hu = Yt(ot, "DataView");
const ki = Hu;
var Vu = Yt(ot, "Promise");
const Di = Vu;
var ju = Yt(ot, "Set");
const Mi = ju;
var $r = "[object Map]", Uu = "[object Object]", Xr = "[object Promise]", Kr = "[object Set]", Jr = "[object WeakMap]", Qr = "[object DataView]", Wu = kt(ki), qu = kt(mn), Gu = kt(Di), Yu = kt(Mi), $u = kt(Ii), Pt = Gt;
(ki && Pt(new ki(new ArrayBuffer(1))) != Qr || mn && Pt(new mn()) != $r || Di && Pt(Di.resolve()) != Xr || Mi && Pt(new Mi()) != Kr || Ii && Pt(new Ii()) != Jr) && (Pt = function(n) {
  var e = Gt(n), t = e == Uu ? n.constructor : void 0, i = t ? kt(t) : "";
  if (i)
    switch (i) {
      case Wu:
        return Qr;
      case qu:
        return $r;
      case Gu:
        return Xr;
      case Yu:
        return Kr;
      case $u:
        return Jr;
    }
  return e;
});
const Li = Pt;
var Xu = ot.Uint8Array;
const es = Xu;
var Ku = "__lodash_hash_undefined__";
function Ju(n) {
  return this.__data__.set(n, Ku), this;
}
function Qu(n) {
  return this.__data__.has(n);
}
function jn(n) {
  var e = -1, t = n == null ? 0 : n.length;
  for (this.__data__ = new Dt(); ++e < t; )
    this.add(n[e]);
}
jn.prototype.add = jn.prototype.push = Ju;
jn.prototype.has = Qu;
function eh(n, e) {
  for (var t = -1, i = n == null ? 0 : n.length; ++t < i; )
    if (e(n[t], t, n))
      return !0;
  return !1;
}
function th(n, e) {
  return n.has(e);
}
var nh = 1, ih = 2;
function eo(n, e, t, i, r, s) {
  var o = t & nh, l = n.length, h = e.length;
  if (l != h && !(o && h > l))
    return !1;
  var d = s.get(n), m = s.get(e);
  if (d && m)
    return d == e && m == n;
  var p = -1, _ = !0, g = t & ih ? new jn() : void 0;
  for (s.set(n, e), s.set(e, n); ++p < l; ) {
    var S = n[p], A = e[p];
    if (i)
      var I = o ? i(A, S, p, e, n, s) : i(S, A, p, n, e, s);
    if (I !== void 0) {
      if (I)
        continue;
      _ = !1;
      break;
    }
    if (g) {
      if (!eh(e, function(L, x) {
        if (!th(g, x) && (S === L || r(S, L, t, i, s)))
          return g.push(x);
      })) {
        _ = !1;
        break;
      }
    } else if (!(S === A || r(S, A, t, i, s))) {
      _ = !1;
      break;
    }
  }
  return s.delete(n), s.delete(e), _;
}
function rh(n) {
  var e = -1, t = Array(n.size);
  return n.forEach(function(i, r) {
    t[++e] = [r, i];
  }), t;
}
function sh(n) {
  var e = -1, t = Array(n.size);
  return n.forEach(function(i) {
    t[++e] = i;
  }), t;
}
var oh = 1, ah = 2, lh = "[object Boolean]", ch = "[object Date]", uh = "[object Error]", hh = "[object Map]", dh = "[object Number]", fh = "[object RegExp]", ph = "[object Set]", mh = "[object String]", vh = "[object Symbol]", gh = "[object ArrayBuffer]", yh = "[object DataView]", ts = yt ? yt.prototype : void 0, yi = ts ? ts.valueOf : void 0;
function _h(n, e, t, i, r, s, o) {
  switch (t) {
    case yh:
      if (n.byteLength != e.byteLength || n.byteOffset != e.byteOffset)
        return !1;
      n = n.buffer, e = e.buffer;
    case gh:
      return !(n.byteLength != e.byteLength || !s(new es(n), new es(e)));
    case lh:
    case ch:
    case dh:
      return Ws(+n, +e);
    case uh:
      return n.name == e.name && n.message == e.message;
    case fh:
    case mh:
      return n == e + "";
    case hh:
      var l = rh;
    case ph:
      var h = i & oh;
      if (l || (l = sh), n.size != e.size && !h)
        return !1;
      var d = o.get(n);
      if (d)
        return d == e;
      i |= ah, o.set(n, e);
      var m = eo(l(n), l(e), i, r, s, o);
      return o.delete(n), m;
    case vh:
      if (yi)
        return yi.call(n) == yi.call(e);
  }
  return !1;
}
var bh = 1, wh = Object.prototype, Eh = wh.hasOwnProperty;
function Sh(n, e, t, i, r, s) {
  var o = t & bh, l = Yr(n), h = l.length, d = Yr(e), m = d.length;
  if (h != m && !o)
    return !1;
  for (var p = h; p--; ) {
    var _ = l[p];
    if (!(o ? _ in e : Eh.call(e, _)))
      return !1;
  }
  var g = s.get(n), S = s.get(e);
  if (g && S)
    return g == e && S == n;
  var A = !0;
  s.set(n, e), s.set(e, n);
  for (var I = o; ++p < h; ) {
    _ = l[p];
    var L = n[_], x = e[_];
    if (i)
      var Z = o ? i(x, L, _, e, n, s) : i(L, x, _, n, e, s);
    if (!(Z === void 0 ? L === x || r(L, x, t, i, s) : Z)) {
      A = !1;
      break;
    }
    I || (I = _ == "constructor");
  }
  if (A && !I) {
    var R = n.constructor, P = e.constructor;
    R != P && "constructor" in n && "constructor" in e && !(typeof R == "function" && R instanceof R && typeof P == "function" && P instanceof P) && (A = !1);
  }
  return s.delete(n), s.delete(e), A;
}
var Ah = 1, ns = "[object Arguments]", is = "[object Array]", Fn = "[object Object]", xh = Object.prototype, rs = xh.hasOwnProperty;
function Ch(n, e, t, i, r, s) {
  var o = Wt(n), l = Wt(e), h = o ? is : Li(n), d = l ? is : Li(e);
  h = h == ns ? Fn : h, d = d == ns ? Fn : d;
  var m = h == Fn, p = d == Fn, _ = h == d;
  if (_ && Vn(n)) {
    if (!Vn(e))
      return !1;
    o = !0, m = !1;
  }
  if (_ && !m)
    return s || (s = new gt()), o || Vi(n) ? eo(n, e, t, i, r, s) : _h(n, e, h, t, i, r, s);
  if (!(t & Ah)) {
    var g = m && rs.call(n, "__wrapped__"), S = p && rs.call(e, "__wrapped__");
    if (g || S) {
      var A = g ? n.value() : n, I = S ? e.value() : e;
      return s || (s = new gt()), r(A, I, t, i, s);
    }
  }
  return _ ? (s || (s = new gt()), Sh(n, e, t, i, r, s)) : !1;
}
function to(n, e, t, i, r) {
  return n === e ? !0 : n == null || e == null || !Ut(n) && !Ut(e) ? n !== n && e !== e : Ch(n, e, t, i, to, r);
}
var Ph = "[object Map]", Th = "[object Set]", Oh = Object.prototype, Ih = Oh.hasOwnProperty;
function no(n) {
  if (n == null)
    return !0;
  if (Gs(n) && (Wt(n) || typeof n == "string" || typeof n.splice == "function" || Vn(n) || Vi(n) || Xs(n)))
    return !n.length;
  var e = Li(n);
  if (e == Ph || e == Th)
    return !n.size;
  if (Ys(n))
    return !Qs(n).length;
  for (var t in n)
    if (Ih.call(n, t))
      return !1;
  return !0;
}
function kh(n, e) {
  return to(n, e);
}
var Dh = 0;
function Mh(n) {
  var e = ++Dh;
  return Cu(n) + e;
}
const $ = "notes-card", et = 60, an = 10.2, Lh = ({ iconType: n, iconColor: e = "#515253" }) => n === "property" ? /* @__PURE__ */ c.createElement(bl, { "data-testid": "svg-property-glyph", fill: e }) : n === "task" ? /* @__PURE__ */ c.createElement(_l, { "data-testid": "svg-task-glyph", fill: e }) : n === "comment" ? /* @__PURE__ */ c.createElement(Zs, { "data-testid": "svg-comment-glyph", fill: e }) : null, Ot = ({
  customStyleInfoNote: n,
  reversedCoordinates: e,
  iconColor: t,
  isHeader: i,
  iconType: r,
  text: s
}) => {
  const { theme: o } = ze(), l = G({
    [`${$}__container__info-note`]: r !== "comment",
    [`${$}__container__info-note__comment`]: r === "comment"
  }), h = G({
    [`${$}__container__info-note__text`]: !0,
    [`${$}__container__info-note__text-dark`]: o === "dark",
    [`${$}__container__info-note__comment__isHeader`]: i
  }), d = Ue(() => {
    var _;
    if (!s || no(s))
      return null;
    if (typeof s == "string")
      return s;
    if (!((_ = s == null ? void 0 : s.geometry) != null && _.coordinates.length))
      return;
    let m, p;
    return e ? [m, p] = s.geometry.coordinates : [p, m] = s.geometry.coordinates, `${m == null ? void 0 : m.toFixed(6)}, ${p == null ? void 0 : p.toFixed(6)}`;
  }, [s]);
  return d ? /* @__PURE__ */ c.createElement("div", { "data-testid": `info-note-container-${r}`, className: l }, /* @__PURE__ */ c.createElement(
    "div",
    {
      className: G(`${$}__container__info-note__svg`, {
        [`${$}__container__info-note__svg-dark`]: o === "dark"
      })
    },
    /* @__PURE__ */ c.createElement(Lh, { iconType: r, iconColor: t })
  ), /* @__PURE__ */ c.createElement("span", { "data-testid": "info-note-span", style: n, className: h }, d)) : null;
};
var st = /* @__PURE__ */ ((n) => (n.VIDEO = "video", n.AUDIO = "audio", n.PICTURES = "pictures", n.DOCUMENTS = "documents", n.OTHER = "other", n))(st || {}), Ri = /* @__PURE__ */ ((n) => (n.POINTS = "points", n.GRID_POLYGON = "grid-polygon", n.AREAS_LABEL = "areas-label", n.AREAS_SOURCE = "areas-source", n.DISEASES_NO_DATA = "diseases-no-data", n))(Ri || {});
const Vt = {
  TODAY: 0,
  LAST_3_DAYS: 3,
  LAST_7_DAYS: 7,
  LAST_14_DAYS: 14,
  LAST_30_DAYS: 30
};
var io = /* @__PURE__ */ ((n) => (n.TODAY = "today", n.LAST_3_DAYS = "lastThreeDays", n.LAST_7_DAYS = "lastSevenDays", n.LAST_14_DAYS = "lastFourteenDays", n.LAST_30_DAYS = "lastThirtyDays", n))(io || {}), qt = {}, Rh = {
  get exports() {
    return qt;
  },
  set exports(n) {
    qt = n;
  }
};
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/
var _i, ss;
function ro() {
  if (ss)
    return _i;
  ss = 1;
  var n = Object.getOwnPropertySymbols, e = Object.prototype.hasOwnProperty, t = Object.prototype.propertyIsEnumerable;
  function i(s) {
    if (s == null)
      throw new TypeError("Object.assign cannot be called with null or undefined");
    return Object(s);
  }
  function r() {
    try {
      if (!Object.assign)
        return !1;
      var s = new String("abc");
      if (s[5] = "de", Object.getOwnPropertyNames(s)[0] === "5")
        return !1;
      for (var o = {}, l = 0; l < 10; l++)
        o["_" + String.fromCharCode(l)] = l;
      var h = Object.getOwnPropertyNames(o).map(function(m) {
        return o[m];
      });
      if (h.join("") !== "0123456789")
        return !1;
      var d = {};
      return "abcdefghijklmnopqrst".split("").forEach(function(m) {
        d[m] = m;
      }), Object.keys(Object.assign({}, d)).join("") === "abcdefghijklmnopqrst";
    } catch (m) {
      return !1;
    }
  }
  return _i = r() ? Object.assign : function(s, o) {
    for (var l, h = i(s), d, m = 1; m < arguments.length; m++) {
      l = Object(arguments[m]);
      for (var p in l)
        e.call(l, p) && (h[p] = l[p]);
      if (n) {
        d = n(l);
        for (var _ = 0; _ < d.length; _++)
          t.call(l, d[_]) && (h[d[_]] = l[d[_]]);
      }
    }
    return h;
  }, _i;
}
/** @license React v16.14.0
 * react-dom-server.browser.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var bi, os;
function zh() {
  if (os)
    return bi;
  os = 1;
  var n = ro(), e = c;
  function t(f) {
    for (var b = "https://reactjs.org/docs/error-decoder.html?invariant=" + f, y = 1; y < arguments.length; y++)
      b += "&args[]=" + encodeURIComponent(arguments[y]);
    return "Minified React error #" + f + "; visit " + b + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
  }
  var i = typeof Symbol == "function" && Symbol.for, r = i ? Symbol.for("react.portal") : 60106, s = i ? Symbol.for("react.fragment") : 60107, o = i ? Symbol.for("react.strict_mode") : 60108, l = i ? Symbol.for("react.profiler") : 60114, h = i ? Symbol.for("react.provider") : 60109, d = i ? Symbol.for("react.context") : 60110, m = i ? Symbol.for("react.concurrent_mode") : 60111, p = i ? Symbol.for("react.forward_ref") : 60112, _ = i ? Symbol.for("react.suspense") : 60113, g = i ? Symbol.for("react.suspense_list") : 60120, S = i ? Symbol.for("react.memo") : 60115, A = i ? Symbol.for("react.lazy") : 60116, I = i ? Symbol.for("react.block") : 60121, L = i ? Symbol.for("react.fundamental") : 60117, x = i ? Symbol.for("react.scope") : 60119;
  function Z(f) {
    if (f._status === -1) {
      f._status = 0;
      var b = f._ctor;
      b = b(), f._result = b, b.then(function(y) {
        f._status === 0 && (y = y.default, f._status = 1, f._result = y);
      }, function(y) {
        f._status === 0 && (f._status = 2, f._result = y);
      });
    }
  }
  function R(f) {
    if (f == null)
      return null;
    if (typeof f == "function")
      return f.displayName || f.name || null;
    if (typeof f == "string")
      return f;
    switch (f) {
      case s:
        return "Fragment";
      case r:
        return "Portal";
      case l:
        return "Profiler";
      case o:
        return "StrictMode";
      case _:
        return "Suspense";
      case g:
        return "SuspenseList";
    }
    if (typeof f == "object")
      switch (f.$$typeof) {
        case d:
          return "Context.Consumer";
        case h:
          return "Context.Provider";
        case p:
          var b = f.render;
          return b = b.displayName || b.name || "", f.displayName || (b !== "" ? "ForwardRef(" + b + ")" : "ForwardRef");
        case S:
          return R(f.type);
        case I:
          return R(f.render);
        case A:
          if (f = f._status === 1 ? f._result : null)
            return R(f);
      }
    return null;
  }
  var P = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
  P.hasOwnProperty("ReactCurrentDispatcher") || (P.ReactCurrentDispatcher = { current: null }), P.hasOwnProperty("ReactCurrentBatchConfig") || (P.ReactCurrentBatchConfig = { suspense: null });
  var W = {};
  function K(f, b) {
    for (var y = f._threadCount | 0; y <= b; y++)
      f[y] = f._currentValue2, f._threadCount = y + 1;
  }
  function J(f, b, y, M) {
    if (M && (M = f.contextType, typeof M == "object" && M !== null))
      return K(M, y), M[y];
    if (f = f.contextTypes) {
      y = {};
      for (var H in f)
        y[H] = b[H];
      b = y;
    } else
      b = W;
    return b;
  }
  for (var q = new Uint16Array(16), F = 0; 15 > F; F++)
    q[F] = F + 1;
  q[15] = 0;
  var V = /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/, j = Object.prototype.hasOwnProperty, X = {}, _e = {};
  function re(f) {
    return j.call(_e, f) ? !0 : j.call(X, f) ? !1 : V.test(f) ? _e[f] = !0 : (X[f] = !0, !1);
  }
  function ne(f, b, y, M) {
    if (y !== null && y.type === 0)
      return !1;
    switch (typeof b) {
      case "function":
      case "symbol":
        return !0;
      case "boolean":
        return M ? !1 : y !== null ? !y.acceptsBooleans : (f = f.toLowerCase().slice(0, 5), f !== "data-" && f !== "aria-");
      default:
        return !1;
    }
  }
  function Ae(f, b, y, M) {
    if (b === null || typeof b == "undefined" || ne(f, b, y, M))
      return !0;
    if (M)
      return !1;
    if (y !== null)
      switch (y.type) {
        case 3:
          return !b;
        case 4:
          return b === !1;
        case 5:
          return isNaN(b);
        case 6:
          return isNaN(b) || 1 > b;
      }
    return !1;
  }
  function Q(f, b, y, M, H, z) {
    this.acceptsBooleans = b === 2 || b === 3 || b === 4, this.attributeName = M, this.attributeNamespace = H, this.mustUseProperty = y, this.propertyName = f, this.type = b, this.sanitizeURL = z;
  }
  var ie = {};
  "children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(f) {
    ie[f] = new Q(f, 0, !1, f, null, !1);
  }), [["acceptCharset", "accept-charset"], ["className", "class"], ["htmlFor", "for"], ["httpEquiv", "http-equiv"]].forEach(function(f) {
    var b = f[0];
    ie[b] = new Q(b, 1, !1, f[1], null, !1);
  }), ["contentEditable", "draggable", "spellCheck", "value"].forEach(function(f) {
    ie[f] = new Q(f, 2, !1, f.toLowerCase(), null, !1);
  }), ["autoReverse", "externalResourcesRequired", "focusable", "preserveAlpha"].forEach(function(f) {
    ie[f] = new Q(f, 2, !1, f, null, !1);
  }), "allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(f) {
    ie[f] = new Q(f, 3, !1, f.toLowerCase(), null, !1);
  }), ["checked", "multiple", "muted", "selected"].forEach(function(f) {
    ie[f] = new Q(f, 3, !0, f, null, !1);
  }), ["capture", "download"].forEach(function(f) {
    ie[f] = new Q(f, 4, !1, f, null, !1);
  }), ["cols", "rows", "size", "span"].forEach(function(f) {
    ie[f] = new Q(f, 6, !1, f, null, !1);
  }), ["rowSpan", "start"].forEach(function(f) {
    ie[f] = new Q(f, 5, !1, f.toLowerCase(), null, !1);
  });
  var qe = /[\-:]([a-z])/g;
  function Ne(f) {
    return f[1].toUpperCase();
  }
  "accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(f) {
    var b = f.replace(
      qe,
      Ne
    );
    ie[b] = new Q(b, 1, !1, f, null, !1);
  }), "xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(f) {
    var b = f.replace(qe, Ne);
    ie[b] = new Q(b, 1, !1, f, "http://www.w3.org/1999/xlink", !1);
  }), ["xml:base", "xml:lang", "xml:space"].forEach(function(f) {
    var b = f.replace(qe, Ne);
    ie[b] = new Q(b, 1, !1, f, "http://www.w3.org/XML/1998/namespace", !1);
  }), ["tabIndex", "crossOrigin"].forEach(function(f) {
    ie[f] = new Q(f, 1, !1, f.toLowerCase(), null, !1);
  }), ie.xlinkHref = new Q("xlinkHref", 1, !1, "xlink:href", "http://www.w3.org/1999/xlink", !0), ["src", "href", "action", "formAction"].forEach(function(f) {
    ie[f] = new Q(f, 1, !1, f.toLowerCase(), null, !0);
  });
  var $t = /["'&<>]/;
  function Ge(f) {
    if (typeof f == "boolean" || typeof f == "number")
      return "" + f;
    f = "" + f;
    var b = $t.exec(f);
    if (b) {
      var y = "", M, H = 0;
      for (M = b.index; M < f.length; M++) {
        switch (f.charCodeAt(M)) {
          case 34:
            b = "&quot;";
            break;
          case 38:
            b = "&amp;";
            break;
          case 39:
            b = "&#x27;";
            break;
          case 60:
            b = "&lt;";
            break;
          case 62:
            b = "&gt;";
            break;
          default:
            continue;
        }
        H !== M && (y += f.substring(H, M)), H = M + 1, y += b;
      }
      f = H !== M ? y + f.substring(H, M) : y;
    }
    return f;
  }
  function bn(f, b) {
    var y = ie.hasOwnProperty(f) ? ie[f] : null, M;
    return (M = f !== "style") && (M = y !== null ? y.type === 0 : !(!(2 < f.length) || f[0] !== "o" && f[0] !== "O" || f[1] !== "n" && f[1] !== "N")), M || Ae(f, b, y, !1) ? "" : y !== null ? (f = y.attributeName, M = y.type, M === 3 || M === 4 && b === !0 ? f + '=""' : (y.sanitizeURL && (b = "" + b), f + '="' + (Ge(b) + '"'))) : re(f) ? f + '="' + (Ge(b) + '"') : "";
  }
  function wn(f, b) {
    return f === b && (f !== 0 || 1 / f === 1 / b) || f !== f && b !== b;
  }
  var _t = typeof Object.is == "function" ? Object.is : wn, Fe = null, be = null, ee = null, bt = !1, Xt = !1, Ye = null, nt = 0;
  function Ie() {
    if (Fe === null)
      throw Error(t(321));
    return Fe;
  }
  function Mt() {
    if (0 < nt)
      throw Error(t(312));
    return { memoizedState: null, queue: null, next: null };
  }
  function Je() {
    return ee === null ? be === null ? (bt = !1, be = ee = Mt()) : (bt = !0, ee = be) : ee.next === null ? (bt = !1, ee = ee.next = Mt()) : (bt = !0, ee = ee.next), ee;
  }
  function wt(f, b, y, M) {
    for (; Xt; )
      Xt = !1, nt += 1, ee = null, y = f(b, M);
    return be = Fe = null, nt = 0, ee = Ye = null, y;
  }
  function Kt(f, b) {
    return typeof b == "function" ? b(f) : b;
  }
  function Jt(f, b, y) {
    if (Fe = Ie(), ee = Je(), bt) {
      var M = ee.queue;
      if (b = M.dispatch, Ye !== null && (y = Ye.get(M), y !== void 0)) {
        Ye.delete(M), M = ee.memoizedState;
        do
          M = f(M, y.action), y = y.next;
        while (y !== null);
        return ee.memoizedState = M, [M, b];
      }
      return [ee.memoizedState, b];
    }
    return f = f === Kt ? typeof b == "function" ? b() : b : y !== void 0 ? y(b) : b, ee.memoizedState = f, f = ee.queue = { last: null, dispatch: null }, f = f.dispatch = En.bind(null, Fe, f), [ee.memoizedState, f];
  }
  function En(f, b, y) {
    if (!(25 > nt))
      throw Error(t(301));
    if (f === Fe)
      if (Xt = !0, f = { action: y, next: null }, Ye === null && (Ye = /* @__PURE__ */ new Map()), y = Ye.get(b), y === void 0)
        Ye.set(b, f);
      else {
        for (b = y; b.next !== null; )
          b = b.next;
        b.next = f;
      }
  }
  function it() {
  }
  var Et = 0, Kn = { readContext: function(f) {
    var b = Et;
    return K(f, b), f[b];
  }, useContext: function(f) {
    Ie();
    var b = Et;
    return K(f, b), f[b];
  }, useMemo: function(f, b) {
    if (Fe = Ie(), ee = Je(), b = b === void 0 ? null : b, ee !== null) {
      var y = ee.memoizedState;
      if (y !== null && b !== null) {
        e: {
          var M = y[1];
          if (M === null)
            M = !1;
          else {
            for (var H = 0; H < M.length && H < b.length; H++)
              if (!_t(b[H], M[H])) {
                M = !1;
                break e;
              }
            M = !0;
          }
        }
        if (M)
          return y[0];
      }
    }
    return f = f(), ee.memoizedState = [f, b], f;
  }, useReducer: Jt, useRef: function(f) {
    Fe = Ie(), ee = Je();
    var b = ee.memoizedState;
    return b === null ? (f = { current: f }, ee.memoizedState = f) : b;
  }, useState: function(f) {
    return Jt(Kt, f);
  }, useLayoutEffect: function() {
  }, useCallback: function(f) {
    return f;
  }, useImperativeHandle: it, useEffect: it, useDebugValue: it, useResponder: function(f, b) {
    return { props: b, responder: f };
  }, useDeferredValue: function(f) {
    return Ie(), f;
  }, useTransition: function() {
    return Ie(), [function(f) {
      f();
    }, !1];
  } }, Sn = { html: "http://www.w3.org/1999/xhtml", mathml: "http://www.w3.org/1998/Math/MathML", svg: "http://www.w3.org/2000/svg" };
  function An(f) {
    switch (f) {
      case "svg":
        return "http://www.w3.org/2000/svg";
      case "math":
        return "http://www.w3.org/1998/Math/MathML";
      default:
        return "http://www.w3.org/1999/xhtml";
    }
  }
  var Qt = { area: !0, base: !0, br: !0, col: !0, embed: !0, hr: !0, img: !0, input: !0, keygen: !0, link: !0, meta: !0, param: !0, source: !0, track: !0, wbr: !0 }, xn = n({ menuitem: !0 }, Qt), St = {
    animationIterationCount: !0,
    borderImageOutset: !0,
    borderImageSlice: !0,
    borderImageWidth: !0,
    boxFlex: !0,
    boxFlexGroup: !0,
    boxOrdinalGroup: !0,
    columnCount: !0,
    columns: !0,
    flex: !0,
    flexGrow: !0,
    flexPositive: !0,
    flexShrink: !0,
    flexNegative: !0,
    flexOrder: !0,
    gridArea: !0,
    gridRow: !0,
    gridRowEnd: !0,
    gridRowSpan: !0,
    gridRowStart: !0,
    gridColumn: !0,
    gridColumnEnd: !0,
    gridColumnSpan: !0,
    gridColumnStart: !0,
    fontWeight: !0,
    lineClamp: !0,
    lineHeight: !0,
    opacity: !0,
    order: !0,
    orphans: !0,
    tabSize: !0,
    widows: !0,
    zIndex: !0,
    zoom: !0,
    fillOpacity: !0,
    floodOpacity: !0,
    stopOpacity: !0,
    strokeDasharray: !0,
    strokeDashoffset: !0,
    strokeMiterlimit: !0,
    strokeOpacity: !0,
    strokeWidth: !0
  }, en = ["Webkit", "ms", "Moz", "O"];
  Object.keys(St).forEach(function(f) {
    en.forEach(function(b) {
      b = b + f.charAt(0).toUpperCase() + f.substring(1), St[b] = St[f];
    });
  });
  var Jn = /([A-Z])/g, Cn = /^ms-/, de = e.Children.toArray, pe = P.ReactCurrentDispatcher, Qn = { listing: !0, pre: !0, textarea: !0 }, tn = /^[a-zA-Z][a-zA-Z:_\.\-\d]*$/, Lt = {}, nn = {};
  function ei(f) {
    if (f == null)
      return f;
    var b = "";
    return e.Children.forEach(f, function(y) {
      y != null && (b += y);
    }), b;
  }
  var Pn = Object.prototype.hasOwnProperty, ti = { children: null, dangerouslySetInnerHTML: null, suppressContentEditableWarning: null, suppressHydrationWarning: null };
  function Tn(f, b) {
    if (f === void 0)
      throw Error(t(152, R(b) || "Component"));
  }
  function ni(f, b, y) {
    function M(B, D) {
      var k = D.prototype && D.prototype.isReactComponent, we = J(D, b, y, k), oe = [], te = !1, ce = { isMounted: function() {
        return !1;
      }, enqueueForceUpdate: function() {
        if (oe === null)
          return null;
      }, enqueueReplaceState: function(Ee, zt) {
        te = !0, oe = [zt];
      }, enqueueSetState: function(Ee, zt) {
        if (oe === null)
          return null;
        oe.push(zt);
      } };
      if (k) {
        if (k = new D(B.props, we, ce), typeof D.getDerivedStateFromProps == "function") {
          var ae = D.getDerivedStateFromProps.call(null, B.props, k.state);
          ae != null && (k.state = n({}, k.state, ae));
        }
      } else if (Fe = {}, k = D(
        B.props,
        we,
        ce
      ), k = wt(D, B.props, k, we), k == null || k.render == null) {
        f = k, Tn(f, D);
        return;
      }
      if (k.props = B.props, k.context = we, k.updater = ce, ce = k.state, ce === void 0 && (k.state = ce = null), typeof k.UNSAFE_componentWillMount == "function" || typeof k.componentWillMount == "function")
        if (typeof k.componentWillMount == "function" && typeof D.getDerivedStateFromProps != "function" && k.componentWillMount(), typeof k.UNSAFE_componentWillMount == "function" && typeof D.getDerivedStateFromProps != "function" && k.UNSAFE_componentWillMount(), oe.length) {
          ce = oe;
          var fe = te;
          if (oe = null, te = !1, fe && ce.length === 1)
            k.state = ce[0];
          else {
            ae = fe ? ce[0] : k.state;
            var me = !0;
            for (fe = fe ? 1 : 0; fe < ce.length; fe++) {
              var ge = ce[fe];
              ge = typeof ge == "function" ? ge.call(k, ae, B.props, we) : ge, ge != null && (me ? (me = !1, ae = n({}, ae, ge)) : n(ae, ge));
            }
            k.state = ae;
          }
        } else
          oe = null;
      if (f = k.render(), Tn(f, D), typeof k.getChildContext == "function" && (B = D.childContextTypes, typeof B == "object")) {
        var xe = k.getChildContext();
        for (var ct in xe)
          if (!(ct in B))
            throw Error(t(108, R(D) || "Unknown", ct));
      }
      xe && (b = n({}, b, xe));
    }
    for (; e.isValidElement(f); ) {
      var H = f, z = H.type;
      if (typeof z != "function")
        break;
      M(H, z);
    }
    return { child: f, context: b };
  }
  var lt = function() {
    function f(y, M) {
      e.isValidElement(y) ? y.type !== s ? y = [y] : (y = y.props.children, y = e.isValidElement(y) ? [y] : de(y)) : y = de(y), y = { type: null, domNamespace: Sn.html, children: y, childIndex: 0, context: W, footer: "" };
      var H = q[0];
      if (H === 0) {
        var z = q;
        H = z.length;
        var B = 2 * H;
        if (!(65536 >= B))
          throw Error(t(304));
        var D = new Uint16Array(B);
        for (D.set(z), q = D, q[0] = H + 1, z = H; z < B - 1; z++)
          q[z] = z + 1;
        q[B - 1] = 0;
      } else
        q[0] = q[H];
      this.threadID = H, this.stack = [y], this.exhausted = !1, this.currentSelectValue = null, this.previousWasTextNode = !1, this.makeStaticMarkup = M, this.suspenseDepth = 0, this.contextIndex = -1, this.contextStack = [], this.contextValueStack = [];
    }
    var b = f.prototype;
    return b.destroy = function() {
      if (!this.exhausted) {
        this.exhausted = !0, this.clearProviders();
        var y = this.threadID;
        q[y] = q[0], q[0] = y;
      }
    }, b.pushProvider = function(y) {
      var M = ++this.contextIndex, H = y.type._context, z = this.threadID;
      K(H, z);
      var B = H[z];
      this.contextStack[M] = H, this.contextValueStack[M] = B, H[z] = y.props.value;
    }, b.popProvider = function() {
      var y = this.contextIndex, M = this.contextStack[y], H = this.contextValueStack[y];
      this.contextStack[y] = null, this.contextValueStack[y] = null, this.contextIndex--, M[this.threadID] = H;
    }, b.clearProviders = function() {
      for (var y = this.contextIndex; 0 <= y; y--)
        this.contextStack[y][this.threadID] = this.contextValueStack[y];
    }, b.read = function(y) {
      if (this.exhausted)
        return null;
      var M = Et;
      Et = this.threadID;
      var H = pe.current;
      pe.current = Kn;
      try {
        for (var z = [""], B = !1; z[0].length < y; ) {
          if (this.stack.length === 0) {
            this.exhausted = !0;
            var D = this.threadID;
            q[D] = q[0], q[0] = D;
            break;
          }
          var k = this.stack[this.stack.length - 1];
          if (B || k.childIndex >= k.children.length) {
            var we = k.footer;
            if (we !== "" && (this.previousWasTextNode = !1), this.stack.pop(), k.type === "select")
              this.currentSelectValue = null;
            else if (k.type != null && k.type.type != null && k.type.type.$$typeof === h)
              this.popProvider(k.type);
            else if (k.type === _) {
              this.suspenseDepth--;
              var oe = z.pop();
              if (B) {
                B = !1;
                var te = k.fallbackFrame;
                if (!te)
                  throw Error(t(303));
                this.stack.push(te), z[this.suspenseDepth] += "<!--$!-->";
                continue;
              } else
                z[this.suspenseDepth] += oe;
            }
            z[this.suspenseDepth] += we;
          } else {
            var ce = k.children[k.childIndex++], ae = "";
            try {
              ae += this.render(ce, k.context, k.domNamespace);
            } catch (fe) {
              throw fe != null && typeof fe.then == "function" ? Error(t(294)) : fe;
            } finally {
            }
            z.length <= this.suspenseDepth && z.push(""), z[this.suspenseDepth] += ae;
          }
        }
        return z[0];
      } finally {
        pe.current = H, Et = M;
      }
    }, b.render = function(y, M, H) {
      if (typeof y == "string" || typeof y == "number")
        return H = "" + y, H === "" ? "" : this.makeStaticMarkup ? Ge(H) : this.previousWasTextNode ? "<!-- -->" + Ge(H) : (this.previousWasTextNode = !0, Ge(H));
      if (M = ni(y, M, this.threadID), y = M.child, M = M.context, y === null || y === !1)
        return "";
      if (!e.isValidElement(y)) {
        if (y != null && y.$$typeof != null)
          throw H = y.$$typeof, Error(H === r ? t(257) : t(258, H.toString()));
        return y = de(y), this.stack.push({ type: null, domNamespace: H, children: y, childIndex: 0, context: M, footer: "" }), "";
      }
      var z = y.type;
      if (typeof z == "string")
        return this.renderDOM(y, M, H);
      switch (z) {
        case o:
        case m:
        case l:
        case g:
        case s:
          return y = de(y.props.children), this.stack.push({ type: null, domNamespace: H, children: y, childIndex: 0, context: M, footer: "" }), "";
        case _:
          throw Error(t(294));
      }
      if (typeof z == "object" && z !== null)
        switch (z.$$typeof) {
          case p:
            Fe = {};
            var B = z.render(y.props, y.ref);
            return B = wt(z.render, y.props, B, y.ref), B = de(B), this.stack.push({ type: null, domNamespace: H, children: B, childIndex: 0, context: M, footer: "" }), "";
          case S:
            return y = [e.createElement(z.type, n({ ref: y.ref }, y.props))], this.stack.push({ type: null, domNamespace: H, children: y, childIndex: 0, context: M, footer: "" }), "";
          case h:
            return z = de(y.props.children), H = {
              type: y,
              domNamespace: H,
              children: z,
              childIndex: 0,
              context: M,
              footer: ""
            }, this.pushProvider(y), this.stack.push(H), "";
          case d:
            z = y.type, B = y.props;
            var D = this.threadID;
            return K(z, D), z = de(B.children(z[D])), this.stack.push({ type: y, domNamespace: H, children: z, childIndex: 0, context: M, footer: "" }), "";
          case L:
            throw Error(t(338));
          case A:
            switch (z = y.type, Z(z), z._status) {
              case 1:
                return y = [e.createElement(z._result, n({ ref: y.ref }, y.props))], this.stack.push({ type: null, domNamespace: H, children: y, childIndex: 0, context: M, footer: "" }), "";
              case 2:
                throw z._result;
              default:
                throw Error(t(295));
            }
          case x:
            throw Error(t(343));
        }
      throw Error(t(130, z == null ? z : typeof z, ""));
    }, b.renderDOM = function(y, M, H) {
      var z = y.type.toLowerCase();
      if (!Lt.hasOwnProperty(z)) {
        if (!tn.test(z))
          throw Error(t(65, z));
        Lt[z] = !0;
      }
      var B = y.props;
      if (z === "input")
        B = n({ type: void 0 }, B, { defaultChecked: void 0, defaultValue: void 0, value: B.value != null ? B.value : B.defaultValue, checked: B.checked != null ? B.checked : B.defaultChecked });
      else if (z === "textarea") {
        var D = B.value;
        if (D == null) {
          D = B.defaultValue;
          var k = B.children;
          if (k != null) {
            if (D != null)
              throw Error(t(92));
            if (Array.isArray(k)) {
              if (!(1 >= k.length))
                throw Error(t(93));
              k = k[0];
            }
            D = "" + k;
          }
          D == null && (D = "");
        }
        B = n({}, B, { value: void 0, children: "" + D });
      } else if (z === "select")
        this.currentSelectValue = B.value != null ? B.value : B.defaultValue, B = n({}, B, { value: void 0 });
      else if (z === "option") {
        k = this.currentSelectValue;
        var we = ei(B.children);
        if (k != null) {
          var oe = B.value != null ? B.value + "" : we;
          if (D = !1, Array.isArray(k)) {
            for (var te = 0; te < k.length; te++)
              if ("" + k[te] === oe) {
                D = !0;
                break;
              }
          } else
            D = "" + k === oe;
          B = n(
            { selected: void 0, children: void 0 },
            B,
            { selected: D, children: we }
          );
        }
      }
      if (D = B) {
        if (xn[z] && (D.children != null || D.dangerouslySetInnerHTML != null))
          throw Error(t(137, z, ""));
        if (D.dangerouslySetInnerHTML != null) {
          if (D.children != null)
            throw Error(t(60));
          if (!(typeof D.dangerouslySetInnerHTML == "object" && "__html" in D.dangerouslySetInnerHTML))
            throw Error(t(61));
        }
        if (D.style != null && typeof D.style != "object")
          throw Error(t(62, ""));
      }
      D = B, k = this.makeStaticMarkup, we = this.stack.length === 1, oe = "<" + y.type;
      for (Ee in D)
        if (Pn.call(D, Ee)) {
          var ce = D[Ee];
          if (ce != null) {
            if (Ee === "style") {
              te = void 0;
              var ae = "", fe = "";
              for (te in ce)
                if (ce.hasOwnProperty(te)) {
                  var me = te.indexOf("--") === 0, ge = ce[te];
                  if (ge != null) {
                    if (me)
                      var xe = te;
                    else if (xe = te, nn.hasOwnProperty(xe))
                      xe = nn[xe];
                    else {
                      var ct = xe.replace(Jn, "-$1").toLowerCase().replace(Cn, "-ms-");
                      xe = nn[xe] = ct;
                    }
                    ae += fe + xe + ":", fe = te, me = ge == null || typeof ge == "boolean" || ge === "" ? "" : me || typeof ge != "number" || ge === 0 || St.hasOwnProperty(fe) && St[fe] ? ("" + ge).trim() : ge + "px", ae += me, fe = ";";
                  }
                }
              ce = ae || null;
            }
            te = null;
            e:
              if (me = z, ge = D, me.indexOf("-") === -1)
                me = typeof ge.is == "string";
              else
                switch (me) {
                  case "annotation-xml":
                  case "color-profile":
                  case "font-face":
                  case "font-face-src":
                  case "font-face-uri":
                  case "font-face-format":
                  case "font-face-name":
                  case "missing-glyph":
                    me = !1;
                    break e;
                  default:
                    me = !0;
                }
            me ? ti.hasOwnProperty(Ee) || (te = Ee, te = re(te) && ce != null ? te + '="' + (Ge(ce) + '"') : "") : te = bn(Ee, ce), te && (oe += " " + te);
          }
        }
      k || we && (oe += ' data-reactroot=""');
      var Ee = oe;
      D = "", Qt.hasOwnProperty(z) ? Ee += "/>" : (Ee += ">", D = "</" + y.type + ">");
      e: {
        if (k = B.dangerouslySetInnerHTML, k != null) {
          if (k.__html != null) {
            k = k.__html;
            break e;
          }
        } else if (k = B.children, typeof k == "string" || typeof k == "number") {
          k = Ge(k);
          break e;
        }
        k = null;
      }
      return k != null ? (B = [], Qn.hasOwnProperty(z) && k.charAt(0) === `
` && (Ee += `
`), Ee += k) : B = de(B.children), y = y.type, H = H == null || H === "http://www.w3.org/1999/xhtml" ? An(y) : H === "http://www.w3.org/2000/svg" && y === "foreignObject" ? "http://www.w3.org/1999/xhtml" : H, this.stack.push({ domNamespace: H, type: z, children: B, childIndex: 0, context: M, footer: D }), this.previousWasTextNode = !1, Ee;
    }, f;
  }(), Rt = { renderToString: function(f) {
    f = new lt(f, !1);
    try {
      return f.read(1 / 0);
    } finally {
      f.destroy();
    }
  }, renderToStaticMarkup: function(f) {
    f = new lt(f, !0);
    try {
      return f.read(1 / 0);
    } finally {
      f.destroy();
    }
  }, renderToNodeStream: function() {
    throw Error(t(207));
  }, renderToStaticNodeStream: function() {
    throw Error(t(208));
  }, version: "16.14.0" };
  return bi = Rt.default || Rt, bi;
}
var Un = {}, Nh = {
  get exports() {
    return Un;
  },
  set exports(n) {
    Un = n;
  }
}, wi, as;
function Fh() {
  if (as)
    return wi;
  as = 1;
  var n = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
  return wi = n, wi;
}
var Ei, ls;
function Zh() {
  return ls || (ls = 1, Ei = Function.call.bind(Object.prototype.hasOwnProperty)), Ei;
}
var Si, cs;
function Bh() {
  if (cs)
    return Si;
  cs = 1;
  var n = function() {
  };
  if (process.env.NODE_ENV !== "production") {
    var e = Fh(), t = {}, i = Zh();
    n = function(s) {
      var o = "Warning: " + s;
      typeof console != "undefined" && console.error(o);
      try {
        throw new Error(o);
      } catch (l) {
      }
    };
  }
  function r(s, o, l, h, d) {
    if (process.env.NODE_ENV !== "production") {
      for (var m in s)
        if (i(s, m)) {
          var p;
          try {
            if (typeof s[m] != "function") {
              var _ = Error(
                (h || "React class") + ": " + l + " type `" + m + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof s[m] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`."
              );
              throw _.name = "Invariant Violation", _;
            }
            p = s[m](o, m, h, l, null, e);
          } catch (S) {
            p = S;
          }
          if (p && !(p instanceof Error) && n(
            (h || "React class") + ": type specification of " + l + " `" + m + "` is invalid; the type checker function must return `null` or an `Error` but returned a " + typeof p + ". You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument)."
          ), p instanceof Error && !(p.message in t)) {
            t[p.message] = !0;
            var g = d ? d() : "";
            n(
              "Failed " + l + " type: " + p.message + (g != null ? g : "")
            );
          }
        }
    }
  }
  return r.resetWarningCache = function() {
    process.env.NODE_ENV !== "production" && (t = {});
  }, Si = r, Si;
}
/** @license React v16.14.0
 * react-dom-server.browser.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var us;
function Hh() {
  return us || (us = 1, process.env.NODE_ENV !== "production" && function() {
    var n = c, e = ro(), t = Bh();
    function i(a) {
      for (var u = "https://reactjs.org/docs/error-decoder.html?invariant=" + a, v = 1; v < arguments.length; v++)
        u += "&args[]=" + encodeURIComponent(arguments[v]);
      return "Minified React error #" + a + "; visit " + u + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
    }
    var r = "16.14.0", s = n.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    s.hasOwnProperty("ReactCurrentDispatcher") || (s.ReactCurrentDispatcher = {
      current: null
    }), s.hasOwnProperty("ReactCurrentBatchConfig") || (s.ReactCurrentBatchConfig = {
      suspense: null
    });
    function o(a) {
      {
        for (var u = arguments.length, v = new Array(u > 1 ? u - 1 : 0), w = 1; w < u; w++)
          v[w - 1] = arguments[w];
        h("warn", a, v);
      }
    }
    function l(a) {
      {
        for (var u = arguments.length, v = new Array(u > 1 ? u - 1 : 0), w = 1; w < u; w++)
          v[w - 1] = arguments[w];
        h("error", a, v);
      }
    }
    function h(a, u, v) {
      {
        var w = v.length > 0 && typeof v[v.length - 1] == "string" && v[v.length - 1].indexOf(`
    in`) === 0;
        if (!w) {
          var E = s.ReactDebugCurrentFrame, T = E.getStackAddendum();
          T !== "" && (u += "%s", v = v.concat([T]));
        }
        var O = v.map(function(se) {
          return "" + se;
        });
        O.unshift("Warning: " + u), Function.prototype.apply.call(console[a], console, O);
        try {
          var N = 0, C = "Warning: " + u.replace(/%s/g, function() {
            return v[N++];
          });
          throw new Error(C);
        } catch (se) {
        }
      }
    }
    var d = typeof Symbol == "function" && Symbol.for, m = d ? Symbol.for("react.portal") : 60106, p = d ? Symbol.for("react.fragment") : 60107, _ = d ? Symbol.for("react.strict_mode") : 60108, g = d ? Symbol.for("react.profiler") : 60114, S = d ? Symbol.for("react.provider") : 60109, A = d ? Symbol.for("react.context") : 60110, I = d ? Symbol.for("react.concurrent_mode") : 60111, L = d ? Symbol.for("react.forward_ref") : 60112, x = d ? Symbol.for("react.suspense") : 60113, Z = d ? Symbol.for("react.suspense_list") : 60120, R = d ? Symbol.for("react.memo") : 60115, P = d ? Symbol.for("react.lazy") : 60116, W = d ? Symbol.for("react.block") : 60121, K = d ? Symbol.for("react.fundamental") : 60117, J = d ? Symbol.for("react.scope") : 60119, q = -1, F = 0, V = 1, j = 2;
    function X(a) {
      return a._status === V ? a._result : null;
    }
    function _e(a) {
      if (a._status === q) {
        a._status = F;
        var u = a._ctor, v = u();
        a._result = v, v.then(function(w) {
          if (a._status === F) {
            var E = w.default;
            E === void 0 && l(`lazy: Expected the result of a dynamic import() call. Instead received: %s

Your code should look like: 
  const MyComponent = lazy(() => import('./MyComponent'))`, w), a._status = V, a._result = E;
          }
        }, function(w) {
          a._status === F && (a._status = j, a._result = w);
        });
      }
    }
    function re(a, u, v) {
      var w = u.displayName || u.name || "";
      return a.displayName || (w !== "" ? v + "(" + w + ")" : v);
    }
    function ne(a) {
      if (a == null)
        return null;
      if (typeof a.tag == "number" && l("Received an unexpected object in getComponentName(). This is likely a bug in React. Please file an issue."), typeof a == "function")
        return a.displayName || a.name || null;
      if (typeof a == "string")
        return a;
      switch (a) {
        case p:
          return "Fragment";
        case m:
          return "Portal";
        case g:
          return "Profiler";
        case _:
          return "StrictMode";
        case x:
          return "Suspense";
        case Z:
          return "SuspenseList";
      }
      if (typeof a == "object")
        switch (a.$$typeof) {
          case A:
            return "Context.Consumer";
          case S:
            return "Context.Provider";
          case L:
            return re(a, a.render, "ForwardRef");
          case R:
            return ne(a.type);
          case W:
            return ne(a.render);
          case P: {
            var u = a, v = X(u);
            if (v)
              return ne(v);
            break;
          }
        }
      return null;
    }
    var Ae = /^(.*)[\\\/]/;
    function Q(a, u, v) {
      var w = "";
      if (u) {
        var E = u.fileName, T = E.replace(Ae, "");
        if (/^index\./.test(T)) {
          var O = E.match(Ae);
          if (O) {
            var N = O[1];
            if (N) {
              var C = N.replace(Ae, "");
              T = C + "/" + T;
            }
          }
        }
        w = " (at " + T + ":" + u.lineNumber + ")";
      } else
        v && (w = " (created by " + v + ")");
      return `
    in ` + (a || "Unknown") + w;
    }
    var ie = !1, qe = !1, Ne, $t;
    Ne = s.ReactDebugCurrentFrame, $t = /* @__PURE__ */ new Set();
    var Ge = {};
    Object.freeze(Ge);
    function bn(a, u) {
      var v = a.contextTypes;
      if (!v)
        return Ge;
      var w = {};
      for (var E in v)
        w[E] = u[E];
      return w;
    }
    function wn(a, u, v) {
      t(a, u, v, "Component", Ne.getCurrentStack);
    }
    function _t(a, u) {
      for (var v = a._threadCount | 0; v <= u; v++)
        a[v] = a._currentValue2, a._threadCount = v + 1;
    }
    function Fe(a, u, v, w) {
      if (w) {
        var E = a.contextType;
        if ("contextType" in a) {
          var T = (
            // Allow null for conditional declaration
            E === null || E !== void 0 && E.$$typeof === A && E._context === void 0
          );
          if (!T && !$t.has(a)) {
            $t.add(a);
            var O = "";
            E === void 0 ? O = " However, it is set to undefined. This can be caused by a typo or by mixing up named and default imports. This can also happen due to a circular dependency, so try moving the createContext() call to a separate file." : typeof E != "object" ? O = " However, it is set to a " + typeof E + "." : E.$$typeof === S ? O = " Did you accidentally pass the Context.Provider instead?" : E._context !== void 0 ? O = " Did you accidentally pass the Context.Consumer instead?" : O = " However, it is set to an object with keys {" + Object.keys(E).join(", ") + "}.", l("%s defines an invalid contextType. contextType should point to the Context object returned by React.createContext().%s", ne(a) || "Component", O);
          }
        }
        if (typeof E == "object" && E !== null)
          return _t(E, v), E[v];
        {
          var N = bn(a, u);
          return a.contextTypes && wn(a.contextTypes, N, "context"), N;
        }
      } else {
        var C = bn(a, u);
        return a.contextTypes && wn(a.contextTypes, C, "context"), C;
      }
    }
    for (var be = new Uint16Array(16), ee = 0; ee < 15; ee++)
      be[ee] = ee + 1;
    be[15] = 0;
    function bt() {
      var a = be, u = a.length, v = u * 2;
      if (!(v <= 65536))
        throw Error("Maximum number of concurrent React renderers exceeded. This can happen if you are not properly destroying the Readable provided by React. Ensure that you call .destroy() on it if you no longer want to read from it, and did not read to the end. If you use .pipe() this should be automatic.");
      var w = new Uint16Array(v);
      w.set(a), be = w, be[0] = u + 1;
      for (var E = u; E < v - 1; E++)
        be[E] = E + 1;
      return be[v - 1] = 0, u;
    }
    function Xt() {
      var a = be[0];
      return a === 0 ? bt() : (be[0] = be[a], a);
    }
    function Ye(a) {
      be[a] = be[0], be[0] = a;
    }
    var nt = 0, Ie = 1, Mt = 2, Je = 3, wt = 4, Kt = 5, Jt = 6, En = ":A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD", it = En + "\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040", Et = "data-reactroot", Kn = new RegExp("^[" + En + "][" + it + "]*$"), Sn = Object.prototype.hasOwnProperty, An = {}, Qt = {};
    function xn(a) {
      return Sn.call(Qt, a) ? !0 : Sn.call(An, a) ? !1 : Kn.test(a) ? (Qt[a] = !0, !0) : (An[a] = !0, l("Invalid attribute name: `%s`", a), !1);
    }
    function St(a, u, v) {
      return u !== null ? u.type === nt : v ? !1 : a.length > 2 && (a[0] === "o" || a[0] === "O") && (a[1] === "n" || a[1] === "N");
    }
    function en(a, u, v, w) {
      if (v !== null && v.type === nt)
        return !1;
      switch (typeof u) {
        case "function":
        case "symbol":
          return !0;
        case "boolean": {
          if (w)
            return !1;
          if (v !== null)
            return !v.acceptsBooleans;
          var E = a.toLowerCase().slice(0, 5);
          return E !== "data-" && E !== "aria-";
        }
        default:
          return !1;
      }
    }
    function Jn(a, u, v, w) {
      if (u === null || typeof u == "undefined" || en(a, u, v, w))
        return !0;
      if (w)
        return !1;
      if (v !== null)
        switch (v.type) {
          case Je:
            return !u;
          case wt:
            return u === !1;
          case Kt:
            return isNaN(u);
          case Jt:
            return isNaN(u) || u < 1;
        }
      return !1;
    }
    function Cn(a) {
      return pe.hasOwnProperty(a) ? pe[a] : null;
    }
    function de(a, u, v, w, E, T) {
      this.acceptsBooleans = u === Mt || u === Je || u === wt, this.attributeName = w, this.attributeNamespace = E, this.mustUseProperty = v, this.propertyName = a, this.type = u, this.sanitizeURL = T;
    }
    var pe = {}, Qn = [
      "children",
      "dangerouslySetInnerHTML",
      // TODO: This prevents the assignment of defaultValue to regular
      // elements (not just inputs). Now that ReactDOMInput assigns to the
      // defaultValue property -- do we need this?
      "defaultValue",
      "defaultChecked",
      "innerHTML",
      "suppressContentEditableWarning",
      "suppressHydrationWarning",
      "style"
    ];
    Qn.forEach(function(a) {
      pe[a] = new de(
        a,
        nt,
        !1,
        // mustUseProperty
        a,
        // attributeName
        null,
        // attributeNamespace
        !1
      );
    }), [["acceptCharset", "accept-charset"], ["className", "class"], ["htmlFor", "for"], ["httpEquiv", "http-equiv"]].forEach(function(a) {
      var u = a[0], v = a[1];
      pe[u] = new de(
        u,
        Ie,
        !1,
        // mustUseProperty
        v,
        // attributeName
        null,
        // attributeNamespace
        !1
      );
    }), ["contentEditable", "draggable", "spellCheck", "value"].forEach(function(a) {
      pe[a] = new de(
        a,
        Mt,
        !1,
        // mustUseProperty
        a.toLowerCase(),
        // attributeName
        null,
        // attributeNamespace
        !1
      );
    }), ["autoReverse", "externalResourcesRequired", "focusable", "preserveAlpha"].forEach(function(a) {
      pe[a] = new de(
        a,
        Mt,
        !1,
        // mustUseProperty
        a,
        // attributeName
        null,
        // attributeNamespace
        !1
      );
    }), [
      "allowFullScreen",
      "async",
      // Note: there is a special case that prevents it from being written to the DOM
      // on the client side because the browsers are inconsistent. Instead we call focus().
      "autoFocus",
      "autoPlay",
      "controls",
      "default",
      "defer",
      "disabled",
      "disablePictureInPicture",
      "formNoValidate",
      "hidden",
      "loop",
      "noModule",
      "noValidate",
      "open",
      "playsInline",
      "readOnly",
      "required",
      "reversed",
      "scoped",
      "seamless",
      // Microdata
      "itemScope"
    ].forEach(function(a) {
      pe[a] = new de(
        a,
        Je,
        !1,
        // mustUseProperty
        a.toLowerCase(),
        // attributeName
        null,
        // attributeNamespace
        !1
      );
    }), [
      "checked",
      // Note: `option.selected` is not updated if `select.multiple` is
      // disabled with `removeAttribute`. We have special logic for handling this.
      "multiple",
      "muted",
      "selected"
      // NOTE: if you add a camelCased prop to this list,
      // you'll need to set attributeName to name.toLowerCase()
      // instead in the assignment below.
    ].forEach(function(a) {
      pe[a] = new de(
        a,
        Je,
        !0,
        // mustUseProperty
        a,
        // attributeName
        null,
        // attributeNamespace
        !1
      );
    }), [
      "capture",
      "download"
      // NOTE: if you add a camelCased prop to this list,
      // you'll need to set attributeName to name.toLowerCase()
      // instead in the assignment below.
    ].forEach(function(a) {
      pe[a] = new de(
        a,
        wt,
        !1,
        // mustUseProperty
        a,
        // attributeName
        null,
        // attributeNamespace
        !1
      );
    }), [
      "cols",
      "rows",
      "size",
      "span"
      // NOTE: if you add a camelCased prop to this list,
      // you'll need to set attributeName to name.toLowerCase()
      // instead in the assignment below.
    ].forEach(function(a) {
      pe[a] = new de(
        a,
        Jt,
        !1,
        // mustUseProperty
        a,
        // attributeName
        null,
        // attributeNamespace
        !1
      );
    }), ["rowSpan", "start"].forEach(function(a) {
      pe[a] = new de(
        a,
        Kt,
        !1,
        // mustUseProperty
        a.toLowerCase(),
        // attributeName
        null,
        // attributeNamespace
        !1
      );
    });
    var tn = /[\-\:]([a-z])/g, Lt = function(a) {
      return a[1].toUpperCase();
    };
    [
      "accent-height",
      "alignment-baseline",
      "arabic-form",
      "baseline-shift",
      "cap-height",
      "clip-path",
      "clip-rule",
      "color-interpolation",
      "color-interpolation-filters",
      "color-profile",
      "color-rendering",
      "dominant-baseline",
      "enable-background",
      "fill-opacity",
      "fill-rule",
      "flood-color",
      "flood-opacity",
      "font-family",
      "font-size",
      "font-size-adjust",
      "font-stretch",
      "font-style",
      "font-variant",
      "font-weight",
      "glyph-name",
      "glyph-orientation-horizontal",
      "glyph-orientation-vertical",
      "horiz-adv-x",
      "horiz-origin-x",
      "image-rendering",
      "letter-spacing",
      "lighting-color",
      "marker-end",
      "marker-mid",
      "marker-start",
      "overline-position",
      "overline-thickness",
      "paint-order",
      "panose-1",
      "pointer-events",
      "rendering-intent",
      "shape-rendering",
      "stop-color",
      "stop-opacity",
      "strikethrough-position",
      "strikethrough-thickness",
      "stroke-dasharray",
      "stroke-dashoffset",
      "stroke-linecap",
      "stroke-linejoin",
      "stroke-miterlimit",
      "stroke-opacity",
      "stroke-width",
      "text-anchor",
      "text-decoration",
      "text-rendering",
      "underline-position",
      "underline-thickness",
      "unicode-bidi",
      "unicode-range",
      "units-per-em",
      "v-alphabetic",
      "v-hanging",
      "v-ideographic",
      "v-mathematical",
      "vector-effect",
      "vert-adv-y",
      "vert-origin-x",
      "vert-origin-y",
      "word-spacing",
      "writing-mode",
      "xmlns:xlink",
      "x-height"
      // NOTE: if you add a camelCased prop to this list,
      // you'll need to set attributeName to name.toLowerCase()
      // instead in the assignment below.
    ].forEach(function(a) {
      var u = a.replace(tn, Lt);
      pe[u] = new de(
        u,
        Ie,
        !1,
        // mustUseProperty
        a,
        null,
        // attributeNamespace
        !1
      );
    }), [
      "xlink:actuate",
      "xlink:arcrole",
      "xlink:role",
      "xlink:show",
      "xlink:title",
      "xlink:type"
      // NOTE: if you add a camelCased prop to this list,
      // you'll need to set attributeName to name.toLowerCase()
      // instead in the assignment below.
    ].forEach(function(a) {
      var u = a.replace(tn, Lt);
      pe[u] = new de(
        u,
        Ie,
        !1,
        // mustUseProperty
        a,
        "http://www.w3.org/1999/xlink",
        !1
      );
    }), [
      "xml:base",
      "xml:lang",
      "xml:space"
      // NOTE: if you add a camelCased prop to this list,
      // you'll need to set attributeName to name.toLowerCase()
      // instead in the assignment below.
    ].forEach(function(a) {
      var u = a.replace(tn, Lt);
      pe[u] = new de(
        u,
        Ie,
        !1,
        // mustUseProperty
        a,
        "http://www.w3.org/XML/1998/namespace",
        !1
      );
    }), ["tabIndex", "crossOrigin"].forEach(function(a) {
      pe[a] = new de(
        a,
        Ie,
        !1,
        // mustUseProperty
        a.toLowerCase(),
        // attributeName
        null,
        // attributeNamespace
        !1
      );
    });
    var nn = "xlinkHref";
    pe[nn] = new de(
      "xlinkHref",
      Ie,
      !1,
      // mustUseProperty
      "xlink:href",
      "http://www.w3.org/1999/xlink",
      !0
    ), ["src", "href", "action", "formAction"].forEach(function(a) {
      pe[a] = new de(
        a,
        Ie,
        !1,
        // mustUseProperty
        a.toLowerCase(),
        // attributeName
        null,
        // attributeNamespace
        !0
      );
    }), s.ReactDebugCurrentFrame;
    var ei = /^[\u0000-\u001F ]*j[\r\n\t]*a[\r\n\t]*v[\r\n\t]*a[\r\n\t]*s[\r\n\t]*c[\r\n\t]*r[\r\n\t]*i[\r\n\t]*p[\r\n\t]*t[\r\n\t]*\:/i, Pn = !1;
    function ti(a) {
      !Pn && ei.test(a) && (Pn = !0, l("A future version of React will block javascript: URLs as a security precaution. Use event handlers instead if you can. If you need to generate unsafe HTML try using dangerouslySetInnerHTML instead. React was passed %s.", JSON.stringify(a)));
    }
    var Tn = /["'&<>]/;
    function ni(a) {
      var u = "" + a, v = Tn.exec(u);
      if (!v)
        return u;
      var w, E = "", T, O = 0;
      for (T = v.index; T < u.length; T++) {
        switch (u.charCodeAt(T)) {
          case 34:
            w = "&quot;";
            break;
          case 38:
            w = "&amp;";
            break;
          case 39:
            w = "&#x27;";
            break;
          case 60:
            w = "&lt;";
            break;
          case 62:
            w = "&gt;";
            break;
          default:
            continue;
        }
        O !== T && (E += u.substring(O, T)), O = T + 1, E += w;
      }
      return O !== T ? E + u.substring(O, T) : E;
    }
    function lt(a) {
      return typeof a == "boolean" || typeof a == "number" ? "" + a : ni(a);
    }
    function Rt(a) {
      return '"' + lt(a) + '"';
    }
    function f() {
      return Et + '=""';
    }
    function b(a, u) {
      var v = Cn(a);
      if (a !== "style" && St(a, v, !1) || Jn(a, u, v, !1))
        return "";
      if (v !== null) {
        var w = v.attributeName, E = v.type;
        return E === Je || E === wt && u === !0 ? w + '=""' : (v.sanitizeURL && (u = "" + u, ti(u)), w + "=" + Rt(u));
      } else if (xn(a))
        return a + "=" + Rt(u);
      return "";
    }
    function y(a, u) {
      return !xn(a) || u == null ? "" : a + "=" + Rt(u);
    }
    function M(a, u) {
      return a === u && (a !== 0 || 1 / a === 1 / u) || a !== a && u !== u;
    }
    var H = typeof Object.is == "function" ? Object.is : M, z = null, B = null, D = null, k = !1, we = !1, oe = null, te = 0, ce = 25, ae = !1, fe;
    function me() {
      if (z === null)
        throw Error(`Invalid hook call. Hooks can only be called inside of the body of a function component. This could happen for one of the following reasons:
1. You might have mismatching versions of React and the renderer (such as React DOM)
2. You might be breaking the Rules of Hooks
3. You might have more than one copy of React in the same app
See https://fb.me/react-invalid-hook-call for tips about how to debug and fix this problem.`);
      return ae && l("Do not call Hooks inside useEffect(...), useMemo(...), or other built-in Hooks. You can only call Hooks at the top level of your React function. For more information, see https://fb.me/rules-of-hooks"), z;
    }
    function ge(a, u) {
      if (u === null)
        return l("%s received a final argument during this render, but not during the previous render. Even though the final argument is optional, its type cannot change between renders.", fe), !1;
      a.length !== u.length && l(`The final argument passed to %s changed size between renders. The order and size of this array must remain constant.

Previous: %s
Incoming: %s`, fe, "[" + a.join(", ") + "]", "[" + u.join(", ") + "]");
      for (var v = 0; v < u.length && v < a.length; v++)
        if (!H(a[v], u[v]))
          return !1;
      return !0;
    }
    function xe() {
      if (te > 0)
        throw Error("Rendered more hooks than during the previous render");
      return {
        memoizedState: null,
        queue: null,
        next: null
      };
    }
    function ct() {
      return D === null ? B === null ? (k = !1, B = D = xe()) : (k = !0, D = B) : D.next === null ? (k = !1, D = D.next = xe()) : (k = !0, D = D.next), D;
    }
    function Ee(a) {
      z = a, ae = !1;
    }
    function zt(a, u, v, w) {
      for (; we; )
        we = !1, te += 1, D = null, v = a(u, w);
      return z = null, B = null, te = 0, oe = null, D = null, ae = !1, v;
    }
    function Ro(a, u) {
      var v = On;
      return _t(a, v), ae && l("Context can only be read while React is rendering. In classes, you can read it in the render method or getDerivedStateFromProps. In function components, you can read it directly in the function body, but not inside Hooks like useReducer() or useMemo()."), a[v];
    }
    function zo(a, u) {
      fe = "useContext", me();
      var v = On;
      return _t(a, v), a[v];
    }
    function ii(a, u) {
      return typeof u == "function" ? u(a) : u;
    }
    function No(a) {
      return fe = "useState", Wi(
        ii,
        // useReducer has a special case to support lazy useState initializers
        a
      );
    }
    function Wi(a, u, v) {
      if (a !== ii && (fe = "useReducer"), z = me(), D = ct(), k) {
        var w = D.queue, E = w.dispatch;
        if (oe !== null) {
          var T = oe.get(w);
          if (T !== void 0) {
            oe.delete(w);
            var O = D.memoizedState, N = T;
            do {
              var C = N.action;
              ae = !0, O = a(O, C), ae = !1, N = N.next;
            } while (N !== null);
            return D.memoizedState = O, [O, E];
          }
        }
        return [D.memoizedState, E];
      } else {
        ae = !0;
        var se;
        a === ii ? se = typeof u == "function" ? u() : u : se = v !== void 0 ? v(u) : u, ae = !1, D.memoizedState = se;
        var ve = D.queue = {
          last: null,
          dispatch: null
        }, Se = ve.dispatch = Ho.bind(null, z, ve);
        return [D.memoizedState, Se];
      }
    }
    function Fo(a, u) {
      z = me(), D = ct();
      var v = u === void 0 ? null : u;
      if (D !== null) {
        var w = D.memoizedState;
        if (w !== null && v !== null) {
          var E = w[1];
          if (ge(v, E))
            return w[0];
        }
      }
      ae = !0;
      var T = a();
      return ae = !1, D.memoizedState = [T, v], T;
    }
    function Zo(a) {
      z = me(), D = ct();
      var u = D.memoizedState;
      if (u === null) {
        var v = {
          current: a
        };
        return Object.seal(v), D.memoizedState = v, v;
      } else
        return u;
    }
    function Bo(a, u) {
      fe = "useLayoutEffect", l("useLayoutEffect does nothing on the server, because its effect cannot be encoded into the server renderer's output format. This will lead to a mismatch between the initial, non-hydrated UI and the intended UI. To avoid this, useLayoutEffect should only be used in components that render exclusively on the client. See https://fb.me/react-uselayouteffect-ssr for common fixes.");
    }
    function Ho(a, u, v) {
      if (!(te < ce))
        throw Error("Too many re-renders. React limits the number of renders to prevent an infinite loop.");
      if (a === z) {
        we = !0;
        var w = {
          action: v,
          next: null
        };
        oe === null && (oe = /* @__PURE__ */ new Map());
        var E = oe.get(u);
        if (E === void 0)
          oe.set(u, w);
        else {
          for (var T = E; T.next !== null; )
            T = T.next;
          T.next = w;
        }
      }
    }
    function Vo(a, u) {
      return a;
    }
    function jo(a, u) {
      return {
        props: u,
        responder: a
      };
    }
    function Uo(a, u) {
      return me(), a;
    }
    function Wo(a) {
      me();
      var u = function(v) {
        v();
      };
      return [u, !1];
    }
    function ri() {
    }
    var On = 0;
    function qi(a) {
      On = a;
    }
    var qo = {
      readContext: Ro,
      useContext: zo,
      useMemo: Fo,
      useReducer: Wi,
      useRef: Zo,
      useState: No,
      useLayoutEffect: Bo,
      useCallback: Vo,
      // useImperativeHandle is not run in the server environment
      useImperativeHandle: ri,
      // Effects are not run in the server environment.
      useEffect: ri,
      // Debugging effect
      useDebugValue: ri,
      useResponder: jo,
      useDeferredValue: Uo,
      useTransition: Wo
    }, In = "http://www.w3.org/1999/xhtml", Gi = "http://www.w3.org/1998/Math/MathML", si = "http://www.w3.org/2000/svg", oi = {
      html: In,
      mathml: Gi,
      svg: si
    };
    function Yi(a) {
      switch (a) {
        case "svg":
          return si;
        case "math":
          return Gi;
        default:
          return In;
      }
    }
    function Go(a, u) {
      return a == null || a === In ? Yi(u) : a === si && u === "foreignObject" ? In : a;
    }
    var $i = null, kn = {
      checkPropTypes: null
    };
    {
      $i = s.ReactDebugCurrentFrame;
      var Yo = {
        button: !0,
        checkbox: !0,
        image: !0,
        hidden: !0,
        radio: !0,
        reset: !0,
        submit: !0
      }, $o = {
        value: function(a, u, v) {
          return Yo[a.type] || a.onChange || a.readOnly || a.disabled || a[u] == null || qe ? null : new Error("You provided a `value` prop to a form field without an `onChange` handler. This will render a read-only field. If the field should be mutable use `defaultValue`. Otherwise, set either `onChange` or `readOnly`.");
        },
        checked: function(a, u, v) {
          return a.onChange || a.readOnly || a.disabled || a[u] == null || qe ? null : new Error("You provided a `checked` prop to a form field without an `onChange` handler. This will render a read-only field. If the field should be mutable use `defaultChecked`. Otherwise, set either `onChange` or `readOnly`.");
        }
      };
      kn.checkPropTypes = function(a, u) {
        t($o, u, "prop", a, $i.getStackAddendum);
      };
    }
    var Xi = {
      area: !0,
      base: !0,
      br: !0,
      col: !0,
      embed: !0,
      hr: !0,
      img: !0,
      input: !0,
      keygen: !0,
      link: !0,
      meta: !0,
      param: !0,
      source: !0,
      track: !0,
      wbr: !0
      // NOTE: menuitem's close tag should be omitted, but that causes problems.
    }, Xo = e({
      menuitem: !0
    }, Xi), Ko = "__html", ai = null;
    ai = s.ReactDebugCurrentFrame;
    function Jo(a, u) {
      if (u) {
        if (Xo[a] && !(u.children == null && u.dangerouslySetInnerHTML == null))
          throw Error(a + " is a void element tag and must neither have `children` nor use `dangerouslySetInnerHTML`." + ai.getStackAddendum());
        if (u.dangerouslySetInnerHTML != null) {
          if (u.children != null)
            throw Error("Can only set one of `children` or `props.dangerouslySetInnerHTML`.");
          if (!(typeof u.dangerouslySetInnerHTML == "object" && Ko in u.dangerouslySetInnerHTML))
            throw Error("`props.dangerouslySetInnerHTML` must be in the form `{__html: ...}`. Please visit https://fb.me/react-invariant-dangerously-set-inner-html for more information.");
        }
        if (!u.suppressContentEditableWarning && u.contentEditable && u.children != null && l("A component is `contentEditable` and contains `children` managed by React. It is now your responsibility to guarantee that none of those nodes are unexpectedly modified or duplicated. This is probably not intentional."), !(u.style == null || typeof u.style == "object"))
          throw Error("The `style` prop expects a mapping from style properties to values, not a string. For example, style={{marginRight: spacing + 'em'}} when using JSX." + ai.getStackAddendum());
      }
    }
    var rn = {
      animationIterationCount: !0,
      borderImageOutset: !0,
      borderImageSlice: !0,
      borderImageWidth: !0,
      boxFlex: !0,
      boxFlexGroup: !0,
      boxOrdinalGroup: !0,
      columnCount: !0,
      columns: !0,
      flex: !0,
      flexGrow: !0,
      flexPositive: !0,
      flexShrink: !0,
      flexNegative: !0,
      flexOrder: !0,
      gridArea: !0,
      gridRow: !0,
      gridRowEnd: !0,
      gridRowSpan: !0,
      gridRowStart: !0,
      gridColumn: !0,
      gridColumnEnd: !0,
      gridColumnSpan: !0,
      gridColumnStart: !0,
      fontWeight: !0,
      lineClamp: !0,
      lineHeight: !0,
      opacity: !0,
      order: !0,
      orphans: !0,
      tabSize: !0,
      widows: !0,
      zIndex: !0,
      zoom: !0,
      // SVG-related properties
      fillOpacity: !0,
      floodOpacity: !0,
      stopOpacity: !0,
      strokeDasharray: !0,
      strokeDashoffset: !0,
      strokeMiterlimit: !0,
      strokeOpacity: !0,
      strokeWidth: !0
    };
    function Qo(a, u) {
      return a + u.charAt(0).toUpperCase() + u.substring(1);
    }
    var ea = ["Webkit", "ms", "Moz", "O"];
    Object.keys(rn).forEach(function(a) {
      ea.forEach(function(u) {
        rn[Qo(u, a)] = rn[a];
      });
    });
    function ta(a, u, v) {
      var w = u == null || typeof u == "boolean" || u === "";
      return w ? "" : !v && typeof u == "number" && u !== 0 && !(rn.hasOwnProperty(a) && rn[a]) ? u + "px" : ("" + u).trim();
    }
    var na = /([A-Z])/g, ia = /^ms-/;
    function ra(a) {
      return a.replace(na, "-$1").toLowerCase().replace(ia, "-ms-");
    }
    function li(a, u) {
      if (a.indexOf("-") === -1)
        return typeof u.is == "string";
      switch (a) {
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
          return !1;
        default:
          return !0;
      }
    }
    var Ki = function() {
    };
    {
      var sa = /^(?:webkit|moz|o)[A-Z]/, oa = /^-ms-/, aa = /-(.)/g, Ji = /;\s*$/, Nt = {}, ci = {}, Qi = !1, er = !1, la = function(a) {
        return a.replace(aa, function(u, v) {
          return v.toUpperCase();
        });
      }, ca = function(a) {
        Nt.hasOwnProperty(a) && Nt[a] || (Nt[a] = !0, l(
          "Unsupported style property %s. Did you mean %s?",
          a,
          // As Andi Smith suggests
          // (http://www.andismith.com/blog/2012/02/modernizr-prefixed/), an `-ms` prefix
          // is converted to lowercase `ms`.
          la(a.replace(oa, "ms-"))
        ));
      }, ua = function(a) {
        Nt.hasOwnProperty(a) && Nt[a] || (Nt[a] = !0, l("Unsupported vendor-prefixed style property %s. Did you mean %s?", a, a.charAt(0).toUpperCase() + a.slice(1)));
      }, ha = function(a, u) {
        ci.hasOwnProperty(u) && ci[u] || (ci[u] = !0, l(`Style property values shouldn't contain a semicolon. Try "%s: %s" instead.`, a, u.replace(Ji, "")));
      }, da = function(a, u) {
        Qi || (Qi = !0, l("`NaN` is an invalid value for the `%s` css style property.", a));
      }, fa = function(a, u) {
        er || (er = !0, l("`Infinity` is an invalid value for the `%s` css style property.", a));
      };
      Ki = function(a, u) {
        a.indexOf("-") > -1 ? ca(a) : sa.test(a) ? ua(a) : Ji.test(u) && ha(a, u), typeof u == "number" && (isNaN(u) ? da(a, u) : isFinite(u) || fa(a, u));
      };
    }
    var pa = Ki, tr = {
      "aria-current": 0,
      // state
      "aria-details": 0,
      "aria-disabled": 0,
      // state
      "aria-hidden": 0,
      // state
      "aria-invalid": 0,
      // state
      "aria-keyshortcuts": 0,
      "aria-label": 0,
      "aria-roledescription": 0,
      // Widget Attributes
      "aria-autocomplete": 0,
      "aria-checked": 0,
      "aria-expanded": 0,
      "aria-haspopup": 0,
      "aria-level": 0,
      "aria-modal": 0,
      "aria-multiline": 0,
      "aria-multiselectable": 0,
      "aria-orientation": 0,
      "aria-placeholder": 0,
      "aria-pressed": 0,
      "aria-readonly": 0,
      "aria-required": 0,
      "aria-selected": 0,
      "aria-sort": 0,
      "aria-valuemax": 0,
      "aria-valuemin": 0,
      "aria-valuenow": 0,
      "aria-valuetext": 0,
      // Live Region Attributes
      "aria-atomic": 0,
      "aria-busy": 0,
      "aria-live": 0,
      "aria-relevant": 0,
      // Drag-and-Drop Attributes
      "aria-dropeffect": 0,
      "aria-grabbed": 0,
      // Relationship Attributes
      "aria-activedescendant": 0,
      "aria-colcount": 0,
      "aria-colindex": 0,
      "aria-colspan": 0,
      "aria-controls": 0,
      "aria-describedby": 0,
      "aria-errormessage": 0,
      "aria-flowto": 0,
      "aria-labelledby": 0,
      "aria-owns": 0,
      "aria-posinset": 0,
      "aria-rowcount": 0,
      "aria-rowindex": 0,
      "aria-rowspan": 0,
      "aria-setsize": 0
    }, Ft = {}, ma = new RegExp("^(aria)-[" + it + "]*$"), va = new RegExp("^(aria)[A-Z][" + it + "]*$"), ga = Object.prototype.hasOwnProperty;
    function ya(a, u) {
      {
        if (ga.call(Ft, u) && Ft[u])
          return !0;
        if (va.test(u)) {
          var v = "aria-" + u.slice(4).toLowerCase(), w = tr.hasOwnProperty(v) ? v : null;
          if (w == null)
            return l("Invalid ARIA attribute `%s`. ARIA attributes follow the pattern aria-* and must be lowercase.", u), Ft[u] = !0, !0;
          if (u !== w)
            return l("Invalid ARIA attribute `%s`. Did you mean `%s`?", u, w), Ft[u] = !0, !0;
        }
        if (ma.test(u)) {
          var E = u.toLowerCase(), T = tr.hasOwnProperty(E) ? E : null;
          if (T == null)
            return Ft[u] = !0, !1;
          if (u !== T)
            return l("Unknown ARIA attribute `%s`. Did you mean `%s`?", u, T), Ft[u] = !0, !0;
        }
      }
      return !0;
    }
    function _a(a, u) {
      {
        var v = [];
        for (var w in u) {
          var E = ya(a, w);
          E || v.push(w);
        }
        var T = v.map(function(O) {
          return "`" + O + "`";
        }).join(", ");
        v.length === 1 ? l("Invalid aria prop %s on <%s> tag. For details, see https://fb.me/invalid-aria-prop", T, a) : v.length > 1 && l("Invalid aria props %s on <%s> tag. For details, see https://fb.me/invalid-aria-prop", T, a);
      }
    }
    function ba(a, u) {
      li(a, u) || _a(a, u);
    }
    var nr = !1;
    function wa(a, u) {
      {
        if (a !== "input" && a !== "textarea" && a !== "select")
          return;
        u != null && u.value === null && !nr && (nr = !0, a === "select" && u.multiple ? l("`value` prop on `%s` should not be null. Consider using an empty array when `multiple` is set to `true` to clear the component or `undefined` for uncontrolled components.", a) : l("`value` prop on `%s` should not be null. Consider using an empty string to clear the component or `undefined` for uncontrolled components.", a));
      }
    }
    var Ea = {}, ir = {}, rr = {
      // HTML
      accept: "accept",
      acceptcharset: "acceptCharset",
      "accept-charset": "acceptCharset",
      accesskey: "accessKey",
      action: "action",
      allowfullscreen: "allowFullScreen",
      alt: "alt",
      as: "as",
      async: "async",
      autocapitalize: "autoCapitalize",
      autocomplete: "autoComplete",
      autocorrect: "autoCorrect",
      autofocus: "autoFocus",
      autoplay: "autoPlay",
      autosave: "autoSave",
      capture: "capture",
      cellpadding: "cellPadding",
      cellspacing: "cellSpacing",
      challenge: "challenge",
      charset: "charSet",
      checked: "checked",
      children: "children",
      cite: "cite",
      class: "className",
      classid: "classID",
      classname: "className",
      cols: "cols",
      colspan: "colSpan",
      content: "content",
      contenteditable: "contentEditable",
      contextmenu: "contextMenu",
      controls: "controls",
      controlslist: "controlsList",
      coords: "coords",
      crossorigin: "crossOrigin",
      dangerouslysetinnerhtml: "dangerouslySetInnerHTML",
      data: "data",
      datetime: "dateTime",
      default: "default",
      defaultchecked: "defaultChecked",
      defaultvalue: "defaultValue",
      defer: "defer",
      dir: "dir",
      disabled: "disabled",
      disablepictureinpicture: "disablePictureInPicture",
      download: "download",
      draggable: "draggable",
      enctype: "encType",
      for: "htmlFor",
      form: "form",
      formmethod: "formMethod",
      formaction: "formAction",
      formenctype: "formEncType",
      formnovalidate: "formNoValidate",
      formtarget: "formTarget",
      frameborder: "frameBorder",
      headers: "headers",
      height: "height",
      hidden: "hidden",
      high: "high",
      href: "href",
      hreflang: "hrefLang",
      htmlfor: "htmlFor",
      httpequiv: "httpEquiv",
      "http-equiv": "httpEquiv",
      icon: "icon",
      id: "id",
      innerhtml: "innerHTML",
      inputmode: "inputMode",
      integrity: "integrity",
      is: "is",
      itemid: "itemID",
      itemprop: "itemProp",
      itemref: "itemRef",
      itemscope: "itemScope",
      itemtype: "itemType",
      keyparams: "keyParams",
      keytype: "keyType",
      kind: "kind",
      label: "label",
      lang: "lang",
      list: "list",
      loop: "loop",
      low: "low",
      manifest: "manifest",
      marginwidth: "marginWidth",
      marginheight: "marginHeight",
      max: "max",
      maxlength: "maxLength",
      media: "media",
      mediagroup: "mediaGroup",
      method: "method",
      min: "min",
      minlength: "minLength",
      multiple: "multiple",
      muted: "muted",
      name: "name",
      nomodule: "noModule",
      nonce: "nonce",
      novalidate: "noValidate",
      open: "open",
      optimum: "optimum",
      pattern: "pattern",
      placeholder: "placeholder",
      playsinline: "playsInline",
      poster: "poster",
      preload: "preload",
      profile: "profile",
      radiogroup: "radioGroup",
      readonly: "readOnly",
      referrerpolicy: "referrerPolicy",
      rel: "rel",
      required: "required",
      reversed: "reversed",
      role: "role",
      rows: "rows",
      rowspan: "rowSpan",
      sandbox: "sandbox",
      scope: "scope",
      scoped: "scoped",
      scrolling: "scrolling",
      seamless: "seamless",
      selected: "selected",
      shape: "shape",
      size: "size",
      sizes: "sizes",
      span: "span",
      spellcheck: "spellCheck",
      src: "src",
      srcdoc: "srcDoc",
      srclang: "srcLang",
      srcset: "srcSet",
      start: "start",
      step: "step",
      style: "style",
      summary: "summary",
      tabindex: "tabIndex",
      target: "target",
      title: "title",
      type: "type",
      usemap: "useMap",
      value: "value",
      width: "width",
      wmode: "wmode",
      wrap: "wrap",
      // SVG
      about: "about",
      accentheight: "accentHeight",
      "accent-height": "accentHeight",
      accumulate: "accumulate",
      additive: "additive",
      alignmentbaseline: "alignmentBaseline",
      "alignment-baseline": "alignmentBaseline",
      allowreorder: "allowReorder",
      alphabetic: "alphabetic",
      amplitude: "amplitude",
      arabicform: "arabicForm",
      "arabic-form": "arabicForm",
      ascent: "ascent",
      attributename: "attributeName",
      attributetype: "attributeType",
      autoreverse: "autoReverse",
      azimuth: "azimuth",
      basefrequency: "baseFrequency",
      baselineshift: "baselineShift",
      "baseline-shift": "baselineShift",
      baseprofile: "baseProfile",
      bbox: "bbox",
      begin: "begin",
      bias: "bias",
      by: "by",
      calcmode: "calcMode",
      capheight: "capHeight",
      "cap-height": "capHeight",
      clip: "clip",
      clippath: "clipPath",
      "clip-path": "clipPath",
      clippathunits: "clipPathUnits",
      cliprule: "clipRule",
      "clip-rule": "clipRule",
      color: "color",
      colorinterpolation: "colorInterpolation",
      "color-interpolation": "colorInterpolation",
      colorinterpolationfilters: "colorInterpolationFilters",
      "color-interpolation-filters": "colorInterpolationFilters",
      colorprofile: "colorProfile",
      "color-profile": "colorProfile",
      colorrendering: "colorRendering",
      "color-rendering": "colorRendering",
      contentscripttype: "contentScriptType",
      contentstyletype: "contentStyleType",
      cursor: "cursor",
      cx: "cx",
      cy: "cy",
      d: "d",
      datatype: "datatype",
      decelerate: "decelerate",
      descent: "descent",
      diffuseconstant: "diffuseConstant",
      direction: "direction",
      display: "display",
      divisor: "divisor",
      dominantbaseline: "dominantBaseline",
      "dominant-baseline": "dominantBaseline",
      dur: "dur",
      dx: "dx",
      dy: "dy",
      edgemode: "edgeMode",
      elevation: "elevation",
      enablebackground: "enableBackground",
      "enable-background": "enableBackground",
      end: "end",
      exponent: "exponent",
      externalresourcesrequired: "externalResourcesRequired",
      fill: "fill",
      fillopacity: "fillOpacity",
      "fill-opacity": "fillOpacity",
      fillrule: "fillRule",
      "fill-rule": "fillRule",
      filter: "filter",
      filterres: "filterRes",
      filterunits: "filterUnits",
      floodopacity: "floodOpacity",
      "flood-opacity": "floodOpacity",
      floodcolor: "floodColor",
      "flood-color": "floodColor",
      focusable: "focusable",
      fontfamily: "fontFamily",
      "font-family": "fontFamily",
      fontsize: "fontSize",
      "font-size": "fontSize",
      fontsizeadjust: "fontSizeAdjust",
      "font-size-adjust": "fontSizeAdjust",
      fontstretch: "fontStretch",
      "font-stretch": "fontStretch",
      fontstyle: "fontStyle",
      "font-style": "fontStyle",
      fontvariant: "fontVariant",
      "font-variant": "fontVariant",
      fontweight: "fontWeight",
      "font-weight": "fontWeight",
      format: "format",
      from: "from",
      fx: "fx",
      fy: "fy",
      g1: "g1",
      g2: "g2",
      glyphname: "glyphName",
      "glyph-name": "glyphName",
      glyphorientationhorizontal: "glyphOrientationHorizontal",
      "glyph-orientation-horizontal": "glyphOrientationHorizontal",
      glyphorientationvertical: "glyphOrientationVertical",
      "glyph-orientation-vertical": "glyphOrientationVertical",
      glyphref: "glyphRef",
      gradienttransform: "gradientTransform",
      gradientunits: "gradientUnits",
      hanging: "hanging",
      horizadvx: "horizAdvX",
      "horiz-adv-x": "horizAdvX",
      horizoriginx: "horizOriginX",
      "horiz-origin-x": "horizOriginX",
      ideographic: "ideographic",
      imagerendering: "imageRendering",
      "image-rendering": "imageRendering",
      in2: "in2",
      in: "in",
      inlist: "inlist",
      intercept: "intercept",
      k1: "k1",
      k2: "k2",
      k3: "k3",
      k4: "k4",
      k: "k",
      kernelmatrix: "kernelMatrix",
      kernelunitlength: "kernelUnitLength",
      kerning: "kerning",
      keypoints: "keyPoints",
      keysplines: "keySplines",
      keytimes: "keyTimes",
      lengthadjust: "lengthAdjust",
      letterspacing: "letterSpacing",
      "letter-spacing": "letterSpacing",
      lightingcolor: "lightingColor",
      "lighting-color": "lightingColor",
      limitingconeangle: "limitingConeAngle",
      local: "local",
      markerend: "markerEnd",
      "marker-end": "markerEnd",
      markerheight: "markerHeight",
      markermid: "markerMid",
      "marker-mid": "markerMid",
      markerstart: "markerStart",
      "marker-start": "markerStart",
      markerunits: "markerUnits",
      markerwidth: "markerWidth",
      mask: "mask",
      maskcontentunits: "maskContentUnits",
      maskunits: "maskUnits",
      mathematical: "mathematical",
      mode: "mode",
      numoctaves: "numOctaves",
      offset: "offset",
      opacity: "opacity",
      operator: "operator",
      order: "order",
      orient: "orient",
      orientation: "orientation",
      origin: "origin",
      overflow: "overflow",
      overlineposition: "overlinePosition",
      "overline-position": "overlinePosition",
      overlinethickness: "overlineThickness",
      "overline-thickness": "overlineThickness",
      paintorder: "paintOrder",
      "paint-order": "paintOrder",
      panose1: "panose1",
      "panose-1": "panose1",
      pathlength: "pathLength",
      patterncontentunits: "patternContentUnits",
      patterntransform: "patternTransform",
      patternunits: "patternUnits",
      pointerevents: "pointerEvents",
      "pointer-events": "pointerEvents",
      points: "points",
      pointsatx: "pointsAtX",
      pointsaty: "pointsAtY",
      pointsatz: "pointsAtZ",
      prefix: "prefix",
      preservealpha: "preserveAlpha",
      preserveaspectratio: "preserveAspectRatio",
      primitiveunits: "primitiveUnits",
      property: "property",
      r: "r",
      radius: "radius",
      refx: "refX",
      refy: "refY",
      renderingintent: "renderingIntent",
      "rendering-intent": "renderingIntent",
      repeatcount: "repeatCount",
      repeatdur: "repeatDur",
      requiredextensions: "requiredExtensions",
      requiredfeatures: "requiredFeatures",
      resource: "resource",
      restart: "restart",
      result: "result",
      results: "results",
      rotate: "rotate",
      rx: "rx",
      ry: "ry",
      scale: "scale",
      security: "security",
      seed: "seed",
      shaperendering: "shapeRendering",
      "shape-rendering": "shapeRendering",
      slope: "slope",
      spacing: "spacing",
      specularconstant: "specularConstant",
      specularexponent: "specularExponent",
      speed: "speed",
      spreadmethod: "spreadMethod",
      startoffset: "startOffset",
      stddeviation: "stdDeviation",
      stemh: "stemh",
      stemv: "stemv",
      stitchtiles: "stitchTiles",
      stopcolor: "stopColor",
      "stop-color": "stopColor",
      stopopacity: "stopOpacity",
      "stop-opacity": "stopOpacity",
      strikethroughposition: "strikethroughPosition",
      "strikethrough-position": "strikethroughPosition",
      strikethroughthickness: "strikethroughThickness",
      "strikethrough-thickness": "strikethroughThickness",
      string: "string",
      stroke: "stroke",
      strokedasharray: "strokeDasharray",
      "stroke-dasharray": "strokeDasharray",
      strokedashoffset: "strokeDashoffset",
      "stroke-dashoffset": "strokeDashoffset",
      strokelinecap: "strokeLinecap",
      "stroke-linecap": "strokeLinecap",
      strokelinejoin: "strokeLinejoin",
      "stroke-linejoin": "strokeLinejoin",
      strokemiterlimit: "strokeMiterlimit",
      "stroke-miterlimit": "strokeMiterlimit",
      strokewidth: "strokeWidth",
      "stroke-width": "strokeWidth",
      strokeopacity: "strokeOpacity",
      "stroke-opacity": "strokeOpacity",
      suppresscontenteditablewarning: "suppressContentEditableWarning",
      suppresshydrationwarning: "suppressHydrationWarning",
      surfacescale: "surfaceScale",
      systemlanguage: "systemLanguage",
      tablevalues: "tableValues",
      targetx: "targetX",
      targety: "targetY",
      textanchor: "textAnchor",
      "text-anchor": "textAnchor",
      textdecoration: "textDecoration",
      "text-decoration": "textDecoration",
      textlength: "textLength",
      textrendering: "textRendering",
      "text-rendering": "textRendering",
      to: "to",
      transform: "transform",
      typeof: "typeof",
      u1: "u1",
      u2: "u2",
      underlineposition: "underlinePosition",
      "underline-position": "underlinePosition",
      underlinethickness: "underlineThickness",
      "underline-thickness": "underlineThickness",
      unicode: "unicode",
      unicodebidi: "unicodeBidi",
      "unicode-bidi": "unicodeBidi",
      unicoderange: "unicodeRange",
      "unicode-range": "unicodeRange",
      unitsperem: "unitsPerEm",
      "units-per-em": "unitsPerEm",
      unselectable: "unselectable",
      valphabetic: "vAlphabetic",
      "v-alphabetic": "vAlphabetic",
      values: "values",
      vectoreffect: "vectorEffect",
      "vector-effect": "vectorEffect",
      version: "version",
      vertadvy: "vertAdvY",
      "vert-adv-y": "vertAdvY",
      vertoriginx: "vertOriginX",
      "vert-origin-x": "vertOriginX",
      vertoriginy: "vertOriginY",
      "vert-origin-y": "vertOriginY",
      vhanging: "vHanging",
      "v-hanging": "vHanging",
      videographic: "vIdeographic",
      "v-ideographic": "vIdeographic",
      viewbox: "viewBox",
      viewtarget: "viewTarget",
      visibility: "visibility",
      vmathematical: "vMathematical",
      "v-mathematical": "vMathematical",
      vocab: "vocab",
      widths: "widths",
      wordspacing: "wordSpacing",
      "word-spacing": "wordSpacing",
      writingmode: "writingMode",
      "writing-mode": "writingMode",
      x1: "x1",
      x2: "x2",
      x: "x",
      xchannelselector: "xChannelSelector",
      xheight: "xHeight",
      "x-height": "xHeight",
      xlinkactuate: "xlinkActuate",
      "xlink:actuate": "xlinkActuate",
      xlinkarcrole: "xlinkArcrole",
      "xlink:arcrole": "xlinkArcrole",
      xlinkhref: "xlinkHref",
      "xlink:href": "xlinkHref",
      xlinkrole: "xlinkRole",
      "xlink:role": "xlinkRole",
      xlinkshow: "xlinkShow",
      "xlink:show": "xlinkShow",
      xlinktitle: "xlinkTitle",
      "xlink:title": "xlinkTitle",
      xlinktype: "xlinkType",
      "xlink:type": "xlinkType",
      xmlbase: "xmlBase",
      "xml:base": "xmlBase",
      xmllang: "xmlLang",
      "xml:lang": "xmlLang",
      xmlns: "xmlns",
      "xml:space": "xmlSpace",
      xmlnsxlink: "xmlnsXlink",
      "xmlns:xlink": "xmlnsXlink",
      xmlspace: "xmlSpace",
      y1: "y1",
      y2: "y2",
      y: "y",
      ychannelselector: "yChannelSelector",
      z: "z",
      zoomandpan: "zoomAndPan"
    }, sr = function() {
    };
    {
      var Ce = {}, Sa = Object.prototype.hasOwnProperty, or = /^on./, Aa = /^on[^A-Z]/, xa = new RegExp("^(aria)-[" + it + "]*$"), Ca = new RegExp("^(aria)[A-Z][" + it + "]*$");
      sr = function(a, u, v, w) {
        if (Sa.call(Ce, u) && Ce[u])
          return !0;
        var E = u.toLowerCase();
        if (E === "onfocusin" || E === "onfocusout")
          return l("React uses onFocus and onBlur instead of onFocusIn and onFocusOut. All React events are normalized to bubble, so onFocusIn and onFocusOut are not needed/supported by React."), Ce[u] = !0, !0;
        if (w) {
          if (Ea.hasOwnProperty(u))
            return !0;
          var T = ir.hasOwnProperty(E) ? ir[E] : null;
          if (T != null)
            return l("Invalid event handler property `%s`. Did you mean `%s`?", u, T), Ce[u] = !0, !0;
          if (or.test(u))
            return l("Unknown event handler property `%s`. It will be ignored.", u), Ce[u] = !0, !0;
        } else if (or.test(u))
          return Aa.test(u) && l("Invalid event handler property `%s`. React events use the camelCase naming convention, for example `onClick`.", u), Ce[u] = !0, !0;
        if (xa.test(u) || Ca.test(u))
          return !0;
        if (E === "innerhtml")
          return l("Directly setting property `innerHTML` is not permitted. For more information, lookup documentation on `dangerouslySetInnerHTML`."), Ce[u] = !0, !0;
        if (E === "aria")
          return l("The `aria` attribute is reserved for future use in React. Pass individual `aria-` attributes instead."), Ce[u] = !0, !0;
        if (E === "is" && v !== null && v !== void 0 && typeof v != "string")
          return l("Received a `%s` for a string attribute `is`. If this is expected, cast the value to a string.", typeof v), Ce[u] = !0, !0;
        if (typeof v == "number" && isNaN(v))
          return l("Received NaN for the `%s` attribute. If this is expected, cast the value to a string.", u), Ce[u] = !0, !0;
        var O = Cn(u), N = O !== null && O.type === nt;
        if (rr.hasOwnProperty(E)) {
          var C = rr[E];
          if (C !== u)
            return l("Invalid DOM property `%s`. Did you mean `%s`?", u, C), Ce[u] = !0, !0;
        } else if (!N && u !== E)
          return l("React does not recognize the `%s` prop on a DOM element. If you intentionally want it to appear in the DOM as a custom attribute, spell it as lowercase `%s` instead. If you accidentally passed it from a parent component, remove it from the DOM element.", u, E), Ce[u] = !0, !0;
        return typeof v == "boolean" && en(u, v, O, !1) ? (v ? l('Received `%s` for a non-boolean attribute `%s`.\n\nIf you want to write it to the DOM, pass a string instead: %s="%s" or %s={value.toString()}.', v, u, u, v, u) : l('Received `%s` for a non-boolean attribute `%s`.\n\nIf you want to write it to the DOM, pass a string instead: %s="%s" or %s={value.toString()}.\n\nIf you used to conditionally omit it with %s={condition && value}, pass %s={condition ? value : undefined} instead.', v, u, u, v, u, u, u), Ce[u] = !0, !0) : N ? !0 : en(u, v, O, !1) ? (Ce[u] = !0, !1) : ((v === "false" || v === "true") && O !== null && O.type === Je && (l("Received the string `%s` for the boolean attribute `%s`. %s Did you mean %s={%s}?", v, u, v === "false" ? "The browser will interpret it as a truthy value." : 'Although this works, it will not work as expected if you pass the string "false".', u, v), Ce[u] = !0), !0);
      };
    }
    var Pa = function(a, u, v) {
      {
        var w = [];
        for (var E in u) {
          var T = sr(a, E, u[E], v);
          T || w.push(E);
        }
        var O = w.map(function(N) {
          return "`" + N + "`";
        }).join(", ");
        w.length === 1 ? l("Invalid value for prop %s on <%s> tag. Either remove it from the element, or pass a string or number value to keep it in the DOM. For details, see https://fb.me/react-attribute-behavior", O, a) : w.length > 1 && l("Invalid values for props %s on <%s> tag. Either remove them from the element, or pass a string or number value to keep them in the DOM. For details, see https://fb.me/react-attribute-behavior", O, a);
      }
    };
    function Ta(a, u, v) {
      li(a, u) || Pa(a, u, v);
    }
    var ut = n.Children.toArray, rt = [], ui = s.ReactCurrentDispatcher, Dn, hi = null, ar = function() {
      return "";
    }, lr = function(a) {
      return "";
    }, cr = function(a, u) {
    }, ur = function(a) {
    }, hr = function(a) {
    }, dr = function() {
    }, fr = !1;
    Dn = s.ReactDebugCurrentFrame, cr = function(a, u) {
      ba(a, u), wa(a, u), Ta(
        a,
        u,
        /* canUseEventSystem */
        !1
      );
    }, lr = function(a) {
      var u = a._source, v = a.type, w = ne(v), E = null;
      return Q(w, u, E);
    }, ur = function(a) {
      rt.push(a), rt.length === 1 && (hi = Dn.getCurrentStack, Dn.getCurrentStack = ar);
    }, hr = function(a) {
      var u = rt[rt.length - 1], v = u[u.length - 1];
      v.debugElementStack.push(a);
    }, dr = function() {
      rt.pop(), rt.length === 0 && (Dn.getCurrentStack = hi, hi = null);
    }, ar = function() {
      if (rt.length === 0)
        return "";
      for (var a = rt[rt.length - 1], u = "", v = a.length - 1; v >= 0; v--)
        for (var w = a[v], E = w.debugElementStack, T = E.length - 1; T >= 0; T--)
          u += lr(E[T]);
      return u;
    };
    var pr = !1, mr = !1, vr = !1, gr = !1, yr = !1, _r = {}, br = {}, wr = {}, Er = {}, Sr = {}, Ar = {}, xr = ["value", "defaultValue"], Oa = {
      listing: !0,
      pre: !0,
      textarea: !0
    }, Ia = /^[a-zA-Z][a-zA-Z:_\.\-\d]*$/, Cr = {};
    function ka(a) {
      if (!Cr.hasOwnProperty(a)) {
        if (!Ia.test(a))
          throw Error("Invalid tag: " + a);
        Cr[a] = !0;
      }
    }
    var di = {}, Da = function(a) {
      if (di.hasOwnProperty(a))
        return di[a];
      var u = ra(a);
      return di[a] = u, u;
    };
    function Ma(a) {
      var u = "", v = "";
      for (var w in a)
        if (a.hasOwnProperty(w)) {
          var E = w.indexOf("--") === 0, T = a[w];
          E || pa(w, T), T != null && (u += v + (E ? w : Da(w)) + ":", u += ta(w, T, E), v = ";");
        }
      return u || null;
    }
    function Pr(a, u) {
      {
        var v = a.constructor, w = v && ne(v) || "ReactClass", E = w + "." + u;
        if (_r[E])
          return;
        l(`%s(...): Can only update a mounting component. This usually means you called %s() outside componentWillMount() on the server. This is a no-op.

Please check the code for the %s component.`, u, u, w), _r[E] = !0;
      }
    }
    function La(a) {
      return a.prototype && a.prototype.isReactComponent;
    }
    function Ra(a) {
      var u = a.dangerouslySetInnerHTML;
      if (u != null) {
        if (u.__html != null)
          return u.__html;
      } else {
        var v = a.children;
        if (typeof v == "string" || typeof v == "number")
          return lt(v);
      }
      return null;
    }
    function za(a) {
      if (!n.isValidElement(a))
        return ut(a);
      var u = a;
      if (u.type !== p)
        return [u];
      var v = u.props.children;
      if (!n.isValidElement(v))
        return ut(v);
      var w = v;
      return [w];
    }
    function Na(a) {
      if (a == null)
        return a;
      var u = "";
      return n.Children.forEach(a, function(v) {
        v != null && (u += v, !yr && typeof v != "string" && typeof v != "number" && (yr = !0, l("Only strings and numbers are supported as <option> children.")));
      }), u;
    }
    var Fa = Object.prototype.hasOwnProperty, Za = "style", Ba = {
      children: null,
      dangerouslySetInnerHTML: null,
      suppressContentEditableWarning: null,
      suppressHydrationWarning: null
    };
    function Ha(a, u, v, w, E, T) {
      var O = "<" + a;
      for (var N in v)
        if (Fa.call(v, N)) {
          var C = v[N];
          if (C != null) {
            N === Za && (C = Ma(C));
            var se = null;
            li(u, v) ? Ba.hasOwnProperty(N) || (se = y(N, C)) : se = b(N, C), se && (O += " " + se);
          }
        }
      return E || T && (O += " " + f()), O;
    }
    function Tr(a, u) {
      if (a === void 0)
        throw Error((ne(u) || "Component") + "(...): Nothing was returned from render. This usually means a return statement is missing. Or, to render nothing, return null.");
    }
    function Va(a, u, v) {
      for (; n.isValidElement(a); ) {
        var w = a, E = w.type;
        if (hr(w), typeof E != "function")
          break;
        T(w, E);
      }
      function T(O, N) {
        var C = La(N), se = Fe(N, u, v, C), ve = [], Se = !1, ke = {
          isMounted: function(ft) {
            return !1;
          },
          enqueueForceUpdate: function(ft) {
            if (ve === null)
              return Pr(ft, "forceUpdate"), null;
          },
          enqueueReplaceState: function(ft, Bt) {
            Se = !0, ve = [Bt];
          },
          enqueueSetState: function(ft, Bt) {
            if (ve === null)
              return Pr(ft, "setState"), null;
            ve.push(Bt);
          }
        }, U;
        if (C) {
          if (U = new N(O.props, se, ke), typeof N.getDerivedStateFromProps == "function") {
            if (U.state === null || U.state === void 0) {
              var Ze = ne(N) || "Unknown";
              Ar[Ze] || (l("`%s` uses `getDerivedStateFromProps` but its initial state is %s. This is not recommended. Instead, define the initial state by assigning an object to `this.state` in the constructor of `%s`. This ensures that `getDerivedStateFromProps` arguments have a consistent shape.", Ze, U.state === null ? "null" : "undefined", Ze), Ar[Ze] = !0);
            }
            var Pe = N.getDerivedStateFromProps.call(null, O.props, U.state);
            if (Pe === void 0) {
              var De = ne(N) || "Unknown";
              Sr[De] || (l("%s.getDerivedStateFromProps(): A valid state object (or null) must be returned. You have returned undefined.", De), Sr[De] = !0);
            }
            Pe != null && (U.state = e({}, U.state, Pe));
          }
        } else {
          if (N.prototype && typeof N.prototype.render == "function") {
            var Me = ne(N) || "Unknown";
            br[Me] || (l("The <%s /> component appears to have a render method, but doesn't extend React.Component. This is likely to cause errors. Change %s to extend React.Component instead.", Me, Me), br[Me] = !0);
          }
          var ht = {};
          if (Ee(ht), U = N(O.props, se, ke), U = zt(N, O.props, U, se), U == null || U.render == null) {
            a = U, Tr(a, N);
            return;
          }
          {
            var Be = ne(N) || "Unknown";
            wr[Be] || (l("The <%s /> component appears to be a function component that returns a class instance. Change %s to a class that extends React.Component instead. If you can't use a class try assigning the prototype on the function as a workaround. `%s.prototype = React.Component.prototype`. Don't use an arrow function since it cannot be called with `new` by React.", Be, Be, Be), wr[Be] = !0);
          }
        }
        U.props = O.props, U.context = se, U.updater = ke;
        var $e = U.state;
        if ($e === void 0 && (U.state = $e = null), typeof U.UNSAFE_componentWillMount == "function" || typeof U.componentWillMount == "function") {
          if (typeof U.componentWillMount == "function") {
            if (U.componentWillMount.__suppressDeprecationWarning !== !0) {
              var dt = ne(N) || "Unknown";
              Er[dt] || (o(
                // keep this warning in sync with ReactStrictModeWarning.js
                `componentWillMount has been renamed, and is not recommended for use. See https://fb.me/react-unsafe-component-lifecycles for details.

* Move code from componentWillMount to componentDidMount (preferred in most cases) or the constructor.

Please update the following components: %s`,
                dt
              ), Er[dt] = !0);
            }
            typeof N.getDerivedStateFromProps != "function" && U.componentWillMount();
          }
          if (typeof U.UNSAFE_componentWillMount == "function" && typeof N.getDerivedStateFromProps != "function" && U.UNSAFE_componentWillMount(), ve.length) {
            var He = ve, Xe = Se;
            if (ve = null, Se = !1, Xe && He.length === 1)
              U.state = He[0];
            else {
              for (var Qe = Xe ? He[0] : U.state, Mn = !0, Zt = Xe ? 1 : 0; Zt < He.length; Zt++) {
                var Ke = He[Zt], sn = typeof Ke == "function" ? Ke.call(U, Qe, O.props, se) : Ke;
                sn != null && (Mn ? (Mn = !1, Qe = e({}, Qe, sn)) : e(Qe, sn));
              }
              U.state = Qe;
            }
          } else
            ve = null;
        }
        a = U.render(), a === void 0 && U.render._isMockFunction && (a = null), Tr(a, N);
        var At;
        {
          if (typeof U.getChildContext == "function") {
            var Ln = N.childContextTypes;
            if (typeof Ln == "object") {
              At = U.getChildContext();
              for (var Rn in At)
                if (!(Rn in Ln))
                  throw Error((ne(N) || "Unknown") + '.getChildContext(): key "' + Rn + '" is not defined in childContextTypes.');
            } else
              l("%s.getChildContext(): childContextTypes must be defined in order to use getChildContext().", ne(N) || "Unknown");
          }
          At && (u = e({}, u, At));
        }
      }
      return {
        child: a,
        context: u
      };
    }
    var Or = /* @__PURE__ */ function() {
      function a(v, w) {
        var E = za(v), T = {
          type: null,
          // Assume all trees start in the HTML namespace (not totally true, but
          // this is what we did historically)
          domNamespace: oi.html,
          children: E,
          childIndex: 0,
          context: Ge,
          footer: ""
        };
        T.debugElementStack = [], this.threadID = Xt(), this.stack = [T], this.exhausted = !1, this.currentSelectValue = null, this.previousWasTextNode = !1, this.makeStaticMarkup = w, this.suspenseDepth = 0, this.contextIndex = -1, this.contextStack = [], this.contextValueStack = [], this.contextProviderStack = [];
      }
      var u = a.prototype;
      return u.destroy = function() {
        this.exhausted || (this.exhausted = !0, this.clearProviders(), Ye(this.threadID));
      }, u.pushProvider = function(w) {
        var E = ++this.contextIndex, T = w.type._context, O = this.threadID;
        _t(T, O);
        var N = T[O];
        this.contextStack[E] = T, this.contextValueStack[E] = N, this.contextProviderStack[E] = w, T[O] = w.props.value;
      }, u.popProvider = function(w) {
        var E = this.contextIndex;
        (E < 0 || w !== this.contextProviderStack[E]) && l("Unexpected pop.");
        var T = this.contextStack[E], O = this.contextValueStack[E];
        this.contextStack[E] = null, this.contextValueStack[E] = null, this.contextProviderStack[E] = null, this.contextIndex--, T[this.threadID] = O;
      }, u.clearProviders = function() {
        for (var w = this.contextIndex; w >= 0; w--) {
          var E = this.contextStack[w], T = this.contextValueStack[w];
          E[this.threadID] = T;
        }
      }, u.read = function(w) {
        if (this.exhausted)
          return null;
        var E = On;
        qi(this.threadID);
        var T = ui.current;
        ui.current = qo;
        try {
          for (var O = [""], N = !1; O[0].length < w; ) {
            if (this.stack.length === 0) {
              this.exhausted = !0, Ye(this.threadID);
              break;
            }
            var C = this.stack[this.stack.length - 1];
            if (N || C.childIndex >= C.children.length) {
              var se = C.footer;
              if (se !== "" && (this.previousWasTextNode = !1), this.stack.pop(), C.type === "select")
                this.currentSelectValue = null;
              else if (C.type != null && C.type.type != null && C.type.type.$$typeof === S) {
                var ve = C.type;
                this.popProvider(ve);
              } else if (C.type === x) {
                this.suspenseDepth--;
                var Se = O.pop();
                if (N) {
                  N = !1;
                  var ke = C.fallbackFrame;
                  if (!ke)
                    throw Error("ReactDOMServer did not find an internal fallback frame for Suspense. This is a bug in React. Please file an issue.");
                  this.stack.push(ke), O[this.suspenseDepth] += "<!--$!-->";
                  continue;
                } else
                  O[this.suspenseDepth] += Se;
              }
              O[this.suspenseDepth] += se;
              continue;
            }
            var U = C.children[C.childIndex++], Ze = "";
            ur(this.stack), C.debugElementStack.length = 0;
            try {
              Ze += this.render(U, C.context, C.domNamespace);
            } catch (Pe) {
              if (Pe != null && typeof Pe.then == "function") {
                if (!ie)
                  throw Error("ReactDOMServer does not yet support Suspense.");
              } else
                throw Pe;
            } finally {
              dr();
            }
            O.length <= this.suspenseDepth && O.push(""), O[this.suspenseDepth] += Ze;
          }
          return O[0];
        } finally {
          ui.current = T, qi(E);
        }
      }, u.render = function(w, E, T) {
        if (typeof w == "string" || typeof w == "number") {
          var O = "" + w;
          return O === "" ? "" : this.makeStaticMarkup ? lt(O) : this.previousWasTextNode ? "<!-- -->" + lt(O) : (this.previousWasTextNode = !0, lt(O));
        } else {
          var N, C = Va(w, E, this.threadID);
          if (N = C.child, E = C.context, N === null || N === !1)
            return "";
          if (!n.isValidElement(N)) {
            if (N != null && N.$$typeof != null) {
              var se = N.$$typeof;
              throw Error(se === m ? "Portals are not currently supported by the server renderer. Render them conditionally so that they only appear on the client render." : "Unknown element-like object type: " + se.toString() + ". This is likely a bug in React. Please file an issue.");
            }
            var ve = ut(N), Se = {
              type: null,
              domNamespace: T,
              children: ve,
              childIndex: 0,
              context: E,
              footer: ""
            };
            return Se.debugElementStack = [], this.stack.push(Se), "";
          }
          var ke = N, U = ke.type;
          if (typeof U == "string")
            return this.renderDOM(ke, E, T);
          switch (U) {
            case _:
            case I:
            case g:
            case Z:
            case p: {
              var Ze = ut(N.props.children), Pe = {
                type: null,
                domNamespace: T,
                children: Ze,
                childIndex: 0,
                context: E,
                footer: ""
              };
              return Pe.debugElementStack = [], this.stack.push(Pe), "";
            }
            case x:
              throw Error("ReactDOMServer does not yet support Suspense.");
          }
          if (typeof U == "object" && U !== null)
            switch (U.$$typeof) {
              case L: {
                var De = N, Me, ht = {};
                Ee(ht), Me = U.render(De.props, De.ref), Me = zt(U.render, De.props, Me, De.ref), Me = ut(Me);
                var Be = {
                  type: null,
                  domNamespace: T,
                  children: Me,
                  childIndex: 0,
                  context: E,
                  footer: ""
                };
                return Be.debugElementStack = [], this.stack.push(Be), "";
              }
              case R: {
                var $e = N, dt = [n.createElement(U.type, e({
                  ref: $e.ref
                }, $e.props))], He = {
                  type: null,
                  domNamespace: T,
                  children: dt,
                  childIndex: 0,
                  context: E,
                  footer: ""
                };
                return He.debugElementStack = [], this.stack.push(He), "";
              }
              case S: {
                var Xe = N, Qe = Xe.props, Mn = ut(Qe.children), Zt = {
                  type: Xe,
                  domNamespace: T,
                  children: Mn,
                  childIndex: 0,
                  context: E,
                  footer: ""
                };
                return Zt.debugElementStack = [], this.pushProvider(Xe), this.stack.push(Zt), "";
              }
              case A: {
                var Ke = N.type;
                Ke._context === void 0 ? Ke !== Ke.Consumer && (fr || (fr = !0, l("Rendering <Context> directly is not supported and will be removed in a future major release. Did you mean to render <Context.Consumer> instead?"))) : Ke = Ke._context;
                var sn = N.props, At = this.threadID;
                _t(Ke, At);
                var Ln = Ke[At], Rn = ut(sn.children(Ln)), ft = {
                  type: N,
                  domNamespace: T,
                  children: Rn,
                  childIndex: 0,
                  context: E,
                  footer: ""
                };
                return ft.debugElementStack = [], this.stack.push(ft), "";
              }
              case K:
                throw Error("ReactDOMServer does not yet support the fundamental API.");
              case P: {
                var Bt = N, zn = N.type;
                switch (_e(zn), zn._status) {
                  case V: {
                    var Ya = [n.createElement(zn._result, e({
                      ref: Bt.ref
                    }, Bt.props))], kr = {
                      type: null,
                      domNamespace: T,
                      children: Ya,
                      childIndex: 0,
                      context: E,
                      footer: ""
                    };
                    return kr.debugElementStack = [], this.stack.push(kr), "";
                  }
                  case j:
                    throw zn._result;
                  case F:
                  default:
                    throw Error("ReactDOMServer does not yet support lazy-loaded components.");
                }
              }
              case J:
                throw Error("ReactDOMServer does not yet support scope components.");
            }
          var fi = "";
          {
            var Dr = ke._owner;
            (U === void 0 || typeof U == "object" && U !== null && Object.keys(U).length === 0) && (fi += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
            var Mr = Dr ? ne(Dr) : null;
            Mr && (fi += `

Check the render method of \`` + Mr + "`.");
          }
          throw Error("Element type is invalid: expected a string (for built-in components) or a class/function (for composite components) but got: " + (U == null ? U : typeof U) + "." + fi);
        }
      }, u.renderDOM = function(w, E, T) {
        var O = w.type.toLowerCase(), N = T;
        T === oi.html && (N = Yi(O)), N === oi.html && O !== w.type && l("<%s /> is using incorrect casing. Use PascalCase for React components, or lowercase for HTML elements.", w.type), ka(O);
        var C = w.props;
        if (O === "input")
          kn.checkPropTypes("input", C), C.checked !== void 0 && C.defaultChecked !== void 0 && !mr && (l("%s contains an input of type %s with both checked and defaultChecked props. Input elements must be either controlled or uncontrolled (specify either the checked prop, or the defaultChecked prop, but not both). Decide between using a controlled or uncontrolled input element and remove one of these props. More info: https://fb.me/react-controlled-components", "A component", C.type), mr = !0), C.value !== void 0 && C.defaultValue !== void 0 && !pr && (l("%s contains an input of type %s with both value and defaultValue props. Input elements must be either controlled or uncontrolled (specify either the value prop, or the defaultValue prop, but not both). Decide between using a controlled or uncontrolled input element and remove one of these props. More info: https://fb.me/react-controlled-components", "A component", C.type), pr = !0), C = e({
            type: void 0
          }, C, {
            defaultChecked: void 0,
            defaultValue: void 0,
            value: C.value != null ? C.value : C.defaultValue,
            checked: C.checked != null ? C.checked : C.defaultChecked
          });
        else if (O === "textarea") {
          kn.checkPropTypes("textarea", C), C.value !== void 0 && C.defaultValue !== void 0 && !gr && (l("Textarea elements must be either controlled or uncontrolled (specify either the value prop, or the defaultValue prop, but not both). Decide between using a controlled or uncontrolled textarea and remove one of these props. More info: https://fb.me/react-controlled-components"), gr = !0);
          var se = C.value;
          if (se == null) {
            var ve = C.defaultValue, Se = C.children;
            if (Se != null) {
              if (l("Use the `defaultValue` or `value` props instead of setting children on <textarea>."), ve != null)
                throw Error("If you supply `defaultValue` on a <textarea>, do not pass children.");
              if (Array.isArray(Se)) {
                if (!(Se.length <= 1))
                  throw Error("<textarea> can only have at most one child.");
                Se = Se[0];
              }
              ve = "" + Se;
            }
            ve == null && (ve = ""), se = ve;
          }
          C = e({}, C, {
            value: void 0,
            children: "" + se
          });
        } else if (O === "select") {
          {
            kn.checkPropTypes("select", C);
            for (var ke = 0; ke < xr.length; ke++) {
              var U = xr[ke];
              if (C[U] != null) {
                var Ze = Array.isArray(C[U]);
                C.multiple && !Ze ? l("The `%s` prop supplied to <select> must be an array if `multiple` is true.", U) : !C.multiple && Ze && l("The `%s` prop supplied to <select> must be a scalar value if `multiple` is false.", U);
              }
            }
            C.value !== void 0 && C.defaultValue !== void 0 && !vr && (l("Select elements must be either controlled or uncontrolled (specify either the value prop, or the defaultValue prop, but not both). Decide between using a controlled or uncontrolled select element and remove one of these props. More info: https://fb.me/react-controlled-components"), vr = !0);
          }
          this.currentSelectValue = C.value != null ? C.value : C.defaultValue, C = e({}, C, {
            value: void 0
          });
        } else if (O === "option") {
          var Pe = null, De = this.currentSelectValue, Me = Na(C.children);
          if (De != null) {
            var ht;
            if (C.value != null ? ht = C.value + "" : ht = Me, Pe = !1, Array.isArray(De)) {
              for (var Be = 0; Be < De.length; Be++)
                if ("" + De[Be] === ht) {
                  Pe = !0;
                  break;
                }
            } else
              Pe = "" + De === ht;
            C = e({
              selected: void 0,
              children: void 0
            }, C, {
              selected: Pe,
              children: Me
            });
          }
        }
        cr(O, C), Jo(O, C);
        var $e = Ha(w.type, O, C, N, this.makeStaticMarkup, this.stack.length === 1), dt = "";
        Xi.hasOwnProperty(O) ? $e += "/>" : ($e += ">", dt = "</" + w.type + ">");
        var He, Xe = Ra(C);
        Xe != null ? (He = [], Oa.hasOwnProperty(O) && Xe.charAt(0) === `
` && ($e += `
`), $e += Xe) : He = ut(C.children);
        var Qe = {
          domNamespace: Go(T, w.type),
          type: O,
          children: He,
          childIndex: 0,
          context: E,
          footer: dt
        };
        return Qe.debugElementStack = [], this.stack.push(Qe), this.previousWasTextNode = !1, $e;
      }, a;
    }();
    function ja(a) {
      var u = new Or(a, !1);
      try {
        var v = u.read(1 / 0);
        return v;
      } finally {
        u.destroy();
      }
    }
    function Ua(a) {
      var u = new Or(a, !0);
      try {
        var v = u.read(1 / 0);
        return v;
      } finally {
        u.destroy();
      }
    }
    function Wa() {
      throw Error("ReactDOMServer.renderToNodeStream(): The streaming API is not available in the browser. Use ReactDOMServer.renderToString() instead.");
    }
    function qa() {
      throw Error("ReactDOMServer.renderToStaticNodeStream(): The streaming API is not available in the browser. Use ReactDOMServer.renderToStaticMarkup() instead.");
    }
    var Ir = {
      renderToString: ja,
      renderToStaticMarkup: Ua,
      renderToNodeStream: Wa,
      renderToStaticNodeStream: qa,
      version: r
    }, Ga = Ir.default || Ir;
    Nh.exports = Ga;
  }()), Un;
}
(function(n) {
  process.env.NODE_ENV === "production" ? n.exports = zh() : n.exports = Hh();
})(Rh);
const so = (n) => /* @__PURE__ */ c.createElement("svg", Y({ width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, n), /* @__PURE__ */ c.createElement("g", { clipPath: "url(#clip0_9113_25872)" }, /* @__PURE__ */ c.createElement(
  "path",
  {
    d: "M18 15V18H6V15H4V18C4 19.1 4.9 20 6 20H18C19.1 20 20 19.1 20 18V15H18ZM17 11L15.59 9.59L13 12.17V4H11V12.17L8.41 9.59L7 11L12 16L17 11Z",
    fill: "#fff"
  }
)), /* @__PURE__ */ c.createElement("defs", null, /* @__PURE__ */ c.createElement("clipPath", { id: "clip0_9113_25872" }, /* @__PURE__ */ c.createElement("rect", { width: "24", height: "24", fill: "white" })))), Vh = (n) => /* @__PURE__ */ c.createElement(
  "svg",
  Y({
    width: "11",
    height: "15",
    viewBox: "0 0 11 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-label": "Pause Button"
  }, n),
  /* @__PURE__ */ c.createElement("line", { x1: "1", y1: "14.15", x2: "1", y2: "2.47955e-05", stroke: "#696F88", strokeWidth: "2" }),
  /* @__PURE__ */ c.createElement("line", { x1: "10", y1: "14.15", x2: "10", y2: "2.47955e-05", stroke: "#696F88", strokeWidth: "2" })
), Bn = (n) => /* @__PURE__ */ c.createElement(
  "svg",
  Y({
    width: "12",
    height: "15",
    viewBox: "0 0 12 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-label": "Play Button"
  }, n),
  /* @__PURE__ */ c.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M11.6585 7.5617L0.926758 14.391V0.732422L11.6585 7.5617ZM8.0197 7.5625L2.87822 4.28449L2.87821 10.8406L8.0197 7.5625Z",
      fill: "#696F88"
    }
  ),
  /* @__PURE__ */ c.createElement("path", { d: "M2 4H4.92683L8.58537 7.65854L4.92683 11.3171H2V4Z", fill: "#696F88" })
), vn = (n) => {
  const e = new Date(0);
  return e.setSeconds(n), e.toISOString().substring(14, 19);
}, jh = ({
  events: n,
  playerButton: e,
  duration: t,
  audio: i
}) => {
  var r, s;
  i.paused ? (i.play(), (r = n.clickToPlayAudio) == null || r.call(n, { audioDuration: t }), e.innerHTML = qt.renderToString(/* @__PURE__ */ c.createElement(Vh, null))) : (i.pause(), (s = n.clickToPauseAudio) == null || s.call(n, { audioDuration: t }), e.innerHTML = qt.renderToString(/* @__PURE__ */ c.createElement(Bn, null)));
}, Uh = (n, e, t) => {
  const i = 100 * n.currentTime / n.duration;
  e.style.backgroundSize = `${i}% 100%`, e.value = `${i}`;
  const r = vn(n.duration - n.currentTime);
  t(r);
}, Wh = (n, e) => {
  const i = +e.value * n.duration / 100;
  n.currentTime = i;
};
const qh = ({ audio: n }) => {
  const [e, t] = le(n.playbackRate), i = () => {
    let r = 0;
    switch (n.playbackRate) {
      case 1:
        r = 1.5;
        break;
      case 1.5:
        r = 2;
        break;
      case 2:
      default:
        r = 1;
    }
    t(r), n.playbackRate = r;
  };
  return /* @__PURE__ */ c.createElement("button", { className: "speed-control", onClick: i, "data-testid": "speed-button" }, e, "x");
}, ji = ({
  audio: n,
  duration: e,
  customAudioStyles: t,
  events: i,
  isGaleryV2: r,
  audioUrl: s,
  audioRateControl: o = !1
}) => {
  const { theme: l } = ze(), h = We(null), d = We(null), [m, p] = le(e), _ = () => h.current && Wh(n, h.current), g = () => d.current && jh({
    playerButton: d.current,
    duration: e,
    events: i,
    audio: n
  });
  return he(() => {
    var S;
    if (n && h && h.current && d && d.current) {
      (S = d.current) == null || S.addEventListener("click", g), n.ontimeupdate = () => h.current && Uh(n, h.current, p), h.current.value = "0";
      const A = () => {
        d.current && (d.current.innerHTML = qt.renderToString(/* @__PURE__ */ c.createElement(Bn, null))), h.current && (h.current.value = "0"), p(e);
      };
      return n.onended = A, h == null || h.current.addEventListener("change", _), () => {
        var I, L;
        (I = d == null ? void 0 : d.current) == null || I.removeEventListener("click", g), (L = h == null ? void 0 : h.current) == null || L.removeEventListener("change", _), n.pause(), n.currentTime = 0, d.current && (d.current.innerHTML = qt.renderToString(/* @__PURE__ */ c.createElement(Bn, null))), h.current && (h.current.value = "0");
      };
    }
  }, [n]), /* @__PURE__ */ c.createElement(
    "div",
    {
      className: G("audio-player", {
        "audio-player-dark": l === "dark"
      }),
      style: t
    },
    /* @__PURE__ */ c.createElement("div", { className: G("controls", { "controls-dark": l === "dark" }) }, /* @__PURE__ */ c.createElement(
      "button",
      {
        ref: d,
        type: "button",
        className: G("player-button", { "player-button-dark": l === "dark" }),
        "data-testid": "player-button"
      },
      /* @__PURE__ */ c.createElement(Bn, null)
    ), r && /* @__PURE__ */ c.createElement("span", { style: { marginLeft: "6px" } }, m), /* @__PURE__ */ c.createElement(
      "input",
      {
        ref: h,
        type: "range",
        className: G("timeline", { "timeline-dark": l === "dark" }),
        max: "100",
        min: "0",
        alt: "Audio Player timeline"
      }
    ), !r && /* @__PURE__ */ c.createElement("span", null, m), /* @__PURE__ */ c.createElement("div", { className: G({ "controls-dl-speed": o === !0 }) }, o && /* @__PURE__ */ c.createElement(qh, { audio: n }), r && /* @__PURE__ */ c.createElement("a", { href: s, download: !0 }, /* @__PURE__ */ c.createElement(so, null))))
  );
};
ji.displayName = "AudioPlayer";
const Gh = {
  normal: "note",
  simulated: "noteSimulated",
  normalPhoto: "notePhoto",
  simulatedPhoto: "noteSimulatedPhoto",
  normalAudio: "noteAudio",
  simulatedAudio: "noteSimulatedAudio",
  normalPhotoAudio: "notePhotoAudio",
  simulatedPhotoAudio: "noteSimulatedPhotoAudio"
}, Yh = (n) => {
  if (typeof n == "string") {
    const e = n.trim().split(/\s+/);
    if (e.length === 2) {
      const t = e[0].charAt(0).toUpperCase(), i = e[1].charAt(0).toUpperCase();
      return `${t}${i}`;
    }
    return n.slice(0, 2).toUpperCase();
  }
  return "";
}, $h = (n) => [...n].reverse(), oo = (n, e) => e ? $h(n) : n, hs = (n, e) => e != null && e.length ? n === st.AUDIO ? e.find((t) => t.file_type === n) : e.filter((t) => t.file_type === n) : [], Xh = ({
  notes: n,
  focusedNote: e,
  reversedCoordinates: t
}) => n != null && n.length ? {
  type: "FeatureCollection",
  features: n.map((i, r) => {
    const s = i.manual_location || i.user_location, o = hs(st.PICTURES, i.note_attachment), l = hs(st.AUDIO, i.note_attachment), h = i.manual_location ? "simulated" : "normal", d = Array.isArray(o) && o.length ? "Photo" : "", m = !Array.isArray(l) && l ? "Audio" : "", p = Gh[h + d + m];
    return Te(Y({}, s), {
      geometry: Te(Y({}, s.geometry), {
        coordinates: oo(s.geometry.coordinates, t)
      }),
      properties: {
        id: i.id,
        icon: p,
        icon_offset: [0, -34],
        opacity: !e || e[0] === r ? 1 : 0.5,
        index: r
      },
      markerProps: {
        notesCreated: i.date
      }
    });
  })
} : { type: "FeatureCollection", features: [] }, vt = (n, e) => {
  const t = e == null ? void 0 : e[n];
  return t || n;
}, Kh = (n) => Re(n).isAfter(Re().endOf("day")), ao = (n) => {
  const e = Re(n[0]), t = Re(n[1]);
  let i = null;
  if (t.format("YYYY-MM-DD") === Re().format("YYYY-MM-DD"))
    switch (t.diff(e, "days")) {
      case Vt.TODAY:
        i = "TODAY";
        break;
      case Vt.LAST_3_DAYS:
        i = "LAST_3_DAYS";
        break;
      case Vt.LAST_7_DAYS:
        i = "LAST_7_DAYS";
        break;
      case Vt.LAST_14_DAYS:
        i = "LAST_14_DAYS";
        break;
      case Vt.LAST_30_DAYS:
        i = "LAST_30_DAYS";
        break;
    }
  return i;
}, Jh = (n, e) => G({
  "selected-range": e === n
}), Qh = () => {
}, ed = (n, e) => {
  var r, s, o, l;
  const t = (s = (r = n == null ? void 0 : n[+e]) == null ? void 0 : r.manual_location) == null ? void 0 : s.geometry.coordinates, i = (l = (o = n == null ? void 0 : n[+e]) == null ? void 0 : o.user_location) == null ? void 0 : l.geometry.coordinates;
  return t || i;
}, ds = (n, e) => n.filter((s) => e.includes(s.value)).map((s) => s.title).reduce((s, o) => s + o.length, 0) > 25 ? 1 : 3, fs = (n, e, t) => n.slice(e, n.length).map((i) => /* @__PURE__ */ c.createElement("span", { key: i, style: { display: "block" } }, vt(i, t))), Ai = ({ tag: n, tagsTranslations: e }) => /* @__PURE__ */ c.createElement("span", { key: n, style: { display: "block" } }, vt(n, e)), pt = ({ tag: n, customStyleInfoTagText: e, tagsTranslations: t, tooltip: i }) => /* @__PURE__ */ c.createElement(
  "div",
  {
    "data-testid": `info-tag-${n.split(" ").join("-").toLowerCase()}`,
    className: `${$}__container__info-note__tags-container__tag-item`,
    key: n
  },
  /* @__PURE__ */ c.createElement(
    "span",
    {
      style: e,
      className: `${$}__container__info-note__tags-container__tag-item__text`
    },
    /* @__PURE__ */ c.createElement(Ds, { title: i ? /* @__PURE__ */ c.createElement("div", null, i) : null, placement: "bottom" }, t ? vt(n, t) : n)
  )
), td = (n, e, t, i) => {
  if (t.length === 1)
    return /* @__PURE__ */ c.createElement(
      pt,
      {
        tag: t[0],
        tagsTranslations: e,
        customStyleInfoTagText: { maxWidth: `${i - et}px` }
      }
    );
  const r = vt(t[0], e).length * an, s = i - r;
  if (t.length === 2) {
    const p = fs(t, 1, e);
    return /* @__PURE__ */ c.createElement(c.Fragment, null, /* @__PURE__ */ c.createElement(pt, { tag: t[0], tagsTranslations: e }), s > et && /* @__PURE__ */ c.createElement(
      pt,
      {
        tag: t[1],
        tagsTranslations: e,
        customStyleInfoTagText: { maxWidth: `${s}px` },
        tooltip: s < vt(t[1], e).length * an && /* @__PURE__ */ c.createElement(Ai, { tag: t[1], tagsTranslations: e })
      }
    ), s < et && /* @__PURE__ */ c.createElement(pt, { tag: "+1", tooltip: p }));
  }
  const o = vt(t[1], e).length * an, l = i - (r + o), d = s < et ? 1 : 2, m = l < et ? d : 3;
  if (t.length >= 3) {
    const p = fs(t, m, e), _ = t.length > 3 || s < et || l < et || r < i;
    return /* @__PURE__ */ c.createElement(c.Fragment, null, /* @__PURE__ */ c.createElement(
      pt,
      {
        tag: t[0],
        tagsTranslations: e,
        customStyleInfoTagText: { maxWidth: `${i - et}px` }
      }
    ), s > et && /* @__PURE__ */ c.createElement(
      pt,
      {
        tag: t[1],
        tagsTranslations: e,
        customStyleInfoTagText: { maxWidth: `${s}px` },
        tooltip: s < vt(t[1], e).length * an && /* @__PURE__ */ c.createElement(Ai, { tag: t[1], tagsTranslations: e })
      }
    ), l > et && /* @__PURE__ */ c.createElement(
      pt,
      {
        tag: t[2],
        tagsTranslations: e,
        customStyleInfoTagText: { maxWidth: `${l}px` },
        tooltip: l < vt(t[2], e).length * an && /* @__PURE__ */ c.createElement(Ai, { tag: t[2], tagsTranslations: e })
      }
    ), _ && !!(t.length - m) && /* @__PURE__ */ c.createElement(pt, { tag: `+${t.length - m}`, tooltip: p }));
  }
}, lo = ({ customStyleInfoTagText: n, tagsTranslations: e, tags: t }) => {
  const i = We(null), [r, s] = le();
  return he(() => {
    var o, l;
    (o = i == null ? void 0 : i.current) != null && o.clientWidth && s((l = i == null ? void 0 : i.current) == null ? void 0 : l.clientWidth);
  }, [i]), !t || !t.length ? null : /* @__PURE__ */ c.createElement(
    "div",
    {
      ref: i,
      "data-testid": "info-tags-container",
      className: `${$}__container__info-note__tags-container`
    },
    td(n, e, t, r)
  );
};
/*!
  * PhotoSwipe Lightbox 5.3.6 - https://photoswipe.com
  * (c) 2023 Dmytro Semenov
  */
function cn(n, e, t) {
  const i = document.createElement(e);
  return n && (i.className = n), t && t.appendChild(i), i;
}
function nd(n, e, t) {
  let i = `translate3d(${n}px,${e || 0}px,0)`;
  return t !== void 0 && (i += ` scale3d(${t},${t},1)`), i;
}
function zi(n, e, t) {
  n.style.width = typeof e == "number" ? `${e}px` : e, n.style.height = typeof t == "number" ? `${t}px` : t;
}
const Ve = {
  IDLE: "idle",
  LOADING: "loading",
  LOADED: "loaded",
  ERROR: "error"
};
function id(n) {
  return "button" in n && n.button === 1 || n.ctrlKey || n.metaKey || n.altKey || n.shiftKey;
}
function Hn(n, e, t = document) {
  let i = [];
  if (n instanceof Element)
    i = [n];
  else if (n instanceof NodeList || Array.isArray(n))
    i = Array.from(n);
  else {
    const r = typeof n == "string" ? n : e;
    r && (i = Array.from(t.querySelectorAll(r)));
  }
  return i;
}
function rd(n) {
  return typeof n == "function" && n.prototype && n.prototype.goTo;
}
function ps() {
  return !!(navigator.vendor && navigator.vendor.match(/apple/i));
}
let sd = class {
  /**
   * @param {T} type
   * @param {PhotoSwipeEventsMap[T]} [details]
   */
  constructor(e, t) {
    this.type = e, this.defaultPrevented = !1, t && Object.assign(this, t);
  }
  preventDefault() {
    this.defaultPrevented = !0;
  }
}, od = class {
  constructor() {
    this._listeners = {}, this._filters = {}, this.pswp = void 0, this.options = void 0;
  }
  /**
   * @template {keyof PhotoSwipeFiltersMap} T
   * @param {T} name
   * @param {PhotoSwipeFiltersMap[T]} fn
   * @param {number} priority
   */
  addFilter(e, t, i = 100) {
    var r, s, o;
    this._filters[e] || (this._filters[e] = []), (r = this._filters[e]) == null || r.push({ fn: t, priority: i }), (s = this._filters[e]) == null || s.sort((l, h) => l.priority - h.priority), (o = this.pswp) == null || o.addFilter(e, t, i);
  }
  /**
   * @template {keyof PhotoSwipeFiltersMap} T
   * @param {T} name
   * @param {PhotoSwipeFiltersMap[T]} fn
   */
  removeFilter(e, t) {
    this._filters[e] && (this._filters[e] = this._filters[e].filter((i) => i.fn !== t)), this.pswp && this.pswp.removeFilter(e, t);
  }
  /**
   * @template {keyof PhotoSwipeFiltersMap} T
   * @param {T} name
   * @param {Parameters<PhotoSwipeFiltersMap[T]>} args
   * @returns {Parameters<PhotoSwipeFiltersMap[T]>[0]}
   */
  applyFilters(e, ...t) {
    var i;
    return (i = this._filters[e]) == null || i.forEach((r) => {
      t[0] = r.fn.apply(this, t);
    }), t[0];
  }
  /**
   * @template {keyof PhotoSwipeEventsMap} T
   * @param {T} name
   * @param {EventCallback<T>} fn
   */
  on(e, t) {
    var i, r;
    this._listeners[e] || (this._listeners[e] = []), (i = this._listeners[e]) == null || i.push(t), (r = this.pswp) == null || r.on(e, t);
  }
  /**
   * @template {keyof PhotoSwipeEventsMap} T
   * @param {T} name
   * @param {EventCallback<T>} fn
   */
  off(e, t) {
    var i;
    this._listeners[e] && (this._listeners[e] = this._listeners[e].filter((r) => t !== r)), (i = this.pswp) == null || i.off(e, t);
  }
  /**
   * @template {keyof PhotoSwipeEventsMap} T
   * @param {T} name
   * @param {PhotoSwipeEventsMap[T]} [details]
   * @returns {AugmentedEvent<T>}
   */
  dispatch(e, t) {
    var r;
    if (this.pswp)
      return this.pswp.dispatch(e, t);
    const i = (
      /** @type {AugmentedEvent<T>} */
      new sd(e, t)
    );
    return (r = this._listeners[e]) == null || r.forEach((s) => {
      s.call(this, i);
    }), i;
  }
}, ad = class {
  /**
   * @param {string | false} imageSrc
   * @param {HTMLElement} container
   */
  constructor(e, t) {
    if (this.element = cn(
      "pswp__img pswp__img--placeholder",
      e ? "img" : "div",
      t
    ), e) {
      const i = (
        /** @type {HTMLImageElement} */
        this.element
      );
      i.decoding = "async", i.alt = "", i.src = e, i.setAttribute("role", "presentation");
    }
    this.element.setAttribute("aria-hidden", "true");
  }
  /**
   * @param {number} width
   * @param {number} height
   */
  setDisplayedSize(e, t) {
    this.element && (this.element.tagName === "IMG" ? (zi(this.element, 250, "auto"), this.element.style.transformOrigin = "0 0", this.element.style.transform = nd(0, 0, e / 250)) : zi(this.element, e, t));
  }
  destroy() {
    var e;
    (e = this.element) != null && e.parentNode && this.element.remove(), this.element = null;
  }
}, ld = class {
  /**
   * @param {SlideData} itemData Slide data
   * @param {PhotoSwipeBase} instance PhotoSwipe or PhotoSwipeLightbox instance
   * @param {number} index
   */
  constructor(e, t, i) {
    this.instance = t, this.data = e, this.index = i, this.element = void 0, this.placeholder = void 0, this.slide = void 0, this.displayedImageWidth = 0, this.displayedImageHeight = 0, this.width = Number(this.data.w) || Number(this.data.width) || 0, this.height = Number(this.data.h) || Number(this.data.height) || 0, this.isAttached = !1, this.hasSlide = !1, this.isDecoding = !1, this.state = Ve.IDLE, this.data.type ? this.type = this.data.type : this.data.src ? this.type = "image" : this.type = "html", this.instance.dispatch("contentInit", { content: this });
  }
  removePlaceholder() {
    this.placeholder && !this.keepPlaceholder() && setTimeout(() => {
      this.placeholder && (this.placeholder.destroy(), this.placeholder = void 0);
    }, 1e3);
  }
  /**
   * Preload content
   *
   * @param {boolean} isLazy
   * @param {boolean} [reload]
   */
  load(e, t) {
    if (this.slide && this.usePlaceholder())
      if (this.placeholder) {
        const i = this.placeholder.element;
        i && !i.parentElement && this.slide.container.prepend(i);
      } else {
        const i = this.instance.applyFilters(
          "placeholderSrc",
          // use  image-based placeholder only for the first slide,
          // as rendering (even small stretched thumbnail) is an expensive operation
          this.data.msrc && this.slide.isFirstSlide ? this.data.msrc : !1,
          this
        );
        this.placeholder = new ad(
          i,
          this.slide.container
        );
      }
    this.element && !t || this.instance.dispatch("contentLoad", { content: this, isLazy: e }).defaultPrevented || (this.isImageContent() ? (this.element = cn("pswp__img", "img"), this.displayedImageWidth && this.loadImage(e)) : (this.element = cn("pswp__content", "div"), this.element.innerHTML = this.data.html || ""), t && this.slide && this.slide.updateContentSize(!0));
  }
  /**
   * Preload image
   *
   * @param {boolean} isLazy
   */
  loadImage(e) {
    var i, r;
    if (!this.isImageContent() || !this.element || this.instance.dispatch("contentLoadImage", { content: this, isLazy: e }).defaultPrevented)
      return;
    const t = (
      /** @type HTMLImageElement */
      this.element
    );
    this.updateSrcsetSizes(), this.data.srcset && (t.srcset = this.data.srcset), t.src = (i = this.data.src) != null ? i : "", t.alt = (r = this.data.alt) != null ? r : "", this.state = Ve.LOADING, t.complete ? this.onLoaded() : (t.onload = () => {
      this.onLoaded();
    }, t.onerror = () => {
      this.onError();
    });
  }
  /**
   * Assign slide to content
   *
   * @param {Slide} slide
   */
  setSlide(e) {
    this.slide = e, this.hasSlide = !0, this.instance = e.pswp;
  }
  /**
   * Content load success handler
   */
  onLoaded() {
    this.state = Ve.LOADED, this.slide && this.element && (this.instance.dispatch("loadComplete", { slide: this.slide, content: this }), this.slide.isActive && this.slide.heavyAppended && !this.element.parentNode && (this.append(), this.slide.updateContentSize(!0)), (this.state === Ve.LOADED || this.state === Ve.ERROR) && this.removePlaceholder());
  }
  /**
   * Content load error handler
   */
  onError() {
    this.state = Ve.ERROR, this.slide && (this.displayError(), this.instance.dispatch("loadComplete", { slide: this.slide, isError: !0, content: this }), this.instance.dispatch("loadError", { slide: this.slide, content: this }));
  }
  /**
   * @returns {Boolean} If the content is currently loading
   */
  isLoading() {
    return this.instance.applyFilters(
      "isContentLoading",
      this.state === Ve.LOADING,
      this
    );
  }
  /**
   * @returns {Boolean} If the content is in error state
   */
  isError() {
    return this.state === Ve.ERROR;
  }
  /**
   * @returns {boolean} If the content is image
   */
  isImageContent() {
    return this.type === "image";
  }
  /**
   * Update content size
   *
   * @param {Number} width
   * @param {Number} height
   */
  setDisplayedSize(e, t) {
    if (this.element && (this.placeholder && this.placeholder.setDisplayedSize(e, t), !this.instance.dispatch(
      "contentResize",
      { content: this, width: e, height: t }
    ).defaultPrevented && (zi(this.element, e, t), this.isImageContent() && !this.isError()))) {
      const i = !this.displayedImageWidth && e;
      this.displayedImageWidth = e, this.displayedImageHeight = t, i ? this.loadImage(!1) : this.updateSrcsetSizes(), this.slide && this.instance.dispatch(
        "imageSizeChange",
        { slide: this.slide, width: e, height: t, content: this }
      );
    }
  }
  /**
   * @returns {boolean} If the content can be zoomed
   */
  isZoomable() {
    return this.instance.applyFilters(
      "isContentZoomable",
      this.isImageContent() && this.state !== Ve.ERROR,
      this
    );
  }
  /**
   * Update image srcset sizes attribute based on width and height
   */
  updateSrcsetSizes() {
    if (!this.isImageContent() || !this.element || !this.data.srcset)
      return;
    const e = (
      /** @type HTMLImageElement */
      this.element
    ), t = this.instance.applyFilters(
      "srcsetSizesWidth",
      this.displayedImageWidth,
      this
    );
    (!e.dataset.largestUsedSize || t > parseInt(e.dataset.largestUsedSize, 10)) && (e.sizes = t + "px", e.dataset.largestUsedSize = String(t));
  }
  /**
   * @returns {boolean} If content should use a placeholder (from msrc by default)
   */
  usePlaceholder() {
    return this.instance.applyFilters(
      "useContentPlaceholder",
      this.isImageContent(),
      this
    );
  }
  /**
   * Preload content with lazy-loading param
   */
  lazyLoad() {
    this.instance.dispatch("contentLazyLoad", { content: this }).defaultPrevented || this.load(!0);
  }
  /**
   * @returns {boolean} If placeholder should be kept after content is loaded
   */
  keepPlaceholder() {
    return this.instance.applyFilters(
      "isKeepingPlaceholder",
      this.isLoading(),
      this
    );
  }
  /**
   * Destroy the content
   */
  destroy() {
    this.hasSlide = !1, this.slide = void 0, !this.instance.dispatch("contentDestroy", { content: this }).defaultPrevented && (this.remove(), this.placeholder && (this.placeholder.destroy(), this.placeholder = void 0), this.isImageContent() && this.element && (this.element.onload = null, this.element.onerror = null, this.element = void 0));
  }
  /**
   * Display error message
   */
  displayError() {
    var e, t;
    if (this.slide) {
      let i = cn("pswp__error-msg", "div");
      i.innerText = (t = (e = this.instance.options) == null ? void 0 : e.errorMsg) != null ? t : "", i = /** @type {HTMLDivElement} */
      this.instance.applyFilters(
        "contentErrorElement",
        i,
        this
      ), this.element = cn("pswp__content pswp__error-msg-container", "div"), this.element.appendChild(i), this.slide.container.innerText = "", this.slide.container.appendChild(this.element), this.slide.updateContentSize(!0), this.removePlaceholder();
    }
  }
  /**
   * Append the content
   */
  append() {
    if (this.isAttached || !this.element)
      return;
    if (this.isAttached = !0, this.state === Ve.ERROR) {
      this.displayError();
      return;
    }
    if (this.instance.dispatch("contentAppend", { content: this }).defaultPrevented)
      return;
    const e = "decode" in this.element;
    this.isImageContent() ? e && this.slide && (!this.slide.isActive || ps()) ? (this.isDecoding = !0, this.element.decode().catch(() => {
    }).finally(() => {
      this.isDecoding = !1, this.appendImage();
    })) : this.appendImage() : this.slide && !this.element.parentNode && this.slide.container.appendChild(this.element);
  }
  /**
   * Activate the slide,
   * active slide is generally the current one,
   * meaning the user can see it.
   */
  activate() {
    this.instance.dispatch("contentActivate", { content: this }).defaultPrevented || !this.slide || (this.isImageContent() && this.isDecoding && !ps() ? this.appendImage() : this.isError() && this.load(!1, !0), this.slide.holderElement && this.slide.holderElement.setAttribute("aria-hidden", "false"));
  }
  /**
   * Deactivate the content
   */
  deactivate() {
    this.instance.dispatch("contentDeactivate", { content: this }), this.slide && this.slide.holderElement && this.slide.holderElement.setAttribute("aria-hidden", "true");
  }
  /**
   * Remove the content from DOM
   */
  remove() {
    this.isAttached = !1, !this.instance.dispatch("contentRemove", { content: this }).defaultPrevented && (this.element && this.element.parentNode && this.element.remove(), this.placeholder && this.placeholder.element && this.placeholder.element.remove());
  }
  /**
   * Append the image content to slide container
   */
  appendImage() {
    this.isAttached && (this.instance.dispatch("contentAppendImage", { content: this }).defaultPrevented || (this.slide && this.element && !this.element.parentNode && this.slide.container.appendChild(this.element), (this.state === Ve.LOADED || this.state === Ve.ERROR) && this.removePlaceholder()));
  }
};
function cd(n, e) {
  if (n.getViewportSizeFn) {
    const t = n.getViewportSizeFn(n, e);
    if (t)
      return t;
  }
  return {
    x: document.documentElement.clientWidth,
    // TODO: height on mobile is very incosistent due to toolbar
    // find a way to improve this
    //
    // document.documentElement.clientHeight - doesn't seem to work well
    y: window.innerHeight
  };
}
function Zn(n, e, t, i, r) {
  let s = 0;
  if (e.paddingFn)
    s = e.paddingFn(t, i, r)[n];
  else if (e.padding)
    s = e.padding[n];
  else {
    const o = "padding" + n[0].toUpperCase() + n.slice(1);
    e[o] && (s = e[o]);
  }
  return Number(s) || 0;
}
function ud(n, e, t, i) {
  return {
    x: e.x - Zn("left", n, e, t, i) - Zn("right", n, e, t, i),
    y: e.y - Zn("top", n, e, t, i) - Zn("bottom", n, e, t, i)
  };
}
const ms = 4e3;
let hd = class {
  /**
   * @param {PhotoSwipeOptions} options PhotoSwipe options
   * @param {SlideData} itemData Slide data
   * @param {number} index Slide index
   * @param {PhotoSwipe} [pswp] PhotoSwipe instance, can be undefined if not initialized yet
   */
  constructor(e, t, i, r) {
    this.pswp = r, this.options = e, this.itemData = t, this.index = i, this.panAreaSize = null, this.elementSize = null, this.fit = 1, this.fill = 1, this.vFill = 1, this.initial = 1, this.secondary = 1, this.max = 1, this.min = 1;
  }
  /**
   * Calculate initial, secondary and maximum zoom level for the specified slide.
   *
   * It should be called when either image or viewport size changes.
   *
   * @param {number} maxWidth
   * @param {number} maxHeight
   * @param {Point} panAreaSize
   */
  update(e, t, i) {
    const r = { x: e, y: t };
    this.elementSize = r, this.panAreaSize = i;
    const s = i.x / r.x, o = i.y / r.y;
    this.fit = Math.min(1, s < o ? s : o), this.fill = Math.min(1, s > o ? s : o), this.vFill = Math.min(1, o), this.initial = this._getInitial(), this.secondary = this._getSecondary(), this.max = Math.max(
      this.initial,
      this.secondary,
      this._getMax()
    ), this.min = Math.min(
      this.fit,
      this.initial,
      this.secondary
    ), this.pswp && this.pswp.dispatch("zoomLevelsUpdate", { zoomLevels: this, slideData: this.itemData });
  }
  /**
   * Parses user-defined zoom option.
   *
   * @private
   * @param {'initial' | 'secondary' | 'max'} optionPrefix Zoom level option prefix (initial, secondary, max)
   * @returns { number | undefined }
   */
  _parseZoomLevelOption(e) {
    const t = (
      /** @type {'initialZoomLevel' | 'secondaryZoomLevel' | 'maxZoomLevel'} */
      e + "ZoomLevel"
    ), i = this.options[t];
    if (i)
      return typeof i == "function" ? i(this) : i === "fill" ? this.fill : i === "fit" ? this.fit : Number(i);
  }
  /**
   * Get zoom level to which image will be zoomed after double-tap gesture,
   * or when user clicks on zoom icon,
   * or mouse-click on image itself.
   * If you return 1 image will be zoomed to its original size.
   *
   * @private
   * @return {number}
   */
  _getSecondary() {
    let e = this._parseZoomLevelOption("secondary");
    return e || (e = Math.min(1, this.fit * 3), this.elementSize && e * this.elementSize.x > ms && (e = ms / this.elementSize.x), e);
  }
  /**
   * Get initial image zoom level.
   *
   * @private
   * @return {number}
   */
  _getInitial() {
    return this._parseZoomLevelOption("initial") || this.fit;
  }
  /**
   * Maximum zoom level when user zooms
   * via zoom/pinch gesture,
   * via cmd/ctrl-wheel or via trackpad.
   *
   * @private
   * @return {number}
   */
  _getMax() {
    return this._parseZoomLevelOption("max") || Math.max(1, this.fit * 4);
  }
};
function co(n, e, t) {
  const i = e.createContentFromData(n, t);
  let r;
  const { options: s } = e;
  if (s) {
    r = new hd(s, n, -1);
    let o;
    e.pswp ? o = e.pswp.viewportSize : o = cd(s, e);
    const l = ud(s, o, n, t);
    r.update(i.width, i.height, l);
  }
  return i.lazyLoad(), r && i.setDisplayedSize(
    Math.ceil(i.width * r.initial),
    Math.ceil(i.height * r.initial)
  ), i;
}
function dd(n, e) {
  const t = e.getItemData(n);
  if (!e.dispatch("lazyLoadSlide", { index: n, itemData: t }).defaultPrevented)
    return co(t, e, n);
}
let fd = class extends od {
  /**
   * Get total number of slides
   *
   * @returns {number}
   */
  getNumItems() {
    var r;
    let e = 0;
    const t = (r = this.options) == null ? void 0 : r.dataSource;
    t && "length" in t ? e = t.length : t && "gallery" in t && (t.items || (t.items = this._getGalleryDOMElements(t.gallery)), t.items && (e = t.items.length));
    const i = this.dispatch("numItems", {
      dataSource: t,
      numItems: e
    });
    return this.applyFilters("numItems", i.numItems, t);
  }
  /**
   * @param {SlideData} slideData
   * @param {number} index
   * @returns {Content}
   */
  createContentFromData(e, t) {
    return new ld(e, this, t);
  }
  /**
   * Get item data by index.
   *
   * "item data" should contain normalized information that PhotoSwipe needs to generate a slide.
   * For example, it may contain properties like
   * `src`, `srcset`, `w`, `h`, which will be used to generate a slide with image.
   *
   * @param {number} index
   * @returns {SlideData}
   */
  getItemData(e) {
    var o;
    const t = (o = this.options) == null ? void 0 : o.dataSource;
    let i = {};
    Array.isArray(t) ? i = t[e] : t && "gallery" in t && (t.items || (t.items = this._getGalleryDOMElements(t.gallery)), i = t.items[e]);
    let r = i;
    r instanceof Element && (r = this._domElementToItemData(r));
    const s = this.dispatch("itemData", {
      itemData: r || {},
      index: e
    });
    return this.applyFilters("itemData", s.itemData, e);
  }
  /**
   * Get array of gallery DOM elements,
   * based on childSelector and gallery element.
   *
   * @param {HTMLElement} galleryElement
   * @returns {HTMLElement[]}
   */
  _getGalleryDOMElements(e) {
    var t, i;
    return (t = this.options) != null && t.children || (i = this.options) != null && i.childSelector ? Hn(
      this.options.children,
      this.options.childSelector,
      e
    ) || [] : [e];
  }
  /**
   * Converts DOM element to item data object.
   *
   * @param {HTMLElement} element DOM element
   * @returns {SlideData}
   */
  _domElementToItemData(e) {
    var r;
    const t = {
      element: e
    }, i = (
      /** @type {HTMLAnchorElement} */
      e.tagName === "A" ? e : e.querySelector("a")
    );
    if (i) {
      t.src = i.dataset.pswpSrc || i.href, i.dataset.pswpSrcset && (t.srcset = i.dataset.pswpSrcset), t.width = i.dataset.pswpWidth ? parseInt(i.dataset.pswpWidth, 10) : 0, t.height = i.dataset.pswpHeight ? parseInt(i.dataset.pswpHeight, 10) : 0, t.w = t.width, t.h = t.height, i.dataset.pswpType && (t.type = i.dataset.pswpType);
      const s = e.querySelector("img");
      s && (t.msrc = s.currentSrc || s.src, t.alt = (r = s.getAttribute("alt")) != null ? r : ""), (i.dataset.pswpCropped || i.dataset.cropped) && (t.thumbCropped = !0);
    }
    return this.applyFilters("domItemData", t, e, i);
  }
  /**
   * Lazy-load by slide data
   *
   * @param {SlideData} itemData Data about the slide
   * @param {number} index
   * @returns {Content} Image that is being decoded or false.
   */
  lazyLoadData(e, t) {
    return co(e, this, t);
  }
};
class pd extends fd {
  /**
   * @param {PhotoSwipeOptions} [options]
   */
  constructor(e) {
    super(), this.options = e || {}, this._uid = 0, this.shouldOpen = !1, this._preloadedContent = void 0, this.onThumbnailsClick = this.onThumbnailsClick.bind(this);
  }
  /**
   * Initialize lightbox, should be called only once.
   * It's not included in the main constructor, so you may bind events before it.
   */
  init() {
    Hn(this.options.gallery, this.options.gallerySelector).forEach((e) => {
      e.addEventListener("click", this.onThumbnailsClick, !1);
    });
  }
  /**
   * @param {MouseEvent} e
   */
  onThumbnailsClick(e) {
    if (id(e) || window.pswp || window.navigator.onLine === !1)
      return;
    let t = { x: e.clientX, y: e.clientY };
    !t.x && !t.y && (t = null);
    let i = this.getClickedIndex(e);
    i = this.applyFilters("clickedIndex", i, e, this);
    const r = {
      gallery: (
        /** @type {HTMLElement} */
        e.currentTarget
      )
    };
    i >= 0 && (e.preventDefault(), this.loadAndOpen(i, r, t));
  }
  /**
   * Get index of gallery item that was clicked.
   *
   * @param {MouseEvent} e click event
   * @returns {number}
   */
  getClickedIndex(e) {
    if (this.options.getClickedIndexFn)
      return this.options.getClickedIndexFn.call(this, e);
    const t = (
      /** @type {HTMLElement} */
      e.target
    ), r = Hn(
      this.options.children,
      this.options.childSelector,
      /** @type {HTMLElement} */
      e.currentTarget
    ).findIndex(
      (s) => s === t || s.contains(t)
    );
    return r !== -1 ? r : this.options.children || this.options.childSelector ? -1 : 0;
  }
  /**
   * Load and open PhotoSwipe
   *
   * @param {number} index
   * @param {DataSource} dataSource
   * @param {Point | null} [initialPoint]
   * @returns {boolean}
   */
  loadAndOpen(e, t, i) {
    return window.pswp ? !1 : (this.options.index = e, this.options.initialPointerPos = i, this.shouldOpen = !0, this.preload(e, t), !0);
  }
  /**
   * Load the main module and the slide content by index
   *
   * @param {number} index
   * @param {DataSource} [dataSource]
   */
  preload(e, t) {
    const { options: i } = this;
    t && (i.dataSource = t);
    const r = [], s = typeof i.pswpModule;
    if (rd(i.pswpModule))
      r.push(Promise.resolve(
        /** @type {Type<PhotoSwipe>} */
        i.pswpModule
      ));
    else {
      if (s === "string")
        throw new Error("pswpModule as string is no longer supported");
      if (s === "function")
        r.push(
          /** @type {() => Promise<Type<PhotoSwipe>>} */
          i.pswpModule()
        );
      else
        throw new Error("pswpModule is not valid");
    }
    typeof i.openPromise == "function" && r.push(i.openPromise()), i.preloadFirstSlide !== !1 && e >= 0 && (this._preloadedContent = dd(e, this));
    const o = ++this._uid;
    Promise.all(r).then((l) => {
      if (this.shouldOpen) {
        const h = l[0];
        this._openPhotoswipe(h, o);
      }
    });
  }
  /**
   * @private
   * @param {Type<PhotoSwipe> | { default: Type<PhotoSwipe> }} module
   * @param {number} uid
   */
  _openPhotoswipe(e, t) {
    if (t !== this._uid && this.shouldOpen || (this.shouldOpen = !1, window.pswp))
      return;
    const i = typeof e == "object" ? new e.default(this.options) : new e(this.options);
    this.pswp = i, window.pswp = i, Object.keys(this._listeners).forEach((r) => {
      var s;
      (s = this._listeners[r]) == null || s.forEach((o) => {
        i.on(
          r,
          /** @type {EventCallback<typeof name>} */
          o
        );
      });
    }), Object.keys(this._filters).forEach((r) => {
      var s;
      (s = this._filters[r]) == null || s.forEach((o) => {
        i.addFilter(r, o.fn, o.priority);
      });
    }), this._preloadedContent && (i.contentLoader.addToCache(this._preloadedContent), this._preloadedContent = void 0), i.on("destroy", () => {
      this.pswp = void 0, delete window.pswp;
    }), i.init();
  }
  /**
   * Unbinds all events, closes PhotoSwipe if it's open.
   */
  destroy() {
    var e;
    (e = this.pswp) == null || e.destroy(), this.shouldOpen = !1, this._listeners = {}, Hn(this.options.gallery, this.options.gallerySelector).forEach((t) => {
      t.removeEventListener("click", this.onThumbnailsClick, !1);
    });
  }
}
/*!
  * PhotoSwipe 5.3.6 - https://photoswipe.com
  * (c) 2023 Dmytro Semenov
  */
function Le(n, e, t) {
  const i = document.createElement(e);
  return n && (i.className = n), t && t.appendChild(i), i;
}
function ye(n, e) {
  return n.x = e.x, n.y = e.y, e.id !== void 0 && (n.id = e.id), n;
}
function uo(n) {
  n.x = Math.round(n.x), n.y = Math.round(n.y);
}
function Ni(n, e) {
  const t = Math.abs(n.x - e.x), i = Math.abs(n.y - e.y);
  return Math.sqrt(t * t + i * i);
}
function fn(n, e) {
  return n.x === e.x && n.y === e.y;
}
function _n(n, e, t) {
  return Math.min(Math.max(n, e), t);
}
function gn(n, e, t) {
  let i = `translate3d(${n}px,${e || 0}px,0)`;
  return t !== void 0 && (i += ` scale3d(${t},${t},1)`), i;
}
function Tt(n, e, t, i) {
  n.style.transform = gn(e, t, i);
}
const md = "cubic-bezier(.4,0,.22,1)";
function ho(n, e, t, i) {
  n.style.transition = e ? `${e} ${t}ms ${i || md}` : "none";
}
function Fi(n, e, t) {
  n.style.width = typeof e == "number" ? `${e}px` : e, n.style.height = typeof t == "number" ? `${t}px` : t;
}
function vd(n) {
  ho(n);
}
function gd(n) {
  return "decode" in n ? n.decode().catch(() => {
  }) : n.complete ? Promise.resolve(n) : new Promise((e, t) => {
    n.onload = () => e(n), n.onerror = t;
  });
}
const je = {
  IDLE: "idle",
  LOADING: "loading",
  LOADED: "loaded",
  ERROR: "error"
};
function yd(n) {
  return "button" in n && n.button === 1 || n.ctrlKey || n.metaKey || n.altKey || n.shiftKey;
}
function _d(n, e, t = document) {
  let i = [];
  if (n instanceof Element)
    i = [n];
  else if (n instanceof NodeList || Array.isArray(n))
    i = Array.from(n);
  else {
    const r = typeof n == "string" ? n : e;
    r && (i = Array.from(t.querySelectorAll(r)));
  }
  return i;
}
function vs() {
  return !!(navigator.vendor && navigator.vendor.match(/apple/i));
}
let fo = !1;
try {
  window.addEventListener("test", null, Object.defineProperty({}, "passive", {
    get: () => {
      fo = !0;
    }
  }));
} catch (n) {
}
class bd {
  constructor() {
    this._pool = [];
  }
  /**
   * Adds event listeners
   *
   * @param {PoolItem['target']} target
   * @param {PoolItem['type']} type Can be multiple, separated by space.
   * @param {PoolItem['listener']} listener
   * @param {PoolItem['passive']} [passive]
   */
  add(e, t, i, r) {
    this._toggleListener(e, t, i, r);
  }
  /**
   * Removes event listeners
   *
   * @param {PoolItem['target']} target
   * @param {PoolItem['type']} type
   * @param {PoolItem['listener']} listener
   * @param {PoolItem['passive']} [passive]
   */
  remove(e, t, i, r) {
    this._toggleListener(e, t, i, r, !0);
  }
  /**
   * Removes all bound events
   */
  removeAll() {
    this._pool.forEach((e) => {
      this._toggleListener(
        e.target,
        e.type,
        e.listener,
        e.passive,
        !0,
        !0
      );
    }), this._pool = [];
  }
  /**
   * Adds or removes event
   *
   * @private
   * @param {PoolItem['target']} target
   * @param {PoolItem['type']} type
   * @param {PoolItem['listener']} listener
   * @param {PoolItem['passive']} [passive]
   * @param {boolean} [unbind] Whether the event should be added or removed
   * @param {boolean} [skipPool] Whether events pool should be skipped
   */
  _toggleListener(e, t, i, r, s, o) {
    if (!e)
      return;
    const l = s ? "removeEventListener" : "addEventListener";
    t.split(" ").forEach((d) => {
      if (d) {
        o || (s ? this._pool = this._pool.filter((p) => p.type !== d || p.listener !== i || p.target !== e) : this._pool.push({
          target: e,
          type: d,
          listener: i,
          passive: r
        }));
        const m = fo ? { passive: r || !1 } : !1;
        e[l](
          d,
          i,
          m
        );
      }
    });
  }
}
function po(n, e) {
  if (n.getViewportSizeFn) {
    const t = n.getViewportSizeFn(n, e);
    if (t)
      return t;
  }
  return {
    x: document.documentElement.clientWidth,
    // TODO: height on mobile is very incosistent due to toolbar
    // find a way to improve this
    //
    // document.documentElement.clientHeight - doesn't seem to work well
    y: window.innerHeight
  };
}
function un(n, e, t, i, r) {
  let s = 0;
  if (e.paddingFn)
    s = e.paddingFn(t, i, r)[n];
  else if (e.padding)
    s = e.padding[n];
  else {
    const o = "padding" + n[0].toUpperCase() + n.slice(1);
    e[o] && (s = e[o]);
  }
  return Number(s) || 0;
}
function mo(n, e, t, i) {
  return {
    x: e.x - un("left", n, e, t, i) - un("right", n, e, t, i),
    y: e.y - un("top", n, e, t, i) - un("bottom", n, e, t, i)
  };
}
class wd {
  /**
   * @param {Slide} slide
   */
  constructor(e) {
    this.slide = e, this.currZoomLevel = 1, this.center = /** @type {Point} */
    { x: 0, y: 0 }, this.max = /** @type {Point} */
    { x: 0, y: 0 }, this.min = /** @type {Point} */
    { x: 0, y: 0 };
  }
  /**
   * _getItemBounds
   *
   * @param {number} currZoomLevel
   */
  update(e) {
    this.currZoomLevel = e, this.slide.width ? (this._updateAxis("x"), this._updateAxis("y"), this.slide.pswp.dispatch("calcBounds", { slide: this.slide })) : this.reset();
  }
  /**
   * _calculateItemBoundsForAxis
   *
   * @param {Axis} axis
   */
  _updateAxis(e) {
    const { pswp: t } = this.slide, i = this.slide[e === "x" ? "width" : "height"] * this.currZoomLevel, s = un(
      e === "x" ? "left" : "top",
      t.options,
      t.viewportSize,
      this.slide.data,
      this.slide.index
    ), o = this.slide.panAreaSize[e];
    this.center[e] = Math.round((o - i) / 2) + s, this.max[e] = i > o ? Math.round(o - i) + s : this.center[e], this.min[e] = i > o ? s : this.center[e];
  }
  // _getZeroBounds
  reset() {
    this.center.x = 0, this.center.y = 0, this.max.x = 0, this.max.y = 0, this.min.x = 0, this.min.y = 0;
  }
  /**
   * Correct pan position if it's beyond the bounds
   *
   * @param {Axis} axis x or y
   * @param {number} panOffset
   * @returns {number}
   */
  correctPan(e, t) {
    return _n(t, this.max[e], this.min[e]);
  }
}
const gs = 4e3;
class vo {
  /**
   * @param {PhotoSwipeOptions} options PhotoSwipe options
   * @param {SlideData} itemData Slide data
   * @param {number} index Slide index
   * @param {PhotoSwipe} [pswp] PhotoSwipe instance, can be undefined if not initialized yet
   */
  constructor(e, t, i, r) {
    this.pswp = r, this.options = e, this.itemData = t, this.index = i, this.panAreaSize = null, this.elementSize = null, this.fit = 1, this.fill = 1, this.vFill = 1, this.initial = 1, this.secondary = 1, this.max = 1, this.min = 1;
  }
  /**
   * Calculate initial, secondary and maximum zoom level for the specified slide.
   *
   * It should be called when either image or viewport size changes.
   *
   * @param {number} maxWidth
   * @param {number} maxHeight
   * @param {Point} panAreaSize
   */
  update(e, t, i) {
    const r = { x: e, y: t };
    this.elementSize = r, this.panAreaSize = i;
    const s = i.x / r.x, o = i.y / r.y;
    this.fit = Math.min(1, s < o ? s : o), this.fill = Math.min(1, s > o ? s : o), this.vFill = Math.min(1, o), this.initial = this._getInitial(), this.secondary = this._getSecondary(), this.max = Math.max(
      this.initial,
      this.secondary,
      this._getMax()
    ), this.min = Math.min(
      this.fit,
      this.initial,
      this.secondary
    ), this.pswp && this.pswp.dispatch("zoomLevelsUpdate", { zoomLevels: this, slideData: this.itemData });
  }
  /**
   * Parses user-defined zoom option.
   *
   * @private
   * @param {'initial' | 'secondary' | 'max'} optionPrefix Zoom level option prefix (initial, secondary, max)
   * @returns { number | undefined }
   */
  _parseZoomLevelOption(e) {
    const t = (
      /** @type {'initialZoomLevel' | 'secondaryZoomLevel' | 'maxZoomLevel'} */
      e + "ZoomLevel"
    ), i = this.options[t];
    if (i)
      return typeof i == "function" ? i(this) : i === "fill" ? this.fill : i === "fit" ? this.fit : Number(i);
  }
  /**
   * Get zoom level to which image will be zoomed after double-tap gesture,
   * or when user clicks on zoom icon,
   * or mouse-click on image itself.
   * If you return 1 image will be zoomed to its original size.
   *
   * @private
   * @return {number}
   */
  _getSecondary() {
    let e = this._parseZoomLevelOption("secondary");
    return e || (e = Math.min(1, this.fit * 3), this.elementSize && e * this.elementSize.x > gs && (e = gs / this.elementSize.x), e);
  }
  /**
   * Get initial image zoom level.
   *
   * @private
   * @return {number}
   */
  _getInitial() {
    return this._parseZoomLevelOption("initial") || this.fit;
  }
  /**
   * Maximum zoom level when user zooms
   * via zoom/pinch gesture,
   * via cmd/ctrl-wheel or via trackpad.
   *
   * @private
   * @return {number}
   */
  _getMax() {
    return this._parseZoomLevelOption("max") || Math.max(1, this.fit * 4);
  }
}
class Ed {
  /**
   * @param {SlideData} data
   * @param {number} index
   * @param {PhotoSwipe} pswp
   */
  constructor(e, t, i) {
    this.data = e, this.index = t, this.pswp = i, this.isActive = t === i.currIndex, this.currentResolution = 0, this.panAreaSize = { x: 0, y: 0 }, this.pan = { x: 0, y: 0 }, this.isFirstSlide = this.isActive && !i.opener.isOpen, this.zoomLevels = new vo(i.options, e, t, i), this.pswp.dispatch("gettingData", {
      slide: this,
      data: this.data,
      index: t
    }), this.content = this.pswp.contentLoader.getContentBySlide(this), this.container = Le("pswp__zoom-wrap", "div"), this.holderElement = null, this.currZoomLevel = 1, this.width = this.content.width, this.height = this.content.height, this.heavyAppended = !1, this.bounds = new wd(this), this.prevDisplayedWidth = -1, this.prevDisplayedHeight = -1, this.pswp.dispatch("slideInit", { slide: this });
  }
  /**
   * If this slide is active/current/visible
   *
   * @param {boolean} isActive
   */
  setIsActive(e) {
    e && !this.isActive ? this.activate() : !e && this.isActive && this.deactivate();
  }
  /**
   * Appends slide content to DOM
   *
   * @param {HTMLElement} holderElement
   */
  append(e) {
    this.holderElement = e, this.container.style.transformOrigin = "0 0", this.data && (this.calculateSize(), this.load(), this.updateContentSize(), this.appendHeavy(), this.holderElement.appendChild(this.container), this.zoomAndPanToInitial(), this.pswp.dispatch("firstZoomPan", { slide: this }), this.applyCurrentZoomPan(), this.pswp.dispatch("afterSetContent", { slide: this }), this.isActive && this.activate());
  }
  load() {
    this.content.load(!1), this.pswp.dispatch("slideLoad", { slide: this });
  }
  /**
   * Append "heavy" DOM elements
   *
   * This may depend on a type of slide,
   * but generally these are large images.
   */
  appendHeavy() {
    const { pswp: e } = this, t = !0;
    this.heavyAppended || !e.opener.isOpen || e.mainScroll.isShifted() || !this.isActive && !t || this.pswp.dispatch("appendHeavy", { slide: this }).defaultPrevented || (this.heavyAppended = !0, this.content.append(), this.pswp.dispatch("appendHeavyContent", { slide: this }));
  }
  /**
   * Triggered when this slide is active (selected).
   *
   * If it's part of opening/closing transition -
   * activate() will trigger after the transition is ended.
   */
  activate() {
    this.isActive = !0, this.appendHeavy(), this.content.activate(), this.pswp.dispatch("slideActivate", { slide: this });
  }
  /**
   * Triggered when this slide becomes inactive.
   *
   * Slide can become inactive only after it was active.
   */
  deactivate() {
    this.isActive = !1, this.content.deactivate(), this.currZoomLevel !== this.zoomLevels.initial && this.calculateSize(), this.currentResolution = 0, this.zoomAndPanToInitial(), this.applyCurrentZoomPan(), this.updateContentSize(), this.pswp.dispatch("slideDeactivate", { slide: this });
  }
  /**
   * The slide should destroy itself, it will never be used again.
   * (unbind all events and destroy internal components)
   */
  destroy() {
    this.content.hasSlide = !1, this.content.remove(), this.container.remove(), this.pswp.dispatch("slideDestroy", { slide: this });
  }
  resize() {
    this.currZoomLevel === this.zoomLevels.initial || !this.isActive ? (this.calculateSize(), this.currentResolution = 0, this.zoomAndPanToInitial(), this.applyCurrentZoomPan(), this.updateContentSize()) : (this.calculateSize(), this.bounds.update(this.currZoomLevel), this.panTo(this.pan.x, this.pan.y));
  }
  /**
   * Apply size to current slide content,
   * based on the current resolution and scale.
   *
   * @param {boolean} [force] if size should be updated even if dimensions weren't changed
   */
  updateContentSize(e) {
    const t = this.currentResolution || this.zoomLevels.initial;
    if (!t)
      return;
    const i = Math.round(this.width * t) || this.pswp.viewportSize.x, r = Math.round(this.height * t) || this.pswp.viewportSize.y;
    !this.sizeChanged(i, r) && !e || this.content.setDisplayedSize(i, r);
  }
  /**
   * @param {number} width
   * @param {number} height
   */
  sizeChanged(e, t) {
    return e !== this.prevDisplayedWidth || t !== this.prevDisplayedHeight ? (this.prevDisplayedWidth = e, this.prevDisplayedHeight = t, !0) : !1;
  }
  /** @returns {HTMLImageElement | HTMLDivElement | null | undefined} */
  getPlaceholderElement() {
    var e;
    return (e = this.content.placeholder) == null ? void 0 : e.element;
  }
  /**
   * Zoom current slide image to...
   *
   * @param {number} destZoomLevel Destination zoom level.
   * @param {Point} [centerPoint]
   * Transform origin center point, or false if viewport center should be used.
   * @param {number | false} [transitionDuration] Transition duration, may be set to 0.
   * @param {boolean} [ignoreBounds] Minimum and maximum zoom levels will be ignored.
   */
  zoomTo(e, t, i, r) {
    const { pswp: s } = this;
    if (!this.isZoomable() || s.mainScroll.isShifted())
      return;
    s.dispatch("beforeZoomTo", {
      destZoomLevel: e,
      centerPoint: t,
      transitionDuration: i
    }), s.animations.stopAllPan();
    const o = this.currZoomLevel;
    r || (e = _n(e, this.zoomLevels.min, this.zoomLevels.max)), this.setZoomLevel(e), this.pan.x = this.calculateZoomToPanOffset("x", t, o), this.pan.y = this.calculateZoomToPanOffset("y", t, o), uo(this.pan);
    const l = () => {
      this._setResolution(e), this.applyCurrentZoomPan();
    };
    i ? s.animations.startTransition({
      isPan: !0,
      name: "zoomTo",
      target: this.container,
      transform: this.getCurrentTransform(),
      onComplete: l,
      duration: i,
      easing: s.options.easing
    }) : l();
  }
  /**
   * @param {Point} [centerPoint]
   */
  toggleZoom(e) {
    this.zoomTo(
      this.currZoomLevel === this.zoomLevels.initial ? this.zoomLevels.secondary : this.zoomLevels.initial,
      e,
      this.pswp.options.zoomAnimationDuration
    );
  }
  /**
   * Updates zoom level property and recalculates new pan bounds,
   * unlike zoomTo it does not apply transform (use applyCurrentZoomPan)
   *
   * @param {number} currZoomLevel
   */
  setZoomLevel(e) {
    this.currZoomLevel = e, this.bounds.update(this.currZoomLevel);
  }
  /**
   * Get pan position after zoom at a given `point`.
   *
   * Always call setZoomLevel(newZoomLevel) beforehand to recalculate
   * pan bounds according to the new zoom level.
   *
   * @param {'x' | 'y'} axis
   * @param {Point} [point]
   * point based on which zoom is performed, usually refers to the current mouse position,
   * if false - viewport center will be used.
   * @param {number} [prevZoomLevel] Zoom level before new zoom was applied.
   * @returns {number}
   */
  calculateZoomToPanOffset(e, t, i) {
    if (this.bounds.max[e] - this.bounds.min[e] === 0)
      return this.bounds.center[e];
    t || (t = this.pswp.getViewportCenterPoint()), i || (i = this.zoomLevels.initial);
    const s = this.currZoomLevel / i;
    return this.bounds.correctPan(
      e,
      (this.pan[e] - t[e]) * s + t[e]
    );
  }
  /**
   * Apply pan and keep it within bounds.
   *
   * @param {number} panX
   * @param {number} panY
   */
  panTo(e, t) {
    this.pan.x = this.bounds.correctPan("x", e), this.pan.y = this.bounds.correctPan("y", t), this.applyCurrentZoomPan();
  }
  /**
   * If the slide in the current state can be panned by the user
   * @returns {boolean}
   */
  isPannable() {
    return Boolean(this.width) && this.currZoomLevel > this.zoomLevels.fit;
  }
  /**
   * If the slide can be zoomed
   * @returns {boolean}
   */
  isZoomable() {
    return Boolean(this.width) && this.content.isZoomable();
  }
  /**
   * Apply transform and scale based on
   * the current pan position (this.pan) and zoom level (this.currZoomLevel)
   */
  applyCurrentZoomPan() {
    this._applyZoomTransform(this.pan.x, this.pan.y, this.currZoomLevel), this === this.pswp.currSlide && this.pswp.dispatch("zoomPanUpdate", { slide: this });
  }
  zoomAndPanToInitial() {
    this.currZoomLevel = this.zoomLevels.initial, this.bounds.update(this.currZoomLevel), ye(this.pan, this.bounds.center), this.pswp.dispatch("initialZoomPan", { slide: this });
  }
  /**
   * Set translate and scale based on current resolution
   *
   * @param {number} x
   * @param {number} y
   * @param {number} zoom
   * @private
   */
  _applyZoomTransform(e, t, i) {
    i /= this.currentResolution || this.zoomLevels.initial, Tt(this.container, e, t, i);
  }
  calculateSize() {
    const { pswp: e } = this;
    ye(
      this.panAreaSize,
      mo(e.options, e.viewportSize, this.data, this.index)
    ), this.zoomLevels.update(this.width, this.height, this.panAreaSize), e.dispatch("calcSlideSize", {
      slide: this
    });
  }
  /** @returns {string} */
  getCurrentTransform() {
    const e = this.currZoomLevel / (this.currentResolution || this.zoomLevels.initial);
    return gn(this.pan.x, this.pan.y, e);
  }
  /**
   * Set resolution and re-render the image.
   *
   * For example, if the real image size is 2000x1500,
   * and resolution is 0.5 - it will be rendered as 1000x750.
   *
   * Image with zoom level 2 and resolution 0.5 is
   * the same as image with zoom level 1 and resolution 1.
   *
   * Used to optimize animations and make
   * sure that browser renders image in the highest quality.
   * Also used by responsive images to load the correct one.
   *
   * @param {number} newResolution
   */
  _setResolution(e) {
    e !== this.currentResolution && (this.currentResolution = e, this.updateContentSize(), this.pswp.dispatch("resolutionChanged"));
  }
}
const Sd = 0.35, Ad = 0.6, ys = 0.4, _s = 0.5;
function xd(n, e) {
  return n * e / (1 - e);
}
class Cd {
  /**
   * @param {Gestures} gestures
   */
  constructor(e) {
    this.gestures = e, this.pswp = e.pswp, this.startPan = { x: 0, y: 0 };
  }
  start() {
    this.pswp.currSlide && ye(this.startPan, this.pswp.currSlide.pan), this.pswp.animations.stopAll();
  }
  change() {
    const { p1: e, prevP1: t, dragAxis: i } = this.gestures, { currSlide: r } = this.pswp;
    if (i === "y" && this.pswp.options.closeOnVerticalDrag && r && r.currZoomLevel <= r.zoomLevels.fit && !this.gestures.isMultitouch) {
      const s = r.pan.y + (e.y - t.y);
      if (!this.pswp.dispatch("verticalDrag", { panY: s }).defaultPrevented) {
        this._setPanWithFriction("y", s, Ad);
        const o = 1 - Math.abs(this._getVerticalDragRatio(r.pan.y));
        this.pswp.applyBgOpacity(o), r.applyCurrentZoomPan();
      }
    } else
      this._panOrMoveMainScroll("x") || (this._panOrMoveMainScroll("y"), r && (uo(r.pan), r.applyCurrentZoomPan()));
  }
  end() {
    const { velocity: e } = this.gestures, { mainScroll: t, currSlide: i } = this.pswp;
    let r = 0;
    if (this.pswp.animations.stopAll(), t.isShifted()) {
      const o = (t.x - t.getCurrSlideX()) / this.pswp.viewportSize.x;
      e.x < -_s && o < 0 || e.x < 0.1 && o < -0.5 ? (r = 1, e.x = Math.min(e.x, 0)) : (e.x > _s && o > 0 || e.x > -0.1 && o > 0.5) && (r = -1, e.x = Math.max(e.x, 0)), t.moveIndexBy(r, !0, e.x);
    }
    i && i.currZoomLevel > i.zoomLevels.max || this.gestures.isMultitouch ? this.gestures.zoomLevels.correctZoomPan(!0) : (this._finishPanGestureForAxis("x"), this._finishPanGestureForAxis("y"));
  }
  /**
   * @private
   * @param {'x' | 'y'} axis
   */
  _finishPanGestureForAxis(e) {
    const { velocity: t } = this.gestures, { currSlide: i } = this.pswp;
    if (!i)
      return;
    const { pan: r, bounds: s } = i, o = r[e], l = this.pswp.bgOpacity < 1 && e === "y", h = 0.995, d = o + xd(t[e], h);
    if (l) {
      const S = this._getVerticalDragRatio(o), A = this._getVerticalDragRatio(d);
      if (S < 0 && A < -ys || S > 0 && A > ys) {
        this.pswp.close();
        return;
      }
    }
    const m = s.correctPan(e, d);
    if (o === m)
      return;
    const p = m === d ? 1 : 0.82, _ = this.pswp.bgOpacity, g = m - o;
    this.pswp.animations.startSpring({
      name: "panGesture" + e,
      isPan: !0,
      start: o,
      end: m,
      velocity: t[e],
      dampingRatio: p,
      onUpdate: (S) => {
        if (l && this.pswp.bgOpacity < 1) {
          const A = 1 - (m - S) / g;
          this.pswp.applyBgOpacity(_n(
            _ + (1 - _) * A,
            0,
            1
          ));
        }
        r[e] = Math.floor(S), i.applyCurrentZoomPan();
      }
    });
  }
  /**
   * Update position of the main scroll,
   * or/and update pan position of the current slide.
   *
   * Should return true if it changes (or can change) main scroll.
   *
   * @private
   * @param {'x' | 'y'} axis
   * @returns {boolean}
   */
  _panOrMoveMainScroll(e) {
    const { p1: t, dragAxis: i, prevP1: r, isMultitouch: s } = this.gestures, { currSlide: o, mainScroll: l } = this.pswp, h = t[e] - r[e], d = l.x + h;
    if (!h || !o)
      return !1;
    if (e === "x" && !o.isPannable() && !s)
      return l.moveTo(d, !0), !0;
    const { bounds: m } = o, p = o.pan[e] + h;
    if (this.pswp.options.allowPanToNext && i === "x" && e === "x" && !s) {
      const _ = l.getCurrSlideX(), g = l.x - _, S = h > 0, A = !S;
      if (p > m.min[e] && S) {
        if (m.min[e] <= this.startPan[e])
          return l.moveTo(d, !0), !0;
        this._setPanWithFriction(e, p);
      } else if (p < m.max[e] && A) {
        if (this.startPan[e] <= m.max[e])
          return l.moveTo(d, !0), !0;
        this._setPanWithFriction(e, p);
      } else if (g !== 0) {
        if (g > 0)
          return l.moveTo(Math.max(d, _), !0), !0;
        if (g < 0)
          return l.moveTo(Math.min(d, _), !0), !0;
      } else
        this._setPanWithFriction(e, p);
    } else
      e === "y" ? !l.isShifted() && m.min.y !== m.max.y && this._setPanWithFriction(e, p) : this._setPanWithFriction(e, p);
    return !1;
  }
  // If we move above - the ratio is negative
  // If we move below the ratio is positive
  /**
   * Relation between pan Y position and third of viewport height.
   *
   * When we are at initial position (center bounds) - the ratio is 0,
   * if position is shifted upwards - the ratio is negative,
   * if position is shifted downwards - the ratio is positive.
   *
   * @private
   * @param {number} panY The current pan Y position.
   * @returns {number}
   */
  _getVerticalDragRatio(e) {
    var t, i;
    return (e - ((i = (t = this.pswp.currSlide) == null ? void 0 : t.bounds.center.y) != null ? i : 0)) / (this.pswp.viewportSize.y / 3);
  }
  /**
   * Set pan position of the current slide.
   * Apply friction if the position is beyond the pan bounds,
   * or if custom friction is defined.
   *
   * @private
   * @param {'x' | 'y'} axis
   * @param {number} potentialPan
   * @param {number} [customFriction] (0.1 - 1)
   */
  _setPanWithFriction(e, t, i) {
    const { currSlide: r } = this.pswp;
    if (!r)
      return;
    const { pan: s, bounds: o } = r;
    if (o.correctPan(e, t) !== t || i) {
      const h = Math.round(t - s[e]);
      s[e] += h * (i || Sd);
    } else
      s[e] = t;
  }
}
const Pd = 0.05, Td = 0.15;
function bs(n, e, t) {
  return n.x = (e.x + t.x) / 2, n.y = (e.y + t.y) / 2, n;
}
class Od {
  /**
   * @param {Gestures} gestures
   */
  constructor(e) {
    this.gestures = e, this._startPan = { x: 0, y: 0 }, this._startZoomPoint = { x: 0, y: 0 }, this._zoomPoint = { x: 0, y: 0 }, this._wasOverFitZoomLevel = !1, this._startZoomLevel = 1;
  }
  start() {
    const { currSlide: e } = this.gestures.pswp;
    e && (this._startZoomLevel = e.currZoomLevel, ye(this._startPan, e.pan)), this.gestures.pswp.animations.stopAllPan(), this._wasOverFitZoomLevel = !1;
  }
  change() {
    const { p1: e, startP1: t, p2: i, startP2: r, pswp: s } = this.gestures, { currSlide: o } = s;
    if (!o)
      return;
    const l = o.zoomLevels.min, h = o.zoomLevels.max;
    if (!o.isZoomable() || s.mainScroll.isShifted())
      return;
    bs(this._startZoomPoint, t, r), bs(this._zoomPoint, e, i);
    let d = 1 / Ni(t, r) * Ni(e, i) * this._startZoomLevel;
    if (d > o.zoomLevels.initial + o.zoomLevels.initial / 15 && (this._wasOverFitZoomLevel = !0), d < l)
      if (s.options.pinchToClose && !this._wasOverFitZoomLevel && this._startZoomLevel <= o.zoomLevels.initial) {
        const m = 1 - (l - d) / (l / 1.2);
        s.dispatch("pinchClose", { bgOpacity: m }).defaultPrevented || s.applyBgOpacity(m);
      } else
        d = l - (l - d) * Td;
    else
      d > h && (d = h + (d - h) * Pd);
    o.pan.x = this._calculatePanForZoomLevel("x", d), o.pan.y = this._calculatePanForZoomLevel("y", d), o.setZoomLevel(d), o.applyCurrentZoomPan();
  }
  end() {
    const { pswp: e } = this.gestures, { currSlide: t } = e;
    (!t || t.currZoomLevel < t.zoomLevels.initial) && !this._wasOverFitZoomLevel && e.options.pinchToClose ? e.close() : this.correctZoomPan();
  }
  /**
   * @private
   * @param {'x' | 'y'} axis
   * @param {number} currZoomLevel
   * @returns {number}
   */
  _calculatePanForZoomLevel(e, t) {
    const i = t / this._startZoomLevel;
    return this._zoomPoint[e] - (this._startZoomPoint[e] - this._startPan[e]) * i;
  }
  /**
   * Correct currZoomLevel and pan if they are
   * beyond minimum or maximum values.
   * With animation.
   *
   * @param {boolean} [ignoreGesture]
   * Wether gesture coordinates should be ignored when calculating destination pan position.
   */
  correctZoomPan(e) {
    const { pswp: t } = this.gestures, { currSlide: i } = t;
    if (!(i != null && i.isZoomable()))
      return;
    this._zoomPoint.x === 0 && (e = !0);
    const r = i.currZoomLevel;
    let s, o = !0;
    r < i.zoomLevels.initial ? s = i.zoomLevels.initial : r > i.zoomLevels.max ? s = i.zoomLevels.max : (o = !1, s = r);
    const l = t.bgOpacity, h = t.bgOpacity < 1, d = ye({ x: 0, y: 0 }, i.pan);
    let m = ye({ x: 0, y: 0 }, d);
    e && (this._zoomPoint.x = 0, this._zoomPoint.y = 0, this._startZoomPoint.x = 0, this._startZoomPoint.y = 0, this._startZoomLevel = r, ye(this._startPan, d)), o && (m = {
      x: this._calculatePanForZoomLevel("x", s),
      y: this._calculatePanForZoomLevel("y", s)
    }), i.setZoomLevel(s), m = {
      x: i.bounds.correctPan("x", m.x),
      y: i.bounds.correctPan("y", m.y)
    }, i.setZoomLevel(r);
    const p = !fn(m, d);
    if (!p && !o && !h) {
      i._setResolution(s), i.applyCurrentZoomPan();
      return;
    }
    t.animations.stopAllPan(), t.animations.startSpring({
      isPan: !0,
      start: 0,
      end: 1e3,
      velocity: 0,
      dampingRatio: 1,
      naturalFrequency: 40,
      onUpdate: (_) => {
        if (_ /= 1e3, p || o) {
          if (p && (i.pan.x = d.x + (m.x - d.x) * _, i.pan.y = d.y + (m.y - d.y) * _), o) {
            const g = r + (s - r) * _;
            i.setZoomLevel(g);
          }
          i.applyCurrentZoomPan();
        }
        h && t.bgOpacity < 1 && t.applyBgOpacity(_n(
          l + (1 - l) * _,
          0,
          1
        ));
      },
      onComplete: () => {
        i._setResolution(s), i.applyCurrentZoomPan();
      }
    });
  }
}
function ws(n) {
  return !!/** @type {HTMLElement} */
  n.target.closest(".pswp__container");
}
class Id {
  /**
   * @param {Gestures} gestures
   */
  constructor(e) {
    this.gestures = e;
  }
  /**
   * @param {Point} point
   * @param {PointerEvent} originalEvent
   */
  click(e, t) {
    const i = (
      /** @type {HTMLElement} */
      t.target.classList
    ), r = i.contains("pswp__img"), s = i.contains("pswp__item") || i.contains("pswp__zoom-wrap");
    r ? this._doClickOrTapAction("imageClick", e, t) : s && this._doClickOrTapAction("bgClick", e, t);
  }
  /**
   * @param {Point} point
   * @param {PointerEvent} originalEvent
   */
  tap(e, t) {
    ws(t) && this._doClickOrTapAction("tap", e, t);
  }
  /**
   * @param {Point} point
   * @param {PointerEvent} originalEvent
   */
  doubleTap(e, t) {
    ws(t) && this._doClickOrTapAction("doubleTap", e, t);
  }
  /**
   * @private
   * @param {Actions} actionName
   * @param {Point} point
   * @param {PointerEvent} originalEvent
   */
  _doClickOrTapAction(e, t, i) {
    var h;
    const { pswp: r } = this.gestures, { currSlide: s } = r, o = (
      /** @type {AddPostfix<Actions, 'Action'>} */
      e + "Action"
    ), l = r.options[o];
    if (!r.dispatch(o, { point: t, originalEvent: i }).defaultPrevented) {
      if (typeof l == "function") {
        l.call(r, t, i);
        return;
      }
      switch (l) {
        case "close":
        case "next":
          r[l]();
          break;
        case "zoom":
          s == null || s.toggleZoom(t);
          break;
        case "zoom-or-close":
          s != null && s.isZoomable() && s.zoomLevels.secondary !== s.zoomLevels.initial ? s.toggleZoom(t) : r.options.clickToCloseNonZoomable && r.close();
          break;
        case "toggle-controls":
          (h = this.gestures.pswp.element) == null || h.classList.toggle("pswp--ui-visible");
          break;
      }
    }
  }
}
const kd = 10, Dd = 300, Md = 25;
class Ld {
  /**
   * @param {PhotoSwipe} pswp
   */
  constructor(e) {
    this.pswp = e, this.dragAxis = null, this.p1 = { x: 0, y: 0 }, this.p2 = { x: 0, y: 0 }, this.prevP1 = { x: 0, y: 0 }, this.prevP2 = { x: 0, y: 0 }, this.startP1 = { x: 0, y: 0 }, this.startP2 = { x: 0, y: 0 }, this.velocity = { x: 0, y: 0 }, this._lastStartP1 = { x: 0, y: 0 }, this._intervalP1 = { x: 0, y: 0 }, this._numActivePoints = 0, this._ongoingPointers = [], this._touchEventEnabled = "ontouchstart" in window, this._pointerEventEnabled = !!window.PointerEvent, this.supportsTouch = this._touchEventEnabled || this._pointerEventEnabled && navigator.maxTouchPoints > 1, this._numActivePoints = 0, this._intervalTime = 0, this._velocityCalculated = !1, this.isMultitouch = !1, this.isDragging = !1, this.isZooming = !1, this.raf = null, this._tapTimer = null, this.supportsTouch || (e.options.allowPanToNext = !1), this.drag = new Cd(this), this.zoomLevels = new Od(this), this.tapHandler = new Id(this), e.on("bindEvents", () => {
      e.events.add(
        e.scrollWrap,
        "click",
        /** @type EventListener */
        this._onClick.bind(this)
      ), this._pointerEventEnabled ? this._bindEvents("pointer", "down", "up", "cancel") : this._touchEventEnabled ? (this._bindEvents("touch", "start", "end", "cancel"), e.scrollWrap && (e.scrollWrap.ontouchmove = () => {
      }, e.scrollWrap.ontouchend = () => {
      })) : this._bindEvents("mouse", "down", "up");
    });
  }
  /**
   * @private
   * @param {'mouse' | 'touch' | 'pointer'} pref
   * @param {'down' | 'start'} down
   * @param {'up' | 'end'} up
   * @param {'cancel'} [cancel]
   */
  _bindEvents(e, t, i, r) {
    const { pswp: s } = this, { events: o } = s, l = r ? e + r : "";
    o.add(
      s.scrollWrap,
      e + t,
      /** @type EventListener */
      this.onPointerDown.bind(this)
    ), o.add(
      window,
      e + "move",
      /** @type EventListener */
      this.onPointerMove.bind(this)
    ), o.add(
      window,
      e + i,
      /** @type EventListener */
      this.onPointerUp.bind(this)
    ), l && o.add(
      s.scrollWrap,
      l,
      /** @type EventListener */
      this.onPointerUp.bind(this)
    );
  }
  /**
   * @param {PointerEvent} e
   */
  onPointerDown(e) {
    const t = e.type === "mousedown" || e.pointerType === "mouse";
    if (t && e.button > 0)
      return;
    const { pswp: i } = this;
    if (!i.opener.isOpen) {
      e.preventDefault();
      return;
    }
    i.dispatch("pointerDown", { originalEvent: e }).defaultPrevented || (t && (i.mouseDetected(), this._preventPointerEventBehaviour(e)), i.animations.stopAll(), this._updatePoints(e, "down"), this._numActivePoints === 1 && (this.dragAxis = null, ye(this.startP1, this.p1)), this._numActivePoints > 1 ? (this._clearTapTimer(), this.isMultitouch = !0) : this.isMultitouch = !1);
  }
  /**
   * @param {PointerEvent} e
   */
  onPointerMove(e) {
    e.preventDefault(), this._numActivePoints && (this._updatePoints(e, "move"), !this.pswp.dispatch("pointerMove", { originalEvent: e }).defaultPrevented && (this._numActivePoints === 1 && !this.isDragging ? (this.dragAxis || this._calculateDragDirection(), this.dragAxis && !this.isDragging && (this.isZooming && (this.isZooming = !1, this.zoomLevels.end()), this.isDragging = !0, this._clearTapTimer(), this._updateStartPoints(), this._intervalTime = Date.now(), this._velocityCalculated = !1, ye(this._intervalP1, this.p1), this.velocity.x = 0, this.velocity.y = 0, this.drag.start(), this._rafStopLoop(), this._rafRenderLoop())) : this._numActivePoints > 1 && !this.isZooming && (this._finishDrag(), this.isZooming = !0, this._updateStartPoints(), this.zoomLevels.start(), this._rafStopLoop(), this._rafRenderLoop())));
  }
  /**
   * @private
   */
  _finishDrag() {
    this.isDragging && (this.isDragging = !1, this._velocityCalculated || this._updateVelocity(!0), this.drag.end(), this.dragAxis = null);
  }
  /**
   * @param {PointerEvent} e
   */
  onPointerUp(e) {
    this._numActivePoints && (this._updatePoints(e, "up"), !this.pswp.dispatch("pointerUp", { originalEvent: e }).defaultPrevented && (this._numActivePoints === 0 && (this._rafStopLoop(), this.isDragging ? this._finishDrag() : !this.isZooming && !this.isMultitouch && this._finishTap(e)), this._numActivePoints < 2 && this.isZooming && (this.isZooming = !1, this.zoomLevels.end(), this._numActivePoints === 1 && (this.dragAxis = null, this._updateStartPoints()))));
  }
  /**
   * @private
   */
  _rafRenderLoop() {
    (this.isDragging || this.isZooming) && (this._updateVelocity(), this.isDragging ? fn(this.p1, this.prevP1) || this.drag.change() : (!fn(this.p1, this.prevP1) || !fn(this.p2, this.prevP2)) && this.zoomLevels.change(), this._updatePrevPoints(), this.raf = requestAnimationFrame(this._rafRenderLoop.bind(this)));
  }
  /**
   * Update velocity at 50ms interval
   *
   * @private
   * @param {boolean} [force]
   */
  _updateVelocity(e) {
    const t = Date.now(), i = t - this._intervalTime;
    i < 50 && !e || (this.velocity.x = this._getVelocity("x", i), this.velocity.y = this._getVelocity("y", i), this._intervalTime = t, ye(this._intervalP1, this.p1), this._velocityCalculated = !0);
  }
  /**
   * @private
   * @param {PointerEvent} e
   */
  _finishTap(e) {
    const { mainScroll: t } = this.pswp;
    if (t.isShifted()) {
      t.moveIndexBy(0, !0);
      return;
    }
    if (e.type.indexOf("cancel") > 0)
      return;
    if (e.type === "mouseup" || e.pointerType === "mouse") {
      this.tapHandler.click(this.startP1, e);
      return;
    }
    const i = this.pswp.options.doubleTapAction ? Dd : 0;
    this._tapTimer ? (this._clearTapTimer(), Ni(this._lastStartP1, this.startP1) < Md && this.tapHandler.doubleTap(this.startP1, e)) : (ye(this._lastStartP1, this.startP1), this._tapTimer = setTimeout(() => {
      this.tapHandler.tap(this.startP1, e), this._clearTapTimer();
    }, i));
  }
  /**
   * @private
   */
  _clearTapTimer() {
    this._tapTimer && (clearTimeout(this._tapTimer), this._tapTimer = null);
  }
  /**
   * Get velocity for axis
   *
   * @private
   * @param {'x' | 'y'} axis
   * @param {number} duration
   * @returns {number}
   */
  _getVelocity(e, t) {
    const i = this.p1[e] - this._intervalP1[e];
    return Math.abs(i) > 1 && t > 5 ? i / t : 0;
  }
  /**
   * @private
   */
  _rafStopLoop() {
    this.raf && (cancelAnimationFrame(this.raf), this.raf = null);
  }
  /**
   * @private
   * @param {PointerEvent} e
   */
  _preventPointerEventBehaviour(e) {
    e.preventDefault();
  }
  /**
   * Parses and normalizes points from the touch, mouse or pointer event.
   * Updates p1 and p2.
   *
   * @private
   * @param {PointerEvent | TouchEvent} e
   * @param {'up' | 'down' | 'move'} pointerType Normalized pointer type
   */
  _updatePoints(e, t) {
    if (this._pointerEventEnabled) {
      const i = (
        /** @type {PointerEvent} */
        e
      ), r = this._ongoingPointers.findIndex((s) => s.id === i.pointerId);
      t === "up" && r > -1 ? this._ongoingPointers.splice(r, 1) : t === "down" && r === -1 ? this._ongoingPointers.push(this._convertEventPosToPoint(i, { x: 0, y: 0 })) : r > -1 && this._convertEventPosToPoint(i, this._ongoingPointers[r]), this._numActivePoints = this._ongoingPointers.length, this._numActivePoints > 0 && ye(this.p1, this._ongoingPointers[0]), this._numActivePoints > 1 && ye(this.p2, this._ongoingPointers[1]);
    } else {
      const i = (
        /** @type {TouchEvent} */
        e
      );
      this._numActivePoints = 0, i.type.indexOf("touch") > -1 ? i.touches && i.touches.length > 0 && (this._convertEventPosToPoint(i.touches[0], this.p1), this._numActivePoints++, i.touches.length > 1 && (this._convertEventPosToPoint(i.touches[1], this.p2), this._numActivePoints++)) : (this._convertEventPosToPoint(
        /** @type {PointerEvent} */
        e,
        this.p1
      ), t === "up" ? this._numActivePoints = 0 : this._numActivePoints++);
    }
  }
  /** update points that were used during previous rAF tick
   * @private
   */
  _updatePrevPoints() {
    ye(this.prevP1, this.p1), ye(this.prevP2, this.p2);
  }
  /** update points at the start of gesture
   * @private
   */
  _updateStartPoints() {
    ye(this.startP1, this.p1), ye(this.startP2, this.p2), this._updatePrevPoints();
  }
  /** @private */
  _calculateDragDirection() {
    if (this.pswp.mainScroll.isShifted())
      this.dragAxis = "x";
    else {
      const e = Math.abs(this.p1.x - this.startP1.x) - Math.abs(this.p1.y - this.startP1.y);
      if (e !== 0) {
        const t = e > 0 ? "x" : "y";
        Math.abs(this.p1[t] - this.startP1[t]) >= kd && (this.dragAxis = t);
      }
    }
  }
  /**
   * Converts touch, pointer or mouse event
   * to PhotoSwipe point.
   *
   * @private
   * @param {Touch | PointerEvent} e
   * @param {Point} p
   * @returns {Point}
   */
  _convertEventPosToPoint(e, t) {
    return t.x = e.pageX - this.pswp.offset.x, t.y = e.pageY - this.pswp.offset.y, "pointerId" in e ? t.id = e.pointerId : e.identifier !== void 0 && (t.id = e.identifier), t;
  }
  /**
   * @private
   * @param {PointerEvent} e
   */
  _onClick(e) {
    this.pswp.mainScroll.isShifted() && (e.preventDefault(), e.stopPropagation());
  }
}
const Rd = 0.35;
class zd {
  /**
   * @param {PhotoSwipe} pswp
   */
  constructor(e) {
    this.pswp = e, this.x = 0, this.slideWidth = 0, this._currPositionIndex = 0, this._prevPositionIndex = 0, this._containerShiftIndex = -1, this.itemHolders = [];
  }
  /**
   * Position the scroller and slide containers
   * according to viewport size.
   *
   * @param {boolean} [resizeSlides] Whether slides content should resized
   */
  resize(e) {
    const { pswp: t } = this, i = Math.round(
      t.viewportSize.x + t.viewportSize.x * t.options.spacing
    ), r = i !== this.slideWidth;
    r && (this.slideWidth = i, this.moveTo(this.getCurrSlideX())), this.itemHolders.forEach((s, o) => {
      r && Tt(s.el, (o + this._containerShiftIndex) * this.slideWidth), e && s.slide && s.slide.resize();
    });
  }
  /**
   * Reset X position of the main scroller to zero
   */
  resetPosition() {
    this._currPositionIndex = 0, this._prevPositionIndex = 0, this.slideWidth = 0, this._containerShiftIndex = -1;
  }
  /**
   * Create and append array of three items
   * that hold data about slides in DOM
   */
  appendHolders() {
    this.itemHolders = [];
    for (let e = 0; e < 3; e++) {
      const t = Le("pswp__item", "div", this.pswp.container);
      t.setAttribute("role", "group"), t.setAttribute("aria-roledescription", "slide"), t.setAttribute("aria-hidden", "true"), t.style.display = e === 1 ? "block" : "none", this.itemHolders.push({
        el: t
        //index: -1
      });
    }
  }
  /**
   * Whether the main scroll can be horizontally swiped to the next or previous slide.
   * @returns {boolean}
   */
  canBeSwiped() {
    return this.pswp.getNumItems() > 1;
  }
  /**
   * Move main scroll by X amount of slides.
   * For example:
   *   `-1` will move to the previous slide,
   *    `0` will reset the scroll position of the current slide,
   *    `3` will move three slides forward
   *
   * If loop option is enabled - index will be automatically looped too,
   * (for example `-1` will move to the last slide of the gallery).
   *
   * @param {number} diff
   * @param {boolean} [animate]
   * @param {number} [velocityX]
   * @returns {boolean} whether index was changed or not
   */
  moveIndexBy(e, t, i) {
    const { pswp: r } = this;
    let s = r.potentialIndex + e;
    const o = r.getNumItems();
    if (r.canLoop()) {
      s = r.getLoopedIndex(s);
      const h = (e + o) % o;
      h <= o / 2 ? e = h : e = h - o;
    } else
      s < 0 ? s = 0 : s >= o && (s = o - 1), e = s - r.potentialIndex;
    r.potentialIndex = s, this._currPositionIndex -= e, r.animations.stopMainScroll();
    const l = this.getCurrSlideX();
    if (!t)
      this.moveTo(l), this.updateCurrItem();
    else {
      r.animations.startSpring({
        isMainScroll: !0,
        start: this.x,
        end: l,
        velocity: i || 0,
        naturalFrequency: 30,
        dampingRatio: 1,
        //0.7,
        onUpdate: (d) => {
          this.moveTo(d);
        },
        onComplete: () => {
          this.updateCurrItem(), r.appendHeavy();
        }
      });
      let h = r.potentialIndex - r.currIndex;
      if (r.canLoop()) {
        const d = (h + o) % o;
        d <= o / 2 ? h = d : h = d - o;
      }
      Math.abs(h) > 1 && this.updateCurrItem();
    }
    return Boolean(e);
  }
  /**
   * X position of the main scroll for the current slide
   * (ignores position during dragging)
   * @returns {number}
   */
  getCurrSlideX() {
    return this.slideWidth * this._currPositionIndex;
  }
  /**
   * Whether scroll position is shifted.
   * For example, it will return true if the scroll is being dragged or animated.
   * @returns {boolean}
   */
  isShifted() {
    return this.x !== this.getCurrSlideX();
  }
  /**
   * Update slides X positions and set their content
   */
  updateCurrItem() {
    var s;
    const { pswp: e } = this, t = this._prevPositionIndex - this._currPositionIndex;
    if (!t)
      return;
    this._prevPositionIndex = this._currPositionIndex, e.currIndex = e.potentialIndex;
    let i = Math.abs(t), r;
    i >= 3 && (this._containerShiftIndex += t + (t > 0 ? -3 : 3), i = 3);
    for (let o = 0; o < i; o++)
      t > 0 ? (r = this.itemHolders.shift(), r && (this.itemHolders[2] = r, this._containerShiftIndex++, Tt(r.el, (this._containerShiftIndex + 2) * this.slideWidth), e.setContent(r, e.currIndex - i + o + 2))) : (r = this.itemHolders.pop(), r && (this.itemHolders.unshift(r), this._containerShiftIndex--, Tt(r.el, this._containerShiftIndex * this.slideWidth), e.setContent(r, e.currIndex + i - o - 2)));
    Math.abs(this._containerShiftIndex) > 50 && !this.isShifted() && (this.resetPosition(), this.resize()), e.animations.stopAllPan(), this.itemHolders.forEach((o, l) => {
      o.slide && o.slide.setIsActive(l === 1);
    }), e.currSlide = (s = this.itemHolders[1]) == null ? void 0 : s.slide, e.contentLoader.updateLazy(t), e.currSlide && e.currSlide.applyCurrentZoomPan(), e.dispatch("change");
  }
  /**
   * Move the X position of the main scroll container
   *
   * @param {number} x
   * @param {boolean} [dragging]
   */
  moveTo(e, t) {
    if (!this.pswp.canLoop() && t) {
      let i = (this.slideWidth * this._currPositionIndex - e) / this.slideWidth;
      i += this.pswp.currIndex;
      const r = Math.round(e - this.x);
      (i < 0 && r > 0 || i >= this.pswp.getNumItems() - 1 && r < 0) && (e = this.x + r * Rd);
    }
    this.x = e, this.pswp.container && Tt(this.pswp.container, e), this.pswp.dispatch("moveMainScroll", { x: e, dragging: t != null ? t : !1 });
  }
}
const Nd = {
  Escape: 27,
  z: 90,
  ArrowLeft: 37,
  ArrowUp: 38,
  ArrowRight: 39,
  ArrowDown: 40,
  Tab: 9
}, Ct = (n, e) => e ? n : Nd[n];
class Fd {
  /**
   * @param {PhotoSwipe} pswp
   */
  constructor(e) {
    this.pswp = e, this._wasFocused = !1, e.on("bindEvents", () => {
      e.options.initialPointerPos || this._focusRoot(), e.events.add(
        document,
        "focusin",
        /** @type EventListener */
        this._onFocusIn.bind(this)
      ), e.events.add(
        document,
        "keydown",
        /** @type EventListener */
        this._onKeyDown.bind(this)
      );
    });
    const t = (
      /** @type {HTMLElement} */
      document.activeElement
    );
    e.on("destroy", () => {
      e.options.returnFocus && t && this._wasFocused && t.focus();
    });
  }
  /** @private */
  _focusRoot() {
    !this._wasFocused && this.pswp.element && (this.pswp.element.focus(), this._wasFocused = !0);
  }
  /**
   * @private
   * @param {KeyboardEvent} e
   */
  _onKeyDown(e) {
    const { pswp: t } = this;
    if (t.dispatch("keydown", { originalEvent: e }).defaultPrevented || yd(e))
      return;
    let i, r, s = !1;
    const o = "key" in e;
    switch (o ? e.key : e.keyCode) {
      case Ct("Escape", o):
        t.options.escKey && (i = "close");
        break;
      case Ct("z", o):
        i = "toggleZoom";
        break;
      case Ct("ArrowLeft", o):
        r = "x";
        break;
      case Ct("ArrowUp", o):
        r = "y";
        break;
      case Ct("ArrowRight", o):
        r = "x", s = !0;
        break;
      case Ct("ArrowDown", o):
        s = !0, r = "y";
        break;
      case Ct("Tab", o):
        this._focusRoot();
        break;
    }
    if (r) {
      e.preventDefault();
      const { currSlide: l } = t;
      t.options.arrowKeys && r === "x" && t.getNumItems() > 1 ? i = s ? "next" : "prev" : l && l.currZoomLevel > l.zoomLevels.fit && (l.pan[r] += s ? -80 : 80, l.panTo(l.pan.x, l.pan.y));
    }
    i && (e.preventDefault(), t[i]());
  }
  /**
   * Trap focus inside photoswipe
   *
   * @private
   * @param {FocusEvent} e
   */
  _onFocusIn(e) {
    const { template: t } = this.pswp;
    t && document !== e.target && t !== e.target && !t.contains(
      /** @type {Node} */
      e.target
    ) && t.focus();
  }
}
const Zd = "cubic-bezier(.4,0,.22,1)";
class Bd {
  /**
   * onComplete can be unpredictable, be careful about current state
   *
   * @param {CssAnimationProps} props
   */
  constructor(e) {
    var m;
    this.props = e;
    const {
      target: t,
      onComplete: i,
      transform: r,
      onFinish: s = () => {
      },
      duration: o = 333,
      easing: l = Zd
    } = e;
    this.onFinish = s;
    const h = r ? "transform" : "opacity", d = (m = e[h]) != null ? m : "";
    this._target = t, this._onComplete = i, this._finished = !1, this._onTransitionEnd = this._onTransitionEnd.bind(this), this._helperTimeout = setTimeout(() => {
      ho(t, h, o, l), this._helperTimeout = setTimeout(() => {
        t.addEventListener("transitionend", this._onTransitionEnd, !1), t.addEventListener("transitioncancel", this._onTransitionEnd, !1), this._helperTimeout = setTimeout(() => {
          this._finalizeAnimation();
        }, o + 500), t.style[h] = d;
      }, 30);
    }, 0);
  }
  /**
   * @private
   * @param {TransitionEvent} e
   */
  _onTransitionEnd(e) {
    e.target === this._target && this._finalizeAnimation();
  }
  /**
   * @private
   */
  _finalizeAnimation() {
    this._finished || (this._finished = !0, this.onFinish(), this._onComplete && this._onComplete());
  }
  // Destroy is called automatically onFinish
  destroy() {
    this._helperTimeout && clearTimeout(this._helperTimeout), vd(this._target), this._target.removeEventListener("transitionend", this._onTransitionEnd, !1), this._target.removeEventListener("transitioncancel", this._onTransitionEnd, !1), this._finished || this._finalizeAnimation();
  }
}
const Hd = 12, Vd = 0.75;
class jd {
  /**
   * @param {number} initialVelocity Initial velocity, px per ms.
   *
   * @param {number} [dampingRatio]
   * Determines how bouncy animation will be.
   * From 0 to 1, 0 - always overshoot, 1 - do not overshoot.
   * "overshoot" refers to part of animation that
   * goes beyond the final value.
   *
   * @param {number} [naturalFrequency]
   * Determines how fast animation will slow down.
   * The higher value - the stiffer the transition will be,
   * and the faster it will slow down.
   * Recommended value from 10 to 50
   */
  constructor(e, t, i) {
    this.velocity = e * 1e3, this._dampingRatio = t || Vd, this._naturalFrequency = i || Hd, this._dampedFrequency = this._naturalFrequency, this._dampingRatio < 1 && (this._dampedFrequency *= Math.sqrt(1 - this._dampingRatio * this._dampingRatio));
  }
  /**
   * @param {number} deltaPosition Difference between current and end position of the animation
   * @param {number} deltaTime Frame duration in milliseconds
   *
   * @returns {number} Displacement, relative to the end position.
   */
  easeFrame(e, t) {
    let i = 0, r;
    t /= 1e3;
    const s = pi(Math.E, -this._dampingRatio * this._naturalFrequency * t);
    if (this._dampingRatio === 1)
      r = this.velocity + this._naturalFrequency * e, i = (e + r * t) * s, this.velocity = i * -this._naturalFrequency + r * s;
    else if (this._dampingRatio < 1) {
      r = 1 / this._dampedFrequency * (this._dampingRatio * this._naturalFrequency * e + this.velocity);
      const o = Math.cos(this._dampedFrequency * t), l = Math.sin(this._dampedFrequency * t);
      i = s * (e * o + r * l), this.velocity = i * -this._naturalFrequency * this._dampingRatio + s * (-this._dampedFrequency * e * l + this._dampedFrequency * r * o);
    }
    return i;
  }
}
class Ud {
  /**
   * @param {SpringAnimationProps} props
   */
  constructor(e) {
    this.props = e, this._raf = 0;
    const {
      start: t,
      end: i,
      velocity: r,
      onUpdate: s,
      onComplete: o,
      onFinish: l = () => {
      },
      dampingRatio: h,
      naturalFrequency: d
    } = e;
    this.onFinish = l;
    const m = new jd(r, h, d);
    let p = Date.now(), _ = t - i;
    const g = () => {
      this._raf && (_ = m.easeFrame(_, Date.now() - p), Math.abs(_) < 1 && Math.abs(m.velocity) < 50 ? (s(i), o && o(), this.onFinish()) : (p = Date.now(), s(_ + i), this._raf = requestAnimationFrame(g)));
    };
    this._raf = requestAnimationFrame(g);
  }
  // Destroy is called automatically onFinish
  destroy() {
    this._raf >= 0 && cancelAnimationFrame(this._raf), this._raf = 0;
  }
}
class Wd {
  constructor() {
    this.activeAnimations = [];
  }
  /**
   * @param {SpringAnimationProps} props
   */
  startSpring(e) {
    this._start(e, !0);
  }
  /**
   * @param {CssAnimationProps} props
   */
  startTransition(e) {
    this._start(e);
  }
  /**
   * @private
   * @param {AnimationProps} props
   * @param {boolean} [isSpring]
   * @returns {Animation}
   */
  _start(e, t) {
    const i = t ? new Ud(
      /** @type SpringAnimationProps */
      e
    ) : new Bd(
      /** @type CssAnimationProps */
      e
    );
    return this.activeAnimations.push(i), i.onFinish = () => this.stop(i), i;
  }
  /**
   * @param {Animation} animation
   */
  stop(e) {
    e.destroy();
    const t = this.activeAnimations.indexOf(e);
    t > -1 && this.activeAnimations.splice(t, 1);
  }
  stopAll() {
    this.activeAnimations.forEach((e) => {
      e.destroy();
    }), this.activeAnimations = [];
  }
  /**
   * Stop all pan or zoom transitions
   */
  stopAllPan() {
    this.activeAnimations = this.activeAnimations.filter((e) => e.props.isPan ? (e.destroy(), !1) : !0);
  }
  stopMainScroll() {
    this.activeAnimations = this.activeAnimations.filter((e) => e.props.isMainScroll ? (e.destroy(), !1) : !0);
  }
  /**
   * Returns true if main scroll transition is running
   */
  // isMainScrollRunning() {
  //   return this.activeAnimations.some((animation) => {
  //     return animation.props.isMainScroll;
  //   });
  // }
  /**
   * Returns true if any pan or zoom transition is running
   */
  isPanRunning() {
    return this.activeAnimations.some((e) => e.props.isPan);
  }
}
class qd {
  /**
   * @param {PhotoSwipe} pswp
   */
  constructor(e) {
    this.pswp = e, e.events.add(
      e.element,
      "wheel",
      /** @type EventListener */
      this._onWheel.bind(this)
    );
  }
  /**
   * @private
   * @param {WheelEvent} e
   */
  _onWheel(e) {
    e.preventDefault();
    const { currSlide: t } = this.pswp;
    let { deltaX: i, deltaY: r } = e;
    if (t && !this.pswp.dispatch("wheel", { originalEvent: e }).defaultPrevented)
      if (e.ctrlKey || this.pswp.options.wheelToZoom) {
        if (t.isZoomable()) {
          let s = -r;
          e.deltaMode === 1 ? s *= 0.05 : s *= e.deltaMode ? 1 : 2e-3, s = pi(2, s);
          const o = t.currZoomLevel * s;
          t.zoomTo(o, {
            x: e.clientX,
            y: e.clientY
          });
        }
      } else
        t.isPannable() && (e.deltaMode === 1 && (i *= 18, r *= 18), t.panTo(
          t.pan.x - i,
          t.pan.y - r
        ));
  }
}
function Gd(n) {
  if (typeof n == "string")
    return n;
  if (!n || !n.isCustomSVG)
    return "";
  const e = n;
  let t = '<svg aria-hidden="true" class="pswp__icn" viewBox="0 0 %d %d" width="%d" height="%d">';
  return t = t.split("%d").join(
    /** @type {string} */
    e.size || 32
  ), e.outlineID && (t += '<use class="pswp__icn-shadow" xlink:href="#' + e.outlineID + '"/>'), t += e.inner, t += "</svg>", t;
}
class Yd {
  /**
   * @param {PhotoSwipe} pswp
   * @param {UIElementData} data
   */
  constructor(e, t) {
    const i = t.name || t.className;
    let r = t.html;
    if (e.options[i] === !1)
      return;
    typeof e.options[i + "SVG"] == "string" && (r = e.options[i + "SVG"]), e.dispatch("uiElementCreate", { data: t });
    let s = "";
    t.isButton ? (s += "pswp__button ", s += t.className || `pswp__button--${t.name}`) : s += t.className || `pswp__${t.name}`;
    let o = t.isButton ? t.tagName || "button" : t.tagName || "div";
    o = /** @type {keyof HTMLElementTagNameMap} */
    o.toLowerCase();
    const l = Le(s, o);
    if (t.isButton) {
      o === "button" && (l.type = "button");
      let { title: m } = t;
      const { ariaLabel: p } = t;
      typeof e.options[i + "Title"] == "string" && (m = e.options[i + "Title"]), m && (l.title = m);
      const _ = p || m;
      _ && l.setAttribute("aria-label", _);
    }
    l.innerHTML = Gd(r), t.onInit && t.onInit(l, e), t.onClick && (l.onclick = (m) => {
      typeof t.onClick == "string" ? e[t.onClick]() : typeof t.onClick == "function" && t.onClick(m, l, e);
    });
    const h = t.appendTo || "bar";
    let d = e.element;
    h === "bar" ? (e.topBar || (e.topBar = Le("pswp__top-bar pswp__hide-on-close", "div", e.scrollWrap)), d = e.topBar) : (l.classList.add("pswp__hide-on-close"), h === "wrapper" && (d = e.scrollWrap)), d == null || d.appendChild(e.applyFilters("uiElement", l, t));
  }
}
function go(n, e, t) {
  n.classList.add("pswp__button--arrow"), n.setAttribute("aria-controls", "pswp__items"), e.on("change", () => {
    e.options.loop || (t ? n.disabled = !(e.currIndex < e.getNumItems() - 1) : n.disabled = !(e.currIndex > 0));
  });
}
const $d = {
  name: "arrowPrev",
  className: "pswp__button--arrow--prev",
  title: "Previous",
  order: 10,
  isButton: !0,
  appendTo: "wrapper",
  html: {
    isCustomSVG: !0,
    size: 60,
    inner: '<path d="M29 43l-3 3-16-16 16-16 3 3-13 13 13 13z" id="pswp__icn-arrow"/>',
    outlineID: "pswp__icn-arrow"
  },
  onClick: "prev",
  onInit: go
}, Xd = {
  name: "arrowNext",
  className: "pswp__button--arrow--next",
  title: "Next",
  order: 11,
  isButton: !0,
  appendTo: "wrapper",
  html: {
    isCustomSVG: !0,
    size: 60,
    inner: '<use xlink:href="#pswp__icn-arrow"/>',
    outlineID: "pswp__icn-arrow"
  },
  onClick: "next",
  onInit: (n, e) => {
    go(n, e, !0);
  }
}, Kd = {
  name: "close",
  title: "Close",
  order: 20,
  isButton: !0,
  html: {
    isCustomSVG: !0,
    inner: '<path d="M24 10l-2-2-6 6-6-6-2 2 6 6-6 6 2 2 6-6 6 6 2-2-6-6z" id="pswp__icn-close"/>',
    outlineID: "pswp__icn-close"
  },
  onClick: "close"
}, Jd = {
  name: "zoom",
  title: "Zoom",
  order: 10,
  isButton: !0,
  html: {
    isCustomSVG: !0,
    // eslint-disable-next-line max-len
    inner: '<path d="M17.426 19.926a6 6 0 1 1 1.5-1.5L23 22.5 21.5 24l-4.074-4.074z" id="pswp__icn-zoom"/><path fill="currentColor" class="pswp__zoom-icn-bar-h" d="M11 16v-2h6v2z"/><path fill="currentColor" class="pswp__zoom-icn-bar-v" d="M13 12h2v6h-2z"/>',
    outlineID: "pswp__icn-zoom"
  },
  onClick: "toggleZoom"
}, Qd = {
  name: "preloader",
  appendTo: "bar",
  order: 7,
  html: {
    isCustomSVG: !0,
    // eslint-disable-next-line max-len
    inner: '<path fill-rule="evenodd" clip-rule="evenodd" d="M21.2 16a5.2 5.2 0 1 1-5.2-5.2V8a8 8 0 1 0 8 8h-2.8Z" id="pswp__icn-loading"/>',
    outlineID: "pswp__icn-loading"
  },
  onInit: (n, e) => {
    let t, i = null;
    const r = (l, h) => {
      n.classList.toggle("pswp__preloader--" + l, h);
    }, s = (l) => {
      t !== l && (t = l, r("active", l));
    }, o = () => {
      var l;
      if (!((l = e.currSlide) != null && l.content.isLoading())) {
        s(!1), i && (clearTimeout(i), i = null);
        return;
      }
      i || (i = setTimeout(() => {
        var h;
        s(Boolean((h = e.currSlide) == null ? void 0 : h.content.isLoading())), i = null;
      }, e.options.preloaderDelay));
    };
    e.on("change", o), e.on("loadComplete", (l) => {
      e.currSlide === l.slide && o();
    }), e.ui && (e.ui.updatePreloaderVisibility = o);
  }
}, ef = {
  name: "counter",
  order: 5,
  onInit: (n, e) => {
    e.on("change", () => {
      n.innerText = e.currIndex + 1 + e.options.indexIndicatorSep + e.getNumItems();
    });
  }
};
function Es(n, e) {
  n.classList.toggle("pswp--zoomed-in", e);
}
class tf {
  /**
   * @param {PhotoSwipe} pswp
   */
  constructor(e) {
    this.pswp = e, this.isRegistered = !1, this.uiElementsData = [], this.items = [], this.updatePreloaderVisibility = () => {
    }, this._lastUpdatedZoomLevel = void 0;
  }
  init() {
    const { pswp: e } = this;
    this.isRegistered = !1, this.uiElementsData = [
      Kd,
      $d,
      Xd,
      Jd,
      Qd,
      ef
    ], e.dispatch("uiRegister"), this.uiElementsData.sort((t, i) => (t.order || 0) - (i.order || 0)), this.items = [], this.isRegistered = !0, this.uiElementsData.forEach((t) => {
      this.registerElement(t);
    }), e.on("change", () => {
      var t;
      (t = e.element) == null || t.classList.toggle("pswp--one-slide", e.getNumItems() === 1);
    }), e.on("zoomPanUpdate", () => this._onZoomPanUpdate());
  }
  /**
   * @param {UIElementData} elementData
   */
  registerElement(e) {
    this.isRegistered ? this.items.push(
      new Yd(this.pswp, e)
    ) : this.uiElementsData.push(e);
  }
  /**
   * Fired each time zoom or pan position is changed.
   * Update classes that control visibility of zoom button and cursor icon.
   *
   * @private
   */
  _onZoomPanUpdate() {
    const { template: e, currSlide: t, options: i } = this.pswp;
    if (this.pswp.opener.isClosing || !e || !t)
      return;
    let { currZoomLevel: r } = t;
    if (this.pswp.opener.isOpen || (r = t.zoomLevels.initial), r === this._lastUpdatedZoomLevel)
      return;
    this._lastUpdatedZoomLevel = r;
    const s = t.zoomLevels.initial - t.zoomLevels.secondary;
    if (Math.abs(s) < 0.01 || !t.isZoomable()) {
      Es(e, !1), e.classList.remove("pswp--zoom-allowed");
      return;
    }
    e.classList.add("pswp--zoom-allowed");
    const o = r === t.zoomLevels.initial ? t.zoomLevels.secondary : t.zoomLevels.initial;
    Es(e, o <= r), (i.imageClickAction === "zoom" || i.imageClickAction === "zoom-or-close") && e.classList.add("pswp--click-to-zoom");
  }
}
function nf(n) {
  const e = n.getBoundingClientRect();
  return {
    x: e.left,
    y: e.top,
    w: e.width
  };
}
function rf(n, e, t) {
  const i = n.getBoundingClientRect(), r = i.width / e, s = i.height / t, o = r > s ? r : s, l = (i.width - e * o) / 2, h = (i.height - t * o) / 2, d = {
    x: i.left + l,
    y: i.top + h,
    w: e * o
  };
  return d.innerRect = {
    w: i.width,
    h: i.height,
    x: l,
    y: h
  }, d;
}
function sf(n, e, t) {
  const i = t.dispatch("thumbBounds", {
    index: n,
    itemData: e,
    instance: t
  });
  if (i.thumbBounds)
    return i.thumbBounds;
  const { element: r } = e;
  let s, o;
  if (r && t.options.thumbSelector !== !1) {
    const l = t.options.thumbSelector || "img";
    o = r.matches(l) ? r : (
      /** @type {HTMLElement | null} */
      r.querySelector(l)
    );
  }
  return o = t.applyFilters("thumbEl", o, e, n), o && (e.thumbCropped ? s = rf(
    o,
    e.width || e.w || 0,
    e.height || e.h || 0
  ) : s = nf(o)), t.applyFilters("thumbBounds", s, e, n);
}
class of {
  /**
   * @param {T} type
   * @param {PhotoSwipeEventsMap[T]} [details]
   */
  constructor(e, t) {
    this.type = e, this.defaultPrevented = !1, t && Object.assign(this, t);
  }
  preventDefault() {
    this.defaultPrevented = !0;
  }
}
class af {
  constructor() {
    this._listeners = {}, this._filters = {}, this.pswp = void 0, this.options = void 0;
  }
  /**
   * @template {keyof PhotoSwipeFiltersMap} T
   * @param {T} name
   * @param {PhotoSwipeFiltersMap[T]} fn
   * @param {number} priority
   */
  addFilter(e, t, i = 100) {
    var r, s, o;
    this._filters[e] || (this._filters[e] = []), (r = this._filters[e]) == null || r.push({ fn: t, priority: i }), (s = this._filters[e]) == null || s.sort((l, h) => l.priority - h.priority), (o = this.pswp) == null || o.addFilter(e, t, i);
  }
  /**
   * @template {keyof PhotoSwipeFiltersMap} T
   * @param {T} name
   * @param {PhotoSwipeFiltersMap[T]} fn
   */
  removeFilter(e, t) {
    this._filters[e] && (this._filters[e] = this._filters[e].filter((i) => i.fn !== t)), this.pswp && this.pswp.removeFilter(e, t);
  }
  /**
   * @template {keyof PhotoSwipeFiltersMap} T
   * @param {T} name
   * @param {Parameters<PhotoSwipeFiltersMap[T]>} args
   * @returns {Parameters<PhotoSwipeFiltersMap[T]>[0]}
   */
  applyFilters(e, ...t) {
    var i;
    return (i = this._filters[e]) == null || i.forEach((r) => {
      t[0] = r.fn.apply(this, t);
    }), t[0];
  }
  /**
   * @template {keyof PhotoSwipeEventsMap} T
   * @param {T} name
   * @param {EventCallback<T>} fn
   */
  on(e, t) {
    var i, r;
    this._listeners[e] || (this._listeners[e] = []), (i = this._listeners[e]) == null || i.push(t), (r = this.pswp) == null || r.on(e, t);
  }
  /**
   * @template {keyof PhotoSwipeEventsMap} T
   * @param {T} name
   * @param {EventCallback<T>} fn
   */
  off(e, t) {
    var i;
    this._listeners[e] && (this._listeners[e] = this._listeners[e].filter((r) => t !== r)), (i = this.pswp) == null || i.off(e, t);
  }
  /**
   * @template {keyof PhotoSwipeEventsMap} T
   * @param {T} name
   * @param {PhotoSwipeEventsMap[T]} [details]
   * @returns {AugmentedEvent<T>}
   */
  dispatch(e, t) {
    var r;
    if (this.pswp)
      return this.pswp.dispatch(e, t);
    const i = (
      /** @type {AugmentedEvent<T>} */
      new of(e, t)
    );
    return (r = this._listeners[e]) == null || r.forEach((s) => {
      s.call(this, i);
    }), i;
  }
}
class lf {
  /**
   * @param {string | false} imageSrc
   * @param {HTMLElement} container
   */
  constructor(e, t) {
    if (this.element = Le(
      "pswp__img pswp__img--placeholder",
      e ? "img" : "div",
      t
    ), e) {
      const i = (
        /** @type {HTMLImageElement} */
        this.element
      );
      i.decoding = "async", i.alt = "", i.src = e, i.setAttribute("role", "presentation");
    }
    this.element.setAttribute("aria-hidden", "true");
  }
  /**
   * @param {number} width
   * @param {number} height
   */
  setDisplayedSize(e, t) {
    this.element && (this.element.tagName === "IMG" ? (Fi(this.element, 250, "auto"), this.element.style.transformOrigin = "0 0", this.element.style.transform = gn(0, 0, e / 250)) : Fi(this.element, e, t));
  }
  destroy() {
    var e;
    (e = this.element) != null && e.parentNode && this.element.remove(), this.element = null;
  }
}
class cf {
  /**
   * @param {SlideData} itemData Slide data
   * @param {PhotoSwipeBase} instance PhotoSwipe or PhotoSwipeLightbox instance
   * @param {number} index
   */
  constructor(e, t, i) {
    this.instance = t, this.data = e, this.index = i, this.element = void 0, this.placeholder = void 0, this.slide = void 0, this.displayedImageWidth = 0, this.displayedImageHeight = 0, this.width = Number(this.data.w) || Number(this.data.width) || 0, this.height = Number(this.data.h) || Number(this.data.height) || 0, this.isAttached = !1, this.hasSlide = !1, this.isDecoding = !1, this.state = je.IDLE, this.data.type ? this.type = this.data.type : this.data.src ? this.type = "image" : this.type = "html", this.instance.dispatch("contentInit", { content: this });
  }
  removePlaceholder() {
    this.placeholder && !this.keepPlaceholder() && setTimeout(() => {
      this.placeholder && (this.placeholder.destroy(), this.placeholder = void 0);
    }, 1e3);
  }
  /**
   * Preload content
   *
   * @param {boolean} isLazy
   * @param {boolean} [reload]
   */
  load(e, t) {
    if (this.slide && this.usePlaceholder())
      if (this.placeholder) {
        const i = this.placeholder.element;
        i && !i.parentElement && this.slide.container.prepend(i);
      } else {
        const i = this.instance.applyFilters(
          "placeholderSrc",
          // use  image-based placeholder only for the first slide,
          // as rendering (even small stretched thumbnail) is an expensive operation
          this.data.msrc && this.slide.isFirstSlide ? this.data.msrc : !1,
          this
        );
        this.placeholder = new lf(
          i,
          this.slide.container
        );
      }
    this.element && !t || this.instance.dispatch("contentLoad", { content: this, isLazy: e }).defaultPrevented || (this.isImageContent() ? (this.element = Le("pswp__img", "img"), this.displayedImageWidth && this.loadImage(e)) : (this.element = Le("pswp__content", "div"), this.element.innerHTML = this.data.html || ""), t && this.slide && this.slide.updateContentSize(!0));
  }
  /**
   * Preload image
   *
   * @param {boolean} isLazy
   */
  loadImage(e) {
    var i, r;
    if (!this.isImageContent() || !this.element || this.instance.dispatch("contentLoadImage", { content: this, isLazy: e }).defaultPrevented)
      return;
    const t = (
      /** @type HTMLImageElement */
      this.element
    );
    this.updateSrcsetSizes(), this.data.srcset && (t.srcset = this.data.srcset), t.src = (i = this.data.src) != null ? i : "", t.alt = (r = this.data.alt) != null ? r : "", this.state = je.LOADING, t.complete ? this.onLoaded() : (t.onload = () => {
      this.onLoaded();
    }, t.onerror = () => {
      this.onError();
    });
  }
  /**
   * Assign slide to content
   *
   * @param {Slide} slide
   */
  setSlide(e) {
    this.slide = e, this.hasSlide = !0, this.instance = e.pswp;
  }
  /**
   * Content load success handler
   */
  onLoaded() {
    this.state = je.LOADED, this.slide && this.element && (this.instance.dispatch("loadComplete", { slide: this.slide, content: this }), this.slide.isActive && this.slide.heavyAppended && !this.element.parentNode && (this.append(), this.slide.updateContentSize(!0)), (this.state === je.LOADED || this.state === je.ERROR) && this.removePlaceholder());
  }
  /**
   * Content load error handler
   */
  onError() {
    this.state = je.ERROR, this.slide && (this.displayError(), this.instance.dispatch("loadComplete", { slide: this.slide, isError: !0, content: this }), this.instance.dispatch("loadError", { slide: this.slide, content: this }));
  }
  /**
   * @returns {Boolean} If the content is currently loading
   */
  isLoading() {
    return this.instance.applyFilters(
      "isContentLoading",
      this.state === je.LOADING,
      this
    );
  }
  /**
   * @returns {Boolean} If the content is in error state
   */
  isError() {
    return this.state === je.ERROR;
  }
  /**
   * @returns {boolean} If the content is image
   */
  isImageContent() {
    return this.type === "image";
  }
  /**
   * Update content size
   *
   * @param {Number} width
   * @param {Number} height
   */
  setDisplayedSize(e, t) {
    if (this.element && (this.placeholder && this.placeholder.setDisplayedSize(e, t), !this.instance.dispatch(
      "contentResize",
      { content: this, width: e, height: t }
    ).defaultPrevented && (Fi(this.element, e, t), this.isImageContent() && !this.isError()))) {
      const i = !this.displayedImageWidth && e;
      this.displayedImageWidth = e, this.displayedImageHeight = t, i ? this.loadImage(!1) : this.updateSrcsetSizes(), this.slide && this.instance.dispatch(
        "imageSizeChange",
        { slide: this.slide, width: e, height: t, content: this }
      );
    }
  }
  /**
   * @returns {boolean} If the content can be zoomed
   */
  isZoomable() {
    return this.instance.applyFilters(
      "isContentZoomable",
      this.isImageContent() && this.state !== je.ERROR,
      this
    );
  }
  /**
   * Update image srcset sizes attribute based on width and height
   */
  updateSrcsetSizes() {
    if (!this.isImageContent() || !this.element || !this.data.srcset)
      return;
    const e = (
      /** @type HTMLImageElement */
      this.element
    ), t = this.instance.applyFilters(
      "srcsetSizesWidth",
      this.displayedImageWidth,
      this
    );
    (!e.dataset.largestUsedSize || t > parseInt(e.dataset.largestUsedSize, 10)) && (e.sizes = t + "px", e.dataset.largestUsedSize = String(t));
  }
  /**
   * @returns {boolean} If content should use a placeholder (from msrc by default)
   */
  usePlaceholder() {
    return this.instance.applyFilters(
      "useContentPlaceholder",
      this.isImageContent(),
      this
    );
  }
  /**
   * Preload content with lazy-loading param
   */
  lazyLoad() {
    this.instance.dispatch("contentLazyLoad", { content: this }).defaultPrevented || this.load(!0);
  }
  /**
   * @returns {boolean} If placeholder should be kept after content is loaded
   */
  keepPlaceholder() {
    return this.instance.applyFilters(
      "isKeepingPlaceholder",
      this.isLoading(),
      this
    );
  }
  /**
   * Destroy the content
   */
  destroy() {
    this.hasSlide = !1, this.slide = void 0, !this.instance.dispatch("contentDestroy", { content: this }).defaultPrevented && (this.remove(), this.placeholder && (this.placeholder.destroy(), this.placeholder = void 0), this.isImageContent() && this.element && (this.element.onload = null, this.element.onerror = null, this.element = void 0));
  }
  /**
   * Display error message
   */
  displayError() {
    var e, t;
    if (this.slide) {
      let i = Le("pswp__error-msg", "div");
      i.innerText = (t = (e = this.instance.options) == null ? void 0 : e.errorMsg) != null ? t : "", i = /** @type {HTMLDivElement} */
      this.instance.applyFilters(
        "contentErrorElement",
        i,
        this
      ), this.element = Le("pswp__content pswp__error-msg-container", "div"), this.element.appendChild(i), this.slide.container.innerText = "", this.slide.container.appendChild(this.element), this.slide.updateContentSize(!0), this.removePlaceholder();
    }
  }
  /**
   * Append the content
   */
  append() {
    if (this.isAttached || !this.element)
      return;
    if (this.isAttached = !0, this.state === je.ERROR) {
      this.displayError();
      return;
    }
    if (this.instance.dispatch("contentAppend", { content: this }).defaultPrevented)
      return;
    const e = "decode" in this.element;
    this.isImageContent() ? e && this.slide && (!this.slide.isActive || vs()) ? (this.isDecoding = !0, this.element.decode().catch(() => {
    }).finally(() => {
      this.isDecoding = !1, this.appendImage();
    })) : this.appendImage() : this.slide && !this.element.parentNode && this.slide.container.appendChild(this.element);
  }
  /**
   * Activate the slide,
   * active slide is generally the current one,
   * meaning the user can see it.
   */
  activate() {
    this.instance.dispatch("contentActivate", { content: this }).defaultPrevented || !this.slide || (this.isImageContent() && this.isDecoding && !vs() ? this.appendImage() : this.isError() && this.load(!1, !0), this.slide.holderElement && this.slide.holderElement.setAttribute("aria-hidden", "false"));
  }
  /**
   * Deactivate the content
   */
  deactivate() {
    this.instance.dispatch("contentDeactivate", { content: this }), this.slide && this.slide.holderElement && this.slide.holderElement.setAttribute("aria-hidden", "true");
  }
  /**
   * Remove the content from DOM
   */
  remove() {
    this.isAttached = !1, !this.instance.dispatch("contentRemove", { content: this }).defaultPrevented && (this.element && this.element.parentNode && this.element.remove(), this.placeholder && this.placeholder.element && this.placeholder.element.remove());
  }
  /**
   * Append the image content to slide container
   */
  appendImage() {
    this.isAttached && (this.instance.dispatch("contentAppendImage", { content: this }).defaultPrevented || (this.slide && this.element && !this.element.parentNode && this.slide.container.appendChild(this.element), (this.state === je.LOADED || this.state === je.ERROR) && this.removePlaceholder()));
  }
}
const uf = 5;
function yo(n, e, t) {
  const i = e.createContentFromData(n, t);
  let r;
  const { options: s } = e;
  if (s) {
    r = new vo(s, n, -1);
    let o;
    e.pswp ? o = e.pswp.viewportSize : o = po(s, e);
    const l = mo(s, o, n, t);
    r.update(i.width, i.height, l);
  }
  return i.lazyLoad(), r && i.setDisplayedSize(
    Math.ceil(i.width * r.initial),
    Math.ceil(i.height * r.initial)
  ), i;
}
function hf(n, e) {
  const t = e.getItemData(n);
  if (!e.dispatch("lazyLoadSlide", { index: n, itemData: t }).defaultPrevented)
    return yo(t, e, n);
}
class df {
  /**
   * @param {PhotoSwipe} pswp
   */
  constructor(e) {
    this.pswp = e, this.limit = Math.max(
      e.options.preload[0] + e.options.preload[1] + 1,
      uf
    ), this._cachedItems = [];
  }
  /**
   * Lazy load nearby slides based on `preload` option.
   *
   * @param {number} [diff] Difference between slide indexes that was changed recently, or 0.
   */
  updateLazy(e) {
    const { pswp: t } = this;
    if (t.dispatch("lazyLoad").defaultPrevented)
      return;
    const { preload: i } = t.options, r = e === void 0 ? !0 : e >= 0;
    let s;
    for (s = 0; s <= i[1]; s++)
      this.loadSlideByIndex(t.currIndex + (r ? s : -s));
    for (s = 1; s <= i[0]; s++)
      this.loadSlideByIndex(t.currIndex + (r ? -s : s));
  }
  /**
   * @param {number} initialIndex
   */
  loadSlideByIndex(e) {
    const t = this.pswp.getLoopedIndex(e);
    let i = this.getContentByIndex(t);
    i || (i = hf(t, this.pswp), i && this.addToCache(i));
  }
  /**
   * @param {Slide} slide
   * @returns {Content}
   */
  getContentBySlide(e) {
    let t = this.getContentByIndex(e.index);
    return t || (t = this.pswp.createContentFromData(e.data, e.index), this.addToCache(t)), t.setSlide(e), t;
  }
  /**
   * @param {Content} content
   */
  addToCache(e) {
    if (this.removeByIndex(e.index), this._cachedItems.push(e), this._cachedItems.length > this.limit) {
      const t = this._cachedItems.findIndex((i) => !i.isAttached && !i.hasSlide);
      t !== -1 && this._cachedItems.splice(t, 1)[0].destroy();
    }
  }
  /**
   * Removes an image from cache, does not destroy() it, just removes.
   *
   * @param {number} index
   */
  removeByIndex(e) {
    const t = this._cachedItems.findIndex((i) => i.index === e);
    t !== -1 && this._cachedItems.splice(t, 1);
  }
  /**
   * @param {number} index
   * @returns {Content | undefined}
   */
  getContentByIndex(e) {
    return this._cachedItems.find((t) => t.index === e);
  }
  destroy() {
    this._cachedItems.forEach((e) => e.destroy()), this._cachedItems = [];
  }
}
class ff extends af {
  /**
   * Get total number of slides
   *
   * @returns {number}
   */
  getNumItems() {
    var r;
    let e = 0;
    const t = (r = this.options) == null ? void 0 : r.dataSource;
    t && "length" in t ? e = t.length : t && "gallery" in t && (t.items || (t.items = this._getGalleryDOMElements(t.gallery)), t.items && (e = t.items.length));
    const i = this.dispatch("numItems", {
      dataSource: t,
      numItems: e
    });
    return this.applyFilters("numItems", i.numItems, t);
  }
  /**
   * @param {SlideData} slideData
   * @param {number} index
   * @returns {Content}
   */
  createContentFromData(e, t) {
    return new cf(e, this, t);
  }
  /**
   * Get item data by index.
   *
   * "item data" should contain normalized information that PhotoSwipe needs to generate a slide.
   * For example, it may contain properties like
   * `src`, `srcset`, `w`, `h`, which will be used to generate a slide with image.
   *
   * @param {number} index
   * @returns {SlideData}
   */
  getItemData(e) {
    var o;
    const t = (o = this.options) == null ? void 0 : o.dataSource;
    let i = {};
    Array.isArray(t) ? i = t[e] : t && "gallery" in t && (t.items || (t.items = this._getGalleryDOMElements(t.gallery)), i = t.items[e]);
    let r = i;
    r instanceof Element && (r = this._domElementToItemData(r));
    const s = this.dispatch("itemData", {
      itemData: r || {},
      index: e
    });
    return this.applyFilters("itemData", s.itemData, e);
  }
  /**
   * Get array of gallery DOM elements,
   * based on childSelector and gallery element.
   *
   * @param {HTMLElement} galleryElement
   * @returns {HTMLElement[]}
   */
  _getGalleryDOMElements(e) {
    var t, i;
    return (t = this.options) != null && t.children || (i = this.options) != null && i.childSelector ? _d(
      this.options.children,
      this.options.childSelector,
      e
    ) || [] : [e];
  }
  /**
   * Converts DOM element to item data object.
   *
   * @param {HTMLElement} element DOM element
   * @returns {SlideData}
   */
  _domElementToItemData(e) {
    var r;
    const t = {
      element: e
    }, i = (
      /** @type {HTMLAnchorElement} */
      e.tagName === "A" ? e : e.querySelector("a")
    );
    if (i) {
      t.src = i.dataset.pswpSrc || i.href, i.dataset.pswpSrcset && (t.srcset = i.dataset.pswpSrcset), t.width = i.dataset.pswpWidth ? parseInt(i.dataset.pswpWidth, 10) : 0, t.height = i.dataset.pswpHeight ? parseInt(i.dataset.pswpHeight, 10) : 0, t.w = t.width, t.h = t.height, i.dataset.pswpType && (t.type = i.dataset.pswpType);
      const s = e.querySelector("img");
      s && (t.msrc = s.currentSrc || s.src, t.alt = (r = s.getAttribute("alt")) != null ? r : ""), (i.dataset.pswpCropped || i.dataset.cropped) && (t.thumbCropped = !0);
    }
    return this.applyFilters("domItemData", t, e, i);
  }
  /**
   * Lazy-load by slide data
   *
   * @param {SlideData} itemData Data about the slide
   * @param {number} index
   * @returns {Content} Image that is being decoded or false.
   */
  lazyLoadData(e, t) {
    return yo(e, this, t);
  }
}
const ln = 3e-3;
class pf {
  /**
   * @param {PhotoSwipe} pswp
   */
  constructor(e) {
    this.pswp = e, this.isClosed = !0, this.isOpen = !1, this.isClosing = !1, this.isOpening = !1, this._duration = void 0, this._useAnimation = !1, this._croppedZoom = !1, this._animateRootOpacity = !1, this._animateBgOpacity = !1, this._placeholder = void 0, this._opacityElement = void 0, this._cropContainer1 = void 0, this._cropContainer2 = void 0, this._thumbBounds = void 0, this._prepareOpen = this._prepareOpen.bind(this), e.on("firstZoomPan", this._prepareOpen);
  }
  open() {
    this._prepareOpen(), this._start();
  }
  close() {
    if (this.isClosed || this.isClosing || this.isOpening)
      return;
    const e = this.pswp.currSlide;
    this.isOpen = !1, this.isOpening = !1, this.isClosing = !0, this._duration = this.pswp.options.hideAnimationDuration, e && e.currZoomLevel * e.width >= this.pswp.options.maxWidthToAnimate && (this._duration = 0), this._applyStartProps(), setTimeout(() => {
      this._start();
    }, this._croppedZoom ? 30 : 0);
  }
  /** @private */
  _prepareOpen() {
    if (this.pswp.off("firstZoomPan", this._prepareOpen), !this.isOpening) {
      const e = this.pswp.currSlide;
      this.isOpening = !0, this.isClosing = !1, this._duration = this.pswp.options.showAnimationDuration, e && e.zoomLevels.initial * e.width >= this.pswp.options.maxWidthToAnimate && (this._duration = 0), this._applyStartProps();
    }
  }
  /** @private */
  _applyStartProps() {
    var r, s;
    const { pswp: e } = this, t = this.pswp.currSlide, { options: i } = e;
    if (i.showHideAnimationType === "fade" ? (i.showHideOpacity = !0, this._thumbBounds = void 0) : i.showHideAnimationType === "none" ? (i.showHideOpacity = !1, this._duration = 0, this._thumbBounds = void 0) : this.isOpening && e._initialThumbBounds ? this._thumbBounds = e._initialThumbBounds : this._thumbBounds = this.pswp.getThumbBounds(), this._placeholder = t == null ? void 0 : t.getPlaceholderElement(), e.animations.stopAll(), this._useAnimation = Boolean(this._duration && this._duration > 50), this._animateZoom = Boolean(this._thumbBounds) && (t == null ? void 0 : t.content.usePlaceholder()) && (!this.isClosing || !e.mainScroll.isShifted()), this._animateZoom ? this._animateRootOpacity = (r = i.showHideOpacity) != null ? r : !1 : (this._animateRootOpacity = !0, this.isOpening && t && (t.zoomAndPanToInitial(), t.applyCurrentZoomPan())), this._animateBgOpacity = !this._animateRootOpacity && this.pswp.options.bgOpacity > ln, this._opacityElement = this._animateRootOpacity ? e.element : e.bg, !this._useAnimation) {
      this._duration = 0, this._animateZoom = !1, this._animateBgOpacity = !1, this._animateRootOpacity = !0, this.isOpening && (e.element && (e.element.style.opacity = String(ln)), e.applyBgOpacity(1));
      return;
    }
    this._animateZoom && this._thumbBounds && this._thumbBounds.innerRect ? (this._croppedZoom = !0, this._cropContainer1 = this.pswp.container, this._cropContainer2 = (s = this.pswp.currSlide) == null ? void 0 : s.holderElement, e.container && (e.container.style.overflow = "hidden", e.container.style.width = e.viewportSize.x + "px")) : this._croppedZoom = !1, this.isOpening ? (this._animateRootOpacity ? (e.element && (e.element.style.opacity = String(ln)), e.applyBgOpacity(1)) : (this._animateBgOpacity && e.bg && (e.bg.style.opacity = String(ln)), e.element && (e.element.style.opacity = "1")), this._animateZoom && (this._setClosedStateZoomPan(), this._placeholder && (this._placeholder.style.willChange = "transform", this._placeholder.style.opacity = String(ln)))) : this.isClosing && (e.mainScroll.itemHolders[0] && (e.mainScroll.itemHolders[0].el.style.display = "none"), e.mainScroll.itemHolders[2] && (e.mainScroll.itemHolders[2].el.style.display = "none"), this._croppedZoom && e.mainScroll.x !== 0 && (e.mainScroll.resetPosition(), e.mainScroll.resize()));
  }
  /** @private */
  _start() {
    this.isOpening && this._useAnimation && this._placeholder && this._placeholder.tagName === "IMG" ? new Promise((e) => {
      let t = !1, i = !0;
      gd(
        /** @type {HTMLImageElement} */
        this._placeholder
      ).finally(() => {
        t = !0, i || e(!0);
      }), setTimeout(() => {
        i = !1, t && e(!0);
      }, 50), setTimeout(e, 250);
    }).finally(() => this._initiate()) : this._initiate();
  }
  /** @private */
  _initiate() {
    var e, t;
    (e = this.pswp.element) == null || e.style.setProperty("--pswp-transition-duration", this._duration + "ms"), this.pswp.dispatch(
      this.isOpening ? "openingAnimationStart" : "closingAnimationStart"
    ), this.pswp.dispatch(
      /** @type {'initialZoomIn' | 'initialZoomOut'} */
      "initialZoom" + (this.isOpening ? "In" : "Out")
    ), (t = this.pswp.element) == null || t.classList.toggle("pswp--ui-visible", this.isOpening), this.isOpening ? (this._placeholder && (this._placeholder.style.opacity = "1"), this._animateToOpenState()) : this.isClosing && this._animateToClosedState(), this._useAnimation || this._onAnimationComplete();
  }
  /** @private */
  _onAnimationComplete() {
    var t;
    const { pswp: e } = this;
    this.isOpen = this.isOpening, this.isClosed = this.isClosing, this.isOpening = !1, this.isClosing = !1, e.dispatch(
      this.isOpen ? "openingAnimationEnd" : "closingAnimationEnd"
    ), e.dispatch(
      /** @type {'initialZoomInEnd' | 'initialZoomOutEnd'} */
      "initialZoom" + (this.isOpen ? "InEnd" : "OutEnd")
    ), this.isClosed ? e.destroy() : this.isOpen && (this._animateZoom && e.container && (e.container.style.overflow = "visible", e.container.style.width = "100%"), (t = e.currSlide) == null || t.applyCurrentZoomPan());
  }
  /** @private */
  _animateToOpenState() {
    const { pswp: e } = this;
    this._animateZoom && (this._croppedZoom && this._cropContainer1 && this._cropContainer2 && (this._animateTo(this._cropContainer1, "transform", "translate3d(0,0,0)"), this._animateTo(this._cropContainer2, "transform", "none")), e.currSlide && (e.currSlide.zoomAndPanToInitial(), this._animateTo(
      e.currSlide.container,
      "transform",
      e.currSlide.getCurrentTransform()
    ))), this._animateBgOpacity && e.bg && this._animateTo(e.bg, "opacity", String(e.options.bgOpacity)), this._animateRootOpacity && e.element && this._animateTo(e.element, "opacity", "1");
  }
  /** @private */
  _animateToClosedState() {
    const { pswp: e } = this;
    this._animateZoom && this._setClosedStateZoomPan(!0), this._animateBgOpacity && e.bgOpacity > 0.01 && e.bg && this._animateTo(e.bg, "opacity", "0"), this._animateRootOpacity && e.element && this._animateTo(e.element, "opacity", "0");
  }
  /**
   * @private
   * @param {boolean} [animate]
   */
  _setClosedStateZoomPan(e) {
    if (!this._thumbBounds)
      return;
    const { pswp: t } = this, { innerRect: i } = this._thumbBounds, { currSlide: r, viewportSize: s } = t;
    if (this._croppedZoom && i && this._cropContainer1 && this._cropContainer2) {
      const o = -s.x + (this._thumbBounds.x - i.x) + i.w, l = -s.y + (this._thumbBounds.y - i.y) + i.h, h = s.x - i.w, d = s.y - i.h;
      e ? (this._animateTo(
        this._cropContainer1,
        "transform",
        gn(o, l)
      ), this._animateTo(
        this._cropContainer2,
        "transform",
        gn(h, d)
      )) : (Tt(this._cropContainer1, o, l), Tt(this._cropContainer2, h, d));
    }
    r && (ye(r.pan, i || this._thumbBounds), r.currZoomLevel = this._thumbBounds.w / r.width, e ? this._animateTo(r.container, "transform", r.getCurrentTransform()) : r.applyCurrentZoomPan());
  }
  /**
   * @private
   * @param {HTMLElement} target
   * @param {'transform' | 'opacity'} prop
   * @param {string} propValue
   */
  _animateTo(e, t, i) {
    if (!this._duration) {
      e.style[t] = i;
      return;
    }
    const { animations: r } = this.pswp, s = {
      duration: this._duration,
      easing: this.pswp.options.easing,
      onComplete: () => {
        r.activeAnimations.length || this._onAnimationComplete();
      },
      target: e
    };
    s[t] = i, r.startTransition(s);
  }
}
const mf = {
  allowPanToNext: !0,
  spacing: 0.1,
  loop: !0,
  pinchToClose: !0,
  closeOnVerticalDrag: !0,
  hideAnimationDuration: 333,
  showAnimationDuration: 333,
  zoomAnimationDuration: 333,
  escKey: !0,
  arrowKeys: !0,
  returnFocus: !0,
  maxWidthToAnimate: 4e3,
  clickToCloseNonZoomable: !0,
  imageClickAction: "zoom-or-close",
  bgClickAction: "close",
  tapAction: "toggle-controls",
  doubleTapAction: "zoom",
  indexIndicatorSep: " / ",
  preloaderDelay: 2e3,
  bgOpacity: 0.8,
  index: 0,
  errorMsg: "The image cannot be loaded",
  preload: [1, 2],
  easing: "cubic-bezier(.4,0,.22,1)"
};
class vf extends ff {
  /**
   * @param {PhotoSwipeOptions} [options]
   */
  constructor(e) {
    super(), this.options = this._prepareOptions(e || {}), this.offset = { x: 0, y: 0 }, this._prevViewportSize = { x: 0, y: 0 }, this.viewportSize = { x: 0, y: 0 }, this.bgOpacity = 1, this.currIndex = 0, this.potentialIndex = 0, this.isOpen = !1, this.isDestroying = !1, this.hasMouse = !1, this._initialItemData = {}, this._initialThumbBounds = void 0, this.topBar = void 0, this.element = void 0, this.template = void 0, this.container = void 0, this.scrollWrap = void 0, this.currSlide = void 0, this.events = new bd(), this.animations = new Wd(), this.mainScroll = new zd(this), this.gestures = new Ld(this), this.opener = new pf(this), this.keyboard = new Fd(this), this.contentLoader = new df(this);
  }
  /** @returns {boolean} */
  init() {
    if (this.isOpen || this.isDestroying)
      return !1;
    this.isOpen = !0, this.dispatch("init"), this.dispatch("beforeOpen"), this._createMainStructure();
    let e = "pswp--open";
    return this.gestures.supportsTouch && (e += " pswp--touch"), this.options.mainClass && (e += " " + this.options.mainClass), this.element && (this.element.className += " " + e), this.currIndex = this.options.index || 0, this.potentialIndex = this.currIndex, this.dispatch("firstUpdate"), this.scrollWheel = new qd(this), (Number.isNaN(this.currIndex) || this.currIndex < 0 || this.currIndex >= this.getNumItems()) && (this.currIndex = 0), this.gestures.supportsTouch || this.mouseDetected(), this.updateSize(), this.offset.y = window.pageYOffset, this._initialItemData = this.getItemData(this.currIndex), this.dispatch("gettingData", {
      index: this.currIndex,
      data: this._initialItemData,
      slide: void 0
    }), this._initialThumbBounds = this.getThumbBounds(), this.dispatch("initialLayout"), this.on("openingAnimationEnd", () => {
      const { itemHolders: t } = this.mainScroll;
      t[0] && (t[0].el.style.display = "block", this.setContent(t[0], this.currIndex - 1)), t[2] && (t[2].el.style.display = "block", this.setContent(t[2], this.currIndex + 1)), this.appendHeavy(), this.contentLoader.updateLazy(), this.events.add(window, "resize", this._handlePageResize.bind(this)), this.events.add(window, "scroll", this._updatePageScrollOffset.bind(this)), this.dispatch("bindEvents");
    }), this.mainScroll.itemHolders[1] && this.setContent(this.mainScroll.itemHolders[1], this.currIndex), this.dispatch("change"), this.opener.open(), this.dispatch("afterInit"), !0;
  }
  /**
   * Get looped slide index
   * (for example, -1 will return the last slide)
   *
   * @param {number} index
   * @returns {number}
   */
  getLoopedIndex(e) {
    const t = this.getNumItems();
    return this.options.loop && (e > t - 1 && (e -= t), e < 0 && (e += t)), _n(e, 0, t - 1);
  }
  appendHeavy() {
    this.mainScroll.itemHolders.forEach((e) => {
      var t;
      (t = e.slide) == null || t.appendHeavy();
    });
  }
  /**
   * Change the slide
   * @param {number} index New index
   */
  goTo(e) {
    this.mainScroll.moveIndexBy(
      this.getLoopedIndex(e) - this.potentialIndex
    );
  }
  /**
   * Go to the next slide.
   */
  next() {
    this.goTo(this.potentialIndex + 1);
  }
  /**
   * Go to the previous slide.
   */
  prev() {
    this.goTo(this.potentialIndex - 1);
  }
  /**
   * @see slide/slide.js zoomTo
   *
   * @param {Parameters<Slide['zoomTo']>} args
   */
  zoomTo(...e) {
    var t;
    (t = this.currSlide) == null || t.zoomTo(...e);
  }
  /**
   * @see slide/slide.js toggleZoom
   */
  toggleZoom() {
    var e;
    (e = this.currSlide) == null || e.toggleZoom();
  }
  /**
   * Close the gallery.
   * After closing transition ends - destroy it
   */
  close() {
    !this.opener.isOpen || this.isDestroying || (this.isDestroying = !0, this.dispatch("close"), this.events.removeAll(), this.opener.close());
  }
  /**
   * Destroys the gallery:
   * - instantly closes the gallery
   * - unbinds events,
   * - cleans intervals and timeouts
   * - removes elements from DOM
   */
  destroy() {
    var e;
    if (!this.isDestroying) {
      this.options.showHideAnimationType = "none", this.close();
      return;
    }
    this.dispatch("destroy"), this._listeners = {}, this.scrollWrap && (this.scrollWrap.ontouchmove = null, this.scrollWrap.ontouchend = null), (e = this.element) == null || e.remove(), this.mainScroll.itemHolders.forEach((t) => {
      var i;
      (i = t.slide) == null || i.destroy();
    }), this.contentLoader.destroy(), this.events.removeAll();
  }
  /**
   * Refresh/reload content of a slide by its index
   *
   * @param {number} slideIndex
   */
  refreshSlideContent(e) {
    this.contentLoader.removeByIndex(e), this.mainScroll.itemHolders.forEach((t, i) => {
      var s, o, l;
      let r = ((o = (s = this.currSlide) == null ? void 0 : s.index) != null ? o : 0) - 1 + i;
      this.canLoop() && (r = this.getLoopedIndex(r)), r === e && (this.setContent(t, e, !0), i === 1 && (this.currSlide = t.slide, (l = t.slide) == null || l.setIsActive(!0)));
    }), this.dispatch("change");
  }
  /**
   * Set slide content
   *
   * @param {ItemHolder} holder mainScroll.itemHolders array item
   * @param {number} index Slide index
   * @param {boolean} [force] If content should be set even if index wasn't changed
   */
  setContent(e, t, i) {
    if (this.canLoop() && (t = this.getLoopedIndex(t)), e.slide) {
      if (e.slide.index === t && !i)
        return;
      e.slide.destroy(), e.slide = void 0;
    }
    if (!this.canLoop() && (t < 0 || t >= this.getNumItems()))
      return;
    const r = this.getItemData(t);
    e.slide = new Ed(r, t, this), t === this.currIndex && (this.currSlide = e.slide), e.slide.append(e.el);
  }
  /** @returns {Point} */
  getViewportCenterPoint() {
    return {
      x: this.viewportSize.x / 2,
      y: this.viewportSize.y / 2
    };
  }
  /**
   * Update size of all elements.
   * Executed on init and on page resize.
   *
   * @param {boolean} [force] Update size even if size of viewport was not changed.
   */
  updateSize(e) {
    if (this.isDestroying)
      return;
    const t = po(this.options, this);
    !e && fn(t, this._prevViewportSize) || (ye(this._prevViewportSize, t), this.dispatch("beforeResize"), ye(this.viewportSize, this._prevViewportSize), this._updatePageScrollOffset(), this.dispatch("viewportSize"), this.mainScroll.resize(this.opener.isOpen), !this.hasMouse && window.matchMedia("(any-hover: hover)").matches && this.mouseDetected(), this.dispatch("resize"));
  }
  /**
   * @param {number} opacity
   */
  applyBgOpacity(e) {
    this.bgOpacity = Math.max(e, 0), this.bg && (this.bg.style.opacity = String(this.bgOpacity * this.options.bgOpacity));
  }
  /**
   * Whether mouse is detected
   */
  mouseDetected() {
    var e;
    this.hasMouse || (this.hasMouse = !0, (e = this.element) == null || e.classList.add("pswp--has_mouse"));
  }
  /**
   * Page resize event handler
   *
   * @private
   */
  _handlePageResize() {
    this.updateSize(), /iPhone|iPad|iPod/i.test(window.navigator.userAgent) && setTimeout(() => {
      this.updateSize();
    }, 500);
  }
  /**
   * Page scroll offset is used
   * to get correct coordinates
   * relative to PhotoSwipe viewport.
   *
   * @private
   */
  _updatePageScrollOffset() {
    this.setScrollOffset(0, window.pageYOffset);
  }
  /**
   * @param {number} x
   * @param {number} y
   */
  setScrollOffset(e, t) {
    this.offset.x = e, this.offset.y = t, this.dispatch("updateScrollOffset");
  }
  /**
   * Create main HTML structure of PhotoSwipe,
   * and add it to DOM
   *
   * @private
   */
  _createMainStructure() {
    this.element = Le("pswp", "div"), this.element.setAttribute("tabindex", "-1"), this.element.setAttribute("role", "dialog"), this.template = this.element, this.bg = Le("pswp__bg", "div", this.element), this.scrollWrap = Le("pswp__scroll-wrap", "section", this.element), this.container = Le("pswp__container", "div", this.scrollWrap), this.scrollWrap.setAttribute("aria-roledescription", "carousel"), this.container.setAttribute("aria-live", "off"), this.container.setAttribute("id", "pswp__items"), this.mainScroll.appendHolders(), this.ui = new tf(this), this.ui.init(), (this.options.appendToEl || document.body).appendChild(this.element);
  }
  /**
   * Get position and dimensions of small thumbnail
   *   {x:,y:,w:}
   *
   * Height is optional (calculated based on the large image)
   *
   * @returns {Bounds | undefined}
   */
  getThumbBounds() {
    return sf(
      this.currIndex,
      this.currSlide ? this.currSlide.data : this._initialItemData,
      this
    );
  }
  /**
   * If the PhotoSwipe can have continuous loop
   * @returns Boolean
   */
  canLoop() {
    return this.options.loop && this.getNumItems() > 2;
  }
  /**
   * @private
   * @param {PhotoSwipeOptions} options
   * @returns {PreparedPhotoSwipeOptions}
   */
  _prepareOptions(e) {
    return window.matchMedia("(prefers-reduced-motion), (update: slow)").matches && (e.showHideAnimationType = "none", e.zoomAnimationDuration = 0), Y(Y({}, mf), e);
  }
}
const gf = ({
  clickedImageIndex: n,
  middle: e,
  photosLength: t
}) => {
  if (typeof n == "number")
    return t && t > 5 ? n <= 3 ? n : e : n;
  if (typeof e == "number")
    return e;
};
const Zi = "gallery--getting-started-", yf = ({
  photos: n,
  testId: e,
  imageRef: t,
  clickedImageIndex: i,
  showHideAnimationType: r,
  galleryId: s
}) => {
  const o = Ue(() => Math.round((n.length - 1) / 2), [n]), l = Ue(() => o >= 3 ? o : 0, [o]), h = new pd({
    gallery: `#${Zi}${s}`,
    children: "a",
    loop: !1,
    bgClickAction: void 0,
    pswpModule: vf,
    showHideAnimationType: r
  });
  return he(() => (h.on("uiRegister", () => {
    h.pswp.ui.registerElement({
      name: "bulletsIndicator",
      className: "pswp__bullets-indicator",
      appendTo: "wrapper",
      onInit: (d, m) => {
        const p = document.createElement("div");
        p.classList.add("pswp__bullet-wrapper");
        const _ = [];
        let g = -1;
        for (let S = 0; S < m.getNumItems(); S++) {
          const A = document.createElement("img");
          A.src = n[S], A.className = "pswp__bullet", A.onclick = () => {
            m.goTo(S);
          }, p.appendChild(A), _.push(A);
        }
        m.on("change", () => {
          g >= 0 && _[g].classList.remove("pswp__bullet--active"), _[m.currIndex].classList.add("pswp__bullet--active"), g = m.currIndex;
          const S = document.querySelector(".pswp__bullet-wrapper");
          S && (S.style.transform = `translateX(calc((25vw - (${m.currIndex} * 96px)) - 40px))`);
        }), d.appendChild(p);
      }
    });
  }), h.init(), () => {
    h.destroy();
  }), [h, n]), n.length ? /* @__PURE__ */ c.createElement("div", { "data-testid": "photoswipe-images-container" }, /* @__PURE__ */ c.createElement("div", { className: "gallery-image" }), n.map((d, m) => {
    const p = Mh();
    let _, g;
    const S = document.createElement("img");
    return S.src = d, S.onload = () => {
      const A = document.querySelector(".gallery-image");
      if (!A)
        return;
      A.appendChild(S), S.style.maxWidth = "100vw", S.style.maxHeight = "80vh", _ = S.clientWidth, g = S.clientHeight;
      const I = document.getElementById(`gallery-tag-a-${m}-${p}`);
      I && (I.setAttribute("data-pswp-width", String(_)), I.setAttribute("data-pswp-height", String(g))), A.removeChild(S);
    }, /* @__PURE__ */ c.createElement(
      "a",
      {
        ref: gf({ clickedImageIndex: i, middle: l, photosLength: n.length }) === m ? t : void 0,
        id: `gallery-tag-a-${m}-${p}`,
        "data-cropped": "true",
        key: `${d}-${m}`,
        href: d,
        "data-testid": `${e}-${m}-${p}`,
        className: "gallery-image-link",
        target: "_blank",
        rel: "noopener noreferrer"
      },
      /* @__PURE__ */ c.createElement("img", { className: "gallery-image-link-image", src: d, alt: "" })
    );
  })) : null;
};
var _o = /* @__PURE__ */ ((n) => (n.FADE = "fade", n.SLIDE = "slide", n.NONE = "none", n))(_o || {});
const Ss = (n) => /* @__PURE__ */ c.createElement("svg", Y({ width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, n), /* @__PURE__ */ c.createElement("g", { id: "chevron_right" }, /* @__PURE__ */ c.createElement(
  "path",
  {
    id: "icon/navigation/chevron_right_24px",
    d: "M9.70492 6L8.29492 7.41L12.8749 12L8.29492 16.59L9.70492 18L15.7049 12L9.70492 6Z",
    fill: "#fff"
  }
)));
const _f = ({ medias: n, position: e, fieldName: t, messages: i, galleryEvents: r }) => {
  var L, x, Z;
  const [s, o] = le(e || 0), [l, h] = le(n[0].id), [d, m] = le(), p = {
    CAMERA: i.uploadedFromCamera,
    GALLERY: i.uploadedFromGallery
  };
  he(() => {
    const R = n.slice(0, 4).map((P, W) => Te(Y({}, P), { index: W }));
    m(R);
  }, []);
  const _ = (R, P) => {
    n[s].id === d[0].id && (R.pop(), R.unshift(Te(Y({}, n[P]), { index: P })), m(R));
  }, g = (R, P) => {
    n[s].id === d[d.length - 1].id && (R.shift(), R.push(Te(Y({}, n[P]), { index: P })), m(R));
  }, S = () => {
    const R = d;
    s === 0 ? (_(R, n.length - 1), h(n[n.length - 1].id), o(n.length - 1)) : (_(R, s - 1), h(n[s - 1].id), o(s - 1));
  }, A = () => {
    const R = d;
    s === n.length - 1 ? (g(R, 0), h(n[0].id), o(0)) : (g(R, s + 1), h(n[s + 1].id), o(s + 1));
  }, I = (Z = (x = (L = n[s]) == null ? void 0 : L.metadata) == null ? void 0 : x.split(":")) == null ? void 0 : Z[1];
  return /* @__PURE__ */ c.createElement("div", { className: "container__gallery" }, /* @__PURE__ */ c.createElement("div", { className: "container__photoswipe" }, /* @__PURE__ */ c.createElement("button", { onClick: S, className: "container__photoswipe__button", "aria-label": i.previousMedia }, /* @__PURE__ */ c.createElement(Ss, { style: { transform: "rotate(180deg)" } })), /* @__PURE__ */ c.createElement("div", { className: "container__photoswipe__image" }, /* @__PURE__ */ c.createElement("header", { className: "container__photoswipe__header" }, /* @__PURE__ */ c.createElement("div", { className: "container__photoswipe__header__container" }, t && /* @__PURE__ */ c.createElement("span", { className: "container__photoswipe__header__title" }, t), I && p[I] && /* @__PURE__ */ c.createElement("span", { className: "container__photoswipe__header__content" }, p[I])), /* @__PURE__ */ c.createElement(
    "a",
    {
      className: "container__photoswipe__header__download",
      href: n[s].url,
      onClick: () => {
        r.photos.downloadMedia({ download: !0 });
      },
      "aria-label": i.download,
      download: !0
    },
    /* @__PURE__ */ c.createElement(so, null)
  )), n[s].type === st.VIDEO ? /* @__PURE__ */ c.createElement("video", { controls: !0, preload: "auto", "aria-label": n[s].description || "" }, /* @__PURE__ */ c.createElement("source", { src: n[s].url, type: "video/mp4" })) : /* @__PURE__ */ c.createElement("img", { src: n[s].url, alt: n[s].description || "", loading: "lazy" })), /* @__PURE__ */ c.createElement("button", { onClick: A, className: "container__photoswipe__button", "aria-label": i.nextMedia }, /* @__PURE__ */ c.createElement(Ss, null))), /* @__PURE__ */ c.createElement("div", { className: "container__preview" }, d == null ? void 0 : d.map((R) => /* @__PURE__ */ c.createElement(
    "button",
    {
      key: R.id,
      className: "container__preview__item",
      style: {
        border: l === R.id ? "1px solid #fff" : "",
        backgroundImage: R.type === "video" ? `url(${R.thumb}` : `url(${R.url}`
      },
      onClick: () => {
        h(R.id), o(R.index);
      },
      onKeyDown: () => {
        h(R.id), o(R.index);
      },
      "aria-label": l === R.id ? `${i.current} ${R.index + 1}` : `${i.goToImage} ${R.index + 1}`
    }
  ))));
}, As = (n) => {
  var t;
  const e = (t = n == null ? void 0 : n.geometry) == null ? void 0 : t.coordinates;
  if (e && !e.some((i) => !i))
    return n;
};
const bf = ({
  audio: n,
  tags: e,
  tagsTranslations: t,
  author: i,
  date: r,
  user_location: s,
  manual_location: o,
  note: l,
  reversedCoordinates: h,
  messages: d,
  product: m,
  galleryEvents: p,
  audioUrl: _,
  audioDuration: g
}) => {
  const S = Ue(() => {
    if (As(o))
      return o;
    if (As(s))
      return s;
  }, [o, s]);
  return /* @__PURE__ */ c.createElement("div", { className: "note-content" }, /* @__PURE__ */ c.createElement(lo, { tags: e, tagsTranslations: t }), n && g && /* @__PURE__ */ c.createElement(
    ji,
    {
      customAudioStyles: { margin: "20px 0 0", background: "#14151C" },
      audio: n,
      duration: g,
      events: p.audioPlayer,
      isGaleryV2: !0,
      audioUrl: _
    }
  ), /* @__PURE__ */ c.createElement("div", { className: "note-content__infos", style: { marginTop: "12px" } }, l && /* @__PURE__ */ c.createElement(Ot, { iconType: "comment", text: l }), r && /* @__PURE__ */ c.createElement(Ot, { iconType: "task", text: Re(r).format("DD MMM, YY • HH:mm[h]") }), (o || s) && /* @__PURE__ */ c.createElement(Ot, { reversedCoordinates: h, text: S, iconType: "property" })), d.createdBy && /* @__PURE__ */ c.createElement("div", { className: "note-content__user" }, d.createdBy, " ", /* @__PURE__ */ c.createElement("b", null, i), " ", m ? `${d.in} ${m}` : ""));
};
const wf = ({
  close: n,
  note: e,
  position: t = 0,
  messages: i,
  fieldName: r,
  product: s,
  galleryEvents: o,
  tagsTranslations: l
}) => {
  var S, A;
  const [h, d] = le(""), m = (S = e.note_attachment || []) == null ? void 0 : S.filter((I) => I.file_type === st.PICTURES), p = (A = e.note_attachment || []) == null ? void 0 : A.find((I) => I.file_type === st.AUDIO), _ = m.map((I) => ({
    url: I.url,
    type: I.file_type,
    id: I.id,
    thumb: I.url_thumbnail,
    description: "",
    metadata: I.metadata
  })), g = p != null && p.url ? new Audio(p == null ? void 0 : p.url) : null;
  return g && (g.preload = "metadata", g.duration ? d(vn(g.duration)) : g.onloadedmetadata = () => {
    h || d(vn(g.duration));
  }), /* @__PURE__ */ c.createElement("div", { className: "gallery" }, /* @__PURE__ */ c.createElement("div", { className: "gallery__content" }, /* @__PURE__ */ c.createElement("button", { className: "gallery__close-button", onClick: n }, /* @__PURE__ */ c.createElement(Oi, { width: "10px", height: "10px" })), /* @__PURE__ */ c.createElement(
    _f,
    {
      medias: _,
      position: t,
      messages: i,
      fieldName: r,
      galleryEvents: o
    }
  ), /* @__PURE__ */ c.createElement(
    bf,
    {
      audio: g,
      tagsTranslations: l,
      tags: e.note_tag,
      note: e.note,
      author: e.author,
      date: e.date,
      user_location: e == null ? void 0 : e.user_location,
      manual_location: e == null ? void 0 : e.manual_location,
      messages: i,
      product: s,
      galleryEvents: o,
      audioUrl: p == null ? void 0 : p.url,
      audioDuration: h
    }
  )));
};
const Ef = document.querySelector("body"), Sf = ({ children: n, fade: e = !1, defaultOpened: t = !1 }, i) => {
  const [r, s] = le(t), o = Oe(() => s(!1), []);
  Ja(
    i,
    () => ({
      open: () => s(!0),
      close: o
    }),
    [o]
  );
  const l = Oe(
    (h) => {
      h.keyCode === 27 && o();
    },
    [o]
  );
  return he(() => (r && document.addEventListener("keydown", l, !1), () => {
    document.removeEventListener("keydown", l, !1);
  }), [l, r]), sl(
    r ? /* @__PURE__ */ c.createElement("div", { className: `modal ${e ? "modal-fade" : ""}` }, /* @__PURE__ */ c.createElement("div", { className: "modal-overlay", onClick: o }), /* @__PURE__ */ c.createElement("div", { className: "modal-body" }, n)) : null,
    Ef
  );
}, Af = Is(Sf), xi = "info-photos", xf = ({
  events: {
    openAllImagesInContractCard: n,
    openAllImagesInExpandedCard: e,
    openImageInContractCard: t,
    openImageInExpandedCard: i
  },
  customStyleTextThumbnail: r,
  isExpanded: s,
  photos: o,
  isGaleryV2: l,
  onThumbnailClick: h,
  noteId: d,
  note: m,
  messages: p,
  fieldName: _,
  productName: g,
  galleryEvents: S,
  tagsTranslations: A
}) => {
  const { theme: I } = ze(), L = We(null), x = c.useRef(null), [Z, R] = le(), P = (F) => {
    R(F), setTimeout(() => {
      var V;
      (V = x.current) == null || V.click();
    }, 0), h == null || h(F);
  }, W = Ue(() => (o == null ? void 0 : o.map((F) => F.url)) || [], [o]), K = Ue(() => (o == null ? void 0 : o.map((F) => F.url_thumbnail)) || [], [o]), J = Ue(() => !!(W && W.length > 3), [W]);
  if (!(W != null && W.length) && !K.length)
    return null;
  const q = (F, V) => {
    const j = J && F === 2;
    return V ? j ? e == null ? void 0 : e({ isExpanded: s }) : i == null ? void 0 : i({ isExpanded: s }) : j ? n == null ? void 0 : n({ isExpanded: s }) : t == null ? void 0 : t({ isExpanded: s });
  };
  return /* @__PURE__ */ c.createElement(
    "div",
    {
      role: "button",
      tabIndex: 0,
      "data-testid": "events-note-thumbnails-container",
      className: `${$}__container__thumbnails-container`,
      onKeyDown: (F) => s && F.stopPropagation(),
      onClick: (F) => s && F.stopPropagation()
    },
    K.map((F, V) => {
      if (J && V > 2)
        return null;
      const j = () => K.length > 5 && V >= 4 ? `linear-gradient(0deg, rgba(0, 0, 0, 0.56), rgba(0, 0, 0, 0.56)), url(${F})` : V <= 4 ? `url(${F})` : null;
      return /* @__PURE__ */ c.createElement(
        "div",
        {
          key: `${F}-${V}`,
          onClick: () => {
            l ? L.current.open() : P(V), q(V, s);
          },
          onKeyDown: () => {
            l ? L.current.open() : P(V);
          },
          "data-testid": `events-note-thumbnail-${F}`,
          className: G({
            [`${$}__container__thumbnails-container__thumbnail`]: !0,
            [`${$}__container__thumbnails-container__thumbnail__expanded`]: s
          }),
          style: { backgroundImage: j() },
          role: "button",
          tabIndex: 0
        },
        J && V === 2 && /* @__PURE__ */ c.createElement(
          "span",
          {
            "data-testid": "events-note-thumbnail-more",
            style: r,
            className: G(`${$}__container__thumbnails-container__thumbnail__text`, {
              [`${$}__container__thumbnails-container__thumbnail__text-dark`]: I === "dark"
            })
          },
          `+${K.length - 3}`
        )
      );
    }),
    l ? /* @__PURE__ */ c.createElement(Af, { ref: L }, /* @__PURE__ */ c.createElement(
      wf,
      {
        note: m,
        close: () => L.current.close(),
        messages: p,
        fieldName: _,
        product: g,
        galleryEvents: S,
        tagsTranslations: A
      }
    )) : /* @__PURE__ */ c.createElement("div", { id: `${Zi}${xi}-${d}`, "data-testid": `${Zi}${xi}` }, /* @__PURE__ */ c.createElement(
      yf,
      {
        galleryId: `${xi}-${d}`,
        clickedImageIndex: Z,
        photos: W,
        testId: "photoswipe",
        imageRef: x,
        showHideAnimationType: _o.FADE
      }
    ))
  );
}, Cf = (t) => {
  var i = t, { fill: n = "#A3A9B9" } = i, e = xt(i, ["fill"]);
  return /* @__PURE__ */ c.createElement("svg", Y({ xmlns: "http://www.w3.org/2000/svg", width: "19", height: "18", viewBox: "0 0 19 18", fill: "none" }, e), /* @__PURE__ */ c.createElement(
    "path",
    {
      fill: n,
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M9.13281 6C9.95781 6 10.6328 5.325 10.6328 4.5C10.6328 3.675 9.95781 3 9.13281 3C8.30781 3 7.63281 3.675 7.63281 4.5C7.63281 5.325 8.30781 6 9.13281 6ZM9.13281 7.5C8.30781 7.5 7.63281 8.175 7.63281 9C7.63281 9.825 8.30781 10.5 9.13281 10.5C9.95781 10.5 10.6328 9.825 10.6328 9C10.6328 8.175 9.95781 7.5 9.13281 7.5ZM7.63281 13.5C7.63281 12.675 8.30781 12 9.13281 12C9.95781 12 10.6328 12.675 10.6328 13.5C10.6328 14.325 9.95781 15 9.13281 15C8.30781 15 7.63281 14.325 7.63281 13.5Z"
    }
  ));
}, bo = Ts(null), rm = () => Os(bo), Pf = ({ closePopup: n, openPopup: e, children: t }) => {
  const i = Ue(() => ({ closePopup: n, openPopup: e }), [n]);
  return /* @__PURE__ */ c.createElement(bo.Provider, { value: i }, t);
}, Tf = { offset: [-5, 13] }, Of = ({ customActionsMenu: n }) => {
  const { theme: e } = ze(), [t, i] = le(!1), r = (o) => {
    i(o);
  }, s = G({
    [`${$}__container__actions-menu__button`]: !0,
    [`${$}__container__actions-menu__button-dark`]: e === "dark",
    active: t
  });
  return /* @__PURE__ */ c.createElement(Pf, { closePopup: () => i(!1), openPopup: () => i(!0) }, /* @__PURE__ */ c.createElement(
    "button",
    {
      className: `${$}__container__actions-menu__unstyled-button`,
      onClick: (o) => o.stopPropagation(),
      onKeyDown: (o) => o.stopPropagation()
    },
    /* @__PURE__ */ c.createElement(
      Ms,
      {
        content: n,
        overlayClassName: "note-card-action-menu-popover",
        trigger: "click",
        placement: "rightTop",
        align: Tf,
        visible: t,
        onVisibleChange: r
      },
      /* @__PURE__ */ c.createElement("button", { className: s, "data-testid": "note-card-actions-menu" }, /* @__PURE__ */ c.createElement(Cf, null))
    )
  ));
}, If = (n) => /* @__PURE__ */ c.createElement("svg", Y({ xmlns: "http://www.w3.org/2000/svg", width: "12", height: "16", fill: "none" }, n), /* @__PURE__ */ c.createElement(
  "path",
  {
    fill: "#696F88",
    fillRule: "evenodd",
    d: "M6 9.875a2.247 2.247 0 0 0 2.25-2.25v-4.5A2.247 2.247 0 0 0 6 .875a2.247 2.247 0 0 0-2.25 2.25v4.5A2.247 2.247 0 0 0 6 9.875Zm-.75-6.75c0-.413.338-.75.75-.75s.75.337.75.75v4.5c0 .412-.338.75-.75.75a.752.752 0 0 1-.75-.75v-4.5Zm.75 8.25c2.07 0 3.75-1.68 3.75-3.75h1.5a5.246 5.246 0 0 1-4.5 5.19v2.31h-1.5v-2.31a5.246 5.246 0 0 1-4.5-5.19h1.5c0 2.07 1.68 3.75 3.75 3.75Z",
    clipRule: "evenodd"
  }
)), kf = ({
  duration: n,
  isExpanded: e,
  hasComment: t,
  hasAudio: i
}) => {
  const { theme: r } = ze(), s = G({
    [`${$}__container__icon`]: !0,
    [`${$}__container__icon-dark`]: r === "dark"
  });
  return /* @__PURE__ */ c.createElement(
    "div",
    {
      className: G({
        [`${$}__container__icon-container`]: !0,
        [`${$}__container__icon-container__expanded`]: e
      }),
      "aria-label": "Icons container"
    },
    t && /* @__PURE__ */ c.createElement("div", { className: s, "aria-label": "Coment" }, /* @__PURE__ */ c.createElement(Zs, null)),
    i && /* @__PURE__ */ c.createElement(c.Fragment, null, /* @__PURE__ */ c.createElement("div", { className: s, "aria-label": "Audio" }, /* @__PURE__ */ c.createElement(If, null)), /* @__PURE__ */ c.createElement(
      "div",
      {
        className: G({
          [`${$}__container__audio-duration-dark`]: r === "dark"
        })
      },
      n || "--:--"
    ))
  );
}, Df = ({ fieldName: n }) => /* @__PURE__ */ c.createElement("div", { className: `${$}__container__info-note__fieldName-container` }, /* @__PURE__ */ c.createElement("span", null, n)), Mf = ({
  customStyleTextThumbnail: n,
  customStyleInfoTagText: e,
  customStyleInfoNote: t,
  customActionsMenu: i,
  tagsTranslations: r,
  isExpanded: s,
  hasComment: o,
  duration: l,
  hasAudio: h,
  noteId: d,
  photos: m,
  events: p,
  note: _,
  isGaleryV2: g,
  photosMessages: S,
  fieldName: A,
  productName: I,
  galleryEvents: L
}) => {
  const { theme: x } = ze(), Z = G({
    [`${$}__container__title-container`]: !0,
    [`${$}__container__title-container-dark`]: x === "dark"
  }), R = s ? null : /* @__PURE__ */ c.createElement(Ot, { customStyleInfoNote: t, iconType: "comment", text: _ == null ? void 0 : _.note, isHeader: !0 }), P = m.length ? /* @__PURE__ */ c.createElement(
    xf,
    {
      customStyleTextThumbnail: n,
      isExpanded: s,
      photos: m,
      events: p,
      noteId: d,
      note: _,
      isGaleryV2: g,
      messages: S,
      fieldName: A,
      productName: I,
      galleryEvents: L,
      tagsTranslations: r
    }
  ) : R;
  return /* @__PURE__ */ c.createElement(c.Fragment, null, /* @__PURE__ */ c.createElement("div", { className: Z }, /* @__PURE__ */ c.createElement(Df, { fieldName: A }), /* @__PURE__ */ c.createElement(
    lo,
    {
      customStyleInfoTagText: e,
      tags: _ == null ? void 0 : _.note_tag,
      tagsTranslations: r
    }
  ), i && /* @__PURE__ */ c.createElement(Of, { customActionsMenu: i })), (!s || !!m.length) && /* @__PURE__ */ c.createElement("div", { className: `${$}__container__resume-note` }, P, !s && /* @__PURE__ */ c.createElement(
    kf,
    {
      duration: l,
      isExpanded: s,
      hasComment: !!(m != null && m.length) && o,
      hasAudio: h
    }
  )));
};
const Lf = ({
  name: n,
  customStyleScouterName: e,
  customStyleScouterInitials: t
}) => {
  const { theme: i } = ze(), r = G({
    [`${$}__container__info-note__scouter-container__name`]: !0,
    [`${$}__container__info-note__scouter-container__name-dark`]: i === "dark"
  }), s = G({
    [`${$}__container__info-note__scouter-container__scouter-initials`]: !0,
    [`${$}__container__info-note__scouter-container__scouter-initials-dark`]: i === "dark"
  });
  return !n || no(n) ? null : /* @__PURE__ */ c.createElement(
    "div",
    {
      "data-testid": "info-scouter-container",
      className: `${$}__container__info-note__scouter-container`
    },
    /* @__PURE__ */ c.createElement("div", { className: s }, /* @__PURE__ */ c.createElement(
      "span",
      {
        className: `${$}__container__info-note__scouter-container__scouter-initials__text`,
        style: t,
        "data-testid": "info-scouter-initials"
      },
      Yh(n)
    )),
    /* @__PURE__ */ c.createElement(Ds, { title: n.length >= 15 ? /* @__PURE__ */ c.createElement("span", null, n) : null }, /* @__PURE__ */ c.createElement("span", { "data-testid": "info-scouter-name", style: e, className: r }, n))
  );
}, { Panel: Rf } = Ls, zf = ({
  customStyleInfoNote: n,
  reversedCoordinates: e,
  customDateComponent: t,
  audioDuration: i,
  events: r,
  audio: s,
  note: o,
  isGaleryV2: l,
  audioUrl: h,
  customStyleScouterName: d,
  customStyleScouterInitials: m
}) => /* @__PURE__ */ c.createElement(c.Fragment, null, s && i && /* @__PURE__ */ c.createElement(
  ji,
  {
    customAudioStyles: { marginBottom: "14px" },
    duration: i,
    events: r,
    audio: s,
    isGaleryV2: l,
    audioUrl: h
  }
), /* @__PURE__ */ c.createElement(
  Ot,
  {
    customStyleInfoNote: Te(Y({}, n), { marginBottom: "14px" }),
    iconType: "comment",
    text: o == null ? void 0 : o.note
  }
), /* @__PURE__ */ c.createElement("div", { style: { display: "flex", justifyContent: "space-between", marginBottom: "12px" } }, /* @__PURE__ */ c.createElement(
  Ot,
  {
    reversedCoordinates: e,
    customStyleInfoNote: n,
    text: (o == null ? void 0 : o.manual_location) || (o == null ? void 0 : o.user_location),
    iconType: "property"
  }
), t || /* @__PURE__ */ c.createElement(
  Ot,
  {
    customStyleInfoNote: n,
    iconType: "task",
    text: Re(o == null ? void 0 : o.date).format("DD MMM, YY • HH:mm[h]")
  }
)), /* @__PURE__ */ c.createElement("div", { style: { display: "flex", marginBottom: "12px" } }, /* @__PURE__ */ c.createElement(
  Lf,
  {
    customStyleScouterName: d,
    customStyleScouterInitials: m,
    name: o == null ? void 0 : o.author
  }
))), Nf = `${$}__container__expanded`, Ff = (R) => {
  var P = R, {
    customStyleScouterInitials: n,
    customStyleScouterName: e,
    customStyleTextThumbnail: t,
    customStyleInfoTagText: i,
    customStyleInfoNote: r,
    customDateComponent: s,
    customActionsMenu: o,
    reversedCoordinates: l,
    tagsTranslations: h,
    virtualizer: d,
    virtualRow: m,
    className: p,
    events: _,
    galleryEvents: g,
    note: S,
    isGaleryV2: A,
    photosMessages: I,
    regionsTreeNode: L,
    productId: x
  } = P, Z = xt(P, [
    "customStyleScouterInitials",
    "customStyleScouterName",
    "customStyleTextThumbnail",
    "customStyleInfoTagText",
    "customStyleInfoNote",
    "customDateComponent",
    "customActionsMenu",
    "reversedCoordinates",
    "tagsTranslations",
    "virtualizer",
    "virtualRow",
    "className",
    "events",
    "galleryEvents",
    "note",
    "isGaleryV2",
    "photosMessages",
    "regionsTreeNode",
    "productId"
  ]);
  var ne, Ae, Q, ie, qe;
  const { theme: W } = ze(), [K, J] = le(""), q = (ne = S.note_attachment || []) == null ? void 0 : ne.filter((Ne) => Ne.file_type === st.PICTURES), F = (Ae = S.note_attachment || []) == null ? void 0 : Ae.find((Ne) => Ne.file_type === st.AUDIO), V = F != null && F.url ? new Audio(F == null ? void 0 : F.url) : null, j = (ie = (Q = S == null ? void 0 : S.context) == null ? void 0 : Q.match(new RegExp("(?<=field:).*(?=\\/)", "gi"))) == null ? void 0 : ie[0], X = L == null ? void 0 : L.find((Ne) => Ne.key === j), _e = ((qe = S == null ? void 0 : S.source) == null ? void 0 : qe.split("/")[0]) || "", re = x ? x[_e] : "";
  return V && (V.preload = "metadata", V.duration ? J(vn(V.duration)) : V.onloadedmetadata = () => {
    K || J(vn(V.duration));
  }), /* @__PURE__ */ c.createElement(
    Rf,
    Te(Y({}, Z), {
      key: m.index,
      "data-index": m.index,
      ref: () => d.measureElement,
      header: /* @__PURE__ */ c.createElement(
        Mf,
        {
          customStyleTextThumbnail: t,
          customStyleInfoTagText: i,
          customStyleInfoNote: r,
          customActionsMenu: o,
          hasComment: Boolean(S == null ? void 0 : S.note.length),
          isExpanded: Z.isActive || !1,
          tagsTranslations: h,
          hasAudio: Boolean(V),
          duration: K,
          noteId: S == null ? void 0 : S.id,
          photos: q,
          events: _,
          galleryEvents: g,
          note: S,
          isGaleryV2: A,
          photosMessages: I,
          fieldName: X == null ? void 0 : X.title,
          productName: re
        }
      ),
      "data-testid": "notes-card-container",
      className: G(p, `${$}__container`, {
        [Nf]: Z.isActive,
        [`${$}__container-dark`]: W === "dark",
        [`${$}__container-dark__expanded`]: Z.isActive && W === "dark"
      })
    }),
    /* @__PURE__ */ c.createElement(
      zf,
      {
        customStyleScouterInitials: n,
        customStyleScouterName: e,
        customStyleInfoNote: r,
        customDateComponent: s,
        reversedCoordinates: l,
        audioDuration: K,
        events: _ == null ? void 0 : _.audioPlayer,
        audio: V,
        note: S,
        isGaleryV2: A,
        audioUrl: F == null ? void 0 : F.url
      }
    )
  );
};
const Zf = (n) => /* @__PURE__ */ c.createElement("svg", Y({ width: "12", height: "8", viewBox: "0 0 12 8", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, n), /* @__PURE__ */ c.createElement("path", { d: "M6 0.296875L0 6.29688L1.41 7.70687L6 3.12687L10.59 7.70687L12 6.29688L6 0.296875Z", fill: "#696F88" }));
const { RangePicker: Bf } = ks, Hf = ({ onChange: n, value: e }) => /* @__PURE__ */ c.createElement("div", { className: "range-picker__container" }, /* @__PURE__ */ c.createElement(
  Bf,
  {
    disabledDate: Kh,
    "data-testid": "range-picker",
    className: "range-picker",
    onChange: n,
    allowClear: !1,
    value: e,
    separator: "~",
    size: "large",
    format: "L"
  }
)), xs = ({
  onDropdownVisibleChange: n,
  allAreSelectedTitle: e,
  maxTagPlaceholder: t,
  treePlaceholder: i,
  treeCheckable: r,
  maxTagCount: s,
  isDisabled: o,
  treeValue: l,
  onChange: h,
  treeData: d,
  testID: m
}) => /* @__PURE__ */ c.createElement(
  el,
  {
    placeholder: l != null && l.length ? i : e,
    onDropdownVisibleChange: n,
    maxTagPlaceholder: t,
    dropdownStyle: { maxHeight: 300 },
    treeCheckable: r,
    treeNodeFilterProp: "title",
    maxTagCount: s,
    disabled: o,
    "data-testid": m,
    treeData: d,
    onChange: h,
    value: l,
    size: "large",
    allowClear: !0
  }
);
const Ci = ({ label: n, testID: e }) => /* @__PURE__ */ c.createElement("span", { "data-testid": e, className: "label-component" }, n), Vf = (g) => {
  var S = g, {
    filterPayload: A = { treeSelectedFields: [], treeSelectedTags: [] }
  } = S, I = A, { treeSelectedFields: n, treeSelectedTags: e } = I, t = xt(I, ["treeSelectedFields", "treeSelectedTags"]), {
    events: { clickToSelectQuickAction: i, clickToSelectARangeDate: r, clickToSelectFields: s, clickToSelectTags: o },
    messages: { rangeDates: l, fields: h, tags: d },
    setFilterPayload: m,
    regionsTreeNode: p,
    tagsTreeNode: _
  } = S;
  const L = Oe(
    (P, W) => {
      W && i({
        quickAction: W
      });
      const K = ao(P);
      return m((J) => Te(Y({}, J), {
        quickFilter: K,
        rangePicker: P
      })), K;
    },
    [m]
  ), x = Oe(
    (P) => {
      L(P), P != null && P.length && P[0] && P[1] && r({
        startDate: P[0].format("YYYY-MM-DD"),
        endDate: P[1].format("YYYY-MM-DD")
      }), m((W) => Te(Y({}, W), {
        rangePicker: P
      }));
    },
    [m, L]
  ), Z = Oe(
    (P) => {
      m((W) => Te(Y({}, W), {
        treeSelectedFields: P
      }));
    },
    [m]
  ), R = Oe(
    (P) => {
      m((W) => Te(Y({}, W), {
        treeSelectedTags: P
      }));
    },
    [m]
  );
  return /* @__PURE__ */ c.createElement("section", { className: "content" }, /* @__PURE__ */ c.createElement(tt, { layout: "vertical" }, /* @__PURE__ */ c.createElement(
    tt.Item,
    {
      "data-testid": "note-filter-range-picker",
      label: /* @__PURE__ */ c.createElement(Ci, { testID: "range-picker-label", label: l.label })
    },
    /* @__PURE__ */ c.createElement("div", { className: "quick-filters", "data-testid": "note-filter-quick-filter" }, Object.entries(Vt).map(([P, W]) => /* @__PURE__ */ c.createElement(
      jt,
      {
        key: P,
        "data-testid": `note-filter-quick-filter-${P}`,
        className: Jh(P, t == null ? void 0 : t.quickFilter),
        onClick: () => {
          L([Re().subtract(W, "days"), Re()], P);
        },
        type: "default",
        size: "large"
      },
      l.quickFilters[io[P]]
    ))),
    /* @__PURE__ */ c.createElement(Hf, { onChange: x, value: t == null ? void 0 : t.rangePicker })
  ), /* @__PURE__ */ c.createElement(
    tt.Item,
    {
      "data-testid": "note-filter-tree-select-fields",
      label: /* @__PURE__ */ c.createElement(Ci, { testID: "tree-select-fields-label", label: h.label })
    },
    /* @__PURE__ */ c.createElement(
      xs,
      {
        allAreSelectedTitle: h.allFields,
        onChange: Z,
        treePlaceholder: h.placeholder,
        treeValue: n,
        onDropdownVisibleChange: (P) => {
          !P && s({
            fields: n.length ? n : ["All fields"]
          });
        },
        testID: "tree-select-fields",
        treeData: p,
        maxTagCount: ds(p, n),
        treeCheckable: !0
      }
    )
  ), !!_.length && /* @__PURE__ */ c.createElement(
    tt.Item,
    {
      "data-testid": "note-filter-tree-select-tags",
      label: /* @__PURE__ */ c.createElement(Ci, { testID: "tree-select-tags-label", label: d.label })
    },
    /* @__PURE__ */ c.createElement(
      xs,
      {
        onChange: R,
        allAreSelectedTitle: d.allTags,
        treePlaceholder: d.placeholder,
        treeValue: e,
        onDropdownVisibleChange: (P) => {
          !P && o({
            tags: e.length ? e : ["All tags"]
          });
        },
        testID: "tree-select-tags",
        treeData: _,
        maxTagCount: ds(_, e),
        treeCheckable: !0
      }
    )
  )));
};
const jf = (n) => {
  const e = We();
  return he(() => {
    e.current = n;
  }, [n]), e.current;
};
function Uf(n, e) {
  const t = We(null), i = We(n);
  return he(() => {
    i.current = n;
  }, [n]), he(() => {
    const r = () => i.current();
    if (typeof e == "number")
      return t.current = window.setTimeout(r, e), () => window.clearTimeout(t.current);
  }, [e]), t;
}
const Wf = (g) => {
  var S = g, {
    events: { inputsEvents: n, clickToCancelTheFilterSelection: e, clickToApplySelectedFilters: t },
    messages: A
  } = S, I = A, { title: i, cancelTitle: r, applyTitle: s } = I, o = xt(I, ["title", "cancelTitle", "applyTitle"]), {
    handleVisibleChange: l,
    handleFilterPayload: h,
    regionsTreeNode: d,
    setFocusedNote: m,
    selectedFilter: p,
    tagsTreeNode: _
  } = S;
  var W, K;
  const [L, x] = le({
    quickFilter: p == null ? void 0 : p.quickFilter,
    rangePicker: p == null ? void 0 : p.rangePicker,
    treeSelectedFields: (W = p == null ? void 0 : p.treeSelectedFields) != null ? W : [],
    treeSelectedTags: (K = p == null ? void 0 : p.treeSelectedTags) != null ? K : []
  }), Z = jf(p);
  he(() => {
    var J, q;
    kh(Z, p) || x({
      quickFilter: ao(p == null ? void 0 : p.rangePicker),
      rangePicker: p == null ? void 0 : p.rangePicker,
      treeSelectedFields: (J = p == null ? void 0 : p.treeSelectedFields) != null ? J : [],
      treeSelectedTags: (q = p == null ? void 0 : p.treeSelectedTags) != null ? q : []
    });
  }, [p, Z]);
  const R = Oe(
    (J) => {
      var q, F, V, j;
      m(), J && (h(J), t({
        fields: J.treeSelectedFields,
        tags: J.treeSelectedTags,
        startDate: (F = (q = J.rangePicker) == null ? void 0 : q[0]) == null ? void 0 : F.format("YYYY-MM-DD"),
        endDate: (j = (V = J.rangePicker) == null ? void 0 : V[1]) == null ? void 0 : j.format("YYYY-MM-DD"),
        quick_action: J.quickFilter
      }));
    },
    [h]
  ), P = () => {
    l(!1), e();
  };
  return /* @__PURE__ */ c.createElement("div", { className: "container" }, /* @__PURE__ */ c.createElement("header", null, /* @__PURE__ */ c.createElement("span", { "data-testid": "header-filter-title", className: "filter-title" }, i)), /* @__PURE__ */ c.createElement(
    Vf,
    {
      setFilterPayload: x,
      regionsTreeNode: d,
      filterPayload: L,
      tagsTreeNode: _,
      messages: o,
      events: n
    }
  ), /* @__PURE__ */ c.createElement("footer", { className: "note-inputs-footer" }, /* @__PURE__ */ c.createElement("div", null, /* @__PURE__ */ c.createElement(jt, { "data-testid": "button-cancel", type: "default", onClick: P }, r), /* @__PURE__ */ c.createElement(jt, { "data-testid": "button-apply", type: "primary", onClick: () => R(L) }, s))));
}, qf = (n) => /* @__PURE__ */ c.createElement("svg", Y({ width: "18", height: "18", viewBox: "0 0 18 18", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, n), /* @__PURE__ */ c.createElement("path", { d: "M5.25001 4.5H12.75L8.99251 9.225L5.25001 4.5ZM3.18751 4.2075C4.70251 6.15 7.50001 9.75 7.50001 9.75V14.25C7.50001 14.6625 7.83751 15 8.25001 15H9.75001C10.1625 15 10.5 14.6625 10.5 14.25V9.75C10.5 9.75 13.29 6.15 14.805 4.2075C15.1875 3.7125 14.835 3 14.2125 3H3.78001C3.15751 3 2.80501 3.7125 3.18751 4.2075Z" })), Gf = (h) => {
  var d = h, {
    events: m
  } = d, p = m, { openFilter: n } = p, e = xt(p, ["openFilter"]), {
    handleFilterPayload: t,
    filtersMessages: i,
    regionsTreeNode: r,
    setFocusedNote: s,
    selectedFilter: o,
    tagsTreeNode: l
  } = d;
  const [_, g] = le(!1), S = (A) => {
    g(A);
  };
  return /* @__PURE__ */ c.createElement(
    Ms,
    {
      "data-testid": "notes-filter-popover",
      content: /* @__PURE__ */ c.createElement(
        Wf,
        {
          handleVisibleChange: S,
          handleFilterPayload: t,
          regionsTreeNode: r,
          selectedFilter: o,
          setFocusedNote: s,
          tagsTreeNode: l,
          messages: i,
          events: e
        }
      ),
      trigger: "click",
      visible: _,
      placement: "rightTop",
      onVisibleChange: S
    },
    /* @__PURE__ */ c.createElement(
      "div",
      {
        "data-testid": "icon-action-to-open",
        className: "filter-button",
        role: "button",
        tabIndex: 0,
        onClick: n,
        onKeyDown: (A) => {
          A.key === "Escape" && S(!1);
        }
      },
      /* @__PURE__ */ c.createElement(qf, { fill: "#696F88" })
    )
  );
}, Cs = {}, Yf = (n, e) => {
  if (n)
    return;
  const { isActive: t } = e;
  return /* @__PURE__ */ c.createElement(
    Zf,
    {
      className: G({
        "notes-sidebar__collapse-icon": !0,
        "notes-sidebar__collapse-icon__expanded": t
      }),
      "data-testid": "collapse-icon"
    }
  );
}, $f = ({
  events: { cardEvents: n, clickToViewANote: e, filtersEvents: t, gallery: i },
  reversedCoordinates: r = !0,
  handleFilterPayload: s,
  messagesSidebar: o,
  regionsTreeNode: l,
  selectedFilter: h,
  setFocusedNote: d,
  tagsTreeNode: m,
  focusedNote: p,
  virtualizer: _,
  parentRef: g,
  className: S,
  isLoading: A,
  errorCode: I,
  isError: L,
  notes: x,
  isGaleryV2: Z,
  productId: R,
  hideCollapseIcon: P
}) => {
  var _e;
  const { theme: W } = ze(), K = We(null), [J, q] = le(Cs);
  he(() => {
    if (!(x != null && x.length)) {
      q(Cs);
      return;
    }
    q(
      x.reduce((re, ne, Ae) => (re[ne.id] = Ae, re), {})
    );
  }, [x]), he(() => {
    if (!(!p || !(x != null && x.length)) && (e({
      from: p[1] === "collapse" ? "card" : "map"
    }), p[1] === "map")) {
      const re = p[0] !== 0 ? p[0] - 1 : p[0];
      _.scrollToIndex(re, { behavior: "smooth", align: "start" });
    }
  }, [p, x, J]);
  const F = _.getVirtualItems(), V = Ue(() => !A && !L && !!(x != null && x.length), [A, L, x]), j = Ue(() => !A && L, [A, L]), X = Ue(() => A && !L, [A, L]);
  return /* @__PURE__ */ c.createElement(
    "div",
    {
      className: G(S, "notes-sidebar__container", {
        "notes-sidebar__container-dark": W === "dark"
      })
    },
    /* @__PURE__ */ c.createElement(
      Fs,
      {
        title: o.title,
        suffixContent: /* @__PURE__ */ c.createElement(
          Gf,
          {
            filtersMessages: o.filters,
            handleFilterPayload: s,
            regionsTreeNode: l,
            selectedFilter: h,
            setFocusedNote: d,
            tagsTreeNode: m,
            events: t
          }
        )
      }
    ),
    /* @__PURE__ */ c.createElement(hl, { title: o.subtitle }),
    /* @__PURE__ */ c.createElement(dl, { ref: K }, X && /* @__PURE__ */ c.createElement(xp, null), (j || !(x != null && x.length)) && /* @__PURE__ */ c.createElement(Cp, { errorMessages: o.errorState, errorCode: I }, /* @__PURE__ */ c.createElement(Tp, null)), /* @__PURE__ */ c.createElement("div", { ref: g, className: "notes-sidebar__container__virtualList List" }, /* @__PURE__ */ c.createElement(
      "div",
      {
        style: {
          height: _.getTotalSize(),
          width: "100%",
          position: "relative"
        }
      },
      V && /* @__PURE__ */ c.createElement(
        Ls,
        {
          expandIconPosition: "right",
          bordered: !1,
          expandIcon: (re) => Yf(P, re),
          onChange: (re) => {
            const ne = ed(x, re), Ae = +re;
            d(ne, Ae, "collapse");
          },
          accordion: !0,
          activeKey: p ? [p[0]] : [],
          style: {
            position: "absolute",
            top: 0,
            left: 0,
            width: "calc(100% - 24px)",
            transform: `translateY(${(_e = _.getVirtualItems()[0]) == null ? void 0 : _e.start}px)`
          },
          className: W === "dark" ? "notes-ant-collapse-borderless-dark" : ""
        },
        x && F.map((re) => /* @__PURE__ */ c.createElement(
          Ff,
          {
            tagsTranslations: o.tagsTranslations,
            reversedCoordinates: r,
            note: x[re.index],
            title: o.title,
            virtualizer: _,
            index: re.index,
            virtualRow: re,
            key: re.index,
            events: n,
            galleryEvents: i,
            isGaleryV2: Z,
            photosMessages: o.photos,
            regionsTreeNode: l,
            productId: R
          }
        ))
      )
    )))
  );
}, Xf = (n) => /* @__PURE__ */ c.createElement("svg", Y({ width: 20, height: 20, fill: "inherit", viewBox: "0 0 20 20" }, n), /* @__PURE__ */ c.createElement(
  "path",
  {
    fill: "#707374",
    fillRule: "evenodd",
    d: "M0 2a2 2 0 012-2h3a1 1 0 010 2H2v3a1 1 0 01-2 0V2zm18 0h-3a1 1 0 110-2h3a2 2 0 012 2v3a1 1 0 11-2 0V2zM1 14a1 1 0 011 1v3h3a1 1 0 110 2H2a2 2 0 01-2-2v-3a1 1 0 011-1zm17 4v-3a1 1 0 112 0v3a2 2 0 01-2 2h-3a1 1 0 110-2h3z",
    clipRule: "evenodd"
  }
)), Kf = (n) => /* @__PURE__ */ c.createElement("svg", Y({ width: "18", height: "18", viewBox: "0 0 18 18", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, n), /* @__PURE__ */ c.createElement("path", { d: "M2.25 5.25H0.75V0.75H5.25V2.25H2.25V5.25Z", fill: "#696F88" }), /* @__PURE__ */ c.createElement(
  "path",
  {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.17 4.515L13.25 4.5C13.39 4.5 13.5 4.61 13.5 4.75V12.31C13.5 12.425 13.425 12.515 13.32 12.55L10.5 13.5L7.5 12.45L4.83 13.485L4.75 13.5C4.61 13.5 4.5 13.39 4.5 13.25V5.69C4.5 5.575 4.575 5.485 4.68 5.45L7.5 4.5L10.5 5.55L13.17 4.515ZM12 11.4108L10.5093 11.913L10.5 11.9098V7.13822L10.5265 7.14749L12 6.57629V11.4108ZM9.75 6.87572L8.25 6.35072V11.1223L9.75 11.6473V6.87572ZM7.5 6.08822V10.8598L7.47352 10.8505L6 11.4217V6.58714L7.49069 6.08496L7.5 6.08822Z",
    fill: "#696F88"
  }
), /* @__PURE__ */ c.createElement("path", { d: "M2.25 12.75H0.75V17.25H5.25V15.75H2.25V12.75Z", fill: "#696F88" }), /* @__PURE__ */ c.createElement("path", { d: "M12.75 15.75V17.25H17.25V12.75H15.75V15.75H12.75Z", fill: "#696F88" }), /* @__PURE__ */ c.createElement("path", { d: "M12.75 2.25V0.75H17.25V5.25H15.75V2.25H12.75Z", fill: "#696F88" }));
const Ps = ({ onClick: n, icon: e, testId: t, className: i }) => /* @__PURE__ */ c.createElement(
  "div",
  {
    onKeyDown: Qh,
    onClick: n,
    className: i || "sd-multilayer-1",
    "data-testid": t,
    role: "button",
    tabIndex: 0
  },
  /* @__PURE__ */ c.createElement(e, null)
), wo = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAG4AAAB8CAMAAAC/m3VZAAAAflBMVEUAAAD///////////////////////////////////////////////////////////////+DVNb///+xk+XRv+/v6frg1PWSaduTatuif+D49f26n+ibdN739P3Bqerw6vqLX9mKXtjYyfLJtO3BquuifuDo3/jZyvK5nueqiuPYDKjaAAAAEXRSTlMA7yDgEICfQMBgcDDPkFCwf7FNWYQAAANmSURBVGje7ZntdqIwEIYBEQStmvBRFPxudb3/G9xuoX2tq06SSXN2T3n+c97zJDOTAF5PT09PT0/PjyAYT5M34jjwvpcwns8G8oLJbBiH3rcQzEfyJqM0sO6VIgvAMglths19STCIAidhwE5geh22PJZ5np/KcnltmLLDxpMvSXndbMUn20V92nwJDJhqEhQvC3GD5nCZOOfs2kU5lsj6i0V+0RbGggFaOq/EQ6qcvaBjnzYD1Ul2+GOTtOQjbVkLJbLNR95UPy3+VKuEIlUpO2LjlVwLDV6wnmZVkgktaqN6Cbu05UJocl52eTozO+rSGqFN0+VFGkWJldQnky2p5sahSoz2zw/0lvIgDDl040xrKTfClO1Rp/u6payEMU1XnRpy9MbR7Z4oy20Eh+1GVS9BDzBYqOpNIMehVCvOMeT4enRxRpDj0c6yJ7pQIMcvTp88VNFzIFPgujhVVnPYHuDiCqnA7WIZPoxrb3q/bMTVCrUp32lsxFXt5oXk1q3ENbkCd2pzTN7RS2GFPTlYnjCd+RzIzpvJP5wFG9wiZmRhLoQVXtv3aHKmVMIKFXkItVfnnRDmUwVsyTGGDuL2HZ764XE7C1MFcf9OZbZxjau+m+Es53MmT6AIxx2fdTszyRMht3kipOR5VyhPFfGII3lZCe90gnqvgWf5Tqh07+PHZShM4nzd24jb4xWduqzsFKeKuM+2vapMH8aFvq1WyHD8kJ1XCjYl1pJYTfb9AXU59Qh8O3q54uvrEHp8uYSMC63onfAlR03vzC9LjGdar9gxlrLAV0ZVvT2nTvBuRzOQvF6vNT4aofdWjTCi0fkgjUEti2fGxmEpScIJ8kzTsJQ0gY887TS0nDJTiTyTNDk1+7VVaE2z15XU3Dh0n/5/ixeJNOO88llxIUtGGvLUBHfrFdKYvyaLjBzKhfwg9QwZD9QCdzXCBrFnTDCSCMxf75TjYWXjXyg2EInZ1RytsnwlgZ96TIJIfmFV7td19kZ9yI+IghqXZCBJsGuOAkeJZ484IsJgZocgGd3NSkOPgF2lILKdgzsaAChH23pu5KDnRA56buSg50QOem7koOdEDnpu5KDnRA56buSg50QOem7koOdEDnpu5KDnRA56buSg50QOem7koAc5F6R4zXFCGHr/Hb8BJrCO+/RO+toAAAAASUVORK5CYII=", Eo = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAG4AAAB8CAMAAAC/m3VZAAAAxlBMVEUAAAD///////////////////////////////////////////////////////////////////+DVNb////z9PZRUlPRv++xk+X5+vuTadv9/f749f34+Pn7+/zBquvv6fqio6Tg1PWif+DLzM2adN6LX9mKXtjw6vrYyfGylOXJtO26n+jZyvLp6uy5n+i5nuff4OKYmZuOj5CqiuO6u7xlZmdbXF3o3/iqiePe3+HU1desra+DhIZ6e3xlZmjn3vff4OF5envKJwLEAAAAEnRSTlMAgO8Q3yCfQGBwv1AwwJDPsI9XA7SQAAAEoklEQVRo3uWaaXPaMBCGLZ84QKBeaoNdDhNCU0jStGl6n///T5Wj8IIBrxwpmnb6fGMmmWde7WolGyxVnMB3aYPr162nxBE2EaVpd0k/XRk9C+iX9bsd8KJPRMKxnoKGu5C96BRYCN3A0k9IlEK2Q0oktNsEUbdznC58Gm0H0VDCVLMvhO0oen0ebCfyEWnsFxd1O1k/19FXuLTD0adnupbSXiwlC5Gm+fKssJQ3F2vuCvHONVVuP9y75xu+7MeztVSvvlu5i9Ho+1b3MBq9240X6tD5CHfz7XmR73fYDGd61nIb4O3zQ77trKYGm7Ozlu+P6N5jtDyyN71GvbYgCJb/HlC/s2Gj+HXR+bxNulO8WuW7gWi7tEOr3T7UfV19eFPUdav1iifOCIBuUfd59eHnoU7I5wrhKtVBwOi4a4i07mL14Y7RMTJ53VvU7hG6sCjLPuRxHF/neUZLUug2vrvOzZsjnVnnZY3WnimeTy6jLZfj+TWz76BLqcFHIzAcjKNDMkyVN0dsXytMFecMshyuPWLMzE8PB7aHT5iZTW6nYUvHvegE99TfOX1G+3y5kR8qDbskGeqXIZ7KcV7b2LLbqIxB6cUI4fxSW7CNhnVk4vHh+JUcRBwD6iuGQ5e8ilguX8rcM8vCOX9s2TiSYEzcclJ5W/p/bJNIigGlHYVnhBpWUtpX9gTEFQ5dIu2j7ikbwVa2lDMpEXzpiZ7ESpYt5cuoEuOXCAi6Kdl17ua4ohdVoxcTXgbgzYPvWFw4FK66kNJ+d0VKRLYfsNdiLGV14avrjHZAMibcq+ixTO7ng8GMVtRYXQvhVMhpAf8U0lAMh8G2giudj3BqrGt4zjWKajjs+wXcdSg4vucSCYrHksxqClqSRwVIgmPNwg2wM1ryWoduLtGbtGKiQ9dbF89hS5dFRWIJTvRmg72j55EWrtjBco7prM6M3XltWvJRjy6hJW22McfqKsyxFjtTeuoqtKZborNpyTQClacKuGTHGHaQ6r7Df/3nuqmGqQLd39OZa93ExL7DVEn06O5pSbNE5+O403V9OGdPhFjniRCy591QeqqU6j6wlxUHO0Fq3/GNSQ5/70t06BI0JnO+XinqUDqplzfZVHKqlL/dWcC8w3RsXVshwfFTgq/rcpRjLflb+1jPwOTfB9t64sWYz6UILfF6sk+vjpZ41+tG8SzZeB/V2xLjmY83nCos5XBdOYTj412p9gkJ2S8c1fb6nNCWEgTM20yGCeE5GbCDmoY9hcJV+bauxfl4m1vphwXwVbZhy0lTJ/iq2jAs5Qk3vkrTbJwRUzhm91V8I83aeF/ek1zIXMEGn1zA6SBTsaF+C4YJO5SHtCFU+GWblHB6C5nKj968M4IwHp9ox1mGv2qy+40vIIzJpNAeSZwRsENLEc+nPbL8anCbLLidxT+gQjRVai6xoGqGhM2apY/AZ2SBpRev1jzpCh2LQblLga/fhDvaIZ71RAgz4RDPRDggzIRDPBPhgDATDvFMhAPCTDjEMxEOCDPhEM9EOCAMhUM8hDOAMBMO8RDOBMJgOMTzLEMIY+EQz7OMEeIxxwiOY/1z/AYQSg8BdcqepwAAAABJRU5ErkJggg==", So = "data:image/png;base64,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", Ao = "data:image/png;base64,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", xo = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAG4AAAB8CAMAAAC/m3VZAAAAe1BMVEUAAAD///////////////////////////////////////////////////////////////////////+DVNb////w6vqTatuLXtmif+DBqeuylOWSadubdN739P3o3/iqiePRv/DQv/DJtO66n+j49f3g0/TZyvLg1PW5nuel2VuZAAAAE3RSTlMA3yC/QBCgYO+Az5DAcFAwsK/ga5JYVgAABGtJREFUaN7s1u12mkAYBOAqAY02tjkz+wWIqEi8/ytsF5dwQo+6LDS/eG5gzrz77sKP2Ww2m81ms4nFL6ttEi2sTfS+fXuJJ4/oorYb/mOT7OL/kRWtec/7auKw1zUfWiTLycKWCT24wPHNaH1T4NvXMYrapFpauU5NLb6OdDV2jhE7VZkq9Mi0rCYr+NJV44d2WbouxF/FReMmrdkV3IWnvXbFThKtAx3ddSz56TU0LWGrlICCow757ewknOxL4DZsIyM6hQb0hRp3pDzaQEEnigPSNnQMkB3J6oo7DNkEGjqb4XltmtDAec/KKNxlJ7m/Arlo+w1N27aDlMguZC1hPQy8ZJAFb5KwnTwq4GwbPpUKpoCqQ/Zz16bBOit4kCmsI28G3L/lok0L4PLW/u9L5M5NIYAqBq7Lig0hEaC7gG/DRikRKHfjjIe8XQaZRgCd4TzgNVu6UQJ2tQc78AJ8sPHLv5yECTo9JXhtxxl5lyuRkQcE0NxnOLGx9C93ZIkgJS9Qld/pxWtXLmclEcJGaRi/5Vy15WoaBDK2nt/diz5Pbi+BEfVqWpHXomjI1CCYMQqajdhjlgI9wgN6Klqrh3G/3Sx76AE9J4/v7IKWniJO01p7HJ2aIk49v+k7WgX6pAf0FbR2T39RTphE+fTmJbSumMT56a5EblN0jnFUnuNA6+fTf9kcBTVGyVlA0lo8iFvTkhCUGEVSeMSxAZBjXxUSYCMgjh7muD/VmWFv4jAMhoHB3aDsOJ2dJk1aIlox/v8/PIlkesWYmjTtLO35xDfzJG7i2JmpUmfwlCo6eWj+Q7j5H0KLzBz97jxZq2kW2tp4JRyTh5hd8hD7K3FE437dJ2uHKy3CDRfQ6PXa6dxahcbIeCe8TiseaAQUD6nSqFkiXB8zZYw3FH5zwykUfumylowlkHWSAG+IWlRGyfu8pxYJMx3FJjYgDln9m07TrfxJYlmRw1qOseOYLKZYTyu2ZDPfky+z9Zrwrs9rjW2hx44KcOFdf2eb2TIK7+tzWZ705DrcBnl672EPJmNYabpALlOPPbVD0dbVZKc0NTf8sZyFOIW0zGCPhl8RaloHdYd2Zgk9o0jJ4sSBpuyzw1Jm8vYQz1AW/iHavmRA0oTUdpTEXdkQolVlQ4ueqFXpZdVNd+/H90WDC7Rs+ezuQwJlE1197jW5MwfW2Lhp8UIgo5iVHwt2M0S+K42GeHG+Y0dOtOH+l/SFC6MhHgTJagro+KOmiDZh8yKHTeGQ9xcj4ENF1ynVMXtkyqAwD90tMJ5kdXEU8KG5hs2sYZbqYKYXFFyH9sOmrjUF2uHKYL2dOTWvPs+xfatjzNYP79ErUmEhiwWP/Im4d08coTaH32tOg2Dz+XMUCQY21Yji6/60WpzTgUEyG+ez5WdQmC/Py5dyq+9iKyMHPRE56MnIQU9EDnoyctATkYOejBz0ROSgJyMHPRE56MnIQU9EDnoyctATkYOejBz0ROSgJyMHPRk51GXVZvXD+A++GcGFIMJiKwAAAABJRU5ErkJggg==", Co = "data:image/png;base64,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", Po = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAG4AAAB8CAMAAAC/m3VZAAAAxlBMVEUAAAD///////////////////////////////////////////////////////////////////////////+DVNb////z9Pbw6vqTats2OUiif+DBqev49f35+fr29/iadN77+/yKXtixlOWSadvg1PXo3/iqiePJtO66n+iLX9jRv/DQv/CLX9mylOXc3eCifuBNUF2srrV8f4nZyvPn6OuVlp7YyfJZXGhCRVKgoqplaHRlZ3OJi5TExcr19Pno6evDxcq3ub+apoUBAAAAFHRSTlMA3yBAv2AQgKDvz5BwwDBQsK/gj15TPeAAAAWuSURBVGje7ZrpctowFEZZjFmTbrqWsQ0GbMDsaUKW7u37v1SvBRrFqLXkBc90pmcmmeTXmU/3aoVaCTQGnV4dALrGu8Ft7bqY7dgkqPcb5UuErIuK0WhsxYxHE0A61xIOUDaJVYJxbGzXroBpoIw5JGGv/IANLBpLJguxhI0r2IRB8nVvK7MhE+iWmk+ySb66WZ6tjbZ0ADrlDaVs28v1a5Y3lCMrwaeX4d2jlWAE9ZJsrctwH4cxny6Hs1WOzriccM9M93IZr3elyg1PWElKqt4ARlq6EfTLG0u1blxOswBYSh0DoISpfgsTbd2b7PtMs9XvGPWYnvGuP2i2tHUTaGVU9XsgM9LUjaCdxWV0AUnXfbzH2f3CdfifrNM/hqh1X4fPlvWF2e7iP+7z6Bod4KjSDYdH6xvTfbT2+EvWqZNBGolWOb4Mv1rWty93X35a1uNwuM/cKoPkMNIHd+bYMb4zcx8oJOcdKh5F0vtkZzbV42iAwFvPVuQC20vojs8oiTP9+Irl22ec5s1X0ULn7HKe5hSZhw5BwuQitr/Duj1/xt8XtrF6S2iLYEubcBZwhuncy4n3iCrk5fGYnOXK84NoyDXKply3Xfin2tlsNOVF89fz8O7jMeMGZBpcNscYh/AURiaU15X74Wd5Tamn23rc5hISbAC86M86B0CpUx8euI1iqMgDz8VGUcYTuozhPvCBtEkQAjzY5K840vXguN9LB7+WTk9uMFPEEqawLHqsfcNtJCZCZxrbebFDe6PObXrYNNU3UVy5jHPdVqQM30Rx4WoBg2J76PvSrpNoUw8l2jL4HvjOJ12Wbxo6a5dLAieLMKIoHEuy7kB1CmdQQijMMgVcw6uHju+jkdZDR4cPpcurpy/cUUjQxv7XCrcmAcCCZMbfPYAAo+mG26AyF2sIydYDRH0LMbvncD54dj4dqhysRExXNZgtHu4JXJITN44HjIFCZ/DKsXAF4p1KaGg1ioNN5pLcuLg5OsAwNcaSkguoBuQCDxDFHv4WELklQQN5F4zpqJ6bEKcMnXPqTY3STUvQ8d5sKHfxubw6aUAumUPMG+URZUlKYc1nnmIFi8rRRcpeMc6dcvALqqa+f75L3CjPsj6Zo7IQPjaADUjqcbZ7XjAp/hTCBqqh4y0NUHRVAeDTJ4cONPiv02wVWwOpVbbKRfO90BWfCD7vTMW8W5DZbFVMt53tyIFPc8UiNitzEXtbxRIt9te28uwQlqML+Qak2F69qe5ZJVUHjNTLVjfb4SHNduDzQHk0csvQLVWdggwghpahoxDT0jvWksNMY1X5i2lxIMTXugMZ56ngs4bJCQWHbCCmp/WmiKow/5VkBpQEyrFkmPxi7uSON6WwQ6XefdIoHM8FyhulU1PRFPEgyGMLTvd6RlMhE/ECnDjzfH2yJIHHdwPdeE9kG9cgMw7QFdmIcJrxYEH8KFfpbN4nHc1PU/lw5iSgcluq307n09yznO90Wpj8ObPItgr1DJ9wnnDzTTs+lNoMEr6DnmchbFm/89N55TsADTT6IwRH2OTnKb0PLZaE+FQ9rFPXA+qwujF6ZvYv2DDmAXuopLPUPYACLFckmAODPXXn8zGRQwHoIk0WYrSFp7apfbDB0u1SVrQI6A7HcwMKm9InAqJwyut0/sPmuq1zKh4j//fCzA4IYeJE51HqASxEp0QUOB2zwJeWhBCHlMFLJIppx8k4g4LfABOEkX8WrGybX5H8KARBvVkrhNmH19And+FP+dvJInry4DV9s1aUxg1IsNpJ3GC0EmjVQY2QFefNTSUyQaOfErHbvq2Vzm0PBEW7UfeMJtOqXQnjj+Fq16JZZTjEqDIcxqsyHGJUGQ7jVRkOMaoMh/GqDIcYVYbDeFWGQ4wqw2G8KsMhRpXhMF6V4RCjynAYr8pwiFFlOIxXZTjEqCacOJf1G7V/jN+pUk4Vd0NE4AAAAABJRU5ErkJggg==", To = "data:image/png;base64,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", Jf = [
  {
    id: "note",
    url: wo
  },
  {
    id: "notePhoto",
    url: Eo
  },
  {
    id: "noteAudio",
    url: So
  },
  {
    id: "notePhotoAudio",
    url: Ao
  },
  {
    id: "noteSimulated",
    url: xo
  },
  {
    id: "noteSimulatedPhoto",
    url: Co
  },
  {
    id: "noteSimulatedAudio",
    url: Po
  },
  {
    id: "noteSimulatedPhotoAudio",
    url: To
  }
];
function Qf(n, e, t) {
  if (t = t || {}, !Oo(t))
    throw new Error("options is invalid");
  var i = t.bbox, r = t.id;
  if (n === void 0)
    throw new Error("geometry is required");
  if (e && e.constructor !== Object)
    throw new Error("properties must be an Object");
  i && tp(i), r && np(r);
  var s = { type: "Feature" };
  return r && (s.id = r), i && (s.bbox = i), s.properties = e || {}, s.geometry = n, s;
}
function ep(n, e, t) {
  if (!n)
    throw new Error("coordinates is required");
  if (!Array.isArray(n))
    throw new Error("coordinates must be an Array");
  if (n.length < 2)
    throw new Error("coordinates must be at least 2 numbers long");
  if (!Bi(n[0]) || !Bi(n[1]))
    throw new Error("coordinates must contain numbers");
  return Qf({
    type: "Point",
    coordinates: n
  }, e, t);
}
function Bi(n) {
  return !isNaN(n) && n !== null && !Array.isArray(n);
}
function Oo(n) {
  return !!n && n.constructor === Object;
}
function tp(n) {
  if (!n)
    throw new Error("bbox is required");
  if (!Array.isArray(n))
    throw new Error("bbox must be an Array");
  if (n.length !== 4 && n.length !== 6)
    throw new Error("bbox must be an Array of 4 or 6 numbers");
  n.forEach(function(e) {
    if (!Bi(e))
      throw new Error("bbox must only contain numbers");
  });
}
function np(n) {
  if (!n)
    throw new Error("id is required");
  if (["string", "number"].indexOf(typeof n) === -1)
    throw new Error("id must be a number or a string");
}
function Io(n, e, t) {
  if (n !== null)
    for (var i, r, s, o, l, h, d, m = 0, p = 0, _, g = n.type, S = g === "FeatureCollection", A = g === "Feature", I = S ? n.features.length : 1, L = 0; L < I; L++) {
      d = S ? n.features[L].geometry : A ? n.geometry : n, _ = d ? d.type === "GeometryCollection" : !1, l = _ ? d.geometries.length : 1;
      for (var x = 0; x < l; x++) {
        var Z = 0, R = 0;
        if (o = _ ? d.geometries[x] : d, o !== null) {
          h = o.coordinates;
          var P = o.type;
          switch (m = t && (P === "Polygon" || P === "MultiPolygon") ? 1 : 0, P) {
            case null:
              break;
            case "Point":
              e(h, p, L, Z, R), p++, Z++;
              break;
            case "LineString":
            case "MultiPoint":
              for (i = 0; i < h.length; i++)
                e(h[i], p, L, Z, R), p++, P === "MultiPoint" && Z++;
              P === "LineString" && Z++;
              break;
            case "Polygon":
            case "MultiLineString":
              for (i = 0; i < h.length; i++) {
                for (r = 0; r < h[i].length - m; r++)
                  e(h[i][r], p, L, Z, R), p++;
                P === "MultiLineString" && Z++, P === "Polygon" && R++;
              }
              P === "Polygon" && Z++;
              break;
            case "MultiPolygon":
              for (i = 0; i < h.length; i++) {
                for (P === "MultiPolygon" && (R = 0), r = 0; r < h[i].length; r++) {
                  for (s = 0; s < h[i][r].length - m; s++)
                    e(h[i][r][s], p, L, Z, R), p++;
                  R++;
                }
                Z++;
              }
              break;
            case "GeometryCollection":
              for (i = 0; i < o.geometries.length; i++)
                Io(o.geometries[i], e, t);
              break;
            default:
              throw new Error("Unknown Geometry Type");
          }
        }
      }
    }
}
function ko(n) {
  var e = [1 / 0, 1 / 0, -1 / 0, -1 / 0];
  return Io(n, function(t) {
    e[0] > t[0] && (e[0] = t[0]), e[1] > t[1] && (e[1] = t[1]), e[2] < t[0] && (e[2] = t[0]), e[3] < t[1] && (e[3] = t[1]);
  }), e;
}
function ip(n, e) {
  if (e = e || {}, !Oo(e))
    throw new Error("options is invalid");
  var t = e.properties;
  if (!n)
    throw new Error("geojson is required");
  var i = ko(n), r = (i[0] + i[2]) / 2, s = (i[1] + i[3]) / 2;
  return ep([r, s], t);
}
var Wn = {}, rp = {
  get exports() {
    return Wn;
  },
  set exports(n) {
    Wn = n;
  }
}, qn = {}, sp = {
  get exports() {
    return qn;
  },
  set exports(n) {
    qn = n;
  }
};
sp.exports = yn;
qn.default = yn;
function yn(n, e) {
  if (!(this instanceof yn))
    return new yn(n, e);
  if (this.data = n || [], this.length = this.data.length, this.compare = e || op, this.length > 0)
    for (var t = (this.length >> 1) - 1; t >= 0; t--)
      this._down(t);
}
function op(n, e) {
  return n < e ? -1 : n > e ? 1 : 0;
}
yn.prototype = {
  push: function(n) {
    this.data.push(n), this.length++, this._up(this.length - 1);
  },
  pop: function() {
    if (this.length !== 0) {
      var n = this.data[0];
      return this.length--, this.length > 0 && (this.data[0] = this.data[this.length], this._down(0)), this.data.pop(), n;
    }
  },
  peek: function() {
    return this.data[0];
  },
  _up: function(n) {
    for (var e = this.data, t = this.compare, i = e[n]; n > 0; ) {
      var r = n - 1 >> 1, s = e[r];
      if (t(i, s) >= 0)
        break;
      e[n] = s, n = r;
    }
    e[n] = i;
  },
  _down: function(n) {
    for (var e = this.data, t = this.compare, i = this.length >> 1, r = e[n]; n < i; ) {
      var s = (n << 1) + 1, o = s + 1, l = e[s];
      if (o < this.length && t(e[o], l) < 0 && (s = o, l = e[o]), t(l, r) >= 0)
        break;
      e[n] = l, n = s;
    }
    e[n] = r;
  }
};
var ap = qn;
rp.exports = Do;
Wn.default = Do;
function Do(n, e, t) {
  e = e || 1;
  for (var i, r, s, o, l = 0; l < n[0].length; l++) {
    var h = n[0][l];
    (!l || h[0] < i) && (i = h[0]), (!l || h[1] < r) && (r = h[1]), (!l || h[0] > s) && (s = h[0]), (!l || h[1] > o) && (o = h[1]);
  }
  var d = s - i, m = o - r, p = Math.min(d, m), _ = p / 2, g = new ap(null, lp);
  if (p === 0)
    return [i, r];
  for (var S = i; S < s; S += p)
    for (var A = r; A < o; A += p)
      g.push(new mt(S + _, A + _, _, n));
  var I = up(n), L = new mt(i + d / 2, r + m / 2, 0, n);
  L.d > I.d && (I = L);
  for (var x = g.length; g.length; ) {
    var Z = g.pop();
    Z.d > I.d && (I = Z, t && console.log("found best %d after %d probes", Math.round(1e4 * Z.d) / 1e4, x)), !(Z.max - I.d <= e) && (_ = Z.h / 2, g.push(new mt(Z.x - _, Z.y - _, _, n)), g.push(new mt(Z.x + _, Z.y - _, _, n)), g.push(new mt(Z.x - _, Z.y + _, _, n)), g.push(new mt(Z.x + _, Z.y + _, _, n)), x += 4);
  }
  return t && (console.log("num probes: " + x), console.log("best distance: " + I.d)), [I.x, I.y];
}
function lp(n, e) {
  return e.max - n.max;
}
function mt(n, e, t, i) {
  this.x = n, this.y = e, this.h = t, this.d = cp(n, e, i), this.max = this.d + this.h * Math.SQRT2;
}
function cp(n, e, t) {
  for (var i = !1, r = 1 / 0, s = 0; s < t.length; s++)
    for (var o = t[s], l = 0, h = o.length, d = h - 1; l < h; d = l++) {
      var m = o[l], p = o[d];
      m[1] > e != p[1] > e && n < (p[0] - m[0]) * (e - m[1]) / (p[1] - m[1]) + m[0] && (i = !i), r = Math.min(r, hp(n, e, m, p));
    }
  return (i ? 1 : -1) * Math.sqrt(r);
}
function up(n) {
  for (var e = 0, t = 0, i = 0, r = n[0], s = 0, o = r.length, l = o - 1; s < o; l = s++) {
    var h = r[s], d = r[l], m = h[0] * d[1] - d[0] * h[1];
    t += (h[0] + d[0]) * m, i += (h[1] + d[1]) * m, e += m * 3;
  }
  return e === 0 ? new mt(r[0][0], r[0][1], 0, n) : new mt(t / e, i / e, 0, n);
}
function hp(n, e, t, i) {
  var r = t[0], s = t[1], o = i[0] - r, l = i[1] - s;
  if (o !== 0 || l !== 0) {
    var h = ((n - r) * o + (e - s) * l) / (o * o + l * l);
    h > 1 ? (r = i[0], s = i[1]) : h > 0 && (r += o * h, s += l * h);
  }
  return o = n - r, l = e - s, o * o + l * l;
}
const Ui = { left: 30, top: 30, bottom: 30, right: 30 }, Mo = ({
  lngLat: n,
  xSemiAxis: e = 100,
  ySemiAxis: t = 100,
  options: i
}) => {
  const r = al(n);
  return ll(r, e, t, i);
}, Hi = (n, e, t) => {
  var i, r, s, o;
  if (n) {
    if (!t)
      return n;
    switch (n.type) {
      case "Feature":
        if ((r = (i = n == null ? void 0 : n.geometry) == null ? void 0 : i.coordinates) != null && r.length)
          return n;
        break;
      case "FeatureCollection":
        if ((s = n == null ? void 0 : n.features) != null && s.some((l) => {
          var h, d;
          return !!((d = (h = l.geometry) == null ? void 0 : h.coordinates) != null && d.length);
        }))
          return n;
        break;
    }
    if ((o = e == null ? void 0 : e.coordinates) != null && o.length)
      return {
        type: "FeatureCollection",
        features: [Mo({
          lngLat: e.coordinates,
          xSemiAxis: 1e3,
          ySemiAxis: 1e3,
          options: {
            units: "meters"
          }
        })]
      };
  }
}, dp = (n) => {
  if (n.geometry.type === "Polygon")
    return n.geometry.coordinates;
  let e = 0, t = [];
  for (let i = 0, r = n.geometry.coordinates.length; i < r; i++) {
    const s = n.geometry.coordinates[i], o = s.length;
    o > e && (t = s, e = o);
  }
  return t;
}, fp = (n) => {
  if (n != null && n.length) {
    const e = Mo({
      lngLat: n,
      xSemiAxis: 100,
      ySemiAxis: 100,
      options: {
        units: "meters"
      }
    });
    return e ? {
      type: "FeatureCollection",
      features: [e]
    } : void 0;
  }
}, pp = ({
  mapbox: n,
  lngLat: e,
  reversedCoordinates: t
}) => {
  const i = oo(e, t), r = fp(i);
  return r && (n == null ? void 0 : n.current) && n.current.fitBounds(zs(r), {
    padding: Ui
  });
}, mp = (n) => {
  let e = 0;
  return typeof (n == null ? void 0 : n.padding) == "number" && !Number.isNaN(n.padding) && (e = n.padding * 2), typeof (n == null ? void 0 : n.padding) == "object" && (e = n.padding.left + n.padding.right), e;
}, vp = (n) => n.getContainer().getBoundingClientRect().width, gp = (n) => typeof n == "number" && !isNaN(n) && n !== null && n !== void 0, yp = (n, e, t, i) => {
  try {
    const r = Hi(e, t, !0);
    if (!r)
      return;
    const s = mp(i), o = vp(n);
    if (!o)
      return;
    const l = zs(r);
    l.every(gp) && n.fitBounds(l, Te(Y({}, i), {
      padding: o >= s ? i == null ? void 0 : i.padding : 0
    }));
  } catch (r) {
    console.error("Error in Notes Package:safeFitBounds:", r);
  }
}, _p = ({
  region: n,
  handleMapbox: e,
  onUnclusteredPointClick: t,
  onMouseClick: i,
  mapbox: r,
  currentPropertyReferencePoint: s,
  handleIsMapboxLoaded: o,
  handleIsMapboxStyleLoaded: l
}) => {
  const h = We(null), [d, m] = le(), [p, _] = le(!1), [g, S] = le(
    Hi(
      n == null ? void 0 : n.geometry,
      s,
      !0
    )
  ), [A, I] = le(!1);
  return he(() => {
    n && S(
      Hi(
        n.geometry,
        s,
        !0
      )
    );
  }, [n, s]), he(() => {
    if (g && (r && (!d || d.id !== n.id) || r && p && n && (!d || d !== n || (g == null ? void 0 : g.features.length) !== d.geometry.features.length))) {
      const L = r.getSource("areas-source");
      if (!n.geometry || !L)
        return;
      L.setData(n.geometry);
      const x = r.getSource("areas-label"), Z = n.geometry.features.map((R) => {
        var P, W;
        if ((W = (P = R.geometry) == null ? void 0 : P.coordinates) != null && W.length)
          return Te(Y({}, R), {
            geometry: {
              type: "Point",
              coordinates: Wn(dp(R))
            }
          });
      }).filter((R) => R !== void 0);
      x.setData({
        type: "FeatureCollection",
        features: Z
      }), m(n);
    }
  }, [r, p, n, d, g, s]), he(() => {
    if (r || !h.current || !n || !g || !g.features.length)
      return;
    const { coordinates: L } = ip(g).geometry, x = new Rs.Map({
      accessToken: "pk.eyJ1Ijoic3RyaWRlcmVuZ2luZWVyaW5nIiwiYSI6ImNrejV5ZWJ4NDB2OGsydm16NXcxbzB0Z2sifQ.03J56R23ti1MDyiLFtX35A",
      container: h.current,
      style: "mapbox://styles/mapbox/satellite-v9",
      center: L,
      crossSourceCollisions: !0,
      attributionControl: !1,
      zoom: 12
    });
    x.on("style.load", () => {
      Jf.forEach((Z) => {
        x && x.loadImage(Z.url, (R, P) => {
          if (R)
            throw R;
          x.hasImage(Z.id) || x.addImage(Z.id, P, { pixelRatio: 2 });
        });
      });
    }), x.on("load", () => {
      x.addControl(new ol({ showCompass: !1, visualizePitch: !1 }), "bottom-right"), x.addSource("areas-source", {
        type: "geojson",
        data: {
          type: "FeatureCollection",
          features: []
        }
      }), x.addSource("areas-label", {
        type: "geojson",
        data: {
          type: "FeatureCollection",
          features: []
        }
      }), x.addLayer({
        id: "areas-boundary",
        type: "line",
        source: "areas-source",
        paint: {
          "line-color": "#fff",
          "line-width": 1
        },
        filter: ["==", "$type", "Polygon"]
      }), x.addLayer({
        id: "areas-label",
        type: "symbol",
        source: "areas-label",
        minzoom: 13,
        layout: {
          "text-field": ["format", ["get", "name"]],
          "text-size": 16,
          "text-font": ["Open Sans Bold"],
          "text-variable-anchor": ["top", "bottom", "left", "right"],
          "text-radial-offset": 0.5,
          "text-justify": "center"
        },
        paint: {
          "text-color": "#fff"
        }
      }), x.addSource("points", {
        type: "geojson",
        cluster: !0,
        data: {
          type: "FeatureCollection",
          features: []
        },
        clusterMaxZoom: 23,
        clusterRadius: 25,
        maxzoom: 23
      }), x.addLayer({
        id: "clusters",
        type: "circle",
        source: "points",
        filter: ["has", "point_count"],
        paint: {
          "circle-color": "#FFFFFF",
          "circle-radius": 20
        }
      }), x.addLayer({
        id: "cluster-count",
        type: "symbol",
        source: "points",
        filter: ["has", "point_count"],
        layout: {
          "text-field": "{point_count_abbreviated}",
          "text-font": ["Open Sans Regular"],
          "text-size": 16
        },
        paint: {
          "text-color": "#000000"
        }
      }), x.addLayer({
        id: "unclustered-point",
        type: "symbol",
        source: "points",
        filter: ["!", ["has", "point_count"]],
        layout: {
          "icon-image": ["get", "icon"],
          "icon-offset": ["coalesce", ["get", "icon_offset"], ["literal", [0, -26]]],
          "icon-allow-overlap": !0,
          "icon-ignore-placement": !0,
          "text-allow-overlap": !0,
          "text-field": ["get", "description"],
          "text-font": ["Open Sans Regular"],
          "text-size": 16,
          "text-offset": [0, -2]
        },
        paint: {
          "text-color": "#000000",
          "icon-opacity": ["get", "opacity"]
        }
      }), g && x.fitBounds(ko(g), {
        padding: Ui
      }), x.resize(), _(!0), o && o(!0);
    }), l && x.on("idle", () => {
      l(!0);
    }), e(x);
  }, [r, e, n, o, l, g]), he(() => {
    r && (r.on("mousemove", "unclustered-point", () => {
      r.getCanvas().style.cursor = "pointer", I(!0);
    }), r.on("mouseleave", "unclustered-point", () => {
      r.getCanvas().style.cursor = "", I(!1);
    }));
  }, [r]), he(() => {
    if (!r)
      return;
    return r.on("click", "unclustered-point", x), r.on("click", L), () => {
      r.off("click", "unclustered-point", x), r.off("click", L);
    };
    function L(Z) {
      i && i(Z, A);
    }
    function x(Z) {
      r && t && t(Z, r);
    }
  }, [r, i, t, A]), /* @__PURE__ */ c.createElement("div", { "data-testid": "sd-map", className: "sd-map" }, /* @__PURE__ */ c.createElement("div", { className: "sd-map__container", ref: h }));
};
const bp = (n) => /* @__PURE__ */ c.createElement("svg", Y({ width: "24", height: "24", viewBox: "0 0 24 24", fill: "none" }, n), /* @__PURE__ */ c.createElement(
  "path",
  {
    d: "M19.6818 18.1454C20.1061 18.5697 20.1061 19.2576 19.6818 19.6818C19.2576 20.1061 18.5697 20.1061 18.1454 19.6818L12 13.5364L5.85455 19.6818C5.4303 20.1061 4.74245 20.1061 4.31819 19.6818C3.89394 19.2576 3.89394 18.5697 4.31819 18.1454L10.4636 12L4.31819 5.85455C3.89394 5.4303 3.89394 4.74245 4.31819 4.31819C4.74245 3.89394 5.4303 3.89394 5.85455 4.31819L12 10.4636L18.1454 4.31819C18.5697 3.89394 19.2576 3.89394 19.6818 4.31819C20.1061 4.74245 20.1061 5.4303 19.6818 5.85455L13.5364 12L19.6818 18.1454Z",
    fill: "#c1c5c8"
  }
));
const wp = {
  noteSimulatedPhotoAudio: To,
  noteSimulatedPhoto: Co,
  noteSimulatedAudio: Po,
  notePhotoAudio: Ao,
  noteSimulated: xo,
  noteAudio: So,
  notePhoto: Eo,
  note: wo
}, Ep = ({ mapboxPopup: n, focusedNote: e, messages: t, data: i }) => /* @__PURE__ */ c.createElement("div", { className: "popup" }, /* @__PURE__ */ c.createElement("div", { className: "popup__header" }, /* @__PURE__ */ c.createElement("div", { className: "popup__header__text" }, i && i.length, " ", t.clusterPopup.groupedPoints), /* @__PURE__ */ c.createElement(
  "div",
  {
    role: "button",
    className: "popup__close-button",
    onKeyDown: () => n.remove(),
    onClick: () => n.remove(),
    "aria-label": "Close Button",
    tabIndex: 0
  },
  /* @__PURE__ */ c.createElement(bp, null)
)), /* @__PURE__ */ c.createElement("div", { className: "popup__container" }, i && i.map((r) => {
  var s, o, l;
  return /* @__PURE__ */ c.createElement(
    "div",
    {
      key: (s = r == null ? void 0 : r.properties) == null ? void 0 : s.index,
      role: "button",
      tabIndex: 0,
      "data-testid": `popup__container__list-${r.key}`,
      className: "popup__container__list",
      onClick: () => {
        var h;
        return e((h = r == null ? void 0 : r.properties) == null ? void 0 : h.index);
      },
      onKeyDown: () => {
        var h;
        return e((h = r == null ? void 0 : r.properties) == null ? void 0 : h.index);
      }
    },
    /* @__PURE__ */ c.createElement("div", { className: "popup__container__img", "data-testid": `popup__container__img-${(o = r == null ? void 0 : r.properties) == null ? void 0 : o.icon}` }, /* @__PURE__ */ c.createElement("img", { "data-testid": "popup__container__img", src: wp[(l = r == null ? void 0 : r.properties) == null ? void 0 : l.icon], alt: "" })),
    /* @__PURE__ */ c.createElement("div", { "data-testid": "popup__container__text" }, /* @__PURE__ */ c.createElement("span", null, t.clusterPopup.note), /* @__PURE__ */ c.createElement("br", null), /* @__PURE__ */ c.createElement("span", null, Re(r.markerProps.notesCreated).format("DD MMM, YY • HH:mm[h]")))
  );
}))), Sp = ({ event: n, focusedNote: e, messages: t, mapbox: i }) => {
  var h;
  if (!i)
    return;
  const r = i.queryRenderedFeatures(n.point, { layers: ["clusters"] });
  if (!(r != null && r.length) || !((h = r[0]) != null && h.properties))
    return;
  const s = r[0].properties.cluster_id, { point_count: o } = r[0].properties;
  i.getSource("points").getClusterLeaves(s, o, 0, (d, m) => {
    if (d)
      throw d;
    const p = new Rs.Popup({
      closeButton: !0,
      closeOnClick: !0,
      offset: 24
    }).setLngLat(n.lngLat).setHTML("</ div>").on("open", (_) => {
      const g = _;
      i.fire("close.popups"), i.fire("load.popupCluster", {
        data: m,
        popup: g.target,
        focusedNote: e,
        messages: t
      }), i.flyTo({
        center: n.lngLat
      }), i.on("close.popups", () => p.remove());
    }).addTo(i);
  });
}, Ap = ({ data: n, popup: e, focusedNote: t, messages: i }) => {
  rl.render(
    /* @__PURE__ */ c.createElement(Ep, { data: n, mapboxPopup: e, focusedNote: t, messages: i }),
    e._content
  );
};
const xp = () => {
  const { theme: n } = ze(), e = G("loading-item skeleton", {
    "loading-item-dark": n === "dark",
    "skeleton-dark": n === "dark"
  });
  return /* @__PURE__ */ c.createElement("div", { className: "loading__container" }, [...new Array(10).keys()].map((t) => /* @__PURE__ */ c.createElement(
    "div",
    {
      key: t,
      className: G("loading__wrapper", {
        "loading__wrapper-dark": n === "dark"
      })
    },
    /* @__PURE__ */ c.createElement("div", { className: "left-hand-side" }, /* @__PURE__ */ c.createElement("div", null, /* @__PURE__ */ c.createElement("div", { className: G(e, "info-first-line-left") }), /* @__PURE__ */ c.createElement("div", { className: G(e, "info-first-line-left") }), /* @__PURE__ */ c.createElement("div", { className: G(e, "info-first-line-left") })), /* @__PURE__ */ c.createElement("div", { className: G(e, "info-second-line-left") })),
    /* @__PURE__ */ c.createElement("div", { className: "right-hand-side" }, /* @__PURE__ */ c.createElement("div", { className: G(e, "info-first-line-right") }), /* @__PURE__ */ c.createElement("div", null, /* @__PURE__ */ c.createElement("div", { className: G(e, "info-second-line-right-circle") }), /* @__PURE__ */ c.createElement("div", { className: G(e, "info-second-line-right-square") })))
  )));
};
const Cp = ({ errorMessages: n, errorCode: e, children: t }) => /* @__PURE__ */ c.createElement("div", { className: "error__container" }, t, /* @__PURE__ */ c.createElement("span", { "data-testid": "error-title", className: "title" }, n.title), e && /* @__PURE__ */ c.createElement("span", { "data-testid": "error-code", className: "error" }, n[e]), n.subtitle && /* @__PURE__ */ c.createElement("span", { "data-testid": "error-subtitle", className: "subtitle" }, n.subtitle));
const Pp = ({ tip: n, iconSize: e = 24 }) => /* @__PURE__ */ c.createElement("div", { "data-testid": "loading-map-container", className: "loading-map__container" }, /* @__PURE__ */ c.createElement(tl, { indicator: /* @__PURE__ */ c.createElement(nl, { type: "loading", style: { fontSize: e }, spin: !0 }), tip: n })), Tp = (n) => /* @__PURE__ */ c.createElement("svg", Y({ width: "234", height: "160", viewBox: "0 0 234 160", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, n), /* @__PURE__ */ c.createElement(
  "path",
  {
    d: "M130.404 95.7494L130.295 95.6315C130.519 95.1455 130.589 94.6025 130.495 94.0755C130.402 93.5486 130.149 93.063 129.77 92.6841C129.408 92.3223 128.948 92.0745 128.447 91.9712C127.946 91.868 127.425 91.9138 126.949 92.1031L126.362 91.5936C130.603 85.5392 132.872 78.3251 132.861 70.9346C132.861 51.0062 116.702 34.8525 96.7689 34.8525C76.8354 34.8525 60.6729 51.002 60.6729 70.9304C60.6729 90.8589 76.8333 107.013 96.7668 107.013C104.622 107.024 112.264 104.463 118.523 99.7199L118.959 100.107C118.778 100.579 118.737 101.093 118.842 101.587C118.947 102.082 119.193 102.535 119.551 102.893C119.913 103.252 120.372 103.499 120.872 103.603C121.372 103.707 121.892 103.663 122.367 103.478C122.421 103.524 122.471 103.574 122.517 103.627L150.487 131.579L158.371 123.701L130.404 95.7494Z",
    fill: "#DFE2E7"
  }
), /* @__PURE__ */ c.createElement(
  "path",
  {
    d: "M125.502 96.2547C125.011 95.7633 124.735 95.0974 124.735 94.4031C124.735 93.7088 125.011 93.0429 125.502 92.5515L132.014 86.0421C132.257 85.7987 132.546 85.6056 132.864 85.4739C133.181 85.3422 133.522 85.2744 133.866 85.2744C134.211 85.2744 134.551 85.3422 134.869 85.4739C135.187 85.6056 135.476 85.7987 135.719 86.0421C136.21 86.5335 136.486 87.1994 136.486 87.8936C136.486 88.5879 136.21 89.2538 135.719 89.7452L129.207 96.2547C128.964 96.498 128.675 96.6911 128.357 96.8228C128.04 96.9545 127.699 97.0223 127.355 97.0223C127.01 97.0223 126.67 96.9545 126.352 96.8228C126.034 96.6911 125.745 96.498 125.502 96.2547Z",
    fill: "white"
  }
), /* @__PURE__ */ c.createElement(
  "path",
  {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M133.866 86.1168C133.633 86.1168 133.402 86.1628 133.186 86.2521C132.971 86.3415 132.775 86.4724 132.61 86.6374L126.098 93.1467L126.098 93.147C125.765 93.4805 125.578 93.9323 125.578 94.4034C125.578 94.8746 125.765 95.3265 126.098 95.6599M132.541 84.6963C132.961 84.5222 133.411 84.4326 133.866 84.4326C134.321 84.4326 134.772 84.5222 135.192 84.6963C135.612 84.8704 135.994 85.1256 136.315 85.4473L136.316 85.4475C136.964 86.0968 137.328 86.9766 137.328 87.894C137.328 88.8113 136.964 89.6911 136.316 90.3404L129.804 96.8501L129.803 96.8504C129.482 97.1719 129.1 97.427 128.68 97.601C128.26 97.7752 127.809 97.8648 127.355 97.8648C126.9 97.8648 126.449 97.7752 126.029 97.601C125.609 97.4269 125.227 97.1718 124.905 96.8501L125.502 96.255L124.905 96.8499C124.257 96.2006 123.893 95.3207 123.893 94.4034C123.893 93.4861 124.257 92.6062 124.905 91.957L131.417 85.4473L131.418 85.447C131.739 85.1255 132.121 84.8704 132.541 84.6963ZM126.098 95.6601C126.263 95.8251 126.459 95.9559 126.674 96.0452C126.89 96.1346 127.121 96.1806 127.355 96.1806C127.588 96.1806 127.819 96.1346 128.035 96.0452C128.25 95.9559 128.446 95.825 128.611 95.6599L135.123 89.1506L135.123 89.1503C135.456 88.8168 135.643 88.365 135.643 87.894C135.643 87.4228 135.456 86.971 135.123 86.6374",
    fill: "#00004B"
  }
), /* @__PURE__ */ c.createElement(
  "path",
  {
    d: "M102.716 100.375C122.65 100.375 138.81 84.2206 138.81 64.293C138.81 44.3654 122.65 28.2109 102.716 28.2109C82.7819 28.2109 66.6221 44.3654 66.6221 64.293C66.6221 84.2206 82.7819 100.375 102.716 100.375Z",
    fill: "white"
  }
), /* @__PURE__ */ c.createElement(
  "path",
  {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M102.716 29.0524C83.2475 29.0524 67.4646 44.8296 67.4646 64.2924C67.4646 83.7552 83.2475 99.5324 102.716 99.5324C122.184 99.5324 137.967 83.7552 137.967 64.2924C137.967 44.8296 122.184 29.0524 102.716 29.0524ZM65.7793 64.2924C65.7793 43.9 82.3161 27.3682 102.716 27.3682C123.116 27.3682 139.653 43.9 139.653 64.2924C139.653 84.6848 123.116 101.217 102.716 101.217C82.3161 101.217 65.7793 84.6848 65.7793 64.2924Z",
    fill: "#00004B"
  }
), /* @__PURE__ */ c.createElement(
  "path",
  {
    d: "M102.716 34.5029C108.615 34.4988 114.382 36.2431 119.289 39.5151C124.195 42.7872 128.02 47.44 130.28 52.885C132.54 58.33 133.133 64.3225 131.984 70.1043C130.835 75.8861 127.996 81.1976 123.826 85.3666C119.656 89.5357 114.342 92.3751 108.557 93.5256C102.772 94.6762 96.7748 94.0861 91.3252 91.8301C85.8756 89.5741 81.2179 85.7535 77.9416 80.8517C74.6652 75.9499 72.9173 70.1871 72.9189 64.2924C72.9181 60.3812 73.6882 56.5082 75.1852 52.8944C76.6822 49.2806 78.8768 45.9969 81.6437 43.2307C84.4106 40.4645 87.6956 38.27 91.3112 36.7725C94.9268 35.275 98.8022 34.5038 102.716 34.5029Z",
    fill: "white"
  }
), /* @__PURE__ */ c.createElement(
  "path",
  {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M116.312 38.7554C110.608 35.7238 104.053 34.6856 97.6908 35.8058C91.3282 36.926 85.5233 40.1404 81.1996 44.9375C76.8758 49.7346 74.2816 55.8389 73.8296 62.2793C73.3776 68.7196 75.0938 75.126 78.7053 80.4793L78.0065 80.95L78.7062 80.4807C81.3498 84.416 84.9237 87.6392 89.1113 89.8649C93.299 92.0905 97.9712 93.25 102.714 93.2406H102.716C109.176 93.2404 115.451 91.0811 120.542 87.1064C125.633 83.1316 129.248 77.5696 130.811 71.3053C132.374 65.0409 131.796 58.4341 129.169 52.5359C126.542 46.6378 122.016 41.787 116.312 38.7554ZM77.3073 81.4199C73.486 75.7553 71.6701 68.9763 72.1483 62.1615C72.6266 55.3463 75.3719 48.8867 79.9473 43.8103C84.5227 38.734 90.6655 35.3326 97.3984 34.1471C104.131 32.9617 111.067 34.0604 117.103 37.2684C123.139 40.4765 127.928 45.6095 130.709 51.851C133.489 58.0925 134.101 65.0838 132.446 71.7128C130.792 78.3417 126.967 84.2274 121.58 88.4335C116.193 92.6393 109.554 94.9242 102.718 94.9248C97.6974 94.9347 92.7522 93.7076 88.3199 91.3519C83.8878 88.9963 80.1053 85.5849 77.3073 81.4199Z",
    fill: "#00004B"
  }
), /* @__PURE__ */ c.createElement(
  "path",
  {
    d: "M120.713 58.5556C122.294 61.4358 123.122 64.6679 123.122 67.9528C123.121 71.2378 122.291 74.4695 120.709 77.349C119.127 80.2284 116.844 82.6627 114.071 84.4265C111.297 86.1903 108.124 87.2267 104.844 87.4398C105.292 87.4671 105.741 87.484 106.196 87.484C109.918 87.4818 113.579 86.5431 116.842 84.7544C120.105 82.9657 122.865 80.3847 124.866 77.2495C126.868 74.1142 128.048 70.5256 128.296 66.8148C128.545 63.104 127.854 59.3904 126.288 56.0166L120.713 58.5556Z",
    fill: "#DFE2E7"
  }
), /* @__PURE__ */ c.createElement("path", { d: "M128.469 96.9901L156.438 124.939L164.322 117.06L136.354 89.1107L128.469 96.9901Z", fill: "white" }), /* @__PURE__ */ c.createElement(
  "path",
  {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M156.438 126.13L127.278 96.9896L136.354 87.9193L165.514 117.06L156.438 126.13ZM156.438 123.748L163.131 117.06L136.354 90.3011L129.661 96.9896L156.438 123.748Z",
    fill: "#00004B"
  }
), /* @__PURE__ */ c.createElement(
  "path",
  {
    d: "M114.581 78.091V78.0678C114.581 75.1408 113.699 72.2817 112.049 69.8627C110.4 67.4438 108.061 65.5771 105.335 64.5057C106.986 63.3681 108.231 61.7325 108.886 59.8379C109.541 57.9433 109.573 55.889 108.977 53.975C108.381 52.061 107.188 50.3876 105.572 49.1994C103.957 48.0111 102.003 47.3701 99.9975 47.3701C97.9916 47.3701 96.0382 48.0111 94.4227 49.1994C92.8072 50.3876 91.6143 52.061 91.0181 53.975C90.422 55.889 90.4538 57.9433 91.1091 59.8379C91.7643 61.7325 93.0086 63.3681 94.6602 64.5057C91.9348 65.5774 89.5955 67.4443 87.9467 69.8632C86.2979 72.2821 85.4161 75.1411 85.416 78.0678V78.091H114.581Z",
    fill: "white"
  }
), /* @__PURE__ */ c.createElement(
  "path",
  {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M107 47L117 57V79H85V47H107ZM107 49.8284V57H114.172L107 49.8284ZM115 59H105V49H87V77H115V59Z",
    fill: "#73DC78"
  }
)), Op = ({
  events: { clickInTheRecenterButton: n },
  onFullscreen: e = () => {
  },
  reversedCoordinates: t = !0,
  latLngFocusedNote: i,
  isLoadingMapInfos: r,
  setFocusedNote: s,
  referencePoint: o,
  messagesMap: l,
  virtualizer: h,
  focusedNote: d,
  rootRegion: m,
  className: p,
  notes: _
}) => {
  const g = We(), [S, A] = le(), [I, L] = le(!1), [x, Z] = le(!1), [R, P] = le(!0), W = Oe((j) => {
    g.current = j;
  }, []);
  he(() => {
    var j;
    g && (g != null && g.current) && ((j = g == null ? void 0 : g.current) == null || j.fire("close.popups"));
  }, [_, g]), he(() => {
    !(i != null && i.length) || !i.some(Number) || pp({ mapbox: g, lngLat: i, reversedCoordinates: t });
  }, [i]);
  const K = Oe(() => {
    g != null && g.current && m && yp(g.current, m == null ? void 0 : m.geometry, o, {
      padding: Ui
    });
  }, [m]), J = Oe(
    (j) => {
      var Q;
      const X = (Q = j.features) == null ? void 0 : Q[0];
      if (!(X != null && X.properties))
        return;
      const { index: _e } = X.properties, { lat: re, lng: ne } = j.lngLat;
      s(t ? [re, ne] : [ne, re], _e);
    },
    [s]
  ), q = Oe(
    (j, X) => {
      !g.current || !d || X || s();
    },
    [g, d, s]
  ), F = Oe(() => {
    var X;
    if (!((X = g.current) != null && X.getSource(Ri.POINTS)))
      return;
    const j = Xh({ notes: _, focusedNote: d, reversedCoordinates: t });
    A(j.features), g.current.getSource(Ri.POINTS).setData(j), !d && K();
  }, [t, K, d, g, _]);
  he(() => {
    !m || !x || !I || F();
  }, [F, x, I, m]), he(() => {
    d || K();
  }, [K, d]), Uf(() => {
    P(!1);
  }, 0);
  const V = Oe(
    (j) => {
      if (!(g != null && g.current))
        return;
      const X = (_e) => {
        s([], _e), h.scrollToIndex(_e, { behavior: "smooth", align: "start" });
      };
      Sp({
        event: j,
        mapbox: g.current,
        focusedNote: X,
        messages: l
      });
    },
    [g]
  );
  return he(() => {
    !(g != null && g.current) || !x || !(S != null && S.length) || g.current.on("click", "clusters", V);
  }, [g, x, S]), he(() => {
    var j, X;
    !g || !x || !I || !g.current || (j = g == null ? void 0 : g.current) != null && j.on && ((X = g == null ? void 0 : g.current) == null || X.on("load.popupCluster", Ap));
  }, [g, x, I]), /* @__PURE__ */ c.createElement("div", { className: G(p, "notes-map__container") }, r && /* @__PURE__ */ c.createElement(Pp, { tip: l.tip }), !R && /* @__PURE__ */ c.createElement(c.Fragment, null, /* @__PURE__ */ c.createElement(
    _p,
    {
      handleIsMapboxStyleLoaded: L,
      onUnclusteredPointClick: J,
      currentPropertyReferencePoint: o,
      handleIsMapboxLoaded: Z,
      onMouseClick: q,
      handleMapbox: W,
      mapbox: g.current,
      region: m
    }
  ), /* @__PURE__ */ c.createElement(
    Ps,
    {
      className: "notes-map__fullscreen",
      testId: "notes-map-fullscreen",
      onClick: e,
      icon: Xf
    }
  ), /* @__PURE__ */ c.createElement(
    Ps,
    {
      onClick: () => {
        K(), n();
      },
      className: "notes-map__centralizer",
      testId: "notes-map-centralizer",
      icon: Kf
    }
  )));
};
/**
 * react-virtual
 *
 * Copyright (c) TanStack
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */
function Gn() {
  return Gn = Object.assign ? Object.assign.bind() : function(n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var i in t)
        Object.prototype.hasOwnProperty.call(t, i) && (n[i] = t[i]);
    }
    return n;
  }, Gn.apply(this, arguments);
}
/**
 * virtual-core
 *
 * Copyright (c) TanStack
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */
function Yn() {
  return Yn = Object.assign ? Object.assign.bind() : function(n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var i in t)
        Object.prototype.hasOwnProperty.call(t, i) && (n[i] = t[i]);
    }
    return n;
  }, Yn.apply(this, arguments);
}
/**
 * virtual-core
 *
 * Copyright (c) TanStack
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */
function Ht(n, e, t) {
  var i, r = (i = t.initialDeps) != null ? i : [], s;
  return function() {
    var o;
    t.key && t.debug != null && t.debug() && (o = Date.now());
    var l = n(), h = l.length !== r.length || l.some(function(S, A) {
      return r[A] !== S;
    });
    if (!h)
      return s;
    r = l;
    var d;
    if (t.key && t.debug != null && t.debug() && (d = Date.now()), s = e.apply(void 0, l), t.key && t.debug != null && t.debug()) {
      var m = Math.round((Date.now() - o) * 100) / 100, p = Math.round((Date.now() - d) * 100) / 100, _ = p / 16, g = function(A, I) {
        for (A = String(A); A.length < I; )
          A = " " + A;
        return A;
      };
      console.info("%c⏱ " + g(p, 5) + " /" + g(m, 5) + " ms", `
            font-size: .6rem;
            font-weight: bold;
            color: hsl(` + Math.max(0, Math.min(120 - 120 * _, 120)) + "deg 100% 31%);", t == null ? void 0 : t.key);
    }
    return t == null || t.onChange == null || t.onChange(s), s;
  };
}
function Pi(n, e) {
  if (n === void 0)
    throw new Error("Unexpected undefined" + (e ? ": " + e : ""));
  return n;
}
var Ip = function(e, t) {
  return Math.abs(e - t) < 1;
};
/**
 * virtual-core
 *
 * Copyright (c) TanStack
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */
var kp = function(e) {
  return e;
}, Dp = function(e) {
  for (var t = Math.max(e.startIndex - e.overscan, 0), i = Math.min(e.endIndex + e.overscan, e.count - 1), r = [], s = t; s <= i; s++)
    r.push(s);
  return r;
}, Mp = function(e, t) {
  var i = e.scrollElement;
  if (i) {
    var r = function(l) {
      var h = l.width, d = l.height;
      t({
        width: Math.round(h),
        height: Math.round(d)
      });
    };
    r(i.getBoundingClientRect());
    var s = new ResizeObserver(function(o) {
      var l = o[0];
      if (l != null && l.borderBoxSize) {
        var h = l.borderBoxSize[0];
        if (h) {
          r({
            width: h.inlineSize,
            height: h.blockSize
          });
          return;
        }
      }
      r(i.getBoundingClientRect());
    });
    return s.observe(i, {
      box: "border-box"
    }), function() {
      s.unobserve(i);
    };
  }
}, Lp = function(e, t) {
  var i = e.scrollElement;
  if (i) {
    var r = function() {
      t(i[e.options.horizontal ? "scrollLeft" : "scrollTop"]);
    };
    return r(), i.addEventListener("scroll", r, {
      passive: !0
    }), function() {
      i.removeEventListener("scroll", r);
    };
  }
}, Rp = function(e, t, i) {
  if (t != null && t.borderBoxSize) {
    var r = t.borderBoxSize[0];
    if (r) {
      var s = Math.round(r[i.options.horizontal ? "inlineSize" : "blockSize"]);
      return s;
    }
  }
  return Math.round(e.getBoundingClientRect()[i.options.horizontal ? "width" : "height"]);
}, zp = function(e, t, i) {
  var r, s, o = t.adjustments, l = o === void 0 ? 0 : o, h = t.behavior, d = e + l;
  (r = i.scrollElement) == null || r.scrollTo == null || r.scrollTo((s = {}, s[i.options.horizontal ? "left" : "top"] = d, s.behavior = h, s));
}, Np = function(e) {
  var t = this;
  this.unsubs = [], this.scrollElement = null, this.isScrolling = !1, this.isScrollingTimeoutId = null, this.scrollToIndexTimeoutId = null, this.measurementsCache = [], this.itemSizeCache = /* @__PURE__ */ new Map(), this.pendingMeasuredCacheIndexes = [], this.scrollDirection = null, this.scrollAdjustments = 0, this.measureElementCache = /* @__PURE__ */ new Map(), this.observer = function() {
    var i = null, r = function() {
      return i || (typeof ResizeObserver != "undefined" ? i = new ResizeObserver(function(o) {
        o.forEach(function(l) {
          t._measureElement(l.target, l);
        });
      }) : null);
    };
    return {
      disconnect: function() {
        var o;
        return (o = r()) == null ? void 0 : o.disconnect();
      },
      observe: function(o) {
        var l;
        return (l = r()) == null ? void 0 : l.observe(o, {
          box: "border-box"
        });
      },
      unobserve: function(o) {
        var l;
        return (l = r()) == null ? void 0 : l.unobserve(o);
      }
    };
  }(), this.range = {
    startIndex: 0,
    endIndex: 0
  }, this.setOptions = function(i) {
    Object.entries(i).forEach(function(r) {
      var s = r[0], o = r[1];
      typeof o == "undefined" && delete i[s];
    }), t.options = Yn({
      debug: !1,
      initialOffset: 0,
      overscan: 1,
      paddingStart: 0,
      paddingEnd: 0,
      scrollPaddingStart: 0,
      scrollPaddingEnd: 0,
      horizontal: !1,
      getItemKey: kp,
      rangeExtractor: Dp,
      onChange: function() {
      },
      measureElement: Rp,
      initialRect: {
        width: 0,
        height: 0
      },
      scrollMargin: 0,
      scrollingDelay: 150,
      indexAttribute: "data-index",
      initialMeasurementsCache: [],
      lanes: 1
    }, i);
  }, this.notify = function() {
    t.options.onChange == null || t.options.onChange(t);
  }, this.cleanup = function() {
    t.unsubs.filter(Boolean).forEach(function(i) {
      return i();
    }), t.unsubs = [], t.scrollElement = null;
  }, this._didMount = function() {
    return t.measureElementCache.forEach(t.observer.observe), function() {
      t.observer.disconnect(), t.cleanup();
    };
  }, this._willUpdate = function() {
    var i = t.options.getScrollElement();
    t.scrollElement !== i && (t.cleanup(), t.scrollElement = i, t._scrollToOffset(t.scrollOffset, {
      adjustments: void 0,
      behavior: void 0
    }), t.unsubs.push(t.options.observeElementRect(t, function(r) {
      var s = t.scrollRect;
      t.scrollRect = r, (t.options.horizontal ? r.width !== s.width : r.height !== s.height) && t.maybeNotify();
    })), t.unsubs.push(t.options.observeElementOffset(t, function(r) {
      t.scrollAdjustments = 0, t.scrollOffset !== r && (t.isScrollingTimeoutId !== null && (clearTimeout(t.isScrollingTimeoutId), t.isScrollingTimeoutId = null), t.isScrolling = !0, t.scrollDirection = t.scrollOffset < r ? "forward" : "backward", t.scrollOffset = r, t.maybeNotify(), t.isScrollingTimeoutId = setTimeout(function() {
        t.isScrollingTimeoutId = null, t.isScrolling = !1, t.scrollDirection = null, t.maybeNotify();
      }, t.options.scrollingDelay));
    })));
  }, this.getSize = function() {
    return t.scrollRect[t.options.horizontal ? "width" : "height"];
  }, this.memoOptions = Ht(function() {
    return [t.options.count, t.options.paddingStart, t.options.scrollMargin, t.options.getItemKey];
  }, function(i, r, s, o) {
    return t.pendingMeasuredCacheIndexes = [], {
      count: i,
      paddingStart: r,
      scrollMargin: s,
      getItemKey: o
    };
  }, {
    key: !1
  }), this.getFurthestMeasurement = function(i, r) {
    for (var s = /* @__PURE__ */ new Map(), o = /* @__PURE__ */ new Map(), l = r - 1; l >= 0; l--) {
      var h = i[l];
      if (!s.has(h.lane)) {
        var d = o.get(h.lane);
        if (d == null || h.end > d.end ? o.set(h.lane, h) : h.end < d.end && s.set(h.lane, !0), s.size === t.options.lanes)
          break;
      }
    }
    return o.size === t.options.lanes ? Array.from(o.values()).sort(function(m, p) {
      return m.end - p.end;
    })[0] : void 0;
  }, this.getMeasurements = Ht(function() {
    return [t.memoOptions(), t.itemSizeCache];
  }, function(i, r) {
    var s = i.count, o = i.paddingStart, l = i.scrollMargin, h = i.getItemKey, d = t.pendingMeasuredCacheIndexes.length > 0 ? Math.min.apply(Math, t.pendingMeasuredCacheIndexes) : 0;
    t.pendingMeasuredCacheIndexes = [];
    for (var m = t.measurementsCache.slice(0, d), p = d; p < s; p++) {
      var _ = h(p), g = t.options.lanes === 1 ? m[p - 1] : t.getFurthestMeasurement(m, p), S = g ? g.end : o + l, A = r.get(_), I = typeof A == "number" ? A : t.options.estimateSize(p), L = S + I, x = g ? g.lane : p % t.options.lanes;
      m[p] = {
        index: p,
        start: S,
        size: I,
        end: L,
        key: _,
        lane: x
      };
    }
    return t.measurementsCache = m, m;
  }, {
    key: process.env.NODE_ENV !== "production" && "getMeasurements",
    debug: function() {
      return t.options.debug;
    }
  }), this.calculateRange = Ht(function() {
    return [t.getMeasurements(), t.getSize(), t.scrollOffset];
  }, function(i, r, s) {
    return t.range = Fp({
      measurements: i,
      outerSize: r,
      scrollOffset: s
    });
  }, {
    key: process.env.NODE_ENV !== "production" && "calculateRange",
    debug: function() {
      return t.options.debug;
    }
  }), this.maybeNotify = Ht(function() {
    var i = t.calculateRange();
    return [i.startIndex, i.endIndex, t.isScrolling];
  }, function() {
    t.notify();
  }, {
    key: process.env.NODE_ENV !== "production" && "maybeNotify",
    debug: function() {
      return t.options.debug;
    },
    initialDeps: [this.range.startIndex, this.range.endIndex, this.isScrolling]
  }), this.getIndexes = Ht(function() {
    return [t.options.rangeExtractor, t.calculateRange(), t.options.overscan, t.options.count];
  }, function(i, r, s, o) {
    return i(Yn({}, r, {
      overscan: s,
      count: o
    }));
  }, {
    key: process.env.NODE_ENV !== "production" && "getIndexes",
    debug: function() {
      return t.options.debug;
    }
  }), this.indexFromElement = function(i) {
    var r = t.options.indexAttribute, s = i.getAttribute(r);
    return s ? parseInt(s, 10) : (console.warn("Missing attribute name '" + r + "={index}' on measured element."), -1);
  }, this._measureElement = function(i, r) {
    var s, o = t.indexFromElement(i), l = t.measurementsCache[o];
    if (l) {
      var h = t.measureElementCache.get(l.key);
      if (!i.isConnected) {
        t.observer.unobserve(i), i === h && t.measureElementCache.delete(l.key);
        return;
      }
      h !== i && (h && t.observer.unobserve(h), t.observer.observe(i), t.measureElementCache.set(l.key, i));
      var d = t.options.measureElement(i, r, t), m = (s = t.itemSizeCache.get(l.key)) != null ? s : l.size, p = d - m;
      p !== 0 && (l.start < t.scrollOffset && (process.env.NODE_ENV !== "production" && t.options.debug && console.info("correction", p), t._scrollToOffset(t.scrollOffset, {
        adjustments: t.scrollAdjustments += p,
        behavior: void 0
      })), t.pendingMeasuredCacheIndexes.push(o), t.itemSizeCache = new Map(t.itemSizeCache.set(l.key, d)), t.notify());
    }
  }, this.measureElement = function(i) {
    i && t._measureElement(i, void 0);
  }, this.getVirtualItems = Ht(function() {
    return [t.getIndexes(), t.getMeasurements()];
  }, function(i, r) {
    for (var s = [], o = 0, l = i.length; o < l; o++) {
      var h = i[o], d = r[h];
      s.push(d);
    }
    return s;
  }, {
    key: process.env.NODE_ENV !== "production" && "getIndexes",
    debug: function() {
      return t.options.debug;
    }
  }), this.getVirtualItemForOffset = function(i) {
    var r = t.getMeasurements();
    return Pi(r[Lo(0, r.length - 1, function(s) {
      return Pi(r[s]).start;
    }, i)]);
  }, this.getOffsetForAlignment = function(i, r) {
    var s = t.getSize();
    r === "auto" && (i <= t.scrollOffset ? r = "start" : i >= t.scrollOffset + s ? r = "end" : r = "start"), r === "start" ? i = i : r === "end" ? i = i - s : r === "center" && (i = i - s / 2);
    var o = t.options.horizontal ? "scrollWidth" : "scrollHeight", l = t.scrollElement ? "document" in t.scrollElement ? t.scrollElement.document.documentElement[o] : t.scrollElement[o] : 0, h = l - t.getSize();
    return Math.max(Math.min(h, i), 0);
  }, this.getOffsetForIndex = function(i, r) {
    r === void 0 && (r = "auto"), i = Math.max(0, Math.min(i, t.options.count - 1));
    var s = Pi(t.getMeasurements()[i]);
    if (r === "auto")
      if (s.end >= t.scrollOffset + t.getSize() - t.options.scrollPaddingEnd)
        r = "end";
      else if (s.start <= t.scrollOffset + t.options.scrollPaddingStart)
        r = "start";
      else
        return [t.scrollOffset, r];
    var o = r === "end" ? s.end + t.options.scrollPaddingEnd : s.start - t.options.scrollPaddingStart;
    return [t.getOffsetForAlignment(o, r), r];
  }, this.isDynamicMode = function() {
    return t.measureElementCache.size > 0;
  }, this.cancelScrollToIndex = function() {
    t.scrollToIndexTimeoutId !== null && (clearTimeout(t.scrollToIndexTimeoutId), t.scrollToIndexTimeoutId = null);
  }, this.scrollToOffset = function(i, r) {
    var s = r === void 0 ? {} : r, o = s.align, l = o === void 0 ? "start" : o, h = s.behavior;
    t.cancelScrollToIndex(), h === "smooth" && t.isDynamicMode() && console.warn("The `smooth` scroll behavior is not fully supported with dynamic size."), t._scrollToOffset(t.getOffsetForAlignment(i, l), {
      adjustments: void 0,
      behavior: h
    });
  }, this.scrollToIndex = function(i, r) {
    var s = r === void 0 ? {} : r, o = s.align, l = o === void 0 ? "auto" : o, h = s.behavior;
    i = Math.max(0, Math.min(i, t.options.count - 1)), t.cancelScrollToIndex(), h === "smooth" && t.isDynamicMode() && console.warn("The `smooth` scroll behavior is not fully supported with dynamic size.");
    var d = t.getOffsetForIndex(i, l), m = d[0], p = d[1];
    t._scrollToOffset(m, {
      adjustments: void 0,
      behavior: h
    }), h !== "smooth" && t.isDynamicMode() && (t.scrollToIndexTimeoutId = setTimeout(function() {
      t.scrollToIndexTimeoutId = null;
      var _ = t.measureElementCache.has(t.options.getItemKey(i));
      if (_) {
        var g = t.getOffsetForIndex(i, p), S = g[0];
        Ip(S, t.scrollOffset) || t.scrollToIndex(i, {
          align: p,
          behavior: h
        });
      } else
        t.scrollToIndex(i, {
          align: p,
          behavior: h
        });
    }));
  }, this.scrollBy = function(i, r) {
    var s = r === void 0 ? {} : r, o = s.behavior;
    t.cancelScrollToIndex(), o === "smooth" && t.isDynamicMode() && console.warn("The `smooth` scroll behavior is not fully supported with dynamic size."), t._scrollToOffset(t.scrollOffset + i, {
      adjustments: void 0,
      behavior: o
    });
  }, this.getTotalSize = function() {
    var i;
    return (((i = t.getMeasurements()[t.options.count - 1]) == null ? void 0 : i.end) || t.options.paddingStart) - t.options.scrollMargin + t.options.paddingEnd;
  }, this._scrollToOffset = function(i, r) {
    var s = r.adjustments, o = r.behavior;
    t.options.scrollToFn(i, {
      behavior: o,
      adjustments: s
    }, t);
  }, this.measure = function() {
    t.itemSizeCache = /* @__PURE__ */ new Map(), t.notify();
  }, this.setOptions(e), this.scrollRect = this.options.initialRect, this.scrollOffset = this.options.initialOffset, this.measurementsCache = this.options.initialMeasurementsCache, this.measurementsCache.forEach(function(i) {
    t.itemSizeCache.set(i.key, i.size);
  }), this.maybeNotify();
}, Lo = function(e, t, i, r) {
  for (; e <= t; ) {
    var s = (e + t) / 2 | 0, o = i(s);
    if (o < r)
      e = s + 1;
    else if (o > r)
      t = s - 1;
    else
      return s;
  }
  return e > 0 ? e - 1 : 0;
};
function Fp(n) {
  for (var e = n.measurements, t = n.outerSize, i = n.scrollOffset, r = e.length - 1, s = function(d) {
    return e[d].start;
  }, o = Lo(0, r, s, i), l = o; l < r && e[l].end < i + t; )
    l++;
  return {
    startIndex: o,
    endIndex: l
  };
}
/**
 * react-virtual
 *
 * Copyright (c) TanStack
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */
var Zp = typeof document != "undefined" ? hn.useLayoutEffect : hn.useEffect;
function Bp(n) {
  var e = hn.useReducer(function() {
    return {};
  }, {})[1], t = Gn({}, n, {
    onChange: function(o) {
      e(), n.onChange == null || n.onChange(o);
    }
  }), i = hn.useState(function() {
    return new Np(t);
  }), r = i[0];
  return r.setOptions(t), hn.useEffect(function() {
    return r._didMount();
  }, []), Zp(function() {
    return r._willUpdate();
  }), r;
}
function Hp(n) {
  return Bp(Gn({
    observeElementRect: Mp,
    observeElementOffset: Lp,
    scrollToFn: zp
  }, n));
}
const Vp = "notes-ant", jp = ({ children: n, theme: e }) => /* @__PURE__ */ c.createElement(il, { prefixCls: Vp }, /* @__PURE__ */ c.createElement(ul, { theme: e }, n)), sm = (Z) => {
  var R = Z, {
    events: P
  } = R, W = P, {
    mapEvents: K
  } = W, J = K, { clickInTheFullscreenButton: n } = J, e = xt(J, ["clickInTheFullscreenButton"]), {
    openNoteScreen: t,
    sideBarEvents: i
  } = W, {
    reversedCoordinates: r = !0,
    handleFilterPayload: s,
    isLoadingMapInfos: o,
    regionsTreeNode: l,
    selectedFilter: h,
    referencePoint: d,
    tagsTreeNode: m,
    rootRegion: p,
    className: _,
    isLoading: g,
    errorCode: S,
    messages: A,
    isError: I,
    notes: L,
    isGaleryV2: x
  } = R;
  const q = We(null), F = c.useRef(null), V = Hp({
    count: (L == null ? void 0 : L.length) || 0,
    getScrollElement: () => F.current,
    estimateSize: () => 130
  }), [j, X] = le(), [_e, re] = le(), ne = Oe(() => {
    var Q, ie;
    (ie = (Q = q == null ? void 0 : q.current) == null ? void 0 : Q.requestFullscreen) == null || ie.call(Q), n();
  }, []), Ae = (Q, ie, qe) => {
    X && X(ie || ie === 0 ? [ie, qe || "map"] : void 0), re && re(Q);
  };
  return he(() => {
    t();
  }, []), /* @__PURE__ */ c.createElement(jp, { theme: "light" }, /* @__PURE__ */ c.createElement(
    "div",
    {
      "data-testid": "notes-component",
      className: G(_, "notes-component__container"),
      ref: q
    },
    /* @__PURE__ */ c.createElement(
      $f,
      {
        handleFilterPayload: s,
        reversedCoordinates: r,
        messagesSidebar: A.sidebar,
        productId: A == null ? void 0 : A.products,
        regionsTreeNode: l,
        selectedFilter: h,
        tagsTreeNode: m,
        setFocusedNote: Ae,
        focusedNote: j,
        virtualizer: V,
        events: i,
        parentRef: F,
        isLoading: g,
        errorCode: S,
        isError: I,
        notes: L,
        isGaleryV2: x
      }
    ),
    /* @__PURE__ */ c.createElement(
      Op,
      {
        reversedCoordinates: r,
        isLoadingMapInfos: o,
        latLngFocusedNote: _e,
        referencePoint: d,
        onFullscreen: ne,
        setFocusedNote: Ae,
        messagesMap: A.map,
        virtualizer: V,
        focusedNote: j,
        rootRegion: p,
        events: e,
        notes: L
      }
    )
  ));
};
export {
  ji as AudioPlayer,
  Cp as ErrorNotes,
  Gf as Filter,
  wf as Gallery,
  Pp as LoadingMap,
  xp as LoadingNotes,
  Op as Map,
  Af as Modal,
  Tp as NotFound,
  Ff as NoteCard,
  sm as Page,
  jp as Provider,
  $f as Sidebar,
  dl as SidebarContent,
  Kp as SidebarCreate,
  Fs as SidebarHeader,
  hl as SidebarSubheader,
  vn as convertSecondsToFormatedString,
  rm as useNotesActionsMenu
};
